"use strict";
/**
 * DO NOT CHANGE THIS TSX MANUALLY
 * This tsx is generated automatically when npm start, no extra command
 * Is needed.
 * Related script "build:icon": "node ./generateSvgIcon.js"
 * And "prestart": "npm run build:icon" will be automatically
 * executed with npm start
 */

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var React = __importStar(require("react"));

var svgIcon = function svgIcon(id, name, svgAttrs, title, variant, size) {
  var idTitle = id + "-title";

  switch (name) {
    case 'gk_steps_01':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, React.createElement("path", {
        d: "M0 48h48V0H0z"
      }), React.createElement("path", {
        fill: "#333",
        fillRule: "nonzero",
        d: "M6 42h14V28H6v14zm-2 2V26h18v18H4zm18-22H4V4h10.648v2H6v14h14v-8.333h2V22zm-8.826-4.411l-4.88-4.882 1.413-1.414 3.118 3.118 6.331-9.948 1.687 1.074-7.669 12.052zM26 10V8h18v2H26zm0 7v-2h14v2H26zm0 15v-2h18v2H26zm0 7v-2h14v2H26z"
      })));

    case 'gk_steps_02':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        fill: "#333",
        fillRule: "nonzero",
        d: "M14.894 12v1.895h-2V12c0-9.228 5.162-10 10-10 4.837 0 9.999.772 9.999 10v1.895h-2V12c0-7.411-3.467-8-8-8-4.532 0-7.999.589-7.999 8zm6.87 1.934l-1-3.5-3.923 1.96-.894-1.788 6.077-3.04 1 3.5 5.922-2.96.895 1.789-8.078 4.039zm24.28 13.036l1.696 1.06-10.665 17.066-6.889-6.89 1.414-1.413 5.112 5.112 9.332-14.935zm-7.704 5.136l-.895 1.788-9.354-4.677-5.197 5.197-5.198-5.198-9.056 4.53-3.851 7.701L3 40.552l4.15-8.297 10.941-5.472 4.803 4.802 4.802-4.802 10.644 5.322zM14.894 19v-5h2v4.527L19.13 23h7.527l2.236-4.473V14h2v5l-3 6h-10l-2.999-6z"
      }));

    case 'gk_steps_03':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, React.createElement("path", {
        d: "M0 48h48V0H0z"
      }), React.createElement("path", {
        fill: "#333",
        fillRule: "nonzero",
        d: "M6 31v-8h2v8H6zm12.186-4.581L22.057 21H2v-2h20.057l-3.871-5.419 1.628-1.162L25.229 20l-5.415 7.581-1.628-1.162zM8 9v8H6V7h36v24h-2V9H8zm19.882 24H46v4.737L43.618 42H4.35L2 37.212V33h18.118l1 2h5.764l1-2zM44 37.264V35H29.118l-1 2h-8.236l-1-2H4v1.788L5.65 40h36.732L44 37.264z"
      })));

    case 'googlepay_steps_01':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 44"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null, React.createElement("path", {
        d: "M36 2H12l-2 4v36l2 4h24l2-4V6l-2-4zm0 34H12V6.472L13.236 4h21.528L36 6.472V36zm-14 6v-2h4v2h-4zM13.5 6.882l.691-1.382H33.5v1H14.809l-.309.618V34.5h-1V6.882z"
      })), React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(-10 -2)"
      }, React.createElement("mask", {
        fill: "#fff"
      }, React.createElement("use", {
        xlinkHref: "#lsg-googlepay-steps-01a"
      })), React.createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#lsg-googlepay-steps-01a"
      }), React.createElement("g", {
        fill: "#000",
        mask: "url(#lsg-googlepay-steps-01b)"
      }, React.createElement("path", {
        d: "M0 0h48v48H0z"
      })), React.createElement("path", {
        d: "M0 0h48v48H0z"
      })));

    case 'googlepay_steps_02':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 44 42"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null, React.createElement("path", {
        d: "M43.618 20H32v2h10.382L44 25.236V34H12v-2h-2v7.236L12.382 44h31.236L46 39.236V24.764L43.618 20zm-1.236 22H13.618L12 38.764V38h32v.764L42.382 42zM30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14zm-13 9v-8h8v-2h-8V7h-2v8H7v2h8v8h2z"
      })), React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(-2 -2)"
      }, React.createElement("mask", {
        fill: "#fff"
      }, React.createElement("use", {
        xlinkHref: "#lsg-googlepay-steps-02a"
      })), React.createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#lsg-googlepay-steps-02a"
      }), React.createElement("g", {
        fill: "#000",
        mask: "url(#lsg-googlepay-steps-02b)"
      }, React.createElement("path", {
        d: "M0 0h48v48H0z"
      })), React.createElement("path", {
        d: "M0 0h48v48H0z"
      })));

    case 'googlepay_steps_03':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 44 40"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null, React.createElement("path", {
        d: "M44 24.528L36.264 40H17.236L16 37.528v-18.7l7.414-7.414.586-.586V4h3.172L30 6.828v5.7l-1.789 3.577L26.764 19h16L44 21.472v3.056zM44 17H30l2-4V6l-4-4h-6v8l-8 8v20l2 4h21.5L46 25v-4l-2-4zM2 42V18h10v24H2zm2-2h6V20H4v20zm3-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 3a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2"
      })), React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, React.createElement("g", {
        transform: "translate(-2 -2)"
      }, React.createElement("mask", {
        fill: "#fff"
      }, React.createElement("use", {
        xlinkHref: "#lsg-googlepay-steps-03a"
      })), React.createElement("use", {
        fill: "#000",
        fillRule: "nonzero",
        xlinkHref: "#lsg-googlepay-steps-03a"
      }), React.createElement("g", {
        fill: "#000",
        mask: "url(#lsg-googlepay-steps-03b)"
      }, React.createElement("path", {
        d: "M0 0h48v48H0z"
      })), React.createElement("path", {
        d: "M0 0h48v48H0z"
      })), React.createElement("path", {
        fill: "#000",
        d: "M1 17h8v22H1z"
      })));

    case 'i_1006':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.78 13h-.16a1 1 0 0 0-.94.84 1 1 0 0 0 .94.88h.32a1 1 0 0 0 .94-.87 1 1 0 0 0-.94-.85h-.17zm0-1.37h.07a.84.84 0 0 0 .84-.81.85.85 0 0 0-.85-.85h-.16a.85.85 0 0 0-.85.85.85.85 0 0 0 .85.81h.11zM12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zM7.9 11.1l-3.59 1.2 3.59 1.2v1.93l-5.39-2.16v-1.93L7.9 9.18v1.92zm4.71 5h-2.08v-5.7l-1.28.3-.41-1.62 2.24-.68h1.53v7.73zm7.28-2.1c0 1.36-1.3 2.24-3.12 2.24s-3.12-.9-3.12-2.23v-.05a1.87 1.87 0 0 1 1.29-1.78 1.82 1.82 0 0 1-1-1.64c0-1.2 1.2-2.12 2.87-2.12s2.87.9 2.87 2.12a1.81 1.81 0 0 1-1 1.64A1.91 1.91 0 0 1 19.92 14z"
      }));

    case 'i_104':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.2 12L6 18.2V24l12-12L6 0v5.8l6.2 6.2z"
      }));

    case 'i_110':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11.85 12L18 5.84V0L6 12l12 12v-5.84z"
      }));

    case 'i_113':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M.27 14a1 1 0 0 1 0-1.36l2.39-2.39a1 1 0 0 1 1.36 0l3.91 3.91a1 1 0 0 0 1.36 0L20 3.46a1 1 0 0 1 1.36 0l2.4 2.36a1 1 0 0 1 0 1.36l-13 13a2.67 2.67 0 0 1-1.64.67H8a2.66 2.66 0 0 1-1.63-.68L.27 14z"
      }));

    case 'i_118':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 5.35H0l12 13.3z"
      }));

    case 'i_204':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 5.29L18.71 0 12 6.71 5.29 0 0 5.29 6.71 12 0 18.71 5.29 24 12 17.29 18.71 24 24 18.71 17.29 12z"
      }));

    case 'i_207':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.73 5.15a2.88 2.88 0 0 0 2.83-2.9A2.38 2.38 0 0 0 16 .7a2.09 2.09 0 0 0-1.59-.7 2.84 2.84 0 0 0-2.83 2.79 2.09 2.09 0 0 0 1.8 2.34H13.72zm2.87 14.27l-.73-1.62-.21.2a12 12 0 0 1-2.47 1.78.69.69 0 0 1 0-.19 3.78 3.78 0 0 1 .13-.83l1.94-7.88a13.26 13.26 0 0 0 .26-2.41 2.42 2.42 0 0 0-.26-1.23 1 1 0 0 0-.92-.51C13 6.73 10 8.58 7.5 10.9l-.15.1.65 1.84.23-.18a20.15 20.15 0 0 1 2.31-1.61 6.16 6.16 0 0 1-.14.88l-1.76 7.6a13 13 0 0 0-.29 2.52 2.16 2.16 0 0 0 .45 1.51 1.43 1.43 0 0 0 1 .43c1.2.01 4.2-1.61 6.73-4.3l.13-.15-.1-.16z"
      }));

    case 'i_211':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.34 20.41L16.91 14A9.15 9.15 0 1 0 14 16.89l6.43 6.44A2.27 2.27 0 0 0 22 24a1.94 1.94 0 0 0 2-1.91v-.07a2.27 2.27 0 0 0-.66-1.61zM14.26 9.13A5.11 5.11 0 1 1 9.15 4a5.12 5.12 0 0 1 5.11 5.13z"
      }));

    case 'i_213':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.62 10.47V6.54A6.54 6.54 0 0 0 12.08 0h-.23a6.54 6.54 0 0 0-6.53 6.54v3.93H3V24h18V10.47h-2.38zm-10-3.93a3.27 3.27 0 0 1 3.27-3.27h.24a3.27 3.27 0 0 1 3.27 3.27v3.93H8.59V6.54z"
      }));

    case 'i_214':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.9.77h-.23a6.1 6.1 0 0 0-6.1 6.1v3.68H0v12.68h16.87V10.57h-2.26V6.89a3.06 3.06 0 0 1 3-3.06h.22a3.06 3.06 0 0 1 3.06 3.06v1.48h1v.39l-1 1v.86H24V6.89A6.11 6.11 0 0 0 17.89.77z"
      }));

    case 'i_613':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 17.22c-1.45-.65-3.64-2.3-6.78-2.88a12.45 12.45 0 0 0 2.07-3.85 7.28 7.28 0 0 0 .27-2.87 13.66 13.66 0 0 0 0-2.91c-.7-2.5-2.48-3.2-4.55-3.2s-3.89.68-4.55 3.2a13.66 13.66 0 0 0 0 2.92 7.28 7.28 0 0 0 .31 2.88 12.51 12.51 0 0 0 2.06 3.85c-3.23.57-5.34 2.19-6.77 2.87C0 18.56 0 20 0 20v2.48h24V20s0-1.46-3-2.8z"
      }));

    case 'i_620':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.92 19.12a1.42 1.42 0 0 0 .08-.46V5.34a1.4 1.4 0 0 0-.08-.44l-7.82 6.7 7.82 7.52zM12 13.22l3.11-2.53L23 4a1.43 1.43 0 0 0-.4-.06H1.44A1.41 1.41 0 0 0 1 4l7.9 6.7 3.1 2.52zm10.56 6.88a1.37 1.37 0 0 0 .39-.1l-7.9-7.59L12 14.94l-3-2.48L1 20a1.46 1.46 0 0 0 .39.06h21.17zM.08 4.9a1.4 1.4 0 0 0-.08.44v13.32a1.39 1.39 0 0 0 .08.46l7.83-7.51L.08 4.9z"
      }));

    case 'i_625':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.76 19.26l-5.27-3.11a.82.82 0 0 0-.89.14L16 17.84a1.58 1.58 0 0 1-1 .4s-2 0-5.67-3.66S5.75 8.9 5.75 8.9a1.58 1.58 0 0 1 .4-1l1.32-1.28a.87.87 0 0 0 .16-.9L4.72.25A.36.36 0 0 0 4.1.13L.49 3.74a1.93 1.93 0 0 0-.49.94s-.7 5.26 6.67 12.63S19.31 24 19.31 24a2 2 0 0 0 .95-.47l3.6-3.61a.38.38 0 0 0-.1-.65z"
      }));

    case 'i_627':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11.74 22.59L24 12 11.74 1.4V8H0v8h11.74v6.6z"
      }));

    case 'i_652':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 5a3 3 0 0 0 3-2 2 2 0 0 0-2-2 3 3 0 0 0-4 2 3 3 0 0 0 3 2zm3 14V7H8v2c2 0 2 0 2 3v7c0 3 0 3-2 3v2h9v-2c-2 0-2 0-2-3z"
      }));

    case 'i_690':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 9.17C23.33 3.92 17.49.26 10.89 1S-.56 6.59.05 11.84a8.86 8.86 0 0 0 4.7 6.58c.13 1.16-.3 2.64-2.31 4.16C1.62 23.2 5.77 24 9.65 20a14.85 14.85 0 0 0 3.46 0c6.6-.73 11.45-5.58 10.89-10.83z"
      }));

    case 'i_691':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 12l-2-2 2-2 2 2zm-6 0l-2-2 2-2 2 2zm-6 0l-2-2 2-1 2 2zm18-3c-1-5-6-9-13-8S-1 7 0 12a9 9 0 0 0 5 7c0 1 0 3-2 4s3 1 7-3h3c7-1 12-6 11-11z"
      }));

    case 'i_692':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.63 8.48a.47.47 0 0 1-.25-.48 9.39 9.39 0 0 0-9.27-8h-.22a9.39 9.39 0 0 0-9.28 8 .47.47 0 0 1-.24.46S.77 9 .77 12.39v1.76c0 2.49 1.48 3.07 2.11 3.07h1.61a1.15 1.15 0 0 0 1.15-1.15V9.52A1.15 1.15 0 0 0 4.5 8.36s-.14 0-.11-.27a7.68 7.68 0 0 1 7.51-6.35h.23a7.68 7.68 0 0 1 7.51 6.35c0 .26-.11.27-.11.27a1.15 1.15 0 0 0-1.15 1.15v6.56a1.15 1.15 0 0 0 1.08 1.14H20a.2.2 0 0 1 .2.23A5 5 0 0 1 14.9 22h-.44a.26.26 0 0 1-.26-.19c-.6-1.67-3.69-1.4-3.83.42A1.65 1.65 0 0 0 11.89 24h.3a2.16 2.16 0 0 0 2-.84.21.21 0 0 1 .2-.16h.5c2.31 0 5.82-1.11 6.25-5.56a.19.19 0 0 1 .17-.21c.68 0 1.9-.62 1.9-3.08v-1.76c0-3.36-1.6-3.91-1.6-3.91z"
      }));

    case 'i_693':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.94 16.39h-3v-1.28s0-.81-1.66-1.54A13.18 13.18 0 0 0 13.5 12a6.88 6.88 0 0 0 1.14-2.13 4 4 0 0 0 .17-1.59 7.5 7.5 0 0 0 0-1.62 2.3 2.3 0 0 0-2.52-1.76 2.3 2.3 0 0 0-2.55 1.75 7.53 7.53 0 0 0 0 1.61 4 4 0 0 0 .17 1.59A6.88 6.88 0 0 0 11 12a13.27 13.27 0 0 0-3.7 1.57c-1.65.73-1.66 1.54-1.66 1.54v1.28H2.06V3.14h19.88v13.25zm.75-15.25H1.31A1.36 1.36 0 0 0 0 2.55V17a1.36 1.36 0 0 0 1.31 1.41h9.51V21H6.74a.85.85 0 0 0-.74.8.94.94 0 0 0 .74 1H18a1 1 0 0 0 .76-1A.86.86 0 0 0 18 21h-4.13v-2.61h8.81A1.36 1.36 0 0 0 24 17V2.55a1.36 1.36 0 0 0-1.31-1.41z"
      }));

    case 'i_695':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm0 21a9 9 0 1 1 9-9 9 9 0 0 1-9 9zm5.82-6.31l-4.75-3.21V6a.51.51 0 0 0-.15-.35.5.5 0 0 0-.35-.15h-1.31a.5.5 0 0 0-.5.5v6.52a.51.51 0 0 0 .15.35.47.47 0 0 0 .13.09l5.53 3.7a.51.51 0 0 0 .28.08H17a.5.5 0 0 0 .32-.22l.68-1.15a.5.5 0 0 0-.18-.68z"
      }));

    case 'i_696':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm9 12a9 9 0 0 1-2 5L7 5l5-2a9 9 0 0 1 9 9zM3 12a9 9 0 0 1 2-5l12 12-5 2a9 9 0 0 1-9-9z"
      }));

    case 'i_707':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 0a7 7 0 0 0-7 7c0 4 7 17 7 17s7-14 7-17a7 7 0 0 0-7-7zm0 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
      }));

    case 'i_912':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 13h5L12 1 0 13h5v11h5v-7h4v7h5V13z"
      }));

    case 'i_956':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.7 18l-.33-.26.35-.22h.18l4-.26c1.5-1 1.2-2.13.84-2.73h-.35c-.43 0-4.4-.18-4.6-.19h-.2l-.35-.26.32-.24h.19c.21 0 4.32-.32 4.66-.33h.73c.81-.74 1.29-1.66.29-2.6s-6.66-.78-6.84-.78L12.4 10l-.4-.14.32-.15a7.54 7.54 0 0 1 1.15-.19c-.84-2.1.66-3.64 1-4.88C15.85.48 12.74 0 12.74 0a27.78 27.78 0 0 1-5.42 9.86c-1 1.09-2.82 2.15-3.93 2.08-4-.24-4.84 10-.36 10.88.9.18 2.15-.51 3.7.1 4.08 1.62 8 .88 11.34.81 2.27 0 2.1-1.68 1.9-2.49-1.09-.06-2.18-.09-2.28-.09h-.2l-.35-.24.34-.24h.19c.12 0 1.65-.09 2.92-.19a1.63 1.63 0 0 0 .63-2.22v-.06c-1.33-.11-3.12-.2-3.22-.2h-.3z"
      }));

    case 'i_967':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.76 11.41zm15.46 0zm.7-.32l-3.46-7.72a.78.78 0 0 0-.1-.15.76.76 0 0 0-.19-.22L20 2.94a.76.76 0 0 0-.2 0H4.25a.77.77 0 0 0-.76.65L.07 11.08a.78.78 0 0 0-.07.33c0 .11.09 2.69 4.29 2.69s4.25-2.6 4.25-2.71a.78.78 0 0 0-.07-.32l-3-6.64h5.36v13.9H8.54a1 1 0 0 0-1 .82H7a1 1 0 0 0 0 1.95h10a1 1 0 0 0 0-1.93h-.58a1 1 0 0 0-1-.82h-2.3V4.45h5.39l-3 6.64a.78.78 0 0 0-.07.33c0 .11.09 2.69 4.28 2.69S24 11.51 24 11.4a.77.77 0 0 0-.07-.32zm-16.17.32h-7L4 4.39a.76.76 0 0 0 .29.06h.34zm15.46 0h-7l3.16-7h.35a.79.79 0 0 0 .32-.07l3.16 7z"
      }));

    case 'i_973':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 19zm-6-3l4 4 2 3h1l3-3-3-2-4-4h-2l-2 2zM9 9l-2 1H6a6 6 0 0 1-6-5h1l3 2a4 4 0 0 0 3-3c0-2 0-1-2-3a6 6 0 0 1 6 6H9zM2 23l-1-1v-4l7-7h6l6-6h1l3-2h1l-3 1h-2l-6 6v3h-1L6 23H2z"
      }));

    case 'i_992':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 5a2 2 0 0 0 0-3l-1-1h-3l-6 5h-2L5 1H2L1 2a2 2 0 0 0 0 3l6 6a2 2 0 0 1 0 3l-6 5a2 2 0 0 0 0 3l2 2h2l6-6h3l6 6h3l2-2a2 2 0 0 0 0-3l-6-6a2 2 0 0 1 0-3l6-6z"
      }));

    case 'i_997':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 12L6 6H0l12 12L24 6h-6z"
      }));

    case 'i_998':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 12l6 6h6L12 6 0 18h6z"
      }));

    case 'legacy_arrow_left':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.01 24.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M11.86 12L18 5.84V0L6 12l12 12v-5.83z",
        className: "cls-1"
      }));

    case 'legacy_arrow_right':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.01 24.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M12.16 12L6 18.17V24l12-12L6 0v5.84z",
        className: "cls-1"
      }));

    case 'legacy_check':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 17.67"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M.28 14a1 1 0 0 1 0-1.36l2.4-2.4a1 1 0 0 1 1.36 0l3.9 3.89a1 1 0 0 0 1.36 0L20 3.45a1 1 0 0 1 1.36 0l2.39 2.37a1 1 0 0 1 0 1.36l-13 13a2.67 2.67 0 0 1-1.64.68H8a2.66 2.66 0 0 1-1.64-.68L.28 14z",
        className: "cls-1",
        transform: "translate(0 -3.17)"
      }));

    case 'legacy_clock':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 21c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm5.8-6.3l-4.7-3.2V6c0-.1-.1-.3-.1-.4-.1-.1-.2-.1-.4-.1h-1.3c-.1 0-.3.1-.4.1s-.1.2-.1.4v6.5c0 .1.1.3.1.4l.1.1 5.5 3.7c.1.1.2.1.3.1h.1c.1 0 .2-.1.3-.2l.7-1.1c.2-.4.1-.7-.1-.8z",
        className: "st0"
      }));

    case 'legacy_home':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 23.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M19.39 12.49H24l-12-12-12 12h4.46v11h5.33v-6.83h4.45v6.84h5.16v-11z",
        className: "cls-1",
        transform: "translate(0 -.49)"
      }));

    case 'legacy_info':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.7 5.1c1.6 0 2.8-1.3 2.8-2.9v-.1c0-.5-.2-1.1-.5-1.5-.3-.3-.9-.6-1.5-.6h-.1c-1.5 0-2.8 1.2-2.8 2.8-.1 1.2.7 2.2 1.8 2.3h.3zm2.9 14.3l-.8-1.6-.1.2c-.7.7-1.5 1.3-2.4 1.8h-.1v-.1-.1c0-.3 0-.6.1-.9l1.9-7.9c.2-.8.2-1.6.3-2.4v-.1c0-.4-.1-.8-.3-1.1-.2-.3-.5-.5-.9-.5h-.1c-1.4 0-4.4 1.9-6.8 4.2l-.1.1.7 1.9.3-.2c.7-.6 1.4-1.1 2.2-1.6l.1-.1c0 .3-.1.6-.1.9l-1.8 7.6c-.2.8-.3 1.7-.3 2.5v.2c0 .5.2 1 .5 1.3.3.3.6.4 1 .4h.1c1.2 0 4.2-1.6 6.6-4.3l.1-.1-.1-.1z",
        className: "st0"
      }));

    case 'legacy_lock':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M14.61 10.58V6.9A6.11 6.11 0 0 0 8.5.79h-.23A6.11 6.11 0 0 0 2.16 6.9v3.68H0v12.64h16.83V10.58h-2.22zM5.22 6.9a3.06 3.06 0 0 1 3.05-3.06h.23a3.06 3.06 0 0 1 3.05 3.06v3.68H5.22V6.9z",
        className: "cls-1"
      }));

    case 'legacy_lock_open':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 22.43"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M17.89.79h-.23a6.11 6.11 0 0 0-6.1 6.11v3.68H0v12.64h16.83V10.58h-2.22V6.9a3.05 3.05 0 0 1 3.05-3.05h.23a3.06 3.06 0 0 1 3.05 3.05v1.47h1v.39l-1 1v.85H24V6.9A6.11 6.11 0 0 0 17.89.78z",
        className: "cls-1",
        transform: "translate(0 -.78)"
      }));

    case 'legacy_mail':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.01 24.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M23.91 19.12a1.42 1.42 0 0 0 .09-.45V5.35a1.4 1.4 0 0 0-.08-.44L16.1 11.6l7.81 7.51zM12 13.22l3.1-2.52L23 4a1.43 1.43 0 0 0-.41 0H1.45A1.41 1.41 0 0 0 1 4l7.9 6.69 3.1 2.53zm10.56 6.88A1.37 1.37 0 0 0 23 20l-7.89-7.58L12 14.94l-3-2.48L1.06 20a1.46 1.46 0 0 0 .39.06h21.11zM.09 4.92a1.4 1.4 0 0 0-.09.43v13.32a1.39 1.39 0 0 0 .08.46l7.82-7.5L.09 4.91z",
        className: "cls-1"
      }));

    case 'legacy_mail_yellow':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.01 24.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M23.91 19.12a1.42 1.42 0 0 0 .09-.45V5.35a1.4 1.4 0 0 0-.08-.44L16.1 11.6l7.81 7.51zM12 13.22l3.1-2.52L23 4a1.43 1.43 0 0 0-.41 0H1.45A1.41 1.41 0 0 0 1 4l7.9 6.69 3.1 2.53zm10.56 6.88A1.37 1.37 0 0 0 23 20l-7.89-7.58L12 14.94l-3-2.48L1.06 20a1.46 1.46 0 0 0 .39.06h21.11zM.09 4.92a1.4 1.4 0 0 0-.09.43v13.32a1.39 1.39 0 0 0 .08.46l7.82-7.5L.09 4.91z",
        className: "cls-1"
      }));

    case 'legacy_search':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.3 20.4L16.9 14c2.7-4.3 1.4-9.9-2.8-12.6S4.2 0 1.5 4.2 0 14.1 4.3 16.8c3 1.9 6.7 1.9 9.7 0l6.4 6.4c.4.4 1 .7 1.6.7 1.1 0 2-.8 2-1.9v-.1c0-.4-.2-1-.7-1.5zm-9-11.3c0 2.8-2.3 5.1-5.1 5.1s-5.1-2.3-5.1-5.1S6.3 4 9.2 4c2.8 0 5.1 2.3 5.1 5.1z",
        className: "st0"
      }));

    case 'legacy_simple_arrow_down':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.01 24.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M24 5.37H0l12 13.28z",
        className: "cls-1"
      }));

    case 'legacy_simple_arrow_up':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24.01 24.01"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M0 18.65h24L12 5.37z",
        className: "cls-1"
      }));

    case 'logo_cb_simple':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 234 32"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        fill: "#fff",
        d: "M233.1 16.7l-5.3 9.3c0-.1 0-.2-.1-.3-.1-.3-.8-2.5-1-3.1v-.1c-.4-1.2-1-2.1-1.3-2.7-1.4-2.4-4.1-7-4.1-7s-2.7-4.6-4.1-7c-.1-.1-.2-.3-.3-.4.6-.7 1.8-2.1 2-2.3.8-.9 1.7-1.6 2.6-2 .8-.4 1.5-.4 2-.4h.2l9.4 16zm-7.5 12.1c-.1.9-.4 1.6-.6 2l-.1.2h-18.7l-5.3-9.2c.1 0 .2.1.3.1.3.1 2.5.5 3.2.7h.1c1.2.2 2.3.2 3 .2h16.7c.3.8.9 2.6 1 2.8.4 1.1.6 2.2.4 3.2zm-10-25.6c-.8.9-1.4 1.9-1.7 2.5-1.4 2.4-4.1 7-4.1 7s-2.7 4.6-4.1 7c-.1.1-.2.3-.3.4-.8-.2-2.8-.5-3-.5-1.2-.2-2.2-.6-3.1-1.3-.7-.5-1.2-1.1-1.4-1.5l-.1-.2.3-.5L207.2.4H218l-.2.2c-.2.3-1.7 2-2.2 2.6zM8.9 25.6c2.6 0 4.6-.9 6.1-2.6l-2.2-2.3c-.9 1-2.1 1.5-3.6 1.5-2.6 0-4.4-2.2-4.4-5.1 0-2.8 1.8-5.1 4.3-5.1 1.3 0 2.5.5 3.4 1.4l2.3-2.4c-1.4-1.5-3.4-2.4-5.7-2.4-4.6 0-8.4 3.8-8.4 8.6.1 4.9 3.7 8.4 8.2 8.4zm15.9-3.4c-2.8 0-4.7-2.2-4.7-5.2 0-2.8 1.8-5.1 4.7-5.1 2.8 0 4.7 2.3 4.7 5.2 0 2.8-1.8 5.1-4.7 5.1zm-.1 3.4c4.9 0 8.6-3.8 8.6-8.6s-3.5-8.4-8.5-8.4c-4.9 0-8.6 3.9-8.6 8.6 0 4.8 3.5 8.4 8.5 8.4zm22.4-.3l2.8-9c.5-1.6.9-3.4.9-3.4h.1s0 1.8.2 3.6l.7 8.8h3.6L53.8 8.8H49L46.5 17c-.4 1.3-.8 3-.8 3s-.4-1.7-.9-3l-2.5-8.1h-4.9l-1.6 16.4h3.4l.7-8.9c.2-1.7.2-3.5.2-3.5h.1s.4 1.8.9 3.4l2.8 8.9 3.2.1zm23 0l2.8-9c.5-1.6.9-3.4.9-3.4h.1s0 1.8.2 3.6l.7 8.8h3.6L76.8 8.8H72L69.5 17c-.4 1.3-.8 3-.8 3s-.4-1.7-.9-3l-2.5-8.1h-4.9l-1.6 16.4h3.4l.7-8.9c.2-1.7.2-3.5.2-3.5h.1s.4 1.8.9 3.4l2.8 8.9 3.2.1zm12.3 0h10.7v-3.1H86v-3.6h6v-3.1h-6V12h7V8.9H82.4v16.4zm23.1-11.2c0 1.5-1 2.2-3 2.2H101v-4.4h1.5c1.9 0 3 .6 3 2.2zm4.4 11.2l-4.1-6.6c2.1-.8 3.3-2.4 3.3-4.5 0-3.3-1.9-5.3-6.9-5.3h-4.9v16.4h3.6v-6h1.1l3.5 6h4.4zm2.1 0h11.5v-3.1h-7l6.8-10.6V8.9h-11.2V12h6.7L112 22.6v2.7zm18.8-6.8h2.7c1.6 0 2.6.5 2.6 1.8s-.8 1.9-2.6 1.9h-2.7v-3.7zm0-6.6h2.1c1.1 0 2.3.4 2.3 1.7 0 1.3-1 1.8-2.1 1.8h-2.2v-3.5zm-3.6 13.4h6.3c2.9 0 6.2-1.3 6.2-4.7 0-2.1-1.4-3.5-3.5-3.8 1.7-.5 2.8-1.8 2.8-3.6 0-3.6-3.2-4.2-6-4.2h-5.7l-.1 16.3zm17.4 0l1.1-3.4h6.4l1.1 3.4h3.9l-5.9-16.4h-4.5L141 25.3h3.6zm6.5-6.4h-4.3l1.5-4.3c.4-1.2.7-2.3.7-2.3s.3 1.1.7 2.3l1.4 4.3zm8.3 6.4h3.3v-7.8c0-1.5-.1-3-.1-3l1.6 2.6 5.6 8.2h3.2V8.9h-3.3v7.4c0 1.5.1 3 .1 3l-1.6-2.6-5.3-7.8h-3.4l-.1 16.4zm17.7-16.4v16.4h3.6v-7.7l5.3 7.7h4.4l-6.1-8.8 5.5-7.6h-4.1l-5 7.4V8.9h-3.6z"
      }));

    case 'logo_coba_band':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 184.73 160"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null, React.createElement("radialGradient", {
        cx: "105.06",
        cy: "92.83",
        r: "36.47",
        gradientTransform: "matrix(3.91 0 0 3.91 -258.57 -221.2)",
        gradientUnits: "userSpaceOnUse"
      }, React.createElement("stop", {
        offset: "0",
        "stop-color": "#ffe319"
      }), React.createElement("stop", {
        offset: ".2",
        "stop-color": "#fdd70d"
      }), React.createElement("stop", {
        offset: ".48",
        "stop-color": "#facb00"
      }), React.createElement("stop", {
        offset: ".63",
        "stop-color": "#f8c700"
      }), React.createElement("stop", {
        offset: ".78",
        "stop-color": "#f1bb00"
      }), React.createElement("stop", {
        offset: ".89",
        "stop-color": "#eaae00"
      }), React.createElement("stop", {
        offset: ".92",
        "stop-color": "#e4a500"
      }), React.createElement("stop", {
        offset: "1",
        "stop-color": "#d89300"
      })), React.createElement("radialGradient", {
        cx: "95.31",
        cy: "56.57",
        r: "36.4",
        xlinkHref: "#Neues_Verlaufsfeld_2"
      }), React.createElement("radialGradient", {
        cx: "69.03",
        cy: "83.22",
        r: "36.31",
        xlinkHref: "#Neues_Verlaufsfeld_2"
      }), React.createElement("radialGradient", {
        cx: "105.06",
        cy: "92.68",
        r: "36.47",
        xlinkHref: "#Neues_Verlaufsfeld_2"
      })), React.createElement("g", null, React.createElement("path", {
        d: "M103.62 5A28.25 28.25 0 0 1 115.15.6c2.6-.28 11.15-.17 20.9-.17a.14.14 0 0 1 .1.06l-.26-.43A1.58 1.58 0 0 0 135 0h-18.42C114 0 104 0 92.47 14l.45.54A51.57 51.57 0 0 1 103.62 5z",
        className: "cls-1",
        transform: "translate(-.27)"
      }), React.createElement("path", {
        d: "M121.86 0H49.48a.12.12 0 0 0-.1 0L13.14 62.83 1.77 82.51.45 84.8l-.17.29a.08.08 0 0 0 0 .11l34.88 60.42a6.72 6.72 0 0 0-.37-.88c-.73-1.37-1.28-2.43-1.58-3.1a28.18 28.18 0 0 1-2-12.18c.58-11.58 6.73-23 9.81-28.36 7.27-12.58 21.31-36.89 21.31-36.89s14-24.32 21.29-36.9c3.09-5.31 9.92-16.39 19.64-22.68A28.29 28.29 0 0 1 114.85.3c1.17-.13 3.57-.2 6.74-.24.26-.06.27-.06.27-.06z",
        className: "cls-2",
        transform: "translate(-.27)"
      }), React.createElement("path", {
        d: "M177.84 97.46c-1.63 2.74-2.9 4.78-3.59 5.72a28.24 28.24 0 0 1-9.53 7.86c-10.33 5.29-23.29 5.66-29.48 5.66H50c-6.18 0-19.15-.37-29.47-5.66a28.27 28.27 0 0 1-9.53-7.86c-.69-.95-2-3-3.58-5.71a.46.46 0 0 0-.2-.22l3.61 6.24L43.45 160a.17.17 0 0 0 .1 0h98.17a.09.09 0 0 0 .09-.05L178 97.23a.46.46 0 0 0-.16.23z",
        className: "cls-3",
        transform: "translate(-.27)"
      }), React.createElement("path", {
        d: "M185 85.07l-49.1-85a.09.09 0 0 0-.09-.07h-14l-.25.06c-3.17 0-5.57.11-6.74.24a28.29 28.29 0 0 0-11.59 4.33 49.65 49.65 0 0 0-10.62 9.62 87.82 87.82 0 0 1 9 13.06L123 64.21s14 24.31 21.29 36.89c3.09 5.35 9.25 16.77 9.82 28.36a28.4 28.4 0 0 1-2 12.18c-.47 1.08-1.62 3.2-3.17 6a.68.68 0 0 0-.11.31L185 85.17a.19.19 0 0 0 0-.1z",
        className: "cls-4",
        transform: "translate(-.27)"
      })));

    case 'logo_coba_band_dark_theme':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 184.71 160"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M184.71 85.08l-49.09-85a.12.12 0 0 0-.1-.06h-4a30.93 30.93 0 0 0-12.25 2.64 42 42 0 0 0-15.1 11.65l-6.31 7.32c1.46 2.19 2.63 4.18 3.51 5.69l21.3 36.89s14 24.31 21.3 36.89a89.8 89.8 0 0 1 6.8 14.34c.68 1.85 3 8.67 3.88 12a53.43 53.43 0 0 1 1.43 7.35l28.62-49.57a.14.14 0 0 0 .01-.14zM143.56 156.45a30.91 30.91 0 0 0 3.84-11.92 41.88 41.88 0 0 0-2.54-18.91c-.19-.54-2-5.55-3.23-9.1-2.64.16-4.93.19-6.68.19H49.76a89.08 89.08 0 0 1-15.82-1.27c-1.94-.33-9-1.74-12.3-2.63a50.94 50.94 0 0 1-7.09-2.43L43.18 160a.09.09 0 0 0 .09 0h98.18a.14.14 0 0 0 .09 0l2-3.5zM92.36 14.26c1.26-1.51 6-6.92 8.42-9.34A54.41 54.41 0 0 1 106.44 0H49.2a.12.12 0 0 0-.1.06L1.5 82.51.01 85.09a.21.21 0 0 0 0 .11l2 3.48A30.91 30.91 0 0 0 10.44 98a41.87 41.87 0 0 0 17.65 7.26l9.48 1.74c1.17-2.37 2.29-4.36 3.17-5.89l21.3-36.89 21.3-36.89a89.12 89.12 0 0 1 9-13.06z",
        className: "cls-1"
      }));

    case 'logo_coba_default':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1200 160"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null, React.createElement("radialGradient", {
        cx: "742.78",
        cy: "92.85",
        r: "36.47",
        gradientTransform: "matrix(3.91 0 0 3.91 -1736.04 -221.2)",
        gradientUnits: "userSpaceOnUse"
      }, React.createElement("stop", {
        offset: "0",
        "stop-color": "#ffe319"
      }), React.createElement("stop", {
        offset: ".2",
        "stop-color": "#fdd70d"
      }), React.createElement("stop", {
        offset: ".48",
        "stop-color": "#facb00"
      }), React.createElement("stop", {
        offset: ".63",
        "stop-color": "#f8c700"
      }), React.createElement("stop", {
        offset: ".78",
        "stop-color": "#f1bb00"
      }), React.createElement("stop", {
        offset: ".89",
        "stop-color": "#eaae00"
      }), React.createElement("stop", {
        offset: ".92",
        "stop-color": "#e4a500"
      }), React.createElement("stop", {
        offset: "1",
        "stop-color": "#d89300"
      })), React.createElement("radialGradient", {
        cx: "733.03",
        cy: "56.59",
        r: "36.4",
        xlinkHref: "#Neues_Verlaufsfeld_2"
      }), React.createElement("radialGradient", {
        cx: "706.75",
        cy: "83.25",
        r: "36.31",
        xlinkHref: "#Neues_Verlaufsfeld_2"
      }), React.createElement("radialGradient", {
        cx: "742.78",
        cy: "92.7",
        r: "36.47",
        xlinkHref: "#Neues_Verlaufsfeld_2"
      })), React.createElement("g", null, React.createElement("path", {
        d: "M1118.62 5.07A28.25 28.25 0 0 1 1130.15.7c2.6-.28 11.15-.17 20.9-.17a.14.14 0 0 1 .1.06l-.26-.43a1.58 1.58 0 0 0-.89-.06h-18.46c-2.58 0-12.56 0-24.11 14l.45.54a51.57 51.57 0 0 1 10.74-9.57z",
        className: "cls-1",
        transform: "translate(0 -.1)"
      }), React.createElement("path", {
        d: "M1136.86.1h-72.38a.12.12 0 0 0-.1 0l-36.24 62.78-11.37 19.68-1.32 2.29-.17.29a.08.08 0 0 0 0 .11l34.88 60.43a6.72 6.72 0 0 0-.37-.88c-.73-1.37-1.28-2.43-1.58-3.1a28.18 28.18 0 0 1-2-12.18c.58-11.58 6.73-23 9.81-28.36 7.27-12.58 21.31-36.89 21.31-36.89s14-24.32 21.29-36.9c3.09-5.35 9.92-16.39 19.64-22.68A28.29 28.29 0 0 1 1129.85.4c1.17-.13 3.57-.2 6.74-.24.26-.01.27-.01.27-.06z",
        className: "cls-2",
        transform: "translate(0 -.1)"
      }), React.createElement("path", {
        d: "M1192.84 97.55c-1.63 2.74-2.9 4.78-3.59 5.72a28.24 28.24 0 0 1-9.53 7.86c-10.33 5.29-23.29 5.66-29.48 5.66H1065c-6.18 0-19.15-.37-29.47-5.66a28.27 28.27 0 0 1-9.53-7.86c-.69-.95-2-3-3.58-5.71a.46.46 0 0 0-.2-.22l3.61 6.24 32.59 56.48a.17.17 0 0 0 .1 0h98.17a.09.09 0 0 0 .09-.05L1193 97.33a.46.46 0 0 0-.16.22z",
        className: "cls-3",
        transform: "translate(0 -.1)"
      }), React.createElement("path", {
        d: "M1200 85.17l-49.1-85a.09.09 0 0 0-.09-.05h-14l-.25.06c-3.17 0-5.57.11-6.74.24a28.29 28.29 0 0 0-11.59 4.33 49.65 49.65 0 0 0-10.62 9.63 87.82 87.82 0 0 1 9 13.06L1138 64.31s14 24.31 21.29 36.89c3.09 5.35 9.25 16.77 9.82 28.36a28.4 28.4 0 0 1-2 12.18c-.47 1.08-1.62 3.2-3.17 6a.68.68 0 0 0-.11.31L1200 85.27a.19.19 0 0 0 0-.1z",
        className: "cls-4",
        transform: "translate(0 -.1)"
      })), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
        d: "M42 131.59c13.25 0 23.46-4.77 31.28-13.72l-11.51-11.81c-4.79 5.12-10.85 7.81-18.68 7.81-13.56 0-22.66-11.31-22.66-26.49C20.43 72.7 29.69 61 42.77 61a24.66 24.66 0 0 1 17.56 7.19l12-12.44a39.31 39.31 0 0 0-29.24-12.43C19.16 43.32 0 63.12 0 87.86c0 25.87 18.83 43.73 42 43.73zM123.92 114.2c-14.69 0-24.11-11.64-24.11-26.82 0-14.36 9.1-26.66 24.11-26.66 14.68 0 24.1 11.66 24.1 26.81 0 14.38-9.1 26.67-24.1 26.67zm-.33 17.39a44 44 0 0 0 44.53-44.53c0-24.89-18-43.74-43.89-43.74a44.05 44.05 0 0 0-44.52 44.54c0 24.91 18 43.73 43.89 43.73zM239 130l14.37-46.77c2.55-8.14 4.46-17.39 4.46-17.39h.32s.16 9.25 1 18.52L262.9 130h18.82l-8.29-85.23h-24.74l-12.93 42.29c-2.07 6.88-4.31 15.65-4.31 15.65s-2.22-8.77-4.45-15.81l-13.11-42.13h-25.22L180.38 130h17.71l3.84-46c.79-8.94 1-18.19 1-18.19h.32s2.08 9.25 4.63 17.72L222.19 130H239zM357.86 130l14.36-46.77c2.56-8.14 4.48-17.39 4.48-17.39h.3s.17 9.25 1 18.52l3.8 45.64h18.84l-8.31-85.23H367.6l-12.93 42.29c-2.08 6.88-4.31 15.65-4.31 15.65s-2.24-8.78-4.47-15.81L332.8 44.77h-25.22l-8.3 85.23H317l3.83-46c.8-8.94 1-18.19 1-18.19h.32s2.07 9.25 4.63 17.72L341.1 130h16.76z",
        transform: "translate(0 -.1)"
      }), React.createElement("path", {
        d: "M421.03 129.9h55.39v-16.27h-36.87V94.95h31.28V78.98h-31.28V60.94h36.39V44.68h-54.91v85.22z"
      }), React.createElement("path", {
        d: "M540.19 72.07c0 8-5.26 11.34-15.65 11.34h-7.65V60.72h7.65c9.91 0 15.65 3 15.65 11.35zM563 130l-20.9-34.32c11-4.15 17.24-12.6 17.24-23.61 0-17.25-9.74-27.29-35.43-27.29h-25.54V130h18.52V99h5.9L541 130h22z",
        transform: "translate(0 -.1)"
      }), React.createElement("path", {
        d: "M573.95 129.9h59.37v-16.27h-36.08l35.28-54.9V44.68h-57.77v16.26h34.46l-35.26 54.92v14.04z"
      }), React.createElement("path", {
        d: "M671 94.89h13.74c8.29 0 13.57 2.55 13.57 9.25 0 6.54-4.14 9.89-13.57 9.89H671V94.89zm0-34.17h10.71c5.89 0 11.8 1.93 11.8 9 0 6.86-5.1 9.56-11 9.56H671V60.72zM652.54 130h32.57c15.16 0 32.08-6.86 32.08-24.58 0-11-7-18.36-18.18-19.79v-.16c8.76-2.71 14.2-9.41 14.2-18.83 0-18.52-16.29-21.87-31.14-21.87h-29.53V130zM742.07 130l5.93-17.39h33.2l5.87 17.39H807l-30.32-85.23h-23L723.37 130h18.69zm33.67-33.35h-22.36l7.51-22.51C763 67.75 764.57 62 764.57 62s1.6 5.74 3.67 12l7.5 22.67zM818.59 130h17.25V89.46c0-7.66-.48-15.48-.48-15.48s4 6.86 8.45 13.55L872.69 130h16.44V44.77h-17.24v38.64c0 7.63.5 15.48.5 15.48s-4-6.87-8.47-13.58l-27.61-40.54h-17.72V130z",
        transform: "translate(0 -.1)"
      }), React.createElement("path", {
        d: "M909.62 44.68v85.22h18.52V90l27.3 39.9h22.82l-31.27-45.64 28.24-39.58h-21.39l-25.7 38.31V44.68h-18.52z"
      }))));

    case 'logo_coba_default_dark_theme':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1201 160.13"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
        d: "M42 131.78c13.26 0 23.48-4.78 31.31-13.73l-11.5-11.83C57 111.34 51 114 43.13 114c-13.57 0-22.68-11.32-22.68-26.51 0-14.69 9.26-26.37 22.36-26.37a24.68 24.68 0 0 1 17.58 7.19l12-12.45a39.33 39.33 0 0 0-29.26-12.43C19.17 43.43 0 63.25 0 88c0 25.89 18.85 43.77 42 43.77zM124 114.37c-14.7 0-24.13-11.66-24.13-26.84C99.9 73.16 109 60.85 124 60.85c14.69 0 24.12 11.67 24.12 26.83 0 14.39-9.11 26.7-24.12 26.7zm-.33 17.41c25.4 0 44.57-20 44.57-44.57 0-24.91-18-43.78-43.92-43.78A44.09 44.09 0 0 0 79.77 88c0 24.93 18.05 43.77 43.92 43.77zM239.15 130.19l14.38-46.81C256.08 75.23 258 66 258 66h.33s.16 9.26 1 18.53l3.84 45.68H282l-8.3-85.3h-24.8L236 87.21c-2.07 6.88-4.31 15.67-4.31 15.67s-2.23-8.79-4.48-15.82l-13.1-42.16h-25.28l-8.3 85.3h17.73l3.84-46c.79-9 1-18.21 1-18.21h.32s2.08 9.26 4.63 17.74l14.38 46.48h16.77zM358.16 130.19l14.38-46.81C375.09 75.23 377 66 377 66h.31s.17 9.26 1 18.53l3.84 45.68H401l-8.31-85.3H367.9L355 87.21c-2.08 6.88-4.31 15.67-4.31 15.67s-2.24-8.79-4.48-15.82l-13.1-42.16h-25.27l-8.31 85.3h17.73l3.84-46c.8-9 1-18.21 1-18.21h.32s2.07 9.26 4.63 17.74l14.38 46.48h16.78z",
        className: "cls-1",
        transform: "translate(0 -.08)"
      }), React.createElement("path", {
        d: "M421.38 130.11h55.43v-16.28h-36.9v-18.7h31.31V79.15h-31.31V61.09h36.42V44.81h-54.95v85.3z",
        className: "cls-1"
      }), React.createElement("path", {
        d: "M540.64 72.21c0 8-5.27 11.35-15.66 11.35h-7.66V60.85H525c9.91 0 15.66 3 15.66 11.36zm22.84 58l-20.93-34.37c11-4.15 17.25-12.61 17.25-23.63 0-17.26-9.75-27.32-35.46-27.32h-25.55v85.3h18.53v-31h5.91l18.21 31h22z",
        className: "cls-1",
        transform: "translate(0 -.08)"
      }), React.createElement("path", {
        d: "M574.43 130.11h59.41v-16.28h-36.1l35.31-54.95V44.81h-57.82v16.28h34.49l-35.29 54.97v14.05z",
        className: "cls-1"
      }), React.createElement("path", {
        d: "M671.61 95h13.75c8.3 0 13.58 2.55 13.58 9.26 0 6.54-4.14 9.9-13.58 9.9h-13.75V95zm0-34.2h10.72c5.89 0 11.81 1.93 11.81 9 0 6.86-5.1 9.57-11 9.57h-11.53V60.85zm-18.52 69.34h32.6c15.17 0 32.11-6.86 32.11-24.6 0-11-7-18.37-18.2-19.81v-.11c8.76-2.72 14.21-9.41 14.21-18.84 0-18.53-16.3-21.88-31.16-21.88h-29.57v85.3zM742.68 130.19l5.89-17.41h33.23l5.91 17.41h20l-30.35-85.3h-23L724 130.19h18.71zm33.7-33.38H754l7.52-22.53c2.07-6.39 3.68-12.14 3.68-12.14s1.6 5.75 3.67 12l7.51 22.68zM819.27 130.19h17.26V89.61c0-7.66-.48-15.49-.48-15.49s4 6.86 8.45 13.56l28.91 42.51h16.45v-85.3h-17.25v38.66c0 7.64.5 15.49.5 15.49s-4-6.87-8.48-13.6L837 44.89h-17.73v85.3z",
        className: "cls-1",
        transform: "translate(0 -.08)"
      }), React.createElement("path", {
        d: "M910.38 44.81v85.3h18.53V90.17l27.32 39.94h22.84l-31.3-45.68 28.27-39.62h-21.41l-25.72 38.35V44.81h-18.53z",
        className: "cls-1"
      }))), React.createElement("path", {
        d: "M1201 85.23L1151.86.13a.12.12 0 0 0-.1-.06h-4a31 31 0 0 0-12.26 2.64 42 42 0 0 0-15.12 11.66l-6.27 7.34c1.46 2.19 2.63 4.18 3.51 5.7l21.32 36.92s14 24.33 21.32 36.92a89.88 89.88 0 0 1 6.81 14.36c.68 1.85 3 8.68 3.88 12a53.48 53.48 0 0 1 1.43 7.36L1201 85.33a.14.14 0 0 0 0-.1zM1159.81 156.66a30.94 30.94 0 0 0 3.85-11.93 41.92 41.92 0 0 0-2.53-18.93c-.19-.54-2-5.56-3.23-9.1-2.64.16-4.94.19-6.69.19h-85.27a89.15 89.15 0 0 1-15.83-1.28c-1.94-.33-9-1.74-12.31-2.63a51 51 0 0 1-7.1-2.44l28.65 49.62a.09.09 0 0 0 .09 0h98.26a.14.14 0 0 0 .09 0l2-3.5zM1108.57 14.34c1.26-1.51 6-6.93 8.43-9.34a54.46 54.46 0 0 1 5.65-4.92h-57.28a.12.12 0 0 0-.1.06l-47.64 82.52-1.49 2.58a.21.21 0 0 0 0 .11l2 3.49a30.94 30.94 0 0 0 8.41 9.3 41.91 41.91 0 0 0 17.66 7.26l9.5 1.76c1.17-2.37 2.3-4.37 3.17-5.9l21.32-36.92 21.32-36.92a89.19 89.19 0 0 1 9-13.07z",
        className: "cls-1",
        transform: "translate(0 -.08)"
      }));

    case 'ribbon_cb_simple':
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 28"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M31.4 14.8l-4.7 8c0-.1 0-.2-.1-.3-.1-.2-.7-2.1-.9-2.7v-.1c-.4-1-.8-1.8-1.1-2.4-1.2-2.1-3.6-6.1-3.6-6.1s-2.3-4-3.6-6.1c-.1-.1-.1-.2-.2-.4.5-.6 1.6-1.8 1.7-2 .7-.8 1.5-1.4 2.3-1.7.8-.1 1.4-.1 1.8-.1h.2l8.2 13.9zm-6.6 10.5c-.1.8-.3 1.3-.5 1.7l-.1.1H7.8l-4.7-8c.1 0 .2 0 .3.1.2.1 2.2.5 2.8.6h.1c1 .2 2 .2 2.6.2h14.6c.3.7.8 2.3.9 2.4.4 1.1.5 2 .4 2.9zM16 3.2c-.7.8-1.2 1.6-1.5 2.1-1.2 2.1-3.5 6.1-3.5 6.1s-2.3 4-3.6 6.1c-.1.1-.1.2-.2.4-.7-.1-2.4-.4-2.6-.5-1.1-.2-2-.6-2.7-1.1-.6-.5-1-1-1.2-1.3l-.1-.1.2-.4L8.8.9h9.3s-.1.1-.1.2c-.2.1-1.6 1.6-2 2.1z"
      }));

    case 'banking_card_addCard':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15 8a7 7 0 1 0-7 7 7 7 0 0 0 7-7zM3 8a5 5 0 1 1 5 5 5 5 0 0 1-5-5z"
      }), React.createElement("path", {
        d: "M21 10h-5v2h5v4H5v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H7v-2h14zM9 11V9h2V7H9V5H7v2H5v2h2v2h2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 10h-5v2h5v4H5v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H7v-2h14z"
      }), React.createElement("path", {
        d: "M15 8a7 7 0 1 0-7 7 7 7 0 0 0 7-7zM4 9V7h3V4h2v3h3v2H9v3H7V9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30 16a14 14 0 1 0-14 14 14 14 0 0 0 14-14zM4 16a12 12 0 1 1 12 12A12 12 0 0 1 4 16z"
      }), React.createElement("path", {
        d: "M42 20H32v2h10a2 2 0 0 1 2 2v10H12v-2h-2v8a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4zm0 22H14a2 2 0 0 1-2-2v-2h32v2a2 2 0 0 1-2 2zM17 25v-8h8v-2h-8V7h-2v8H7v2h8v8h2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 20H32v2h10a2 2 0 0 1 2 2v10H12v-2h-2v8a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4zm0 22H14a2 2 0 0 1-2-2v-2h32v2a2 2 0 0 1-2 2z"
      }), React.createElement("path", {
        d: "M30 16a14 14 0 1 0-14 14 14 14 0 0 0 14-14zM7 17v-2h8V7h2v8h8v2h-8v8h-2v-8z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M60 32a28 28 0 1 0-28 28 28 28 0 0 0 28-28zM8 32a24 24 0 1 1 24 24A24 24 0 0 1 8 32z"
      }), React.createElement("path", {
        d: "M34 50V34h16v-4H34V14h-4v16H14v4h16v16h4zM84 40H64v4h20a4 4 0 0 1 4 4v20H24v-4h-4v16a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8zm0 44H28a4 4 0 0 1-4-4v-4h64v4a4 4 0 0 1-4 4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M60 32a28 28 0 1 0-28 28 28 28 0 0 0 28-28zm-46 2v-4h16V14h4v16h16v4H34v16h-4V34z"
      }), React.createElement("path", {
        d: "M84 40H64v4h20a4 4 0 0 1 4 4v20H24v-4h-4v16a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8zm0 44H28a4 4 0 0 1-4-4v-4h64v4a4 4 0 0 1-4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15 8a7 7 0 1 0-7 7 7 7 0 0 0 7-7zM3 8a5 5 0 1 1 5 5 5 5 0 0 1-5-5z"
      }), React.createElement("path", {
        d: "M21 10h-5v2h5v4H5v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H7v-2h14zM9 11V9h2V7H9V5H7v2H5v2h2v2h2z"
      }));

    case 'banking_card_blockCard':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 18v-2h9l-1.21-2H3V6h2.94l-1.2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11.38l-1.21-2zM21 4H9.42L7.61 1 5.89 2l12.5 20.75 1.72-1L19.06 20H21a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 14h-3.14l-1.21-2H21zm0-4h-5.55l-4.82-8H21z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.74 4H3a2 2 0 0 0-2 2v8h9.76zM1 16v2a2 2 0 0 0 2 2h11.38L12 16zM23 14V6a2 2 0 0 0-2-2H9.42L7.61 1 5.89 2l12.5 20.75 1.72-1L19.06 20H21a2 2 0 0 0 2-2v-2h-6.35l-1.2-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 8H15.68l-3.32-5.52-1.72 1 25 41.5 1.72-1L35 40h7a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4zm2 28a2 2 0 0 1-2 2h-8.25l-3.61-6H44zm0-8H27.73L16.88 10H42a2 2 0 0 1 2 2zM6 38a2 2 0 0 1-2-2v-4h19.64l-2.41-4H4V12a2 2 0 0 1 2-2h4.38l-1.2-2H6a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h22.45l-1.2-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 32v-4h17.23L9.18 8H6a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h22.45l-4.81-8zM42 8H15.68l-3.32-5.52-1.72 1 25 41.5 1.72-1L35 40h7a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4zm2 24H30.14l-2.41-4H44z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 25v3h2v-3h10.78l-1.21-2H13a2 2 0 0 0-2 2z"
      }), React.createElement("path", {
        d: "M12 76a4 4 0 0 1-4-4v-8h39.27l-4.82-8H8V24a4 4 0 0 1 4-4h8.76l-2.41-4H12a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h44.91l-2.41-4zM84 16H31.36L24.71 5l-3.42 2 50 83 3.42-2-4.8-8H84a8 8 0 0 0 8-8V24a8 8 0 0 0-8-8zm4 56a4 4 0 0 1-4 4H67.5l-7.23-12H88zm0-16H55.46L36.78 25H82v-2H35.58l-1.81-3H84a4 4 0 0 1 4 4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 16H31.36L24.71 5l-3.42 2 50 83 3.42-2-4.8-8H84a8 8 0 0 0 8-8V24a8 8 0 0 0-8-8zm0 5v2H35.58l-1.21-2zm4 43H60.27l-4.81-8H88zM8 64v-8h34.45L22.57 23H11v3H9v-3a2 2 0 0 1 2-2h10.37l-3-5H12a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h44.91l-9.64-16z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 18v-2h9l-1.21-2H3V6h2.94l-1.2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11.38l-1.21-2zM21 4H9.42L7.61 1 5.89 2l12.5 20.75 1.72-1L19.06 20H21a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 14h-3.14l-1.21-2H21zm0-4h-5.55l-4.82-8H21z"
      }));

    case 'banking_card_multipleCards':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 12V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM3 4h14v8H3z"
      }), React.createElement("path", {
        d: "M21 10h-1v2h1v4H5v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H7v-2h14zM5 7h3v2H5z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 10h-1v2h1v4H5v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H7v-2h14z"
      }), React.createElement("path", {
        d: "M19 12V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM8 9H5V7h3z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 24V8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4zM4 24V8a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
      }), React.createElement("path", {
        d: "M42 20h-1v2h1a2 2 0 0 1 2 2v10H12v-2h-2v8a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4zm0 22H14a2 2 0 0 1-2-2v-2h32v2a2 2 0 0 1-2 2zM9 19h8v-6H9zm2-4h4v2h-4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 20h-1v2h1a2 2 0 0 1 2 2v10H12v-2h-2v8a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4zm2 20a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-2h32z"
      }), React.createElement("path", {
        d: "M38 24V8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4zm-22-6h-6v-4h6z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 48V16a8 8 0 0 0-8-8H12a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8zM8 48V16a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4z"
      }), React.createElement("path", {
        d: "M84 40h-4v4h4a4 4 0 0 1 4 4v20H24v-8h-4v20a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8zm0 44H28a4 4 0 0 1-4-4v-4h64v4a4 4 0 0 1-4 4zM19 37h14V27H19zm2-8h10v6H21zM12 19v2h2v-2a1 1 0 0 1 1-1h51v-2H15a3 3 0 0 0-3 3z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 40h-4v4h4a4 4 0 0 1 4 4v20H24v-8h-4v20a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8zm0 44H28a4 4 0 0 1-4-4v-4h64v4a4 4 0 0 1-4 4z"
      }), React.createElement("path", {
        d: "M76 48V16a8 8 0 0 0-8-8H12a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8zM12 17v2h-2v-2a3 3 0 0 1 3-3h55v2H13a1 1 0 0 0-1 1zm20 19H20v-8h12z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 12V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM3 4h14v8H3z"
      }), React.createElement("path", {
        d: "M21 10h-1v2h1v4H5v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H7v-2h14zM5 7h3v2H5z"
      }));

    case 'banking_card_singleCard':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v8H3V6zM3 18v-2h18v2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-2H1zM21 4H3a2 2 0 0 0-2 2v8h22V6a2 2 0 0 0-2-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 8H6a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4zm2 28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4h40zm0-8H4V12a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 8H6a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4zm2 24H4v-4h40z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 16H12a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h72a8 8 0 0 0 8-8V24a8 8 0 0 0-8-8zm4 56a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-8h80zm0-16H8V24a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4z"
      }), React.createElement("path", {
        d: "M11 25v3h2v-3h69v-2H13a2 2 0 0 0-2 2z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 16H12a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h72a8 8 0 0 0 8-8V24a8 8 0 0 0-8-8zM9 23a2 2 0 0 1 2-2h73v2H11v3H9zm79 41H8v-8h80z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v8H3V6zM3 18v-2h18v2z"
      }));

    case 'banking_cash_banknoteEur':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 4v15h20V4zm18 13H4V6h16z"
      }), React.createElement("path", {
        d: "M12.61 15.15A2.79 2.79 0 0 0 15 13.74l-.88-.65a1.83 1.83 0 0 1-1.52 1 1.71 1.71 0 0 1-1.6-1.31h2.16v-.86H10.8v-.4a3.17 3.17 0 0 1 0-.44h2.33v-.85H11A1.66 1.66 0 0 1 12.54 9a1.78 1.78 0 0 1 1.53.91l.93-.68a2.75 2.75 0 0 0-2.43-1.32 3 3 0 0 0-2.84 2.32h-.94v.85h.78a3.54 3.54 0 0 0 0 .46v.38h-.78v.86h.91a3 3 0 0 0 2.91 2.37z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 4v15h20V4zm10.61 11.15a3 3 0 0 1-2.91-2.37h-.91v-.86h.77v-.38a3.54 3.54 0 0 1 0-.46h-.77v-.85h.94a3 3 0 0 1 2.84-2.32A2.75 2.75 0 0 1 15 9.23l-.93.69A1.78 1.78 0 0 0 12.54 9 1.66 1.66 0 0 0 11 10.23h2.14v.85h-2.33a3.17 3.17 0 0 0 0 .44v.4h2.34v.86H11a1.71 1.71 0 0 0 1.64 1.27 1.83 1.83 0 0 0 1.52-1l.88.65a2.79 2.79 0 0 1-2.43 1.45z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M41 9H3v28h38zm-2 26H5V11h34z"
      }), React.createElement("path", {
        d: "M43 13v26H7v2h38V13h-2z"
      }), React.createElement("path", {
        d: "M22.92 32c2.71 0 4.39-1.52 5.71-3.51l-1.37-1c-1.15 1.68-2.38 2.76-4.27 2.76-2.38 0-4.2-1.68-4.92-4.27h6.24v-1.49h-6.53a9.8 9.8 0 0 1-.05-1.23 12.7 12.7 0 0 1 .07-1.37h6.51v-1.48h-6.17c.74-2.43 2.42-4.11 4.58-4.11s3.22.94 4.42 2.62l1.44-1a6.53 6.53 0 0 0-5.78-3.32c-3.24 0-5.72 2.45-6.61 5.81h-2.25v1.48h2a13.22 13.22 0 0 0-.08 1.42 8.93 8.93 0 0 0 .05 1.18h-1.97V26h2.18c.88 3.58 3.39 6 6.8 6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43 13v26H7v2h38V13h-2z"
      }), React.createElement("path", {
        d: "M41 9H3v28h38zM22.92 32c-3.41 0-6-2.4-6.8-6h-2.18v-1.51h1.94a8.93 8.93 0 0 1-.05-1.18 13.22 13.22 0 0 1 .08-1.42h-2v-1.48h2.25c.89-3.36 3.37-5.81 6.61-5.81a6.53 6.53 0 0 1 5.78 3.29l-1.44 1c-1.2-1.68-2.38-2.62-4.42-2.62s-3.81 1.73-4.55 4.14h6.17v1.48H17.8a12.7 12.7 0 0 0-.07 1.37 9.8 9.8 0 0 0 .05 1.23h6.53V26h-6.24c.72 2.59 2.54 4.27 4.92 4.27 1.89 0 3.12-1.08 4.27-2.76l1.37 1c-1.32 1.95-3 3.49-5.71 3.49z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 12H4v56h72zm-4 52H8V16h64z"
      }), React.createElement("path", {
        d: "M88 28v52H20v4h72V28h-4z"
      }), React.createElement("path", {
        d: "M84 20h-4v52H12v4h72V20z"
      }), React.createElement("path", {
        d: "M41.83 58c5.43 0 8.79-3 11.43-7l-2.74-2c-2.3 3.36-4.75 5.52-8.54 5.52-4.76 0-8.41-3.36-9.85-8.54h12.49V43H31.56a19.12 19.12 0 0 1-.1-2.44 25 25 0 0 1 .15-2.74h13v-3H32.28c1.49-4.85 4.85-8.21 9.17-8.21 4.08 0 6.43 1.88 8.83 5.24l2.88-2.07c-2.54-3.78-5.9-6.58-11.57-6.58-6.48 0-11.42 4.89-13.2 11.61h-4.51v3h3.93c-.09.91-.14 1.87-.14 2.83a17.71 17.71 0 0 0 .1 2.35h-3.89v3h4.37C29.93 53.15 35 58 41.83 58z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M88 28v52H20v4h72V28h-4z"
      }), React.createElement("path", {
        d: "M84 20h-4v52H12v4h72V20z"
      }), React.createElement("path", {
        d: "M76 12H4v56h72zM41.83 58c-6.82 0-11.9-4.8-13.58-12h-4.37v-3h3.89a17.71 17.71 0 0 1-.1-2.35c0-1 0-1.92.14-2.83h-3.93v-3h4.51c1.78-6.72 6.72-11.61 13.2-11.61 5.67 0 9 2.78 11.57 6.57l-2.88 2.07c-2.4-3.36-4.75-5.24-8.83-5.24-4.32 0-7.68 3.36-9.17 8.21h12.34v3h-13a25 25 0 0 0-.15 2.74 19.12 19.12 0 0 0 .1 2.44h13.05v3H32.13c1.44 5.18 5.09 8.54 9.85 8.54 3.79 0 6.24-2.16 8.54-5.52l2.74 1.92c-2.64 3.99-6 7.06-11.43 7.06z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 4v15h20V4zm18 13H4V6h16z"
      }), React.createElement("path", {
        d: "M12.61 15.15A2.79 2.79 0 0 0 15 13.74l-.88-.65a1.83 1.83 0 0 1-1.52 1 1.71 1.71 0 0 1-1.6-1.31h2.16v-.86H10.8v-.4a3.17 3.17 0 0 1 0-.44h2.33v-.85H11A1.66 1.66 0 0 1 12.54 9a1.78 1.78 0 0 1 1.53.91l.93-.68a2.75 2.75 0 0 0-2.43-1.32 3 3 0 0 0-2.84 2.32h-.94v.85h.78a3.54 3.54 0 0 0 0 .46v.38h-.78v.86h.91a3 3 0 0 0 2.91 2.37z"
      }));

    case 'banking_cash_banknoteUsd':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 4v15h20V4zm18 13H4V6h16z"
      }), React.createElement("path", {
        d: "M9.79 13.1l-.64.9a4.61 4.61 0 0 0 2.36 1v1h.87v-1c1.26-.12 2.12-.85 2.12-1.94 0-1.07-.65-1.67-2.17-2.05V9.1a3.69 3.69 0 0 1 1.36.65l.56-.94a3.91 3.91 0 0 0-1.87-.76v-.6h-.87V8c-1.25.11-2.1.84-2.1 1.92 0 1.13.68 1.68 2.14 2v2a3.67 3.67 0 0 1-1.76-.82zm2.54-.9c.77.23 1 .5 1 .94 0 .48-.35.79-1 .86zm-1.74-2.32c0-.43.32-.77 1-.83v1.77c-.81-.25-1-.52-1-.94z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.33 12.2V14c.64-.07 1-.38 1-.86-.01-.44-.23-.71-1-.94zM10.59 9.87c0 .42.19.69 1 .93V9c-.68.1-1 .44-1 .87z"
      }), React.createElement("path", {
        d: "M2 4v15h20V4zm12.5 9.09c0 1.09-.86 1.82-2.12 1.94v1h-.87V15a4.61 4.61 0 0 1-2.36-1l.64-.92a3.67 3.67 0 0 0 1.76.88V12c-1.46-.37-2.14-.92-2.14-2s.85-1.81 2.1-1.92v-.63h.87v.6a3.91 3.91 0 0 1 1.87.76l-.56.94a3.69 3.69 0 0 0-1.36-.65V11c1.52.38 2.17 1 2.17 2.05z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M41 9H3v28h38zm-2 26H5V11h34z"
      }), React.createElement("path", {
        d: "M43 13v26H7v2h38V13h-2z"
      }), React.createElement("path", {
        d: "M16 26.94l-1 1.44a9.81 9.81 0 0 0 5.66 2.47v2.4h1.54V30.9c3-.19 5.11-1.94 5.11-4.54 0-2.44-1.54-3.84-5.18-4.65v-5.93a7.44 7.44 0 0 1 3.62 1.73l1-1.44a8.64 8.64 0 0 0-4.58-1.92v-1.44h-1.56v1.39c-2.95.14-5 2-5 4.44 0 2.52 1.56 3.82 5.11 4.66v6A8.1 8.1 0 0 1 16 26.94zm6-3.41c2.64.7 3.33 1.54 3.33 2.95 0 1.56-1.27 2.69-3.33 2.81zm-4.66-5.11c0-1.47 1.22-2.62 3.26-2.71v5.66c-2.6-.7-3.18-1.58-3.18-2.95z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43 13v26H7v2h38V13h-2z"
      }), React.createElement("path", {
        d: "M22.08 23.53v5.79c2.06-.12 3.33-1.25 3.33-2.81 0-1.44-.69-2.28-3.33-2.98z"
      }), React.createElement("path", {
        d: "M41 9H3v28h38zM22.15 30.9v2.35h-1.54v-2.4A9.81 9.81 0 0 1 15 28.38l1-1.44a8.1 8.1 0 0 0 4.65 2.3v-6c-3.55-.84-5.11-2.14-5.11-4.66 0-2.47 2.09-4.3 5-4.44v-1.43h1.54v1.44a8.64 8.64 0 0 1 4.58 1.92l-1 1.44a7.44 7.44 0 0 0-3.62-1.73v5.93c3.64.81 5.18 2.21 5.18 4.65.04 2.64-2.07 4.35-5.07 4.54z"
      }), React.createElement("path", {
        d: "M17.42 18.42c0 1.37.62 2.25 3.26 2.95v-5.66c-2.04.09-3.26 1.29-3.26 2.71z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 12H4v56h72zm-4 52H8V16h64z"
      }), React.createElement("path", {
        d: "M88 28v52H20v4h72V28h-4z"
      }), React.createElement("path", {
        d: "M84 20h-4v52H12v4h72V20z"
      }), React.createElement("path", {
        d: "M28.05 48.45l-2.16 2.88a19.75 19.75 0 0 0 11.33 5v4.8h3.07v-4.7c6-.39 10.23-3.89 10.23-9.08 0-4.89-3.07-7.68-10.37-9.31V26.13a15 15 0 0 1 7.25 3.46l2.06-2.88a17.35 17.35 0 0 0-9.17-3.84V20h-3.07v2.78c-5.9.29-10.08 3.94-10.08 8.88v.05c0 5 3.12 7.63 10.23 9.31v12.04a16.33 16.33 0 0 1-9.32-4.61zm12.1-6.81c5.28 1.39 6.67 3.07 6.67 5.9v.05c0 3.12-2.54 5.38-6.67 5.62zm-9.31-10.23c0-2.93 2.45-5.23 6.53-5.42v11.33c-5.28-1.4-6.53-3.17-6.53-5.91z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M88 28v52H20v4h72V28h-4z"
      }), React.createElement("path", {
        d: "M84 20h-4v52H12v4h72V20z"
      }), React.createElement("path", {
        d: "M40.15 41.64v11.57c4.13-.24 6.67-2.5 6.67-5.62v-.05c0-2.83-1.39-4.54-6.67-5.9z"
      }), React.createElement("path", {
        d: "M76 12H4v56h72zM40.29 56.38v4.7h-3.07v-4.8a19.75 19.75 0 0 1-11.33-5l2.16-2.88a16.33 16.33 0 0 0 9.32 4.61V41c-7.11-1.68-10.23-4.27-10.23-9.31v-.05c0-4.94 4.18-8.59 10.08-8.88V20h3.07v2.88a17.35 17.35 0 0 1 9.17 3.84l-2.06 2.87a15 15 0 0 0-7.25-3.46V38c7.3 1.63 10.37 4.42 10.37 9.31 0 5.18-4.23 8.69-10.23 9.07z"
      }), React.createElement("path", {
        d: "M30.84 31.41c0 2.74 1.25 4.51 6.53 5.91V26c-4.08.18-6.53 2.48-6.53 5.41z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 4v15h20V4zm18 13H4V6h16z"
      }), React.createElement("path", {
        d: "M9.79 13.1l-.64.9a4.61 4.61 0 0 0 2.36 1v1h.87v-1c1.26-.12 2.12-.85 2.12-1.94 0-1.07-.65-1.67-2.17-2.05V9.1a3.69 3.69 0 0 1 1.36.65l.56-.94a3.91 3.91 0 0 0-1.87-.76v-.6h-.87V8c-1.25.11-2.1.84-2.1 1.92 0 1.13.68 1.68 2.14 2v2a3.67 3.67 0 0 1-1.76-.82zm2.54-.9c.77.23 1 .5 1 .94 0 .48-.35.79-1 .86zm-1.74-2.32c0-.43.32-.77 1-.83v1.77c-.81-.25-1-.52-1-.94z"
      }));

    case 'banking_cash_coinEur':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 3a9 9 0 1 1-9 9 9 9 0 0 1 9-9m0-2a11 11 0 1 0 11 11A11 11 0 0 0 12 1z"
      }), React.createElement("path", {
        d: "M12.07 16a2.61 2.61 0 0 1-2.37-2H12v-1H9.47a7.18 7.18 0 0 1 0-2H12v-1H9.7a2.61 2.61 0 0 1 2.37-2c.61 0 1.23.11 2.1 1.42l1.66-1.1A4.27 4.27 0 0 0 12.07 6a4.74 4.74 0 0 0-4.45 4H6v1h1.45v2H6v1h1.62a4.74 4.74 0 0 0 4.45 4 4.27 4.27 0 0 0 3.76-2.32l-1.66-1.1c-.87 1.31-1.49 1.42-2.1 1.42z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 9v1H9.47a7.18 7.18 0 0 0 0 2H12v1H9.7a2.61 2.61 0 0 0 2.37 2c.61 0 1.23-.11 2.1-1.42l1.66 1.1A4.27 4.27 0 0 1 12.07 18a4.74 4.74 0 0 1-4.45-4H6v-1h1.45v-1-1H6v-1h1.62a4.74 4.74 0 0 1 4.45-4 4.27 4.27 0 0 1 3.76 2.32l-1.66 1.1C13.3 8.11 12.68 8 12.07 8a2.61 2.61 0 0 0-2.37 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 4A20 20 0 1 1 4 24 20 20 0 0 1 24 4m0-2a22 22 0 1 0 22 22A22 22 0 0 0 24 2z"
      }), React.createElement("path", {
        d: "M24.94 31a5.06 5.06 0 0 1-4.72-4H26v-2h-6.15v-1-1H26v-2h-5.78a5.06 5.06 0 0 1 4.72-4c1.39 0 2.62.44 4.08 2.55l1.67-1.15C29 16 27.32 15 24.94 15c-2.08 0-5.71 1.34-6.82 6H16v2h1.83v2H16v2h2.12c1.11 4.67 4.74 6 6.82 6 2.38 0 4.1-1 5.75-3.42L29 28.44C27.56 30.55 26.33 31 24.94 31z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm2 19v2h-6.15v2H26v2h-5.78a5.06 5.06 0 0 0 4.72 4c1.39 0 2.62-.44 4.08-2.55l1.67 1.15C29 32 27.32 33 24.94 33c-2.08 0-5.71-1.34-6.82-6H16v-2h1.83v-1-1H16v-2h2.12c1.11-4.67 4.74-6 6.82-6 2.38 0 4.1 1 5.75 3.42L29 19.56C27.56 17.45 26.33 17 24.94 17a5.06 5.06 0 0 0-4.72 4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 8A40 40 0 1 1 8 48 40 40 0 0 1 48 8m0-4a44 44 0 1 0 44 44A44 44 0 0 0 48 4z"
      }), React.createElement("path", {
        d: "M49.88 61.12c-3.06 0-7.8-1.84-9.57-8.07H53v-3H39.74a24.09 24.09 0 0 1-.14-2.49 22.62 22.62 0 0 1 .15-2.56H53v-3H40.33c1.79-6.17 6.5-8 9.55-8 2.81 0 5.28.84 8.2 5l3.26-2.32C58 32 54.61 30 49.88 30c-4.2 0-11.58 2.66-13.7 12H32v3h3.71c-.07.81-.11 1.66-.11 2.56s0 1.7.11 2.49H32v3h4.17c2.09 9.4 9.5 12.07 13.71 12.07 4.73 0 8.16-2 11.46-6.65l-3.26-2.32c-2.92 4.13-5.39 4.97-8.2 4.97z"
      }), React.createElement("path", {
        d: "M48 14a34 34 0 1 1-34 34 34 34 0 0 1 34-34m0-2a36 36 0 1 0 36 36 36 36 0 0 0-36-36z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 12a36 36 0 1 0 36 36 36 36 0 0 0-36-36zm5 30v3H39.75a22.62 22.62 0 0 0-.15 2.56 24.09 24.09 0 0 0 .14 2.49H53v3H40.3c1.78 6.23 6.52 8.07 9.58 8.07 2.81 0 5.28-.84 8.2-5l3.26 2.32c-3.3 4.66-6.73 6.65-11.46 6.65-4.21 0-11.62-2.67-13.71-12.07H32v-3h3.71c-.07-.79-.11-1.62-.11-2.49s0-1.75.11-2.56H32V42h4.18c2.12-9.34 9.5-12 13.7-12 4.73 0 8.16 2 11.46 6.65L58.08 39c-2.92-4.13-5.39-5-8.2-5-3.05 0-7.76 1.83-9.55 8z"
      }), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 82a38 38 0 1 1 38-38 38 38 0 0 1-38 38z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 3a9 9 0 1 1-9 9 9 9 0 0 1 9-9m0-2a11 11 0 1 0 11 11A11 11 0 0 0 12 1z"
      }), React.createElement("path", {
        d: "M12.07 16a2.61 2.61 0 0 1-2.37-2H12v-1H9.47a7.18 7.18 0 0 1 0-2H12v-1H9.7a2.61 2.61 0 0 1 2.37-2c.61 0 1.23.11 2.1 1.42l1.66-1.1A4.27 4.27 0 0 0 12.07 6a4.74 4.74 0 0 0-4.45 4H6v1h1.45v2H6v1h1.62a4.74 4.74 0 0 0 4.45 4 4.27 4.27 0 0 0 3.76-2.32l-1.66-1.1c-.87 1.31-1.49 1.42-2.1 1.42z"
      }));

    case 'banking_graphs_graph':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.57 5.49a2 2 0 1 0-1.77-.94l-2.12 4a1.92 1.92 0 0 0-.95.28L11 6.72a2 2 0 1 0-3.71 1.06L4.7 12.5a2 2 0 1 0 1.76 1l2.59-4.75a2 2 0 0 0 1-.29l3.73 2.07a2 2 0 0 0 4 0 2 2 0 0 0-.3-1.05zM3 20h2v3H3zM11 17h2v6h-2zM19 15h2v8h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.5.5a3 3 0 0 0-3 3 2.79 2.79 0 0 0 .19 1L15 7.59l-.26.08-2.82-1.59A3 3 0 0 0 6 6.75a2.89 2.89 0 0 0 .18 1l-2.11 3.84a3 3 0 1 0 3.68 2.91 2.89 2.89 0 0 0-.18-1l2.11-3.84.32-.08 2.86 1.59a3 3 0 0 0 5.92-.67 2.79 2.79 0 0 0-.19-1l1.65-3.08A3 3 0 0 0 19.5.5zM3 20h4v3H3zM10 17h4v6h-4zM17 15h4v8h-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39 8a3 3 0 1 0-3-3 2.94 2.94 0 0 0 .79 2l-4.84 9a2.3 2.3 0 0 0-.45 0 3 3 0 0 0-2 .76L21 12a2.83 2.83 0 0 0 .05-.5 3 3 0 1 0-5.23 2L10 24.05a2.61 2.61 0 0 0-.5-.05 3 3 0 1 0 2.23 1l5.79-10.56a2.61 2.61 0 0 0 .48.05 3 3 0 0 0 2-.76l8.57 4.76a2.83 2.83 0 0 0-.05.5 3 3 0 0 0 6 0 2.94 2.94 0 0 0-.79-2l4.84-9A2.3 2.3 0 0 0 39 8zM7 36h2v7H7z"
      }), React.createElement("path", {
        d: "M18 26h2v17h-2zM40 20h2v23h-2zM29 30h2v13h-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.13 9a4 4 0 1 0-3.52-1.9L31.37 15a4 4 0 0 0-1.91.57L22 11.43a4 4 0 0 0-8 .07 3.9 3.9 0 0 0 .59 2.06L9.41 23a4 4 0 1 0 4.09 4 3.9 3.9 0 0 0-.59-2.06l5.18-9.45a3.9 3.9 0 0 0 1.91-.57l7.47 4.15a4 4 0 1 0 7.38-2.17zM6 36h4v7H6z"
      }), React.createElement("path", {
        d: "M17 26h4v17h-4zM39 20h4v23h-4zM28 30h4v13h-4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78 4a6 6 0 0 0-4.43 10l-9.66 18a5.5 5.5 0 0 0-.91 0 6 6 0 0 0-4 1.51L41.91 24a6.64 6.64 0 0 0 .09-1 6 6 0 1 0-10.47 4L20 48.08A6 6 0 1 0 25 54a6 6 0 0 0-1.53-4L35 28.92a5.94 5.94 0 0 0 5-1.43L57.09 37a6.64 6.64 0 0 0-.09 1 6 6 0 1 0 10.43-4l9.66-18a5.5 5.5 0 0 0 .91 0 6 6 0 0 0 0-12zM15 72h4v14h-4z"
      }), React.createElement("path", {
        d: "M36 52h4v34h-4zM78 41h4v45h-4zM57 60h4v26h-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78.26 18a8 8 0 1 0-7.05-3.78L62.74 30a8 8 0 0 0-3.85 1.13L44 22.86A8 8 0 0 0 28 23a7.89 7.89 0 0 0 1.17 4.14L18.82 46A8 8 0 1 0 27 54a7.89 7.89 0 0 0-1.17-4.14L36.18 31a8 8 0 0 0 3.93-1.13L55 38.14a8 8 0 1 0 14.78-4.35zM13 72h8v14h-8z"
      }), React.createElement("path", {
        d: "M34 52h8v34h-8zM76 41h8v45h-8zM55 60h8v26h-8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.57 5.49a2 2 0 1 0-1.77-.94l-2.12 4a1.92 1.92 0 0 0-.95.28L11 6.72a2 2 0 1 0-3.71 1.06L4.7 12.5a2 2 0 1 0 1.76 1l2.59-4.75a2 2 0 0 0 1-.29l3.73 2.07a2 2 0 0 0 4 0 2 2 0 0 0-.3-1.05zM3 20h2v3H3zM11 17h2v6h-2zM19 15h2v8h-2z"
      }));

    case 'banking_graphs_piechart':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 2h-2v11h11v-2a9 9 0 0 0-9-9zm0 9V4a7 7 0 0 1 7 7z"
      }), React.createElement("path", {
        d: "M11 20A7 7 0 0 1 9 6.29V4.23A9 9 0 1 0 19.77 15h-2.06A7 7 0 0 1 11 20z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 13V4.11A8.89 8.89 0 1 0 19.89 13z"
      }), React.createElement("path", {
        d: "M13 2a9 9 0 0 1 9 9h-9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 41a17 17 0 0 1-3-33.72v-2A19 19 0 1 0 42.74 27h-2A17 17 0 0 1 24 41z"
      }), React.createElement("path", {
        d: "M26 2h-2v22h22v-2A20 20 0 0 0 26 2zm0 20V4a18 18 0 0 1 18 18z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 24V5a19 19 0 1 0 19 19z"
      }), React.createElement("path", {
        d: "M26 2a20 20 0 0 1 20 20H26z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 82a34 34 0 0 1-6-67.46v-4.06A38 38 0 1 0 85.52 54h-4.06A34.05 34.05 0 0 1 48 82z"
      }), React.createElement("path", {
        d: "M52 4h-4v44h44v-4A40 40 0 0 0 52 4zm0 40V8a36 36 0 0 1 36 36z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 48V10a38 38 0 1 0 38 38z"
      }), React.createElement("path", {
        d: "M52 4a40 40 0 0 1 40 40H52z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 2h-2v11h11v-2a9 9 0 0 0-9-9zm0 9V4a7 7 0 0 1 7 7z"
      }), React.createElement("path", {
        d: "M11 20A7 7 0 0 1 9 6.29V4.23A9 9 0 1 0 19.77 15h-2.06A7 7 0 0 1 11 20z"
      }));

    case 'banking_transfer_standingOrder':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 2h2v2H5zM11 2h2v2h-2zM14 6v6h2V4h-3v2h1zM7 4h4v2H7zM8.49 15.32A6.11 6.11 0 0 1 9.38 14H4V6h1V4H2v12h6.15z"
      }), React.createElement("path", {
        d: "M20.14 8.55l-1.78.9L20.63 14h-6.78a4 4 0 0 0-3.57 2.21l-2.17 4.34 1.78.9 2.18-4.34A2 2 0 0 1 13.85 16h6.78l-2.27 4.55 1.78.9L23.37 15z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 2h2v2H5zM11 2h2v2h-2zM8.76 14.76A5 5 0 0 1 13.24 12H16V4h-3v2h-2V4H7v2H5V4H2v12h6.15z"
      }), React.createElement("path", {
        d: "M20.14 8.55l-1.78.9L20.63 14h-7.39a3 3 0 0 0-2.69 1.66l-2.44 4.89 1.78.9 2.45-4.9a1 1 0 0 1 .9-.55h7.39l-2.27 4.55 1.78.9L23.37 15z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 29V9h5v2h2V9h10v2h2V9h5v15h2V7h-7V4h-2v3H13V4h-2v3H4v24h13.3a13.34 13.34 0 0 1 1.28-2z"
      }), React.createElement("path", {
        d: "M39.39 17.55l-1.78.9L42.88 29H28.83a8 8 0 0 0-7.16 4.42l-4.06 8.13 1.78.9 4.07-8.13A6 6 0 0 1 28.83 31h14.05l-5.27 10.55 1.78.9L45.62 30z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 4h2v3h-2zM23 4h2v3h-2zM17.48 30.63A11.92 11.92 0 0 1 28.21 24H32V7h-7v3h-2V7H13v3h-2V7H4v24h13.29z"
      }), React.createElement("path", {
        d: "M39.29 17.11l-3.58 1.78L40.26 28h-12a8 8 0 0 0-7.16 4.42l-4.34 8.69 3.58 1.78 4.34-8.68A4 4 0 0 1 28.21 32h12l-4.55 9.11 3.58 1.78L45.74 30z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 58V18h10v4h4v-4h20v4h4v-4h10v30h4V14H50V8h-4v6H26V8h-4v6H8v48h26.6a26.18 26.18 0 0 1 2.56-4z"
      }), React.createElement("path", {
        d: "M78.79 35.11l-3.58 1.78L85.76 58H57.65a15.92 15.92 0 0 0-14.31 8.84l-8.13 16.27 3.58 1.78 8.13-16.26A11.93 11.93 0 0 1 57.65 62h28.11L75.21 83.11l3.58 1.78L91.24 60zM14 27h44v2H14z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 8h4v6h-4zM46 8h4v6h-4zM78.58 34.21l-7.16 3.58L80.53 56H56.42a15.91 15.91 0 0 0-14.31 8.84l-8.69 17.37 7.16 3.58 8.68-17.37A8 8 0 0 1 56.42 64h24.11l-9.11 18.21 7.16 3.58L91.47 60z"
      }), React.createElement("path", {
        d: "M35 61.27A23.86 23.86 0 0 1 56.42 48H64V14H50v6h-4v-6H26v6h-4v-6H8v48h26.58zM14 27h44v2H14z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 2h2v2H5zM11 2h2v2h-2zM14 6v6h2V4h-3v2h1zM7 4h4v2H7zM8.49 15.32A6.11 6.11 0 0 1 9.38 14H4V6h1V4H2v12h6.15z"
      }), React.createElement("path", {
        d: "M20.14 8.55l-1.78.9L20.63 14h-6.78a4 4 0 0 0-3.57 2.21l-2.17 4.34 1.78.9 2.18-4.34A2 2 0 0 1 13.85 16h6.78l-2.27 4.55 1.78.9L23.37 15z"
      }));

    case 'banking_transfer_transferRebooking':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.84 14H4.12l2.27-4.55-1.78-.9L1.38 15l3.23 6.45 1.78-.9L4.12 16h5.72a2.48 2.48 0 0 1 2.23 1.38l2 4.07 1.78-.9-2-4.06A4.47 4.47 0 0 0 9.84 14zM19.39 2.55l-1.78.9L19.88 8h-5.72a2.48 2.48 0 0 1-2.23-1.38l-2-4.07-1.78.9 2 4.06a4.47 4.47 0 0 0 4 2.49h5.72l-2.27 4.55 1.78.9L22.62 9z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.79 2.11l-3.58 1.78L17.76 7h-3.91a1 1 0 0 1-.85-.55l-2.21-4.34-3.58 1.78 2.17 4.35A5 5 0 0 0 13.85 11h3.91l-1.55 3.11 3.58 1.78L23.24 9zM10.15 13H6.24l1.55-3.11-3.58-1.78L.76 15l3.45 6.89 3.58-1.78L6.24 17h3.91a1 1 0 0 1 .89.55l2.17 4.34 3.58-1.78-2.17-4.35A5 5 0 0 0 10.15 13z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.67 29h-13l5.27-10.55-1.78-.9L3.88 30l6.23 12.45 1.78-.9L6.62 31h13.05A6 6 0 0 1 25 34.32l4.07 8.13 1.78-.9-4.06-8.13A8 8 0 0 0 19.67 29zM37.89 5.55l-1.78.9L41.38 17H28.33A6 6 0 0 1 23 13.68l-4.11-8.13-1.78.9 4.06 8.13A8 8 0 0 0 28.33 19h13.05l-5.27 10.55 1.78.9L44.12 18z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M37.79 5.11l-3.58 1.78L38.76 16h-11a4 4 0 0 1-3.58-2.21l-4.39-8.68-3.58 1.78 4.34 8.69A8 8 0 0 0 27.71 20h11l-4.55 9.11 3.58 1.78L44.24 18zM20.29 28h-11l4.55-9.11-3.58-1.78L3.76 30l6.45 12.89 3.58-1.78L9.24 32h11a4 4 0 0 1 3.58 2.21l4.34 8.68 3.58-1.78-4.34-8.69A8 8 0 0 0 20.29 28z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.35 58H13.24l10.55-21.11-3.58-1.78L7.76 60l12.45 24.89 3.58-1.78L13.24 62h26.11a11.93 11.93 0 0 1 10.73 6.63l8.13 16.26 3.58-1.78-8.13-16.27A15.92 15.92 0 0 0 39.35 58zM75.79 11.11l-3.58 1.78L82.76 34H56.65a11.93 11.93 0 0 1-10.73-6.63l-8.13-16.26-3.58 1.78 8.13 16.27A15.92 15.92 0 0 0 56.65 38h26.11L72.21 59.11l3.58 1.78L88.24 36z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M75.58 10.21l-7.16 3.58L77.53 32H55.42a8 8 0 0 1-7.16-4.42l-8.68-17.37-7.16 3.58 8.69 17.36A15.9 15.9 0 0 0 55.42 40h22.11l-9.11 18.21 7.16 3.58L88.47 36zM40.58 56H18.47l9.11-18.21-7.16-3.58L7.53 60l12.89 25.79 7.16-3.58L18.47 64h22.11a8 8 0 0 1 7.16 4.42l8.68 17.37 7.16-3.58-8.69-17.36A15.9 15.9 0 0 0 40.58 56z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.84 14H4.12l2.27-4.55-1.78-.9L1.38 15l3.23 6.45 1.78-.9L4.12 16h5.72a2.48 2.48 0 0 1 2.23 1.38l2 4.07 1.78-.9-2-4.06A4.47 4.47 0 0 0 9.84 14zM19.39 2.55l-1.78.9L19.88 8h-5.72a2.48 2.48 0 0 1-2.23-1.38l-2-4.07-1.78.9 2 4.06a4.47 4.47 0 0 0 4 2.49h5.72l-2.27 4.55 1.78.9L22.62 9z"
      }));

    case 'banking_transfer_transferReceive':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.61 2.55l-3.68 7.34A2 2 0 0 1 14.15 11H4.72l3.15-5.5-1.74-1L1.85 12l4.28 7.5 1.74-1L4.72 13h9.43a4 4 0 0 0 3.57-2.21l3.67-7.34z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.71 2.11l-4 7.89H7.45l2.29-4-3.48-2-4.56 8 4.56 8 3.48-2-2.29-4h7.31a4 4 0 0 0 3.58-2.21l3.95-7.9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.11 5.55L33 19.68A6 6 0 0 1 27.67 23h-20l7.15-12.5-1.74-1L4.85 24l8.28 14.5 1.74-1L7.72 25h20a8 8 0 0 0 7.16-4.42l7.01-14.13z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.21 5.11l-7.34 14.68A4 4 0 0 1 28.29 22H10.45l6.29-11-3.48-2L4.7 24l8.56 15 3.48-2-6.29-11h17.84a8 8 0 0 0 7.16-4.42l7.34-14.69z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80.21 11.11L66.08 39.37A11.93 11.93 0 0 1 55.35 46h-39.9l14.29-25-3.48-2L9.7 48l16.56 29 3.48-2-14.29-25h39.9a15.92 15.92 0 0 0 14.31-8.84l14.13-28.27z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78.42 10.21L63.74 39.58A8 8 0 0 1 56.58 44H20.89l12.58-22-6.94-4L9.39 48l17.14 30 6.94-4-12.58-22h35.69a15.91 15.91 0 0 0 14.31-8.84l14.69-29.37z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.61 2.55l-3.68 7.34A2 2 0 0 1 14.15 11H4.72l3.15-5.5-1.74-1L1.85 12l4.28 7.5 1.74-1L4.72 13h9.43a4 4 0 0 0 3.57-2.21l3.67-7.34z"
      }));

    case 'banking_transfer_transferRecurring':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.85 6h6.53l-1.27 2.55 1.78.9L18.12 5 15.89.55l-1.78.9L15.38 4H8.85a4 4 0 0 0-3.57 2.21l-3.17 6.34 1.78.9 3.18-6.34A2 2 0 0 1 8.85 6zM20.11 10.55l-3.18 6.34A2 2 0 0 1 15.15 18H8.62l1.27-2.55-1.78-.9L5.88 19l2.23 4.45 1.78-.9L8.62 20h6.53a4 4 0 0 0 3.57-2.21l3.17-6.34z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.21 11.11L16.76 16H10l1.34-2.23-2.63-1.54L5.25 18l3.46 5.77 2.58-1.54L10 20h6.81a4 4 0 0 0 3.58-2.21l2.45-4.9z"
      }), React.createElement("path", {
        d: "M14.05 8l-1.34 2.23 2.58 1.54L18.75 6 15.29.23l-2.58 1.54L14.05 4H7.24a4 4 0 0 0-3.58 2.21l-2.45 4.9 3.58 1.78L7.24 8z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.33 11h14.05l-3.27 6.55 1.78.9L35.12 10l-4.23-8.45-1.78.9L32.38 9H18.33a8 8 0 0 0-7.16 4.42L6.11 23.55l1.78.9L13 14.32A6 6 0 0 1 18.33 11zM40.11 23.55L35 33.68A6 6 0 0 1 29.67 37H15.62l3.27-6.55-1.78-.9L12.88 38l4.23 8.45 1.78-.9L15.62 39h14.05a8 8 0 0 0 7.16-4.42l5.06-10.13z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.21 23.11l-5.34 10.68A4 4 0 0 1 30.29 36h-13l2.55-5.11-3.58-1.78-4.5 8.89 4.45 8.89 3.58-1.78L17.24 40h13.05a8 8 0 0 0 7.16-4.42l5.34-10.69zM17.71 12h13.05l-2.55 5.11 3.58 1.78L36.24 10l-4.45-8.89-3.58 1.78L30.76 8h-13a8 8 0 0 0-7.16 4.42L5.21 23.11l3.58 1.78 5.34-10.68A4 4 0 0 1 17.71 12z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36.65 22h28.11l-6.55 13.11 3.58 1.78L70.24 20 61.79 3.11l-3.58 1.78L64.76 18H36.65a15.92 15.92 0 0 0-14.31 8.84L12.21 47.11l3.58 1.78 10.13-20.26A11.93 11.93 0 0 1 36.65 22zM80.21 47.11L70.08 67.37A11.93 11.93 0 0 1 59.35 74H31.24l6.55-13.11-3.58-1.78L25.76 76l8.45 16.89 3.58-1.78L31.24 78h28.11a15.92 15.92 0 0 0 14.31-8.84l10.13-20.27z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78.42 46.21L67.74 67.58A8 8 0 0 1 60.58 72H34.47l5.11-10.21-7.16-3.58L23.53 76l8.89 17.79 7.16-3.58L34.47 80h26.11a15.91 15.91 0 0 0 14.31-8.84l10.69-21.37zM35.42 24h26.11l-5.11 10.21 7.16 3.58L72.47 20 63.58 2.21l-7.16 3.58L61.53 16H35.42a15.91 15.91 0 0 0-14.31 8.84L10.42 46.21l7.16 3.58 10.68-21.37A8 8 0 0 1 35.42 24z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.85 6h6.53l-1.27 2.55 1.78.9L18.12 5 15.89.55l-1.78.9L15.38 4H8.85a4 4 0 0 0-3.57 2.21l-3.17 6.34 1.78.9 3.18-6.34A2 2 0 0 1 8.85 6zM20.11 10.55l-3.18 6.34A2 2 0 0 1 15.15 18H8.62l1.27-2.55-1.78-.9L5.88 19l2.23 4.45 1.78-.9L8.62 20h6.53a4 4 0 0 0 3.57-2.21l3.17-6.34z"
      }));

    case 'banking_transfer_transferScheduled':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 5v6h5V9h-3V5H8z"
      }), React.createElement("path", {
        d: "M8.93 15a6 6 0 1 1 5.26-3h2.22A7.9 7.9 0 0 0 17 9a8 8 0 1 0-9.07 7.92l.81-1.6a1.69 1.69 0 0 1 .19-.32z"
      }), React.createElement("path", {
        d: "M20.14 8.55l-1.78.9L20.63 14H14.1a4 4 0 0 0-3.57 2.21l-2.17 4.34 1.78.9 2.18-4.34A2 2 0 0 1 14.1 16h6.53l-2.27 4.55 1.78.9L23.37 15z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.14 8.55l-1.78.9L20.63 14h-7.14a3 3 0 0 0-2.69 1.66l-2.44 4.89 1.78.9 2.45-4.9a1 1 0 0 1 .9-.55h7.14l-2.27 4.55 1.78.9L23.37 15z"
      }), React.createElement("path", {
        d: "M13.49 12h2.92A7.9 7.9 0 0 0 17 9a8 8 0 1 0-9.06 7.92L9 14.76A5 5 0 0 1 13.49 12zM8 4h2v4h3v2H8z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 18h-7V8h-2v12h9v-2z"
      }), React.createElement("path", {
        d: "M4 18a14 14 0 0 1 28 0 13.87 13.87 0 0 1-1.37 6h2.2a16 16 0 1 0-17 9.84l1-1.9A14 14 0 0 1 4 18z"
      }), React.createElement("path", {
        d: "M39.39 17.55l-1.78.9L42.88 29H28.83a8 8 0 0 0-7.16 4.42l-4.06 8.13 1.78.9 4.07-8.13A6 6 0 0 1 28.83 31h14.05l-5.27 10.55 1.78.9L45.62 30z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.29 17.11l-3.58 1.78L41.26 28h-13a8 8 0 0 0-7.16 4.42l-4.34 8.69 3.58 1.78 4.34-8.68A4 4 0 0 1 28.21 32h13l-4.55 9.11 3.58 1.78L46.74 30z"
      }), React.createElement("path", {
        d: "M28.21 24h4.62a16 16 0 1 0-17 9.84l1.61-3.21A11.92 11.92 0 0 1 28.21 24zM17 8h2v10h7v2h-9z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M52 35H38V16h-4v23h18v-4z"
      }), React.createElement("path", {
        d: "M8 36a28 28 0 0 1 56 0 27.75 27.75 0 0 1-2.71 12h4.37a32 32 0 1 0-33.93 19.71l1.91-3.82A28 28 0 0 1 8 36z"
      }), React.createElement("path", {
        d: "M78.79 35.11l-3.58 1.78L85.76 58H57.65a15.92 15.92 0 0 0-14.31 8.84l-8.13 16.27 3.58 1.78 8.13-16.26A11.93 11.93 0 0 1 57.65 62h28.11L75.21 83.11l3.58 1.78L91.24 60z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78.58 34.21l-7.16 3.58L80.53 56H56.42a15.91 15.91 0 0 0-14.31 8.84l-8.69 17.37 7.16 3.58 8.68-17.37A8 8 0 0 1 56.42 64h24.11l-9.11 18.21 7.16 3.58L91.47 60z"
      }), React.createElement("path", {
        d: "M56.42 48h9.25a32 32 0 1 0-33.94 19.71L35 61.27A23.86 23.86 0 0 1 56.42 48zM34 16h4v19h14v4H34z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 5v6h5V9h-3V5H8z"
      }), React.createElement("path", {
        d: "M8.93 15a6 6 0 1 1 5.26-3h2.22A7.9 7.9 0 0 0 17 9a8 8 0 1 0-9.07 7.92l.81-1.6a1.69 1.69 0 0 1 .19-.32z"
      }), React.createElement("path", {
        d: "M20.14 8.55l-1.78.9L20.63 14H14.1a4 4 0 0 0-3.57 2.21l-2.17 4.34 1.78.9 2.18-4.34A2 2 0 0 1 14.1 16h6.53l-2.27 4.55 1.78.9L23.37 15z"
      }));

    case 'banking_transfer_transferStandard':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.87 4.5l-1.74 1 3.15 5.5H9.85a4 4 0 0 0-3.57 2.21l-3.67 7.34 1.78.9 3.68-7.34A2 2 0 0 1 9.85 13h9.43l-3.15 5.5 1.74 1 4.28-7.5z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.74 4l-3.48 2 2.29 4H9.24a4 4 0 0 0-3.58 2.21l-3.95 7.9 3.58 1.78 4-7.89h7.31l-2.29 4 3.48 2 4.56-8z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M34.87 9.5l-1.74 1L40.28 23h-20a8 8 0 0 0-7.16 4.42L6.11 41.55l1.78.9L15 28.32A6 6 0 0 1 20.33 25h20l-7.2 12.5 1.74 1L43.15 24z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M34.74 9l-3.48 2 6.29 11H19.71a8 8 0 0 0-7.16 4.42L5.21 41.11l3.58 1.78 7.34-14.68A4 4 0 0 1 19.71 26h17.84l-6.29 11 3.48 2 8.56-15z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M69.74 19l-3.48 2 14.29 25h-39.9a15.92 15.92 0 0 0-14.31 8.84L12.21 83.11l3.58 1.78 14.13-28.26A11.93 11.93 0 0 1 40.65 50h39.9L66.26 75l3.48 2L86.3 48z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M69.47 18l-6.94 4 12.58 22H39.42a15.91 15.91 0 0 0-14.31 8.84L10.42 82.21l7.16 3.58 14.68-29.37A8 8 0 0 1 39.42 52h35.69L62.53 74l6.94 4 17.14-30z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.87 4.5l-1.74 1 3.15 5.5H9.85a4 4 0 0 0-3.57 2.21l-3.67 7.34 1.78.9 3.68-7.34A2 2 0 0 1 9.85 13h9.43l-3.15 5.5 1.74 1 4.28-7.5z"
      }));

    case 'banking_transfer_transferslip':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 16h14v2H5zM14.52 2.56L11.48.81l-5.46 9.58 3.14 1.57 5.36-9.4zM7.78 13.51l-2.29-1.15.01 2.45 2.28-1.3z"
      }), React.createElement("path", {
        d: "M14 7v2h7v11H3V9h2V7H1v15h22V7h-9z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.71 7l-4.09 7.19L4.7 17H20v2H4l-.02-8.05L6.23 7H1v15h22V7h-9.29z"
      }), React.createElement("path", {
        d: "M5.5 14.81l2.28-1.3-2.29-1.15.01 2.45zM9.16 11.96l5.36-9.4L11.48.81l-5.46 9.58 3.14 1.57z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M28 15v2h16v25H4V17h6.5v-2H2v29h44V15H28z"
      }), React.createElement("path", {
        d: "M10 35h28.5v2H10zM11.5 32.49l6.26-3.58L30.39 6.76l-7.79-4.5L10 24.42v7.21a1 1 0 0 0 1.5.86zm.5-2.58v-4l3.5 2zM23.34 5l4.33 2.5-10.79 18.92-4.34-2.48z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11.99 29.91l3.48-1.99-3.5-2 .02 3.99zM16.88 26.42L27.67 7.49l-4.33-2.5-10.8 18.95 4.34 2.48z"
      }), React.createElement("path", {
        d: "M25.69 15l-7.93 13.91-6.26 3.58a1 1 0 0 1-1.5-.86v-7.21L15.33 15H2v29h44V15zM38.5 37H10v-2h28.5z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M56 30v4h32v50H8V34h13v-4H4v58h88V30H56z"
      }), React.createElement("path", {
        d: "M20 68h57v4H20zM20 63.26A2 2 0 0 0 23 65l12.54-7.17 25.24-44.32-15.58-9-25.26 44.32zM55.34 15l-1.55 2.72-8.58-5.15L46.68 10zm-11.12-.7l8.58 5.15-19 33.39-8.68-5zM30.94 55.84l-7 4v-8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M51.39 30L35.53 57.82 23 65a2 2 0 0 1-3-1.73l-.06-14.43L30.67 30H4v58h88V30zM77 72H20v-4h57z"
      }), React.createElement("path", {
        d: "M23.98 59.81l6.96-3.97-6.99-4 .03 7.97zM55.34 14.99l-8.66-5-1.47 2.57 8.58 5.15 1.55-2.72zM33.76 52.84L52.8 19.45l-8.58-5.15-19.14 33.58 8.68 4.96z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 16h14v2H5zM14.52 2.56L11.48.81l-5.46 9.58 3.14 1.57 5.36-9.4zM7.78 13.51l-2.29-1.15.01 2.45 2.28-1.3z"
      }), React.createElement("path", {
        d: "M14 7v2h7v11H3V9h2V7H1v15h22V7h-9z"
      }));

    case 'banking___atm':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 1v8h4v13h14V9h4V1zm16 19H7V6h10zm4-13h-2V6h1V4H4v2h1v1H3V3h18z"
      }), React.createElement("path", {
        d: "M12.35 16.46a2.79 2.79 0 0 0 2.42-1.41l-.88-.65a1.84 1.84 0 0 1-1.53 1 1.7 1.7 0 0 1-1.63-1.27h2.16v-.85h-2.34v-.4a3.17 3.17 0 0 1 0-.44h2.33v-.85h-2.13a1.66 1.66 0 0 1 1.54-1.22 1.78 1.78 0 0 1 1.53.91l.93-.69a2.75 2.75 0 0 0-2.44-1.32 3 3 0 0 0-2.83 2.32h-.94v.85h.78a3.54 3.54 0 0 0 0 .46v.38h-.78v.85h.91a3 3 0 0 0 2.9 2.33z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 1v8h4v13h14V9h4V1zm11.35 15.46a3 3 0 0 1-2.9-2.37h-.91v-.85h.77v-.38a3.54 3.54 0 0 1 0-.46h-.77v-.85h.94a3 3 0 0 1 2.83-2.32 2.75 2.75 0 0 1 2.44 1.32l-.93.69a1.78 1.78 0 0 0-1.53-.91 1.66 1.66 0 0 0-1.54 1.22h2.14v.85h-2.33a3.17 3.17 0 0 0 0 .44v.4h2.34v.85h-2.17a1.7 1.7 0 0 0 1.63 1.27 1.84 1.84 0 0 0 1.53-1l.88.65a2.79 2.79 0 0 1-2.42 1.45zM21 7h-2V6h1V4H4v2h1v1H3V3h18z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 2v12h8v24h28V14h8V2zm34 34H12V9h24zm8-24h-6V9h3V7H7v2h3v3H4V4h40z"
      }), React.createElement("path", {
        d: "M24.92 31c2.71 0 4.39-1.52 5.71-3.51l-1.37-1c-1.15 1.68-2.38 2.76-4.27 2.76-2.38 0-4.2-1.68-4.92-4.27h6.24v-1.49h-6.53a9.8 9.8 0 0 1-.05-1.23 12.7 12.7 0 0 1 .07-1.37h6.51v-1.48h-6.17c.74-2.43 2.42-4.11 4.58-4.11s3.22.94 4.42 2.62l1.44-1a6.53 6.53 0 0 0-5.78-3.32c-3.24 0-5.72 2.45-6.61 5.81h-2.25v1.48h2a13.22 13.22 0 0 0-.08 1.42 8.93 8.93 0 0 0 .05 1.18h-1.97V25h2.18c.88 3.58 3.39 6 6.8 6zM10 40h28v2H10zM10 44h28v2H10z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 2v12h8v24h28V14h8V2zm22.92 29c-3.41 0-6-2.4-6.8-6h-2.18v-1.51h1.94a8.93 8.93 0 0 1-.05-1.18 13.22 13.22 0 0 1 .08-1.42h-2v-1.48h2.25c.89-3.36 3.37-5.81 6.61-5.81a6.53 6.53 0 0 1 5.78 3.29l-1.44 1c-1.2-1.68-2.38-2.62-4.42-2.62s-3.81 1.73-4.55 4.14h6.17v1.48H19.8a12.7 12.7 0 0 0-.07 1.37 9.8 9.8 0 0 0 .05 1.23h6.53V25h-6.24c.72 2.59 2.54 4.27 4.92 4.27 1.89 0 3.12-1.08 4.27-2.76l1.37 1c-1.32 1.95-3 3.49-5.71 3.49zM44 12h-6V9h3V7H7v2h3v3H4V4h40zM10 40h28v2H10zM10 44h28v2H10z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 4H4v24h16v48h56V28h16zM72 72H24V18h48zm16-48H76v-6h6v-4H14v4h6v6H8V8h80z"
      }), React.createElement("path", {
        d: "M49.83 60c5.42 0 8.79-3 11.43-7l-2.74-2c-2.3 3.36-4.75 5.52-8.55 5.52-4.75 0-8.4-3.36-9.84-8.54h12.49V45H39.56a19.12 19.12 0 0 1-.1-2.44 25 25 0 0 1 .15-2.74h13v-3H40.28c1.49-4.85 4.85-8.21 9.17-8.21 4.08 0 6.43 1.88 8.83 5.24l2.88-2.07C58.62 28 55.25 25.2 49.59 25.2c-6.48 0-11.42 4.89-13.2 11.61h-4.51v3h3.93c-.09.91-.14 1.87-.14 2.83a17.71 17.71 0 0 0 .1 2.35h-3.89v3h4.37C37.93 55.15 43 60 49.83 60zM20 80h56v4H20zM20 88h56v4H20z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 4v24h16v48h56V28h16V4zm45.83 56c-6.82 0-11.9-4.8-13.58-12h-4.37v-3h3.89a17.71 17.71 0 0 1-.1-2.35c0-1 0-1.92.14-2.83h-3.93v-3h4.51c1.78-6.72 6.72-11.61 13.2-11.61 5.66 0 9 2.78 11.57 6.57l-2.88 2.07c-2.4-3.36-4.75-5.24-8.83-5.24-4.32 0-7.68 3.36-9.17 8.21h12.34v3h-13a25 25 0 0 0-.15 2.74 19.12 19.12 0 0 0 .1 2.44h13.05v3H40.13c1.44 5.18 5.09 8.54 9.84 8.54 3.8 0 6.25-2.16 8.55-5.52l2.74 1.92C58.62 56.93 55.25 60 49.83 60zM88 24H76v-6h6v-4H14v4h6v6H8V8h80zM20 80h56v4H20zM20 88h56v4H20z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 1v8h4v13h14V9h4V1zm16 19H7V6h10zm4-13h-2V6h1V4H4v2h1v1H3V3h18z"
      }), React.createElement("path", {
        d: "M12.35 16.46a2.79 2.79 0 0 0 2.42-1.41l-.88-.65a1.84 1.84 0 0 1-1.53 1 1.7 1.7 0 0 1-1.63-1.27h2.16v-.85h-2.34v-.4a3.17 3.17 0 0 1 0-.44h2.33v-.85h-2.13a1.66 1.66 0 0 1 1.54-1.22 1.78 1.78 0 0 1 1.53.91l.93-.69a2.75 2.75 0 0 0-2.44-1.32 3 3 0 0 0-2.83 2.32h-.94v.85h.78a3.54 3.54 0 0 0 0 .46v.38h-.78v.85h.91a3 3 0 0 0 2.9 2.33z"
      }));

    case 'banking___contactless':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.76 9.53l.32.3a3 3 0 0 1 0 4.34l-.32.3 2 .79a4.91 4.91 0 0 0 0-6.52zM7.27 7.77L7.5 8a6 6 0 0 1 0 8l-.23.26 2 .77a7.95 7.95 0 0 0 0-10zM12 5.93l.15.2a10 10 0 0 1 0 11.74l-.15.2 1.92.75a12 12 0 0 0 0-13.64z"
      }), React.createElement("path", {
        d: "M18.47 3.38l-1.89.74.11.17a14 14 0 0 1 0 15.42l-.11.17 1.89.74a15.95 15.95 0 0 0 0-17.24z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.76 9.53l.32.3a3 3 0 0 1 0 4.34l-.32.3 2 .79a4.91 4.91 0 0 0 0-6.52zM7.27 7.77L7.5 8a6 6 0 0 1 0 8l-.23.26 2 .77a7.95 7.95 0 0 0 0-10zM12 5.93l.15.2a10 10 0 0 1 0 11.74l-.15.2 1.92.75a12 12 0 0 0 0-13.64z"
      }), React.createElement("path", {
        d: "M18.47 3.38l-1.89.74.11.17a14 14 0 0 1 0 15.42l-.11.17 1.89.74a15.95 15.95 0 0 0 0-17.24z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 24a28.84 28.84 0 0 1-4.62 15.69l1.79.9a30.91 30.91 0 0 0 0-33.18l-1.79.9A28.84 28.84 0 0 1 36 24z"
      }), React.createElement("path", {
        d: "M28 24a20.84 20.84 0 0 1-3.83 12.08L26 37a22.92 22.92 0 0 0 0-26l-1.8.9A20.84 20.84 0 0 1 28 24zM20 24a13 13 0 0 1-3.12 8.44l1.83.91a14.93 14.93 0 0 0 0-18.7l-1.83.91A13 13 0 0 1 20 24zM12 24a6.94 6.94 0 0 1-2.07 5l1.86.94a9 9 0 0 0 0-11.8L9.93 19A6.94 6.94 0 0 1 12 24z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 24a28.84 28.84 0 0 1-4.62 15.69l1.79.9a30.91 30.91 0 0 0 0-33.18l-1.79.9A28.84 28.84 0 0 1 36 24z"
      }), React.createElement("path", {
        d: "M28 24a20.84 20.84 0 0 1-3.83 12.08L26 37a22.92 22.92 0 0 0 0-26l-1.8.9A20.84 20.84 0 0 1 28 24zM20 24a13 13 0 0 1-3.12 8.44l1.83.91a14.93 14.93 0 0 0 0-18.7l-1.83.91A13 13 0 0 1 20 24zM12 24a6.94 6.94 0 0 1-2.07 5l1.86.94a9 9 0 0 0 0-11.8L9.93 19A6.94 6.94 0 0 1 12 24z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 48a57.73 57.73 0 0 1-9.23 31.39l3.6 1.79a62 62 0 0 0 0-66.36l-3.6 1.79A57.73 57.73 0 0 1 72 48zM56 48a41.66 41.66 0 0 1-7.66 24.17L52 74a46 46 0 0 0 0-52l-3.62 1.81A41.66 41.66 0 0 1 56 48zM40 48a26 26 0 0 1-6.24 16.88l3.68 1.84a30 30 0 0 0 0-37.44l-3.68 1.84A26 26 0 0 1 40 48zM24 48a13.87 13.87 0 0 1-4.14 9.93l3.73 1.86a18 18 0 0 0 0-23.58l-3.73 1.86A13.87 13.87 0 0 1 24 48z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 48a57.73 57.73 0 0 1-9.23 31.39l3.6 1.79a62 62 0 0 0 0-66.36l-3.6 1.79A57.73 57.73 0 0 1 72 48zM56 48a41.66 41.66 0 0 1-7.66 24.17L52 74a46 46 0 0 0 0-52l-3.62 1.81A41.66 41.66 0 0 1 56 48zM40 48a26 26 0 0 1-6.24 16.88l3.68 1.84a30 30 0 0 0 0-37.44l-3.68 1.84A26 26 0 0 1 40 48zM24 48a13.87 13.87 0 0 1-4.14 9.93l3.73 1.86a18 18 0 0 0 0-23.58l-3.73 1.86A13.87 13.87 0 0 1 24 48z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.76 9.53l.32.3a3 3 0 0 1 0 4.34l-.32.3 2 .79a4.91 4.91 0 0 0 0-6.52zM7.27 7.77L7.5 8a6 6 0 0 1 0 8l-.23.26 2 .77a7.95 7.95 0 0 0 0-10zM12 5.93l.15.2a10 10 0 0 1 0 11.74l-.15.2 1.92.75a12 12 0 0 0 0-13.64z"
      }), React.createElement("path", {
        d: "M18.47 3.38l-1.89.74.11.17a14 14 0 0 1 0 15.42l-.11.17 1.89.74a15.95 15.95 0 0 0 0-17.24z"
      }));

    case 'banking___gem':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.5 2h-11L1 7.5l11 16 11-16zM3.59 7.74L7.33 4h9.34l3.74 3.74L12 20z"
      }), React.createElement("path", {
        d: "M10 7h8v2h-8zM6 7h2v2H6z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.5 2h-11L1 7.5l11 16 11-16zM8 9H6V7h2zm2 0V7h8v2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 4H13L1 16l23 31 23-31zM3.63 16.19L13.83 6h20.34l10.2 10.19L24 43.64z"
      }), React.createElement("path", {
        d: "M41 15h-7.38l-3.5-7h-2.24l3.5 7H16.62l3.5-7h-2.24l-3.95 7.9 5.2 17.82 3.43 4.62L16.33 17h15.34l-6.23 21.34 3.43-4.62L33.75 17H41v-2zM7 15h4.5v2H7z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 4H13L1 16l23 31 23-31zM11.5 17H7v-2h4.5zm16 22l-3.4 4.51L31.67 17H16.33l7.57 26.51L20.52 39l-6.59-23.1L18.88 6h2.24l-4.5 9h14.76l-4.5-9h2.24l4.5 9H41v2h-7.25z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M70 8H26L2 32l46 62 46-62zM7.27 32.39L27.66 12h40.68l20.39 20.39L48 87.29z"
      }), React.createElement("path", {
        d: "M82 32H66.63l-7.58-16h-2.21l7.58 16H31.58l7.58-16h-2.21l-8.02 16.92L39.86 69.6l3.49 4.7L31.34 34h33.32L52.65 74.3l3.49-4.7L66.75 34H82v-2zM14 32h9v2h-9z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M70 8H26L2 32l46 62 46-62zM23 34h-9v-2h9zm29.92 46.65l-3.47 4.68L64.66 34H31.34l15.21 51.33-3.47-4.68-14.15-47.73 10-20.92h2.22l-9.56 20h32.82l-9.56-20h2.22l9.56 20H82v2H66.75z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.5 2h-11L1 7.5l11 16 11-16zM3.59 7.74L7.33 4h9.34l3.74 3.74L12 20z"
      }), React.createElement("path", {
        d: "M10 7h8v2h-8zM6 7h2v2H6z"
      }));

    case 'banking___handMoney':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.55 13.63a3.47 3.47 0 0 0-3.16-.48L16 14.29l.37-.74L7.24 9H2V7H0v15h2v-2.38L8.76 23a5 5 0 0 0 4.48 0L24 17.62v-1.15a3.47 3.47 0 0 0-1.45-2.84zm-10.21 7.58a3 3 0 0 1-2.68 0L2 17.38V11h4.76l6.9 3.45-.66 1.31a1 1 0 0 1-1.34.45l-4.21-2.1-.9 1.78L10.76 18a3 3 0 0 0 1.34.32 2.83 2.83 0 0 0 1-.16 3 3 0 0 0 1.63-1.33L20 15.05a1.5 1.5 0 0 1 2 1.33zM18 11a5 5 0 1 0-5-5 5 5 0 0 0 5 5zm0-8a3 3 0 1 1-3 3 3 3 0 0 1 3-3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "18",
        cy: "6",
        r: "5"
      }), React.createElement("path", {
        d: "M19.71 14.1l-4.37 1.45-.55 1.11a3 3 0 0 1-1.74 1.5 2.83 2.83 0 0 1-1 .16 3 3 0 0 1-1.29-.32l-4.21-2.11.9-1.78 4.21 2.1a1 1 0 0 0 .76.06 1 1 0 0 0 .58-.51l1.11-2.21L7 10H2V7H0v15h2v-3.5l7.21 3.61a4 4 0 0 0 3.58 0L23 17v-.53a2.5 2.5 0 0 0-3.29-2.37z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10zm0-18a8 8 0 1 1-8 8 8 8 0 0 1 8-8zM44.51 28.07a5.91 5.91 0 0 0-5.41-.82l-9.13 3 1.37-2.74L14.24 19H3v-5H1v30h2v-6.38l15 7.49a9.11 9.11 0 0 0 8.06 0L47 34.62v-1.68a6 6 0 0 0-2.49-4.87zm.49 5.31l-19.87 9.94a7 7 0 0 1-6.26 0L3 35.38V21h10.76l14.9 7.45L26.89 32a3 3 0 0 1-4 1.34l-8.42-4.21-.9 1.78 8.43 4.2a5 5 0 0 0 3.82.27 5 5 0 0 0 2.89-2.51l11-3.68A4 4 0 0 1 45 32.94z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "36",
        cy: "12",
        r: "10"
      }), React.createElement("path", {
        d: "M39.42 28.19l-10.08 3.36-.66 1.32a5 5 0 0 1-2.89 2.51 5 5 0 0 1-3.79-.27l-8.42-4.22.9-1.78 8.42 4.21a3 3 0 0 0 2.29.16 2.94 2.94 0 0 0 1.7-1.48l2.22-4.42L14 20H3v-6H1v30h2v-7.5l15.42 7.71a8 8 0 0 0 7.16 0L46 34v-1.06a5 5 0 0 0-6.58-4.75z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 44a20 20 0 1 0-20-20 20 20 0 0 0 20 20zm0-36a16 16 0 1 1-16 16A16 16 0 0 1 72 8zM87 56.14a11.89 11.89 0 0 0-10.81-1.65L58 60.58l2.73-5.47L26.47 38H8V28H4v60h4V77.24l26 13a18.09 18.09 0 0 0 16.1 0l42-21v-3.37a11.88 11.88 0 0 0-5.1-9.73zm1 10.62L48.26 86.63a14.06 14.06 0 0 1-12.52 0L8 72.76V42h17.53l29.79 14.89L51.79 64a6 6 0 0 1-3.47 3 5.93 5.93 0 0 1-4.58-.33l-16.85-8.46-1.78 3.58L42 70.21a10 10 0 0 0 13.42-4.47l22.1-7.45A8 8 0 0 1 88 65.87z"
      }), React.createElement("path", {
        d: "M72 13v-2a13 13 0 0 0-13 13h2a11 11 0 0 1 11-11zM45.13 82.32a7 7 0 0 1-6.26 0L18.45 72.11l-.9 1.78L38 84.11a9.11 9.11 0 0 0 8.06 0l34.39-17.22-.9-1.78z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 4a20 20 0 1 0 20 20A20 20 0 0 0 72 4zm0 9a11 11 0 0 0-11 11h-2a13 13 0 0 1 13-13zM76.84 56.39l-20.16 6.72-1.31 2.63A10 10 0 0 1 42 70.21l-16.89-8.42 1.78-3.58 16.85 8.42a5.93 5.93 0 0 0 4.58.33 6 6 0 0 0 3.47-3l4.42-8.84L26 40H8V28H4v60h4V75l26.84 13.42a16 16 0 0 0 14.32 0L90 68v-2.13a10 10 0 0 0-13.16-9.48zM46 84.11a9.11 9.11 0 0 1-8.06 0L17.55 73.89l.9-1.78 20.42 10.21a7 7 0 0 0 6.26 0l34.42-17.21.9 1.78z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.55 13.63a3.47 3.47 0 0 0-3.16-.48L16 14.29l.37-.74L7.24 9H2V7H0v15h2v-2.38L8.76 23a5 5 0 0 0 4.48 0L24 17.62v-1.15a3.47 3.47 0 0 0-1.45-2.84zm-10.21 7.58a3 3 0 0 1-2.68 0L2 17.38V11h4.76l6.9 3.45-.66 1.31a1 1 0 0 1-1.34.45l-4.21-2.1-.9 1.78L10.76 18a3 3 0 0 0 1.34.32 2.83 2.83 0 0 0 1-.16 3 3 0 0 0 1.63-1.33L20 15.05a1.5 1.5 0 0 1 2 1.33zM18 11a5 5 0 1 0-5-5 5 5 0 0 0 5 5zm0-8a3 3 0 1 1-3 3 3 3 0 0 1 3-3z"
      }));

    case 'banking___multibanking':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 16.5A1.5 1.5 0 1 1 4.5 18 1.5 1.5 0 0 1 6 16.5M6 15a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM17 13a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zM18 4.5A1.5 1.5 0 1 1 16.5 6 1.5 1.5 0 0 1 18 4.5M18 3a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM7 3a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "6",
        cy: "18",
        r: "3"
      }), React.createElement("circle", {
        cx: "17",
        cy: "17",
        r: "6"
      }), React.createElement("circle", {
        cx: "18",
        cy: "6",
        r: "3"
      }), React.createElement("circle", {
        cx: "7",
        cy: "7",
        r: "6"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 32a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zM34 24a10 10 0 1 1-10 10 10 10 0 0 1 10-10m0-2a12 12 0 1 0 12 12 12 12 0 0 0-12-12zM36 8a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zM14 4A10 10 0 1 1 4 14 10 10 0 0 1 14 4m0-2a12 12 0 1 0 12 12A12 12 0 0 0 14 2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "12",
        cy: "36",
        r: "6"
      }), React.createElement("circle", {
        cx: "34",
        cy: "34",
        r: "12"
      }), React.createElement("circle", {
        cx: "36",
        cy: "12",
        r: "6"
      }), React.createElement("circle", {
        cx: "14",
        cy: "14",
        r: "12"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 64a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-4a12 12 0 1 0 12 12 12 12 0 0 0-12-12zM68 48a20 20 0 1 1-20 20 20 20 0 0 1 20-20m0-4a24 24 0 1 0 24 24 24 24 0 0 0-24-24zM72 16a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-4a12 12 0 1 0 12 12 12 12 0 0 0-12-12zM28 8A20 20 0 1 1 8 28 20 20 0 0 1 28 8m0-4a24 24 0 1 0 24 24A24 24 0 0 0 28 4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "24",
        cy: "72",
        r: "12"
      }), React.createElement("circle", {
        cx: "68",
        cy: "68",
        r: "24"
      }), React.createElement("circle", {
        cx: "72",
        cy: "24",
        r: "12"
      }), React.createElement("circle", {
        cx: "28",
        cy: "28",
        r: "24"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 16.5A1.5 1.5 0 1 1 4.5 18 1.5 1.5 0 0 1 6 16.5M6 15a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM17 13a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zM18 4.5A1.5 1.5 0 1 1 16.5 6 1.5 1.5 0 0 1 18 4.5M18 3a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM7 3a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z"
      }));

    case 'banking___phototan':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM20 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM4 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM5.17 1.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM13.17 9.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM21.17 9.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM5.17 17.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM12 18a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM20 18a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3"
      }), React.createElement("path", {
        d: "M12 1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM20 7a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-5a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3"
      }), React.createElement("circle", {
        cx: "20",
        cy: "12",
        r: "3"
      }), React.createElement("circle", {
        cx: "4",
        cy: "20",
        r: "3"
      }), React.createElement("path", {
        d: "M12 17a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM20 17a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM24 13.75A5.75 5.75 0 1 0 18.25 8 5.76 5.76 0 0 0 24 13.75zm0-10A4.25 4.25 0 1 1 19.75 8 4.26 4.26 0 0 1 24 3.75zM40 13.75A5.75 5.75 0 1 0 34.25 8 5.76 5.76 0 0 0 40 13.75zm0-10A4.25 4.25 0 1 1 35.75 8 4.26 4.26 0 0 1 40 3.75zM8 29.75A5.75 5.75 0 1 0 2.25 24 5.76 5.76 0 0 0 8 29.75zm0-10A4.25 4.25 0 1 1 3.75 24 4.26 4.26 0 0 1 8 19.75zM24 18a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM40 30a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-9a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM8 34a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM24 34.25A5.75 5.75 0 1 0 29.75 40 5.76 5.76 0 0 0 24 34.25zm0 10A4.25 4.25 0 1 1 28.25 40 4.26 4.26 0 0 1 24 44.25zM40 34.25A5.75 5.75 0 1 0 45.75 40 5.76 5.76 0 0 0 40 34.25zm0 10A4.25 4.25 0 1 1 44.25 40 4.26 4.26 0 0 1 40 44.25z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "8",
        cy: "8",
        r: "6"
      }), React.createElement("path", {
        d: "M24 13.75A5.75 5.75 0 1 0 18.25 8 5.76 5.76 0 0 0 24 13.75zm0-10A4.25 4.25 0 1 1 19.75 8 4.26 4.26 0 0 1 24 3.75zM40 13.75A5.75 5.75 0 1 0 34.25 8 5.76 5.76 0 0 0 40 13.75zm0-10A4.25 4.25 0 1 1 35.75 8 4.26 4.26 0 0 1 40 3.75zM8 29.75A5.75 5.75 0 1 0 2.25 24 5.76 5.76 0 0 0 8 29.75zm0-10A4.25 4.25 0 1 1 3.75 24 4.26 4.26 0 0 1 8 19.75z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "6"
      }), React.createElement("circle", {
        cx: "40",
        cy: "24",
        r: "6"
      }), React.createElement("circle", {
        cx: "8",
        cy: "40",
        r: "6"
      }), React.createElement("path", {
        d: "M24 34.25A5.75 5.75 0 1 0 29.75 40 5.76 5.76 0 0 0 24 34.25zm0 10A4.25 4.25 0 1 1 28.25 40 4.26 4.26 0 0 1 24 44.25zM40 34.25A5.75 5.75 0 1 0 45.75 40 5.76 5.76 0 0 0 40 34.25zm0 10A4.25 4.25 0 1 1 44.25 40 4.26 4.26 0 0 1 40 44.25z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4zm0 18a6 6 0 1 1 6-6 6 6 0 0 1-6 6zM48 27a11 11 0 1 0-11-11 11 11 0 0 0 11 11zm0-20a9 9 0 1 1-9 9 9 9 0 0 1 9-9zM80 27a11 11 0 1 0-11-11 11 11 0 0 0 11 11zm0-20a9 9 0 1 1-9 9 9 9 0 0 1 9-9zM16 59A11 11 0 1 0 5 48a11 11 0 0 0 11 11zm0-20a9 9 0 1 1-9 9 9 9 0 0 1 9-9zM80 60a12 12 0 1 0-12-12 12 12 0 0 0 12 12zm0-18a6 6 0 1 1-6 6 6 6 0 0 1 6-6zM48 36a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 18a6 6 0 1 1 6-6 6 6 0 0 1-6 6zM16 68a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 18a6 6 0 1 1 6-6 6 6 0 0 1-6 6zM48 69a11 11 0 1 0 11 11 11 11 0 0 0-11-11zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9zM80 69a11 11 0 1 0 11 11 11 11 0 0 0-11-11zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 36a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }), React.createElement("circle", {
        cx: "16",
        cy: "16",
        r: "11"
      }), React.createElement("circle", {
        cx: "48",
        cy: "48",
        r: "11"
      }), React.createElement("circle", {
        cx: "80",
        cy: "48",
        r: "11"
      }), React.createElement("path", {
        d: "M80 68a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM48 4a12 12 0 1 0 12 12A12 12 0 0 0 48 4zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM80 28a12 12 0 1 0-12-12 12 12 0 0 0 12 12zm0-20a8 8 0 1 1-8 8 8 8 0 0 1 8-8zM48 68a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }), React.createElement("circle", {
        cx: "16",
        cy: "80",
        r: "11"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM20 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM4 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM5.17 1.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM13.17 9.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM21.17 9.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM5.17 17.24a3 3 0 0 0-2.34 0 3 3 0 0 0 0 5.52 3 3 0 0 0 2.34 0 3 3 0 0 0 0-5.52zM12 18a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zM20 18a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-1a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
      }));

    case 'brands_banks_comdirect':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.72 5.29a11 11 0 1 0 0 13.47l-3.11-3.65a6 6 0 1 1-.1-6.38l3.25-3.44z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.43 10.58a22 22 0 1 0-.08 26.94l-6.21-7.3a12 12 0 1 1-.21-12.77l6.5-6.87z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands_banks_commerzbank':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.55 20.61H6.45l-2.4-4a10.82 10.82 0 0 0 2.76.39h10.38a13 13 0 0 0 1.39-.07 4.56 4.56 0 0 1 .17.9 2.62 2.62 0 0 1-.19 1.11c-.06.12-1 1.71-1 1.71zM7.17 3.38h4.77c-.16.15-.32.32-.48.5a11.59 11.59 0 0 0-1.16 1.6l-5.24 8.64a11.51 11.51 0 0 0-.63 1.19 6.32 6.32 0 0 1-.87-.31 2.68 2.68 0 0 1-.9-.7c-.08-.11-1.07-1.7-1.07-1.7l5.58-9.22zM12 5.52c.15.22 5.91 9.73 6.06 10H5.94c.18-.36 5.91-9.81 6.06-10zm10.4 7.08L20 16.52q-.09-.3-.21-.63a10.71 10.71 0 0 0-.88-1.77l-5.16-8.59c-.25-.4-.49-.76-.74-1.09a4.78 4.78 0 0 1 .74-.59 2.7 2.7 0 0 1 1.08-.4h2.03zM6.73 2a.74.74 0 0 0-.66.38l-6 9.88a.64.64 0 0 0 0 .68l5.26 8.7A.76.76 0 0 0 6 22h12a.77.77 0 0 0 .65-.36l5.26-8.7a.64.64 0 0 0 0-.68l-6-9.88a.76.76 0 0 0-.64-.38H6.73z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.58 12.63L20 18.84a5.52 5.52 0 0 0-.18-.92c-.11-.41-.39-1.26-.48-1.49a10.51 10.51 0 0 0-.85-1.79L15.83 10s-1.76-3-2.66-4.62c-.11-.19-.26-.43-.44-.71l.78-.91a5.25 5.25 0 0 1 1.89-1.43A3.93 3.93 0 0 1 16.93 2h.52zm-5.14 8.93l-.25.43H5.91L2.32 15.8a6.47 6.47 0 0 0 .88.3c.42.11 1.3.29 1.54.33a11.54 11.54 0 0 0 2 .16H18.2c.16.45.38 1.07.4 1.14a5.27 5.27 0 0 1 .32 2.37 4.11 4.11 0 0 1-.48 1.46zM12 3.78a12.68 12.68 0 0 0-1.13 1.63C10 7 8.25 10 8.25 10l-2.66 4.64c-.11.19-.25.44-.39.73L4 15.15a5.14 5.14 0 0 1-2.2-.9 4 4 0 0 1-1.05-1.17l-.25-.43.19-.33L6.64 2h7.16a7.7 7.7 0 0 0-.71.61c-.3.31-.89.98-1.09 1.17z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35.61 43H12.39l-5.64-9.87a18.64 18.64 0 0 0 6.69 1h21.12a24.21 24.21 0 0 0 3.23-.2 9.85 9.85 0 0 1 .44 2.43 6 6 0 0 1-.42 2.64c-.07.16-2.2 4-2.2 4zM22.69 7.57a22.32 22.32 0 0 0-1.79 2.76L10.34 28.77A25.5 25.5 0 0 0 8.9 31.7a10.59 10.59 0 0 1-2.31-.83 6.07 6.07 0 0 1-2-1.67c-.2-.28-2.33-3.92-2.33-3.92L13.86 5h11.29l-.15.13c-.3.25-.6.53-.9.83l-.1.11c-.26.27-.51.55-.77.85l-.55.65zM24 9.2a23.86 23.86 0 0 1 1.37 2.13l10.56 18.44c.19.34.68 1.2 1.15 2.27a23.45 23.45 0 0 1-2.52.13H13.44a24.8 24.8 0 0 1-2.52-.17 24.15 24.15 0 0 1 1.15-2.27l10.56-18.4c.45-.78.91-1.49 1.37-2.13zM34.14 5l11.61 20.28-1.45 2.53-4.2 7.33a14.46 14.46 0 0 0-.69-2.63 24.31 24.31 0 0 0-1.75-3.74L27.1 10.33a26.92 26.92 0 0 0-1.79-2.73q.41-.42.81-.78l.17-.14a9.94 9.94 0 0 1 .89-.68 6 6 0 0 1 2.43-.92h.07c.18 0 4.46-.06 4.46-.06zM48 25.27L35.28 3H12.7L0 25.36 11.26 45H37z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24.08 7.56a22.38 22.38 0 0 0-2.25 3.27l-5.32 9.22-5.33 9.22c-.22.39-.5.88-.79 1.48L8 30.31a10.52 10.52 0 0 1-4.41-1.82 7.63 7.63 0 0 1-2.1-2.32L1 25.3l.37-.64L13.27 4H27.6a14.08 14.08 0 0 0-1.41 1.23c-.61.6-1.79 1.96-2.11 2.33zm12.8 35.55l-.51.88H11.79l-7.15-12.4a11.84 11.84 0 0 0 1.77.61c.82.22 2.59.58 3.07.66a22.11 22.11 0 0 0 4 .32H36.4c.31.89.76 2.14.8 2.27a10.4 10.4 0 0 1 .64 4.73 7.84 7.84 0 0 1-.96 2.93zm10.28-17.84L40 37.69a13.24 13.24 0 0 0-.36-1.84c-.22-.82-.8-2.53-1-3A22.41 22.41 0 0 0 37 29.27l-5.32-9.22-5.33-9.22c-.21-.38-.51-.88-.87-1.42L27 7.57a10.44 10.44 0 0 1 3.8-2.91A7.78 7.78 0 0 1 33.86 4h1z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.55 20.61H6.45l-2.4-4a10.82 10.82 0 0 0 2.76.39h10.38a13 13 0 0 0 1.39-.07 4.56 4.56 0 0 1 .17.9 2.62 2.62 0 0 1-.19 1.11c-.06.12-1 1.71-1 1.71zM7.17 3.38h4.77c-.16.15-.32.32-.48.5a11.59 11.59 0 0 0-1.16 1.6l-5.24 8.64a11.51 11.51 0 0 0-.63 1.19 6.32 6.32 0 0 1-.87-.31 2.68 2.68 0 0 1-.9-.7c-.08-.11-1.07-1.7-1.07-1.7l5.58-9.22zM12 5.52c.15.22 5.91 9.73 6.06 10H5.94c.18-.36 5.91-9.81 6.06-10zm10.4 7.08L20 16.52q-.09-.3-.21-.63a10.71 10.71 0 0 0-.88-1.77l-5.16-8.59c-.25-.4-.49-.76-.74-1.09a4.78 4.78 0 0 1 .74-.59 2.7 2.7 0 0 1 1.08-.4h2.03zM6.73 2a.74.74 0 0 0-.66.38l-6 9.88a.64.64 0 0 0 0 .68l5.26 8.7A.76.76 0 0 0 6 22h12a.77.77 0 0 0 .65-.36l5.26-8.7a.64.64 0 0 0 0-.68l-6-9.88a.76.76 0 0 0-.64-.38H6.73z"
      }));

    case 'brands_banks_deutschebank':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 1h22v22H1zm2.59 2.59v16.82h16.82V3.59zm10.72 2h4.21L9.79 18.52H5.58z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 2h44v44H2zm5.18 5.18v33.64h33.64V7.18zm21.45 4h8.42L19.59 37.05h-8.42z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands_banks_ing':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.69 15.11a1.6 1.6 0 0 1 1.12 0 6.78 6.78 0 0 1-1 .51 1.78 1.78 0 0 1-.12-.51zm5.23-.18c.49-.06 1.42 0 1 .68a4.5 4.5 0 0 0-1.07-.36c.02-.11.05-.25.07-.32zm-3.45-6l-1-.06c-.19-.45 2.94-2.27 1 .02zm2.08-1.22c.44 0 2.33.2 2.09.81-.13.33-1.09.4-1.31.28-.06 0 0-.44-.12-.52-.28-.28-.45-.28-.66-.61zm4.12.43c-.27-.19-.46-.47-.73-.67s-.7-.28-.79-.43c-.29-.46.34-1.19.83-1.3 1.45-.36 1.96 2.01.69 2.36zm-9.6.2c-.45-.48-1.21-1.14-.8-1.87A1.37 1.37 0 0 1 12.93 6c.47.19.9.57.68 1.06a7.38 7.38 0 0 1-1.54 1.24zm3.22 4.38c-.14.2-.49.35-.65.53s-.17.33-.34.47c-.37.32-.79.42-.79-.19s.64-.67 1-1 .3-1 .32-1.58c-.38 0-.64.11-1-.06a4 4 0 0 1-1.13-1.14c.55-.19 2.44-.34 2.81.13s-.16 2.21-.22 2.8zm3.05-.2c-.09-.69-.58-2.37 0-2.75a5.34 5.34 0 0 1 2.75 0c-.51.68-1.58 1.64-2.36.81a1.7 1.7 0 0 0 .6 1.86c.32.28 1.24.8 1.24 1.07.02 1.31-1.84-.73-2.23-1.03zM23 17c-.45-.25-.91-.5-1.38-.71-.67-.31-.85-.26-.85-1a8.78 8.78 0 0 1 1.69.37c.35.15.41.06.54.38a3.79 3.79 0 0 1 0 .96zm0-1.89a9.79 9.79 0 0 0-1.61-.43c-.83-.12-.86 0-.39-.55a7 7 0 0 0 1.43-2.85 1.42 1.42 0 0 0-.62.26c.12-.53.25-1.07.35-1.61a3 3 0 0 1 .08-.75c.08-.11.63-.41.76-.53zM18.75 23h-1.37a2.1 2.1 0 0 0 .39-1.11c0-.67 0-.73-.61-.67-1.1.13-.48 1.07-.55 1.78-.77 0-.71-.06-.85-.77-.09-.4 0-.5-.4-.74s-.9-.21-1 .16.42 1 .6 1.35h-6.2c.22-.24 1.08-.93 1.11-1.24 0 0-.26-.4-.28-.42-.25-.25-.17-.18-.58-.12-.22 0-1.15.26-1.25.45S8.29 23 8.29 23H1V1h22v2.3a8.08 8.08 0 0 0-2-1.11c-.5-.07-.41 0-.86.31-.16.11-.57.54-.77.36s.15-.7 0-.9a2.94 2.94 0 0 0-.75-.07c-.13.09-.17.73-.24.92-.17.44-.31.76-.83.83A14.62 14.62 0 0 0 17.73 2c-.51.14-1.11.53-1.61.61a2.31 2.31 0 0 1-1.27-.41l-.43 1.23c-.31-.22-.64-.43-.94-.67a8.36 8.36 0 0 0-.84-.76c-.44-.11-1.29.36-1.67.52a5.89 5.89 0 0 0-2.44 2.61c.31.17.76.42 1 .3s.43-.69.64-.87a6.68 6.68 0 0 1 2.17-1.26c.51.07 1.38.93 1.86 1.19 1 .52 1.14.24 1.41-.81a1.61 1.61 0 0 0 .61.19c.68 0 0 1.22.73 1.22a4.74 4.74 0 0 0 2.16-.92c.72-.61 1.06-.85 2-.46.68.26 1.12.6 1.8.15v2.19c-.71-.77-1.16-1.45-2.33-1.23a1.54 1.54 0 0 0-1.14.66c-.14.21-.14.5-.27.69s0 .15-.44.27-1 .25-1.53.4-.59.07-1.2-.09c-.34-.09-1 0-1.3-.14s-.4-.66-.69-.93C12.59 4.31 10 5 10.23 7.25a2.35 2.35 0 0 0 .68 1.31c.21.18.67.17.81.45a11.16 11.16 0 0 1-.08 1.48c0 .42.13.83.21 1.25-.85-.38-.64.3-.27.88s1.13 1 1.25 1.8a11.57 11.57 0 0 0-2.18.38c-.74.26-1.69.41-1.36 1.32.38-.07 4.17-1.61 3.62-.4-.24.52-4.24 1.28-3.06 2.37a12.79 12.79 0 0 1 2.75-1.42 1.25 1.25 0 0 1 1-.14c.61.28.17.54 1 .24.63-.24 1.87-.43 2.13-1s-.5-1-.57-1.7c-.9.38-1-.45-.28-.81.51-.24 2.32-.36 2.73.15.16.2.23.61 0 .78a.26.26 0 0 1-.37 0c-.24-.11-.33 0-.27.26-.39.3-.89.93-.52 1.43.25.34 1.33.58 1.82.87s.35.25.82.13.06-.39.64-.32A5.77 5.77 0 0 1 23 17.67a28.65 28.65 0 0 1 0 3.09c-.27-.33-.26-.68-.65-.85-.59-.25-.52-.11-.52.25a1.26 1.26 0 0 0 .59 1 2.94 2.94 0 0 0 .58.16V23h-2.59c-.69 0-.95 0-.95-.58s-.06-1.1-.06-1.65c-1.18-.13-1.38 1.85-.65 2.23m-.69-4.39a4.36 4.36 0 0 1 .8.69c.4-.57.85-1.55.31-2a4.31 4.31 0 0 0-2.6-.43c-.43 0-2.21.15-2.45.73-.1.25.3 1.27.61 1.27s.45-.49.67-.56c0 .32-.1 1.07.18 1.32.5.44 1-.19 1-.6.54.81 1.59.75 1.43-.39M9.31 5.83c-.15-.27-.75-.06-.91.07-.4.35-.34 1.1-.29 1.56a2.53 2.53 0 0 1 .11.65c-.07.36-.34.37-.56.64s-.25.12-.27.59a6.78 6.78 0 0 0 .14 1.19c.28-.27.54-.56.84-.82s1.06-.64 1.17-.92-.31-.94-.38-1.38a4.69 4.69 0 0 1 .15-1.58m.24 6.54a5.91 5.91 0 0 0-2.47 1.15c-.44.45-.37.41-.31 1.1a10.36 10.36 0 0 0 .12 1.12 18.35 18.35 0 0 1 1.84-1.9c.55-.4 1-.7.82-1.47m-2.08 7.11a1.75 1.75 0 0 0 .72-1.81 5.62 5.62 0 0 1 0-2.2 2.51 2.51 0 0 0-.95.48c-.38.36-.29.62-.25 1.16a7.05 7.05 0 0 0 .48 2.37m.07-6.77c.4-.44 3.15-2 1.93-2.56a3.37 3.37 0 0 0-1.87.47c-.49.49-.25 1.5-.06 2.09m13.68 8.61c.06-.69-.38-.8-1-.94a2.29 2.29 0 0 0 .63 2.34c.19.11.74.23.87 0 0-.05-.48-1.22-.51-1.38m-9.79-1.93c-.72-1.19-1.15.15-.95.93a1.61 1.61 0 0 0 1.31 1.16c.06-.22-.2-.67-.25-.91a5.19 5.19 0 0 1-.11-1.18m-3.6 1.85c.32-.28.56-.68.87-1s.45-.36.45-.66-.37-.68-.49-.69c-.3 0-1.09.84-1.11 1a8.38 8.38 0 0 0 .28 1.34m4.81-1.63a1.7 1.7 0 0 0 0 1.24 4.89 4.89 0 0 0 .6 1.31c.3-.6.68-2.71-.64-2.55"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25.27 39.21a3.4 3.4 0 0 0 .09 2.48 9.47 9.47 0 0 0 1.19 2.62c.61-1.2 1.37-5.41-1.28-5.1m-9.62 3.28c.64-.57 1.13-1.37 1.74-2 .46-.45.91-.72.9-1.32a2.8 2.8 0 0 0-1-1.39c-.58-.08-2.16 1.69-2.2 2a15.94 15.94 0 0 0 .54 2.7m7.2-3.7c-1.44-2.38-2.29.28-1.9 1.84A3.25 3.25 0 0 0 23.58 43c.13-.45-.41-1.35-.51-1.82a10.94 10.94 0 0 1-.22-2.35m19.58 3.84c.13-1.36-.75-1.6-2-1.87-.57 1.21.06 4 1.26 4.68.37.22 1.47.47 1.73 0 0-.08-1-2.43-1-2.76m-27.35-17.3c.81-.89 6.31-4 3.88-5.12-.64-.28-3.27.49-3.74.95-1 1-.5 3-.14 4.17M15 39a3.49 3.49 0 0 0 1.42-3.62 11 11 0 0 1 0-4.39 5 5 0 0 0-1.91.94c-.75.72-.57 1.24-.5 2.34A14.17 14.17 0 0 0 15 39m4.16-14.21c-1.67.53-3.68 1-4.95 2.3-.88.89-.74.82-.62 2.19a20.82 20.82 0 0 0 .24 2.23c1.3-1.24 2.2-2.73 3.67-3.79 1.11-.8 1.94-1.4 1.66-2.93m-.48-13.1c-.31-.53-1.51-.1-1.84.16-.87.69-.68 2.17-.57 3.12a5.39 5.39 0 0 1 .23 1.29c-.15.72-.69.74-1.13 1.28s-.5.24-.55 1.19a17.4 17.4 0 0 0 .28 2.37c.58-.54 1.08-1.12 1.7-1.64.47-.4 2.11-1.29 2.32-1.85.32-.85-.61-1.88-.75-2.74a9.26 9.26 0 0 1 .31-3.18m17.44 25.53a8.45 8.45 0 0 1 1.6 1.38c.79-1.15 1.7-3.1.61-4.06s-3.8-.93-5.18-.87c-.88 0-4.42.31-4.9 1.47-.21.49.6 2.53 1.21 2.53.37 0 .91-1 1.34-1.11 0 .64-.2 2.15.35 2.63 1 .88 1.93-.36 2.1-1.19 1.1 1.62 3.19 1.5 2.87-.78M37.5 46h-2.74a4.31 4.31 0 0 0 .78-2.22c0-1.33 0-1.46-1.22-1.33-2.19.25-1 2.13-1.11 3.55-1.53 0-1.41-.12-1.7-1.53-.16-.81-.07-1-.8-1.48s-1.79-.43-2 .31.83 2 1.2 2.7H17.52c.43-.48 2.17-1.87 2.22-2.47 0 0-.52-.81-.56-.85-.5-.5-.34-.36-1.16-.24-.43.07-2.29.52-2.49.9s1 2.66 1 2.66H2V2h43.91v4.6c-1.18-.6-2.7-2-4-2.21-1-.15-.83-.08-1.72.6-.31.24-1.13 1.08-1.55.73s.31-1.4 0-1.8a6 6 0 0 0-1.5-.14c-.27.19-.35 1.46-.49 1.83-.34.89-.63 1.52-1.66 1.67a32 32 0 0 0 .53-3.19c-1 .27-2.23 1-3.24 1.22a4.61 4.61 0 0 1-2.53-.84c-.28.83-.57 1.65-.86 2.48-.62-.45-1.27-.87-1.88-1.34a15.55 15.55 0 0 0-1.69-1.52c-.87-.22-2.58.71-3.32 1-2.33 1-3.57 3-4.9 5.14.63.34 1.53.83 2.09.61s.81-1.36 1.22-1.72c.74-.68 3.62-2.6 4.27-2.51 1 .13 2.76 1.84 3.71 2.36 1.94 1.06 2.28.49 2.82-1.62a3.11 3.11 0 0 0 1.23.39c1.36 0 0 2.43 1.46 2.43a9.26 9.26 0 0 0 4.33-1.84c1.42-1.2 2.11-1.69 4.08-.92 1.35.53 2.22 1.21 3.6.31v4.39c-1.44-1.54-2.33-2.9-4.66-2.47A3.1 3.1 0 0 0 39 11c-.29.41-.28 1-.54 1.39-.41.61-.06.29-.89.54-1 .3-2.05.48-3.05.79s-1.19.14-2.39-.18c-.7-.19-2 0-2.6-.28s-.81-1.32-1.39-1.86c-2.93-2.74-8.19-1.39-7.63 3.15a4.65 4.65 0 0 0 1.35 2.61c.42.37 1.34.34 1.61.9s-.2 2.39-.15 2.95c.09.85.27 1.68.42 2.51-1.69-.76-1.29.6-.55 1.76s2.26 2 2.51 3.61a21.4 21.4 0 0 0-4.36.76c-1.48.5-3.38.82-2.72 2.64.76-.14 8.34-3.22 7.24-.81-.48 1-8.49 2.55-6.12 4.74a24.68 24.68 0 0 1 5.5-2.83c.61-.23 1.26-.6 1.92-.3 1.22.56.33 1.09 1.92.49 1.27-.48 3.74-.86 4.26-2.05.6-1.36-1-2-1.14-3.39-1.8.76-2.06-.9-.56-1.62 1-.49 4.64-.71 5.45.3.32.4.46 1.23 0 1.57a.55.55 0 0 1-.75 0q-.72-.32-.54.51c-.77.61-1.78 1.87-1 2.88.5.67 2.66 1.15 3.64 1.73s.7.49 1.63.25.13-.76 1.27-.64c.9.1 4.21 1.5 4.66 2.24a60.46 60.46 0 0 1 0 6.2c-.56-.66-.54-1.38-1.31-1.71-1.18-.51-1-.23-1 .51a2.54 2.54 0 0 0 1.17 2 6.86 6.86 0 0 0 1.18.32V46h-5.22c-1.38 0-1.9 0-1.9-1.16s-.12-2.2-.12-3.31c-2.36-.25-2.8 3.72-1.3 4.47zm8.41-15.83a21.21 21.21 0 0 0-3.22-.85c-1.67-.24-1.74 0-.79-1.09a14.41 14.41 0 0 0 2.87-5.71 2.73 2.73 0 0 0-1.25.53c.24-1.07.5-2.14.69-3.22a6.44 6.44 0 0 1 .17-1.5 18.42 18.42 0 0 1 1.53-1.06zm0 3.79c-.92-.5-1.82-1-2.77-1.42-1.33-.61-1.69-.53-1.69-2.1a18.26 18.26 0 0 1 3.37.75c.69.3.83.12 1.09.76a8 8 0 0 1 0 2.05zm-9.23-9c-.19-1.39-1.16-4.75 0-5.49s4.16-.25 5.5 0c-1 1.35-3.16 3.28-4.71 1.63a3.38 3.38 0 0 0 1.2 3.7c.64.57 2.48 1.62 2.48 2.16.03 2.69-3.68-1.41-4.47-1.96zm-6.09.4c-.3.4-1 .71-1.32 1.06s-.34.65-.67.94c-.75.64-1.6.83-1.6-.36s1.3-1.35 2-2c.82-.81.61-2 .65-3.17-.76 0-1.28.23-2-.12a7.61 7.61 0 0 1-2.25-2.27c1.09-.39 4.88-.7 5.61.25s-.32 4.5-.42 5.67zm-6.45-8.76c-.91-1-2.42-2.27-1.61-3.74a2.74 2.74 0 0 1 3.32-1c.95.39 1.82 1.15 1.38 2.12a15.75 15.75 0 0 1-3.09 2.62zm19.21-.4c-.54-.37-.92-.95-1.47-1.34-.34-.25-1.4-.56-1.59-.85-.58-.92.68-2.38 1.67-2.6 2.91-.65 3.93 4.09 1.39 4.79zm-8.25-.85c.89.05 4.66.39 4.17 1.61-.25.66-2.17.81-2.61.56-.13-.06-.06-.88-.24-1.05-.56-.56-.89-.38-1.32-1.12zm-4.16 2.43l-2.07-.12c-.3-.81 5.95-4.47 2.07.12zm6.9 12.08c1-.12 2.84 0 2 1.36a9.14 9.14 0 0 0-2.14-.72c.05-.21.1-.43.14-.64zm-10.45.36a3.23 3.23 0 0 1 2.23 0 15.33 15.33 0 0 1-1.92 1 2.81 2.81 0 0 1-.31-1z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands_banks_n26':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 10.06l4.58 7h.84V7.94h-1v6.91L1 8.11l-.11-.17H0V17h1zm12.16 3.34c1.55-1 2.16-1.81 2.16-3a2.5 2.5 0 0 0-2.68-2.65A3.09 3.09 0 0 0 9.8 9.69l-.15.31.92.44.15-.34a2.08 2.08 0 0 1 1.91-1.32 1.5 1.5 0 0 1 1.65 1.61c0 .65-.27 1.22-1.63 2.08-2.41 1.53-3 2.21-3 3.85V17h5.65v-1h-4.6c.09-.85.44-1.34 2.46-2.6zm7.9-2.28a3.51 3.51 0 0 0-2.09.79c.15-2 1-3.11 2.29-3.11a2.11 2.11 0 0 1 1.55.64l.29.26.67-.8-.3-.27a3.18 3.18 0 0 0-2.21-.86c-2.06 0-3.34 1.86-3.34 4.86 0 3.36 1.62 4.57 3.13 4.57A3 3 0 0 0 24 14.07a2.76 2.76 0 0 0-2.94-2.95zm1.92 3a2 2 0 0 1-1.92 2.09c-.85 0-1.91-.75-2.09-2.86a3 3 0 0 1 2.1-1.14A1.76 1.76 0 0 1 23 14.07zM0 18.22h6.46V19H0zM0 6h6.46v.78H0z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.06 19.11l9.16 14h1.68V14.88h-2v13.83L2 15.22l-.23-.34H0v18.19h2zm24.26 6.68c3.1-1.94 4.32-3.6 4.32-5.95a5 5 0 0 0-5.36-5.3 6.22 6.22 0 0 0-5.68 3.83l-.31.71 1.85.87.31-.67a4.17 4.17 0 0 1 3.82-2.64 3 3 0 0 1 3.29 3.22c0 1.3-.55 2.44-3.25 4.16-4.83 3.06-5.9 4.42-6 7.69v1.37h11.3V31h-9.22c.18-1.7.9-2.68 4.93-5.21zm15.81-4.55a7.05 7.05 0 0 0-4.2 1.58c.32-3.92 2-6.22 4.6-6.22a4.29 4.29 0 0 1 3.1 1.27l.58.53 1.32-1.61-.53-.52a6.34 6.34 0 0 0-4.43-1.74c-4.12 0-6.68 3.73-6.68 9.72 0 6.74 3.24 9.14 6.27 9.14C46 33.4 48 30.25 48 27.14c0-4.36-3.16-5.9-5.87-5.9zm3.87 5.9a3.9 3.9 0 0 1-3.84 4.18c-1.71 0-3.81-1.5-4.18-5.71a5.87 5.87 0 0 1 4.2-2.29A3.51 3.51 0 0 1 46 27.14zm-46 8.3h12.93V37H0zM.05 11h12.88v1.56H.05z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands_banks_postbank':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.49 4l-9.94.26C4.49 7.35.63 15.24 0 20h8.54A22.57 22.57 0 0 1 19.49 4zM24 10.53a11.82 11.82 0 0 0-5.32 7.82h-2.55a13 13 0 0 1 4.5-7.76l3.37-.06zm-7.62-2.44l5.82-.16A15.46 15.46 0 0 0 14.64 19h-4.42c.37-2.67 2.2-7.95 6.16-10.91z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39 8l-19.86.53C9 14.71 1.25 30.49 0 40h17.08A45.19 45.19 0 0 1 39 8zm9 13.05A23.7 23.7 0 0 0 37.35 36.7h-5.1c.89-5.22 4.17-12 9-15.52.06-.03 6.75-.13 6.75-.13zm-15.24-4.87l11.64-.33C34.84 20.9 30.08 31.48 29.28 38h-8.85c.75-5.34 4.42-15.89 12.33-21.82z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands_banks_sparkasse':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a2.63 2.63 0 0 0-1 .22 2.34 2.34 0 0 0-.83.54 2.88 2.88 0 0 0-.58.87 2.44 2.44 0 0 0-.22 1 2.63 2.63 0 0 0 .22 1.05 2.58 2.58 0 0 0 .58.83 2.44 2.44 0 0 0 .83.59 2.62 2.62 0 0 0 2.1 0 2.54 2.54 0 0 0 .83-.58 2.58 2.58 0 0 0 .58-.83 2.63 2.63 0 0 0 .22-1.05 2.44 2.44 0 0 0-.22-1 2.88 2.88 0 0 0-.58-.87 2.43 2.43 0 0 0-.83-.54A2.63 2.63 0 0 0 12 1zM6.64 8a2.42 2.42 0 0 0-1 .18 2.76 2.76 0 0 0-.87.58 2.51 2.51 0 0 0-.54.87 2.44 2.44 0 0 0-.22 1v5.87h12.26v1.63H4v1.05a2.71 2.71 0 0 0 .22 1.05 2.43 2.43 0 0 0 .54.83 2.76 2.76 0 0 0 .87.58 2.44 2.44 0 0 0 1 .21h10.73a2.44 2.44 0 0 0 1-.21 2.76 2.76 0 0 0 .87-.58 2.7 2.7 0 0 0 .58-.83 2.67 2.67 0 0 0 .19-1.09v-5.87H7.73v-1.59H20v-1.09a2.42 2.42 0 0 0-.18-1 2.67 2.67 0 0 0-1.45-1.45 2.42 2.42 0 0 0-1-.18z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 3a5.29 5.29 0 0 0-2.1.43 5.09 5.09 0 0 0-1.66 1.09 5.58 5.58 0 0 0-1.16 1.74 5 5 0 0 0-.44 2 5.25 5.25 0 0 0 1.6 3.76 5.28 5.28 0 0 0 1.66 1.16 5.34 5.34 0 0 0 4.2 0 5.28 5.28 0 0 0 1.66-1.16 5.25 5.25 0 0 0 1.6-3.76 5 5 0 0 0-.44-2 5.58 5.58 0 0 0-1.16-1.74 5.09 5.09 0 0 0-1.66-1.09A5.29 5.29 0 0 0 24 3zM13.29 16.9a4.92 4.92 0 0 0-2 .36 5.64 5.64 0 0 0-1.74 1.16 5.46 5.46 0 0 0-1.09 1.74 4.93 4.93 0 0 0-.43 2v11.75h24.51v3.26H8v2.1a5.47 5.47 0 0 0 .43 2.1A5.25 5.25 0 0 0 9.52 43a5.61 5.61 0 0 0 1.74 1.15 4.81 4.81 0 0 0 2 .44h21.45a4.81 4.81 0 0 0 2-.44A5.61 5.61 0 0 0 38.48 43a5.44 5.44 0 0 0 1.16-1.67 5.25 5.25 0 0 0 .36-2.1V27.54H15.46v-3.18H40v-2.17a4.89 4.89 0 0 0-.36-2 5.33 5.33 0 0 0-2.9-2.9 4.92 4.92 0 0 0-2-.36z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands_banks_targo':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.16 3.86A2.77 2.77 0 1 1 12 6.53a2.76 2.76 0 0 1-2.84-2.67zm1.46 8.91a1.61 1.61 0 0 1-2.31.09L3.6 8.15a1.64 1.64 0 0 1 .08-2.32A1.62 1.62 0 0 1 6 5.75l4.72 4.71a1.62 1.62 0 0 1-.1 2.31zm2.61 0a1.62 1.62 0 0 1-.09-2.32l4.71-4.71a1.62 1.62 0 0 1 2.31.09 1.62 1.62 0 0 1 .09 2.31l-4.71 4.71a1.61 1.61 0 0 1-2.31-.08zm-9.7 9.7a1.63 1.63 0 0 1-.07-2.34l4.82-4.81a1.7 1.7 0 0 1 2.39 2.4l-4.81 4.81a1.6 1.6 0 0 1-2.33-.06zm16.79 0a1.6 1.6 0 0 1-2.33.06l-4.82-4.81a1.7 1.7 0 0 1 2.4-2.4l4.81 4.81a1.63 1.63 0 0 1-.06 2.34z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.31 7.72A5.53 5.53 0 1 1 24 13.06a5.55 5.55 0 0 1-5.69-5.34zm2.93 17.82a3.22 3.22 0 0 1-4.63.17l-9.42-9.42a3.27 3.27 0 0 1 .17-4.63 3.25 3.25 0 0 1 4.64-.17l9.42 9.43a3.22 3.22 0 0 1-.18 4.62zm5.21 0a3.22 3.22 0 0 1-.17-4.62l9.42-9.42a3.23 3.23 0 0 1 4.63.17 3.26 3.26 0 0 1 .17 4.62l-9.42 9.43a3.23 3.23 0 0 1-4.63-.19zm-19.4 19.4a3.26 3.26 0 0 1-.13-4.67l9.63-9.63a3.4 3.4 0 0 1 4.8 4.8l-9.63 9.63a3.24 3.24 0 0 1-4.67-.13zm33.59 0a3.24 3.24 0 0 1-4.67.13l-9.63-9.63a3.4 3.4 0 0 1 4.8-4.8l9.63 9.63a3.26 3.26 0 0 1-.13 4.67z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands___apple':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.15 3.53a4.08 4.08 0 0 1-3.28 1.54A4.65 4.65 0 0 1 13 1.68 4.89 4.89 0 0 1 16.29 0a4.94 4.94 0 0 1-1.14 3.53zm1.13 1.79a5.14 5.14 0 0 1 4 2.19 5 5 0 0 0-2.38 4.19 4.92 4.92 0 0 0 2.94 4.46 11.48 11.48 0 0 1-1.51 3.11C18.44 20.62 17.49 22 16 22s-2-.9-3.64-.9-2.21.85-3.59.9-2.56-1.43-3.48-2.78C3.4 16.48 2 11.51 3.91 8.16A5.33 5.33 0 0 1 8.45 5.4c1.43 0 2.74.95 3.61.95s2.41-1.13 4.22-1.03z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30.3 7.05a8.19 8.19 0 0 1-6.56 3.1 9.27 9.27 0 0 1 2.34-6.79A9.76 9.76 0 0 1 32.58 0a9.85 9.85 0 0 1-2.28 7.05zm2.26 3.59A10.33 10.33 0 0 1 40.62 15a10 10 0 0 0-4.76 8.38 9.85 9.85 0 0 0 5.88 8.93 23.87 23.87 0 0 1-3 6.21C36.88 41.24 35 43.89 32 44s-3.88-1.75-7.23-1.75-4.47 1.64-7.22 1.75c-2.92.1-5.13-2.86-7-5.57C6.8 33 3.91 23 7.82 16.31a10.68 10.68 0 0 1 9.08-5.51c2.86-.05 5.49 1.9 7.23 1.9s4.81-2.27 8.43-2.06z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'brands___google':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.05 2.69a9.26 9.26 0 0 0-8.31 5.12 9.28 9.28 0 0 0 0 8.34 9.26 9.26 0 0 0 8.31 5.12 8.91 8.91 0 0 0 6.16-2.22A9.12 9.12 0 0 0 21 12.21c0-.44 0-.87-.07-1.29h-8.19v2.16h5.64l-.17.88a5.81 5.81 0 0 1-2.31 3.75 6.88 6.88 0 0 1-3.85 1.09 6.8 6.8 0 0 1-6.35-9 6.74 6.74 0 0 1 6.35-4.66 6.28 6.28 0 0 1 3.82 1.26l1.81-1.8a9 9 0 0 0-5.63-1.91m0 20.08a10.79 10.79 0 1 1 0-21.58A10.4 10.4 0 0 1 19.29 4l.57.53-3.94 3.94-.53-.47a4.67 4.67 0 0 0-3.34-1.3 5.24 5.24 0 0 0-4.93 3.6 5.18 5.18 0 0 0 0 3.36 5.24 5.24 0 0 0 4.93 3.64 5.4 5.4 0 0 0 3-.83 4.13 4.13 0 0 0 1.42-1.89h-5.23V9.42h10.93l.11.62a12.88 12.88 0 0 1 .18 2.17 10.61 10.61 0 0 1-3.23 7.94 10.37 10.37 0 0 1-7.18 2.62"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.54 10.17H12v3.66h5.49a5.11 5.11 0 0 1-2 3.26 6.13 6.13 0 0 1-3.42 1 6 6 0 0 1-5.66-4.19 6.1 6.1 0 0 1 0-3.84 6 6 0 0 1 5.65-4.15 5.44 5.44 0 0 1 3.85 1.51l2.87-2.87a9.65 9.65 0 0 0-6.72-2.61 10 10 0 1 0 0 20.08 9.6 9.6 0 0 0 6.66-2.42 9.81 9.81 0 0 0 3-7.39 12.21 12.21 0 0 0-.17-2"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24.11 4.88A19 19 0 0 0 7 15.39a19 19 0 0 0 0 17.14 19 19 0 0 0 17.11 10.52 18.31 18.31 0 0 0 12.65-4.58c3.65-3.37 5.66-8.36 5.66-14a22.34 22.34 0 0 0-.21-3.08H25v5.32h11.15l-.22 1.18A11.08 11.08 0 0 1 31.51 35a13.23 13.23 0 0 1-7.4 2.09A13.16 13.16 0 0 1 11.19 24a13.14 13.14 0 0 1 .68-4.16 13 13 0 0 1 12.24-9 12 12 0 0 1 7.67 2.64l4.32-4.33a18.42 18.42 0 0 0-12-4.27m0 40.17a21.09 21.09 0 1 1 0-42.17 20.37 20.37 0 0 1 14.13 5.5l.76.7-7.16 7.16-.71-.68a10 10 0 0 0-7-2.73 11.12 11.12 0 0 0-10.35 14.66 11 11 0 0 0 10.34 7.61 11.27 11.27 0 0 0 6.29-1.75 8.79 8.79 0 0 0 3.28-4.69H23v-9.32h20.91l.15.83a24.88 24.88 0 0 1 .36 4.25c0 6.26-2.24 11.77-6.31 15.52a20.23 20.23 0 0 1-14 5.11"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.07 20.34H24v7.31h11a10.18 10.18 0 0 1-4 6.53A12.17 12.17 0 0 1 12.19 24a12.15 12.15 0 0 1 11.92-12.17 10.89 10.89 0 0 1 7.71 3l5.74-5.73a19.33 19.33 0 0 0-13.45-5.23 20.09 20.09 0 1 0 0 40.18 19.27 19.27 0 0 0 13.33-4.85c3.79-3.5 6-8.67 6-14.78a23.38 23.38 0 0 0-.35-4.08"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.05 2.69a9.26 9.26 0 0 0-8.31 5.12 9.28 9.28 0 0 0 0 8.34 9.26 9.26 0 0 0 8.31 5.12 8.91 8.91 0 0 0 6.16-2.22A9.12 9.12 0 0 0 21 12.21c0-.44 0-.87-.07-1.29h-8.19v2.16h5.64l-.17.88a5.81 5.81 0 0 1-2.31 3.75 6.88 6.88 0 0 1-3.85 1.09 6.8 6.8 0 0 1-6.35-9 6.74 6.74 0 0 1 6.35-4.66 6.28 6.28 0 0 1 3.82 1.26l1.81-1.8a9 9 0 0 0-5.63-1.91m0 20.08a10.79 10.79 0 1 1 0-21.58A10.4 10.4 0 0 1 19.29 4l.57.53-3.94 3.94-.53-.47a4.67 4.67 0 0 0-3.34-1.3 5.24 5.24 0 0 0-4.93 3.6 5.18 5.18 0 0 0 0 3.36 5.24 5.24 0 0 0 4.93 3.64 5.4 5.4 0 0 0 3-.83 4.13 4.13 0 0 0 1.42-1.89h-5.23V9.42h10.93l.11.62a12.88 12.88 0 0 1 .18 2.17 10.61 10.61 0 0 1-3.23 7.94 10.37 10.37 0 0 1-7.18 2.62"
      }));

    case 'brands___visa':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.21 15.52h-2l1.27-7.31h1.94zm7.06-7.13L17 10l-.17-.08a3.33 3.33 0 0 0-1.45-.28c-.77 0-1.12.32-1.13.63s.42.57 1.1.9c1.12.52 1.64 1.16 1.64 2 0 1.52-1.35 2.5-3.39 2.5a6.21 6.21 0 0 1-2.18-.39l.28-1.64.25.12a4 4 0 0 0 1.83.39c.56 0 1.16-.23 1.17-.72 0-.32-.26-.55-1-.91s-1.72-.93-1.71-2c0-1.42 1.37-2.42 3.29-2.42a4.92 4.92 0 0 1 1.74.29zm5-.18h-1.52a1 1 0 0 0-1 .6l-2.9 6.71h2.05s.33-.9.41-1.1h2.5c.05.26.23 1.1.23 1.1h1.8l-1.58-7.31zm-2.4 4.72l.77-2s.16-.42.26-.7l.14.63.45 2.12zM6.63 8.21h2.06l-3.06 7.3H3.57L1.82 9.12a5.62 5.62 0 0 1 2.69 3.06l.21 1zM3.17 8c.42 0 .77.15.88.61L4.73 12A6.47 6.47 0 0 0 0 8.15V8z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.56 31.15h-3.93l2.46-14.73H23zm14.22-14.37L34.24 20l-.35-.16a6.84 6.84 0 0 0-2.89-.6c-1.55 0-2.25.64-2.26 1.27s.84 1.14 2.21 1.82c2.26 1.05 3.31 2.33 3.29 4 0 3.05-2.71 5-6.83 5a12.23 12.23 0 0 1-4.41-.75l.55-3.3.51.23a8 8 0 0 0 3.69.79c1.13 0 2.34-.46 2.35-1.45 0-.64-.51-1.11-2-1.83s-3.47-1.88-3.44-4c0-2.86 2.74-4.87 6.62-4.87a9.9 9.9 0 0 1 3.5.63zm10-.36h-3a1.93 1.93 0 0 0-2 1.22l-5.86 13.51H38s.68-1.82.82-2.21h5l.47 2.21H48l-3.17-14.73zM40 25.93c.33-.85 1.57-4.12 1.57-4.12s.32-.86.51-1.41l.28 1.27s.74 3.52.9 4.26zm-26.64-9.51h4.14l-6.16 14.71H7.19L3.67 18.25a11.32 11.32 0 0 1 5.42 6.18l.42 2zm-7-.42a1.61 1.61 0 0 1 1.77 1.24L9.52 24c-1.34-3.53-4.6-6.48-9.52-7.7l.06-.3z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'communication_feedback_dislike':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 15h5l-.79 1.58a2 2 0 0 0-.21.89V21a2 2 0 0 0 2 2h4v-3.59a1 1 0 0 1 .29-.7L18 15V5l-1-2H7.24a2 2 0 0 0-1.79 1.11l-3.24 6.47a2 2 0 0 0-.21.89V13a2 2 0 0 0 2 2zM7.24 5h8.52l.24.47v8.7l-3.12 3.12a3 3 0 0 0-.88 2.12V21h-2v-3.53L12.24 13H4v-1.53zM20 3h2v12h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 15h6l-.79 1.58a2 2 0 0 0-.21.89V21a2 2 0 0 0 2 2h3v-3.59a1 1 0 0 1 .29-.7L18 15V5l-1-2H7.24a2 2 0 0 0-1.79 1.11l-3.24 6.47a2 2 0 0 0-.21.89V13a2 2 0 0 0 2 2zM20 3h2v12h-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 31h12l-1.58 3.16a3.92 3.92 0 0 0-.42 1.78V42a4 4 0 0 0 4 4h6v-7.17a2 2 0 0 1 .59-1.42L34 30V10l-2-4H13a4 4 0 0 0-3.61 2.21l-7 14A3.92 3.92 0 0 0 2 23.94V27a4 4 0 0 0 4 4zm-2-7.06a2 2 0 0 1 .21-.89l7-13.94A2 2 0 0 1 13 8h17.76L32 10.47v18.7L25.17 36A4 4 0 0 0 24 38.83V44h-4a2 2 0 0 1-2-2v-6.06a2 2 0 0 1 .21-.89l3-6H6a2 2 0 0 1-2-2zM46 6H36v24h10zm-2 22h-6V8h6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 31h14l-1.58 3.16a3.92 3.92 0 0 0-.42 1.78V42a4 4 0 0 0 4 4h4v-7.17a2 2 0 0 1 .59-1.42L34 30V10l-2-4H13a4 4 0 0 0-3.61 2.21l-7 14A3.92 3.92 0 0 0 2 23.94V27a4 4 0 0 0 4 4zM36 6h10v24H36z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 62h24l-3.16 6.31a8.08 8.08 0 0 0-.84 3.58V84a8 8 0 0 0 8 8h12V77.66a4 4 0 0 1 1.17-2.83L68 60V20l-4-8H25.94a8 8 0 0 0-7.15 4.42L4.84 44.31A8.08 8.08 0 0 0 4 47.89V54a8 8 0 0 0 8 8zM8 47.89a4.09 4.09 0 0 1 .42-1.79l14-27.89A4 4 0 0 1 25.94 16h35.59L64 20.94v37.4L50.34 72A8 8 0 0 0 48 77.66V88h-8a4 4 0 0 1-4-4V71.89a4.09 4.09 0 0 1 .42-1.79l6-12.1H12a4 4 0 0 1-4-4zM92 12H72v48h20zm-4 44H76V16h12z"
      }), React.createElement("path", {
        d: "M82 26a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM27.62 22H53v-2H27.62a2 2 0 0 0-1.79 1.11L12.11 48.55l1.78.9z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 12H72v48h20zM82 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM12 62h28l-3.16 6.31a8.08 8.08 0 0 0-.84 3.58V84a8 8 0 0 0 8 8h8V77.66a4 4 0 0 1 1.17-2.83L68 60V20l-4-8H25.94a8 8 0 0 0-7.15 4.42L4.84 44.31A8.08 8.08 0 0 0 4 47.89V54a8 8 0 0 0 8 8zm13.83-40.89A2 2 0 0 1 27.62 20H53v2H27.62L13.89 49.45l-1.78-.9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 15h5l-.79 1.58a2 2 0 0 0-.21.89V21a2 2 0 0 0 2 2h4v-3.59a1 1 0 0 1 .29-.7L18 15V5l-1-2H7.24a2 2 0 0 0-1.79 1.11l-3.24 6.47a2 2 0 0 0-.21.89V13a2 2 0 0 0 2 2zM7.24 5h8.52l.24.47v8.7l-3.12 3.12a3 3 0 0 0-.88 2.12V21h-2v-3.53L12.24 13H4v-1.53zM20 3h2v12h-2z"
      }));

    case 'communication_feedback_happy':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M16.17 13.42a4.66 4.66 0 0 1-8.34 0l-.44-.87-1.78.9.43.87a6.67 6.67 0 0 0 11.92 0l.43-.87-1.78-.9zM15 9.34a.64.64 0 0 1 1.1 0l.56 1.11 1.78-.9-.55-1.1a2.61 2.61 0 0 0-4.68 0l-.55 1.1 1.78.9zM8 9.34a.64.64 0 0 1 1.1 0l.56 1.11 1.78-.9-.55-1.1a2.61 2.61 0 0 0-4.68 0l-.55 1.1 1.78.9z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zM6.16 8.45a2.61 2.61 0 0 1 4.68 0l.55 1.1-1.78.9-.56-1.11a.64.64 0 0 0-1.1 0l-.56 1.11-1.78-.9zM18 14.32a6.67 6.67 0 0 1-12 0l-.43-.87 1.78-.9.44.87a4.66 4.66 0 0 0 8.34 0l.44-.87 1.78.9zm-1.35-3.87l-.56-1.11a.64.64 0 0 0-1.1 0l-.56 1.11-1.78-.9.55-1.1a2.61 2.61 0 0 1 4.68 0l.55 1.1z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm0 42a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M33.24 29.29a10.33 10.33 0 0 1-18.48 0l-.87-1.74-1.78.9.89 1.74a12.34 12.34 0 0 0 22.06 0l.86-1.74-1.78-.9zM31 15a4.21 4.21 0 0 0-3.79 2.34l-1.1 2.21 1.78.9L29 18.24a2.23 2.23 0 0 1 4 0l1.11 2.21 1.78-.9-1.1-2.21A4.21 4.21 0 0 0 31 15zM15 18.24a2.23 2.23 0 0 1 4 0l1.11 2.21 1.78-.9-1.1-2.21a4.24 4.24 0 0 0-7.58 0l-1.1 2.21 1.78.9z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zM13.21 17.34a4.24 4.24 0 0 1 7.58 0l1.1 2.21-1.78.9L19 18.24a2.23 2.23 0 0 0-4 0l-1.11 2.21-1.78-.9zM35 30.19a12.34 12.34 0 0 1-22.06 0l-.86-1.74 1.78-.9.87 1.74a10.33 10.33 0 0 0 18.48 0l.87-1.74 1.78.9zm-.92-9.74L33 18.24a2.23 2.23 0 0 0-4 0l-1.11 2.21-1.78-.9 1.1-2.21a4.24 4.24 0 0 1 7.58 0l1.1 2.21z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 84a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
      }), React.createElement("path", {
        d: "M66.47 58.58a20.65 20.65 0 0 1-36.94 0l-1.74-3.47-3.58 1.78L26 60.37a24.65 24.65 0 0 0 44.1 0l1.74-3.48-3.58-1.78zM62 30a8.43 8.43 0 0 0-7.58 4.68l-2.21 4.43 3.58 1.78L58 36.47a4.47 4.47 0 0 1 8 0l2.21 4.42 3.58-1.78-2.21-4.43A8.43 8.43 0 0 0 62 30zM30 36.47a4.47 4.47 0 0 1 8 0l2.21 4.42 3.58-1.78-2.21-4.43a8.48 8.48 0 0 0-15.16 0l-2.21 4.43 3.58 1.78z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zM26.42 34.68a8.48 8.48 0 0 1 15.16 0l2.21 4.43-3.58 1.78L38 36.47a4.47 4.47 0 0 0-8 0l-2.21 4.42-3.58-1.78zm43.63 25.69a24.65 24.65 0 0 1-44.1 0l-1.74-3.48 3.58-1.78 1.74 3.47a20.65 20.65 0 0 0 36.94 0l1.74-3.47 3.58 1.78zm-1.84-19.48L66 36.47a4.47 4.47 0 0 0-8 0l-2.21 4.42-3.58-1.78 2.21-4.43a8.48 8.48 0 0 1 15.16 0l2.21 4.43z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M16.17 13.42a4.66 4.66 0 0 1-8.34 0l-.44-.87-1.78.9.43.87a6.67 6.67 0 0 0 11.92 0l.43-.87-1.78-.9zM15 9.34a.64.64 0 0 1 1.1 0l.56 1.11 1.78-.9-.55-1.1a2.61 2.61 0 0 0-4.68 0l-.55 1.1 1.78.9zM8 9.34a.64.64 0 0 1 1.1 0l.56 1.11 1.78-.9-.55-1.1a2.61 2.61 0 0 0-4.68 0l-.55 1.1 1.78.9z"
      }));

    case 'communication_feedback_like':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 9h-5l.79-1.58a2 2 0 0 0 .21-.89V3a2 2 0 0 0-2-2h-4v3.59a1 1 0 0 1-.29.7L6 9v10l1 2h9.76a2 2 0 0 0 1.79-1.11l3.24-6.47a2 2 0 0 0 .21-.89V11a2 2 0 0 0-2-2zm-3.24 10H8.24L8 18.53v-8.7l3.12-3.12A3 3 0 0 0 12 4.59V3h2v3.53L11.76 11H20v1.53zM2 9h2v12H2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 9h-6l.79-1.58a2 2 0 0 0 .21-.89V3a2 2 0 0 0-2-2h-3v3.59a1 1 0 0 1-.29.7L6 9v10l1 2h9.76a2 2 0 0 0 1.79-1.11l3.24-6.47a2 2 0 0 0 .21-.89V11a2 2 0 0 0-2-2zM2 9h2v12H2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 17H30l1.58-3.16a3.92 3.92 0 0 0 .42-1.78V6a4 4 0 0 0-4-4h-6v7.17a2 2 0 0 1-.59 1.42L14 18v20l2 4h19a4 4 0 0 0 3.58-2.21l7-13.95a3.92 3.92 0 0 0 .42-1.78V21a4 4 0 0 0-4-4zm2 7.06a2 2 0 0 1-.21.89l-7 13.94A2 2 0 0 1 35 40H17.24L16 37.53v-18.7L22.83 12A4 4 0 0 0 24 9.17V4h4a2 2 0 0 1 2 2v6.06a2 2 0 0 1-.21.89l-3 6.05H42a2 2 0 0 1 2 2zM2 42h10V18H2zm2-22h6v20H4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 17H28l1.58-3.16a3.92 3.92 0 0 0 .42-1.78V6a4 4 0 0 0-4-4h-4v7.17a2 2 0 0 1-.59 1.42L14 18v20l2 4h19a4 4 0 0 0 3.58-2.21l7-13.95a3.92 3.92 0 0 0 .42-1.78V21a4 4 0 0 0-4-4zM2 18h10v24H2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 34H60l3.16-6.31a8.08 8.08 0 0 0 .84-3.58V12a8 8 0 0 0-8-8H44v14.34a4 4 0 0 1-1.17 2.83L28 36v40l4 8h38.06a8 8 0 0 0 7.15-4.42l14-27.89a8.08 8.08 0 0 0 .79-3.58V42a8 8 0 0 0-8-8zm4 14.11a4.09 4.09 0 0 1-.42 1.79l-14 27.89A4 4 0 0 1 70.06 80H34.47L32 75.06v-37.4L45.66 24A8 8 0 0 0 48 18.34V8h8a4 4 0 0 1 4 4v12.11a4.09 4.09 0 0 1-.42 1.79l-6 12.1H84a4 4 0 0 1 4 4zM4 84h20V36H4zm4-44h12v40H8z"
      }), React.createElement("path", {
        d: "M14 70a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM68.38 74H43v2h25.38a2 2 0 0 0 1.79-1.11l13.72-27.44-1.78-.9z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 84h20V36H4zm10-14a4 4 0 1 1-4 4 4 4 0 0 1 4-4zM84 34H56l3.16-6.31a8.08 8.08 0 0 0 .84-3.58V12a8 8 0 0 0-8-8h-8v14.34a4 4 0 0 1-1.17 2.83L28 36v40l4 8h38.06a8 8 0 0 0 7.15-4.42l14-27.89a8.08 8.08 0 0 0 .79-3.58V42a8 8 0 0 0-8-8zM70.17 74.89A2 2 0 0 1 68.38 76H43v-2h25.38l13.73-27.45 1.78.9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 9h-5l.79-1.58a2 2 0 0 0 .21-.89V3a2 2 0 0 0-2-2h-4v3.59a1 1 0 0 1-.29.7L6 9v10l1 2h9.76a2 2 0 0 0 1.79-1.11l3.24-6.47a2 2 0 0 0 .21-.89V11a2 2 0 0 0-2-2zm-3.24 10H8.24L8 18.53v-8.7l3.12-3.12A3 3 0 0 0 12 4.59V3h2v3.53L11.76 11H20v1.53zM2 9h2v12H2z"
      }));

    case 'communication_feedback_neutral':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z",
        className: "a"
      }), React.createElement("path", {
        d: "M7 15h10v2H7z"
      }), React.createElement("circle", {
        cx: "8",
        cy: "10",
        r: "2"
      }), React.createElement("circle", {
        cx: "16",
        cy: "10",
        r: "2"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm-6 9a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm11 7H7v-2h10zm-1-5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm0 42a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M13 31h22v2H13z"
      }), React.createElement("circle", {
        cx: "17",
        cy: "20",
        r: "3"
      }), React.createElement("circle", {
        cx: "31",
        cy: "20",
        r: "3"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm7 15a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm-14 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm18 16H13v-2h22z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 84a40 40 0 1 1 40-40 40 40 0 0 1-40 40z",
        className: "a"
      }), React.createElement("path", {
        d: "M26 62h44v4H26z"
      }), React.createElement("circle", {
        cx: "34",
        cy: "40",
        r: "6"
      }), React.createElement("circle", {
        cx: "62",
        cy: "40",
        r: "6"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm14 30a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm-28 0a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm36 32H26v-4h44z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z",
        className: "a"
      }), React.createElement("path", {
        d: "M7 15h10v2H7z"
      }), React.createElement("circle", {
        cx: "8",
        cy: "10",
        r: "2"
      }), React.createElement("circle", {
        cx: "16",
        cy: "10",
        r: "2"
      }));

    case 'communication_feedback_sad':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "8",
        cy: "10",
        r: "2"
      }), React.createElement("circle", {
        cx: "16",
        cy: "10",
        r: "2"
      }), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M12 13a6.63 6.63 0 0 0-6 3.68l1.79.9a4.66 4.66 0 0 1 8.34 0l1.79-.9A6.63 6.63 0 0 0 12 13z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zM8 8a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm8.17 9.58a4.66 4.66 0 0 0-8.34 0L6 16.68a6.67 6.67 0 0 1 11.92 0zM16 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm0 42a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M24 27a12.28 12.28 0 0 0-11 6.81l1.79.9a10.33 10.33 0 0 1 18.48 0l1.79-.9A12.28 12.28 0 0 0 24 27z"
      }), React.createElement("circle", {
        cx: "17",
        cy: "20",
        r: "3"
      }), React.createElement("circle", {
        cx: "31",
        cy: "20",
        r: "3"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm7 15a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm-14 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm16.24 17.71a10.33 10.33 0 0 0-18.48 0l-1.76-.9a12.34 12.34 0 0 1 22.06 0z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 84a40 40 0 1 1 40-40 40 40 0 0 1-40 40z",
        className: "a"
      }), React.createElement("path", {
        d: "M48 54a24.51 24.51 0 0 0-22 13.63l3.58 1.79a20.65 20.65 0 0 1 36.94 0l3.58-1.79A24.51 24.51 0 0 0 48 54z",
        className: "a"
      }), React.createElement("circle", {
        cx: "34",
        cy: "40",
        r: "6"
      }), React.createElement("circle", {
        cx: "62",
        cy: "40",
        r: "6"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm14 30a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm-28 0a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm32.47 35.42a20.65 20.65 0 0 0-36.94 0L26 67.63a24.65 24.65 0 0 1 44.1 0z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "8",
        cy: "10",
        r: "2"
      }), React.createElement("circle", {
        cx: "16",
        cy: "10",
        r: "2"
      }), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M12 13a6.63 6.63 0 0 0-6 3.68l1.79.9a4.66 4.66 0 0 1 8.34 0l1.79-.9A6.63 6.63 0 0 0 12 13z"
      }));

    case 'communication___call':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.76 3l1.81 3.6-1.94 1.94.53 1.25a11.47 11.47 0 0 0 6.05 6.05l1.25.53 1.94-1.94 3.6 1.81V20A17 17 0 0 1 4 3h3.76M9 1H2v2a19 19 0 0 0 19 19h2v-7l-6-3-2 2a9.48 9.48 0 0 1-5-5l2-2-3-6z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 21A18 18 0 0 1 3 3V2h5.38l2.4 4.8-2 2 .27.62a10.46 10.46 0 0 0 5.53 5.53l.62.27 2-2 4.8 2.4V21z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.71 4l3.9 8.57-6 6 .53 1.25c2.13 5 9.09 11.92 14.05 14.05l1.25.53 4.94-4.94L44 34.24V42h-2A36 36 0 0 1 6 6V4h9.71M17 2H4v4a38 38 0 0 0 38 38h4V33l-12-6-5 5c-4.49-1.93-11.07-8.51-13-13l6-6-5-11z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 43A37 37 0 0 1 5 6V3h11.36l4.44 9.78-6 6 .27.62c2 4.69 8.84 11.52 13.53 13.53l.62.27 5-5L45 33.62V43z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M68 54L58 64c-9-3.85-22.15-17-26-26l13-13L35 4H8v8a76 76 0 0 0 76 76h8V66zm.79 4.87L88 68.47v3.91L66.18 61.47zm-28.62-34.7l-2.31 2.31L28.62 8h3.85zM84 84a72.08 72.08 0 0 1-72-72V8h14.38l10 20-9.11 9.12 1.06 2.49c4.26 9.92 18.18 23.84 28.1 28.1l2.49 1.06L64.69 63 88 74.62V84z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M90 73.38v-6.14L68.39 56.43l-4.09 4.1L90 73.38z"
      }), React.createElement("path", {
        d: "M62.81 62l-4.35 4.35-1.25-.53c-9.38-4-23-17.67-27-27.05l-.53-1.25 7.68-7.68L25.38 6H10v6a74.09 74.09 0 0 0 74 74h6V75.62z"
      }), React.createElement("path", {
        d: "M38.8 28.37l3.79-3.79L33.74 6h-6.12L38.8 28.37z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.76 3l1.81 3.6-1.94 1.94.53 1.25a11.47 11.47 0 0 0 6.05 6.05l1.25.53 1.94-1.94 3.6 1.81V20A17 17 0 0 1 4 3h3.76M9 1H2v2a19 19 0 0 0 19 19h2v-7l-6-3-2 2a9.48 9.48 0 0 1-5-5l2-2-3-6z"
      }));

    case 'communication___chat':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 5v10h-9.24L9 18.53 7.24 15H4V5h16m0-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2l3 6 3-6h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 17h-8l-3 6-3-6H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40 6H8a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h4l6 12 6-12h16a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4zm2 24a2 2 0 0 1-2 2H22.76L18 41.53 13.24 32H8a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h32a2 2 0 0 1 2 2z"
      }), React.createElement("circle", {
        cx: "16",
        cy: "20",
        r: "2"
      }), React.createElement("circle", {
        cx: "24",
        cy: "20",
        r: "2"
      }), React.createElement("circle", {
        cx: "32",
        cy: "20",
        r: "2"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40 6H8a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h4l6 12 6-12h16a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4zM16 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm8 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm8 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80 12H16a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8h8l12 24 12-24h32a8 8 0 0 0 8-8V20a8 8 0 0 0-8-8zm4 48a4 4 0 0 1-4 4H45.53L36 83.06 26.47 64H16a4 4 0 0 1-4-4V20a4 4 0 0 1 4-4h64a4 4 0 0 1 4 4z"
      }), React.createElement("circle", {
        cx: "32",
        cy: "40",
        r: "4"
      }), React.createElement("circle", {
        cx: "48",
        cy: "40",
        r: "4"
      }), React.createElement("circle", {
        cx: "64",
        cy: "40",
        r: "4"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80 12H16a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8h8l12 24 12-24h32a8 8 0 0 0 8-8V20a8 8 0 0 0-8-8zM32 44a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm16 0a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm16 0a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 5v10h-9.24L9 18.53 7.24 15H4V5h16m0-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2l3 6 3-6h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
      }));

    case 'communication___envelope':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 18H3v-7.54L1 9v11h22V9l-2 1.46V18z"
      }), React.createElement("path", {
        d: "M1 4v2l9.82 7.14a2 2 0 0 0 2.36 0L23 6V4zm11 7.53L4.4 6h15.2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 12.78l11-7.61V4H1v1.17l11 7.61z"
      }), React.createElement("path", {
        d: "M13.14 14.43a2 2 0 0 1-2.28 0L1 7.6V20h22V7.6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 38H4V17.45L2 16v24h44V16l-2 1.45V38z"
      }), React.createElement("path", {
        d: "M2 8v4l19.65 14.29a4 4 0 0 0 4.7 0L46 12V8zm42 3L25.18 24.67a2 2 0 0 1-2.36 0L4 11v-1h40z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.84 26a2 2 0 0 0 2.32 0L46 11.19V8H2v3.19z"
      }), React.createElement("path", {
        d: "M26.31 27.59a4 4 0 0 1-4.62 0L2 13.64V40h44V13.64z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M88 74.59l-23.29-23.3-1.42 1.42L86.59 76H9.41l23.3-23.29-1.42-1.42L8 74.59V34.91L4 32v48h88V32l-4 2.91v39.68z"
      }), React.createElement("path", {
        d: "M4 16v8l39.29 28.58a8 8 0 0 0 9.42 0L92 24v-8zm84 6L50.35 49.34a4 4 0 0 1-4.7 0L8 22v-2h80z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M52.71 55.05a8 8 0 0 1-9.42 0L4 26.47V80h88V26.47zm-44 21.66l-1.42-1.42 23-23 1.42 1.42zm78.58 0l-23-23 1.42-1.42 23 23z"
      }), React.createElement("path", {
        d: "M45.65 51.82a4 4 0 0 0 4.7 0L92 21.53V16H4v5.53z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 18H3v-7.54L1 9v11h22V9l-2 1.46V18z"
      }), React.createElement("path", {
        d: "M1 4v2l9.82 7.14a2 2 0 0 0 2.36 0L23 6V4zm11 7.53L4.4 6h15.2z"
      }));

    case 'communication___inbox':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.55 5.11A2 2 0 0 0 18.76 4H5.24a2 2 0 0 0-1.79 1.11L1 10v8l1 2h20l1-2v-8zM5.24 6h13.52l2 4H17l-2 4H9l-2-4H3.24zM21 18H3v-6h2.76l2 4h8.48l2-4H21z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.55 5.11A2 2 0 0 0 18.76 4H5.24a2 2 0 0 0-1.79 1.11L1 10v8l1 2h20l1-2v-8zM5.24 6h13.52l2 4H17l-2 4H9l-2-4H3.24z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M41.11 10.21A4 4 0 0 0 37.53 8H10.47a4 4 0 0 0-3.58 2.21L2 20v16l2 4h40l2-4V20zm-32.43.9A2 2 0 0 1 10.47 10h27.06a2 2 0 0 1 1.79 1.11L43.76 20H34l-4 8H18l-4-8H4.24zM44 35.53L42.76 38H5.24L4 35.53V22h8.76l4 8h14.48l4-8H44z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M41.11 10.21A4 4 0 0 0 37.53 8H10.47a4 4 0 0 0-3.58 2.21L2 20v16l2 4h40l2-4V20zm-32.43.9A2 2 0 0 1 10.47 10h27.06a2 2 0 0 1 1.79 1.11L43.76 20H34l-4 8H18l-4-8H4.24z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 33h56v2H20zM25 25h46v2H25z"
      }), React.createElement("path", {
        d: "M82.21 20.42A8 8 0 0 0 75.06 16H20.94a8 8 0 0 0-7.15 4.42L4 40v32l4 8h80l4-8V40zm-64.84 1.79A4 4 0 0 1 20.94 20h54.12a4 4 0 0 1 3.57 2.21L87.53 40H68l-8 16H36l-8-16H8.47zM88 71.06L85.53 76H10.47L8 71.06V44h17.53l8 16h28.94l8-16H88z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 33h56v2H20zM25 25h46v2H25z"
      }), React.createElement("path", {
        d: "M82.21 20.42A8 8 0 0 0 75.06 16H20.94a8 8 0 0 0-7.15 4.42L4 40v32l4 8h80l4-8V40zm-64.84 1.79A4 4 0 0 1 20.94 20h54.12a4 4 0 0 1 3.57 2.21L87.53 40H68l-8 16H36l-8-16H8.47z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.55 5.11A2 2 0 0 0 18.76 4H5.24a2 2 0 0 0-1.79 1.11L1 10v8l1 2h20l1-2v-8zM5.24 6h13.52l2 4H17l-2 4H9l-2-4H3.24zM21 18H3v-6h2.76l2 4h8.48l2-4H21z"
      }));

    case 'communication___news':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 8V3H0v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8zm2 11H2V5h16v12h2v-7h2z"
      }), React.createElement("path", {
        d: "M10 7H4v6h6zm-2 4H6V9h2zM12 11h4v2h-4zM12 7h4v2h-4zM4 15h12v2H4z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 8v9h-2V3H0v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8zM3 7h6v6H3zm13 10H3v-2h13zm0-4h-5v-2h5zm0-4h-5V7h5z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 15V7H2v30a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V15zm2 22a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h36v28h2V17h2z"
      }), React.createElement("path", {
        d: "M22 13H8v12h14zm-2 10H10v-8h10zM8 33h28v2H8zM8 28h28v2H8zM25 18h11v2H25zM25 23h11v2H25zM25 13h11v2H25z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43 15v22h-2V7H2v30a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V15zM8 13h14v12H8zm28 22H8v-2h28zm0-5H8v-2h28zm0-5H25v-2h11zm0-5H25v-2h11zm0-5H25v-2h11z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 30V14H4v60a8 8 0 0 0 8 8h72a8 8 0 0 0 8-8V30zm4 44a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V18h72v56h4V34h4z"
      }), React.createElement("path", {
        d: "M16 50h25V26H16zm2-22h21v20H18zM16 67h25v2H16zM16 57h25v2H16zM47 67h25v2H47zM47 57h25v2H47zM47 37h25v2H47zM47 27h25v2H47zM47 47h25v2H47z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M86 30v44h-4V14H4v60a8 8 0 0 0 8 8h72a8 8 0 0 0 8-8V30zM41 69H16v-2h25zm0-10H16v-2h25zm0-9H16V26h25zm31 19H47v-2h25zm0-10H47v-2h25zm0-10H47v-2h25zm0-10H47v-2h25zm0-10H47v-2h25z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 8V3H0v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8zm2 11H2V5h16v12h2v-7h2z"
      }), React.createElement("path", {
        d: "M10 7H4v6h6zm-2 4H6V9h2zM12 11h4v2h-4zM12 7h4v2h-4zM4 15h12v2H4z"
      }));

    case 'communication___textchat':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 8h-3v2h3v7h-2l-1 2-1-2h-7v-2H8v2a2 2 0 0 0 2 2h6l2 4 2-4h1a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
      }), React.createElement("path", {
        d: "M14 13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h1l2 4 2-4zm-8 0l-1-2H3V4h11v7H7z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 8h-3v2h3v7h-2l-1 2-1-2h-7v-2H8v2a2 2 0 0 0 2 2h6l2 4 2-4h1a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
      }), React.createElement("path", {
        d: "M14 13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h1l2 4 2-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 16h-8v2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3.24L36 41.53 33.24 36H20a2 2 0 0 1-2-2v-6h-2v6a4 4 0 0 0 4 4h12l4 8 4-8h2a4 4 0 0 0 4-4V20a4 4 0 0 0-4-4z"
      }), React.createElement("path", {
        d: "M28 26a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h2l4 8 4-8zm-16 3.53L9.24 24H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H14.76z"
      }), React.createElement("path", {
        d: "M8 17h12v2H8zM8 11h18v2H8z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 16h-8v2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3.24L36 41.53 33.24 36H20a2 2 0 0 1-2-2v-6h-2v6a4 4 0 0 0 4 4h12l4 8 4-8h2a4 4 0 0 0 4-4V20a4 4 0 0 0-4-4z"
      }), React.createElement("path", {
        d: "M28 26a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h2l4 8 4-8zM8 11h18v2H8zm0 8v-2h12v2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 32H68v4h16a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4h-6.47L72 83.06 66.47 72H40a4 4 0 0 1-4-4V56h-4v12a8 8 0 0 0 8 8h24l8 16 8-16h4a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8z"
      }), React.createElement("path", {
        d: "M56 52a8 8 0 0 0 8-8V16a8 8 0 0 0-8-8H12a8 8 0 0 0-8 8v28a8 8 0 0 0 8 8h4l8 16 8-16zm-32 7.06L18.47 48H12a4 4 0 0 1-4-4V16a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H29.53z"
      }), React.createElement("path", {
        d: "M16 29h36v2H16zM16 37h24v2H16zM16 21h36v2H16z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 32H68v4h16a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4h-6.47L72 83.06 66.47 72H40a4 4 0 0 1-4-4V56h-4v12a8 8 0 0 0 8 8h24l8 16 8-16h4a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8z"
      }), React.createElement("path", {
        d: "M56 52a8 8 0 0 0 8-8V16a8 8 0 0 0-8-8H12a8 8 0 0 0-8 8v28a8 8 0 0 0 8 8h4l8 16 8-16zM16 21h36v2H16zm0 8h36v2H16zm0 10v-2h24v2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 8h-3v2h3v7h-2l-1 2-1-2h-7v-2H8v2a2 2 0 0 0 2 2h6l2 4 2-4h1a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
      }), React.createElement("path", {
        d: "M14 13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h1l2 4 2-4zm-8 0l-1-2H3V4h11v7H7z"
      }));

    case 'interaction_arrows_arrowDown':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 17.06V4h-2v13.06l-5.42-3.87-1.16 1.62L12 20.23l7.58-5.42-1.16-1.62L13 17.06z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14 14.73V4h-4v10.73l-4.13-2.95-1.74 2.44L12 19.84l7.87-5.62-1.74-2.44L14 14.73z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25 38.06V10h-2v28.06l-12.42-8.87-1.16 1.62L24 41.23l14.58-10.42-1.16-1.62L25 38.06z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 34.11V9h-4v25.11l-10.84-7.74-2.32 3.26L24 40.46l15.16-10.83-2.32-3.26L26 34.11z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M50 76.11V20h-4v56.11L21.16 58.37l-2.32 3.26L48 82.46l29.16-20.83-2.32-3.26L50 76.11z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M52 68.23V18h-8v50.23L22.32 52.74l-4.64 6.52L48 80.92l30.33-21.66-4.66-6.52L52 68.23z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 17.06V4h-2v13.06l-5.42-3.87-1.16 1.62L12 20.23l7.58-5.42-1.16-1.62L13 17.06z"
      }));

    case 'interaction_arrows_arrowLeft':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.19 19.58l1.62-1.16L4.94 13H22v-2H4.94l3.87-5.42-1.62-1.16L1.77 12l5.42 7.58z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.37 20.16l3.26-2.32L7.89 14H22v-4H7.89l2.74-3.84-3.26-2.32L1.54 12l5.83 8.16z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.19 38.58l1.62-1.16L7.94 25H44v-2H7.94l8.87-12.42-1.62-1.16L4.77 24l10.42 14.58z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.37 39.16l3.26-2.32L10.89 26H44v-4H10.89l7.74-10.84-3.26-2.32L4.54 24l10.83 15.16z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30.37 77.16l3.26-2.32L15.89 50H88v-4H15.89l17.74-24.84-3.26-2.32L9.54 48l20.83 29.16z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30.75 78.33l6.51-4.66L21.77 52H88v-8H21.77l15.49-21.68-6.51-4.64L9.08 48l21.67 30.33z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.19 19.58l1.62-1.16L4.94 13H22v-2H4.94l3.87-5.42-1.62-1.16L1.77 12l5.42 7.58z"
      }));

    case 'interaction_arrows_arrowRight':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.81 4.42l-1.62 1.16L19.06 11H2v2h17.06l-3.87 5.42 1.62 1.16L22.23 12l-5.42-7.58z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.63 3.84l-3.26 2.32L16.11 10H2v4h14.11l-2.74 3.84 3.26 2.32L22.46 12l-5.83-8.16z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32.81 9.42l-1.62 1.16L40.06 23H4v2h36.06l-8.87 12.42 1.62 1.16L43.23 24 32.81 9.42z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32.63 8.84l-3.26 2.32L37.11 22H4v4h33.11l-7.74 10.84 3.26 2.32L43.46 24 32.63 8.84z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M65.63 18.84l-3.26 2.32L80.11 46H8v4h72.11L62.37 74.84l3.26 2.32L86.46 48 65.63 18.84z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M65.25 17.68l-6.51 4.64L74.23 44H8v8h66.23L58.74 73.67l6.51 4.66L86.92 48 65.25 17.68z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.81 4.42l-1.62 1.16L19.06 11H2v2h17.06l-3.87 5.42 1.62 1.16L22.23 12l-5.42-7.58z"
      }));

    case 'interaction_arrows_arrowUp':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 6.94V20h2V6.94l5.42 3.87 1.16-1.62L12 3.77 4.42 9.19l1.16 1.62L11 6.94z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 9.27V20h4V9.27l4.13 2.95 1.74-2.44L12 4.16 4.13 9.78l1.74 2.44L10 9.27z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 9.94V38h2V9.94l12.42 8.87 1.16-1.62L24 6.77 9.42 17.19l1.16 1.62L23 9.94z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 13.89V39h4V13.89l10.84 7.74 2.32-3.26L24 7.54 8.84 18.37l2.32 3.26L22 13.89z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 19.89V76h4V19.89l24.84 17.74 2.32-3.26L48 13.54 18.84 34.37l2.32 3.26L46 19.89z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 27.77V78h8V27.77l21.67 15.49 4.66-6.52L48 15.08 17.68 36.74l4.64 6.52L44 27.77z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 6.94V20h2V6.94l5.42 3.87 1.16-1.62L12 3.77 4.42 9.19l1.16 1.62L11 6.94z"
      }));

    case 'interaction_arrows_chevronDown':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 15.15l-7.5-4.28 1-1.74 6.5 3.72 6.5-3.72 1 1.74-7.5 4.28z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 16.3l-7.99-4.56 1.98-3.48L12 11.7l6.01-3.44 1.98 3.48L12 16.3z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 30.15L9.5 21.87l1-1.74L24 27.85l13.5-7.72 1 1.74L24 30.15z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 31.3L9.01 22.74l1.98-3.48L24 26.7l13.01-7.44 1.98 3.48L24 31.3z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 60.3L19.01 43.74l1.98-3.48L48 55.7l27.01-15.44 1.98 3.48L48 60.3z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 62.61L18.02 45.47l3.96-6.94L48 53.39l26.02-14.86 3.96 6.94L48 62.61z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 15.15l-7.5-4.28 1-1.74 6.5 3.72 6.5-3.72 1 1.74-7.5 4.28z"
      }));

    case 'interaction_arrows_chevronLeft':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.13 19.5L8.85 12l4.28-7.5 1.74 1-3.72 6.5 3.72 6.5-1.74 1z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.26 19.99L7.7 12l4.56-7.99 3.48 1.98L12.3 12l3.44 6.01-3.48 1.98z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26.13 38.5L17.85 24l8.28-14.5 1.74 1L20.15 24l7.72 13.5-1.74 1z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25.26 38.99L16.7 24l8.56-14.99 3.48 1.98L21.3 24l7.44 13.01-3.48 1.98z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M52.26 76.99L35.7 48l16.56-28.99 3.48 1.98L40.3 48l15.44 27.01-3.48 1.98z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M50.53 77.98L33.39 48l17.14-29.98 6.94 3.96L42.61 48l14.86 26.02-6.94 3.96z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.13 19.5L8.85 12l4.28-7.5 1.74 1-3.72 6.5 3.72 6.5-1.74 1z"
      }));

    case 'interaction_arrows_chevronRight':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.87 19.5l-1.74-1 3.72-6.5-3.72-6.5 1.74-1 4.28 7.5-4.28 7.5z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11.74 19.99l-3.48-1.98L11.7 12 8.26 5.99l3.48-1.98L16.3 12l-4.56 7.99z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.87 38.5l-1.74-1L27.85 24l-7.72-13.5 1.74-1L30.15 24l-8.28 14.5z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.74 38.99l-3.48-1.98L26.7 24l-7.44-13.01 3.48-1.98L31.3 24l-8.56 14.99z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.74 76.99l-3.48-1.98L55.7 48 40.26 20.99l3.48-1.98L60.3 48 43.74 76.99z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M45.47 77.98l-6.94-3.96L53.39 48 38.53 21.98l6.94-3.96L62.61 48 45.47 77.98z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.87 19.5l-1.74-1 3.72-6.5-3.72-6.5 1.74-1 4.28 7.5-4.28 7.5z"
      }));

    case 'interaction_arrows_chevronUp':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.5 14.87L12 11.15l-6.5 3.72-1-1.74L12 8.85l7.5 4.28-1 1.74z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.01 15.74L12 12.3l-6.01 3.44-1.98-3.48L12 7.7l7.99 4.56-1.98 3.48z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M37.5 27.87L24 20.15l-13.5 7.72-1-1.74L24 17.85l14.5 8.28-1 1.74z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M37.01 28.74L24 21.3l-13.01 7.44-1.98-3.48L24 16.7l14.99 8.56-1.98 3.48z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M75.01 55.74L48 40.3 20.99 55.74l-1.98-3.48L48 35.7l28.99 16.56-1.98 3.48z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M74.02 57.47L48 42.61 21.98 57.47l-3.96-6.94L48 33.39l29.98 17.14-3.96 6.94z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.5 14.87L12 11.15l-6.5 3.72-1-1.74L12 8.85l7.5 4.28-1 1.74z"
      }));

    case 'interaction___add':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 11h-9V2h-2v9H2v2h9v9h2v-9h9v-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 10h-8V2h-4v8H2v4h8v8h4v-8h8v-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 23H25V6h-2v17H6v2h17v17h2V25h17v-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 22H26V6h-4v16H6v4h16v16h4V26h16v-4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 46H50V12h-4v34H12v4h34v34h4V50h34v-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M84 44H52V12h-8v32H12v8h32v32h8V52h32v-8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 11h-9V2h-2v9H2v2h9v9h2v-9h9v-2z"
      }));

    case 'interaction___checkmark':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.18 21.6l-6.89-6.89 1.42-1.42 5.11 5.11 9.33-14.93 1.7 1.06L10.18 21.6z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.36 22.19l-7.77-7.78 2.82-2.82 4.23 4.22L18.3 1.94l3.4 2.12-11.34 18.13z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.18 41.6L7.29 28.71l1.42-1.42L19.82 38.4 39.15 7.47l1.7 1.06L20.18 41.6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.36 41.19L6.59 27.41l2.82-2.82 10.23 10.22L38.3 4.94l3.4 2.12-21.34 34.13z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.36 83.19L14.59 57.41l2.82-2.82 22.23 22.22L78.3 14.94l3.4 2.12-41.34 66.13z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.73 82.38L13.17 54.83l5.66-5.66 20.44 20.45L76.61 9.88l6.78 4.24-42.66 68.26z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.18 21.6l-6.89-6.89 1.42-1.42 5.11 5.11 9.33-14.93 1.7 1.06L10.18 21.6z"
      }));

    case 'interaction___close':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.46 4.96l-1.42-1.42L12 10.59 4.96 3.54 3.54 4.96 10.59 12l-7.05 7.04 1.42 1.42L12 13.41l7.04 7.05 1.42-1.42L13.41 12l7.05-7.04z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.16 5.66l-2.82-2.82L12 9.17 5.66 2.84 2.84 5.66 9.17 12l-6.33 6.34 2.82 2.82L12 14.83l6.34 6.33 2.82-2.82L14.83 12l6.33-6.34z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.21 9.21l-1.42-1.42L24 22.59 9.21 7.79 7.79 9.21 22.59 24 7.79 38.79l1.42 1.42L24 25.41l14.79 14.8 1.42-1.42L25.41 24l14.8-14.79z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.91 9.91l-2.82-2.82L24 21.17 9.91 7.09 7.09 9.91 21.17 24 7.09 38.09l2.82 2.82L24 26.83l14.09 14.08 2.82-2.82L26.83 24 40.91 9.91z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80.41 18.41l-2.82-2.82L48 45.17 18.41 15.59l-2.82 2.82L45.17 48 15.59 77.59l2.82 2.82L48 50.83l29.59 29.58 2.82-2.82L50.83 48l29.58-29.59z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M81.83 19.83l-5.66-5.66L48 42.34 19.83 14.17l-5.66 5.66L42.34 48 14.17 76.17l5.66 5.66L48 53.66l28.17 28.17 5.66-5.66L53.66 48l28.17-28.17z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.46 4.96l-1.42-1.42L12 10.59 4.96 3.54 3.54 4.96 10.59 12l-7.05 7.04 1.42 1.42L12 13.41l7.04 7.05 1.42-1.42L13.41 12l7.05-7.04z"
      }));

    case 'interaction___copy':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 0H3v20h15zm-2 18H5V2h11z"
      }), React.createElement("path", {
        d: "M20 3v19H6v2h16V3h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 0h15v20H3z"
      }), React.createElement("path", {
        d: "M20 3v19H6v2h16V3h-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 2H6v40h32zm-2 38H8V4h28z"
      }), React.createElement("path", {
        d: "M40 7v37H11v2h31V7h-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 2h32v40H6z"
      }), React.createElement("path", {
        d: "M40 7v37H11v2h31V7h-2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 4H12v80h64zm-4 76H16V8h56z"
      }), React.createElement("path", {
        d: "M80 14v74H22v4h62V14h-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 4h64v80H12z"
      }), React.createElement("path", {
        d: "M80 14v74H22v4h62V14h-4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 0H3v20h15zm-2 18H5V2h11z"
      }), React.createElement("path", {
        d: "M20 3v19H6v2h16V3h-2z"
      }));

    case 'interaction___dashLong':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 11h20v2H2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 10h20v4H2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 23h36v2H6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 22h36v4H6z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 46h72v4H12z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 44h72v8H12z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 11h20v2H2z"
      }));

    case 'interaction___dashShort':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 11h14v2H5z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 10h14v4H5z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 23h28v2H10z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 22h28v4H10z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 46h56v4H20z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 44h56v8H20z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 11h14v2H5z"
      }));

    case 'interaction___download':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.58 12.81l-1.16-1.62L13 15.06V2h-2v13.06l-5.42-3.87-1.16 1.62L12 18.23l7.58-5.42zM2 21h20v2H2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.87 12.22l-1.74-2.44L14 12.73V2h-4v10.73L5.87 9.78l-1.74 2.44L12 17.84l7.87-5.62zM2 19h20v4H2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38.58 24.81l-1.16-1.62L25 32.06V4h-2v28.06l-12.42-8.87-1.16 1.62L24 35.23l14.58-10.42zM4 42h40v2H4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.16 24.63l-2.32-3.26L26 29.11V4h-4v25.11l-10.84-7.74-2.32 3.26L24 35.46l15.16-10.83zM4 40h40v4H4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M77.16 49.63l-2.32-3.26L50 64.11V8h-4v56.11L21.16 46.37l-2.32 3.26L48 70.46l29.16-20.83zM8 84h80v4H8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78.33 49.26l-4.66-6.52L52 58.23V8h-8v50.23L22.32 42.74l-4.64 6.52L48 70.92l30.33-21.66zM8 80h80v8H8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.58 12.81l-1.16-1.62L13 15.06V2h-2v13.06l-5.42-3.87-1.16 1.62L12 18.23l7.58-5.42zM2 21h20v2H2z"
      }));

    case 'interaction___eyeHide':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.46 10.18A4 4 0 0 0 12 16z"
      }), React.createElement("path", {
        d: "M12 18.25c-3.46 0-6.93-3.88-8.61-6.25A21.86 21.86 0 0 1 7.1 7.93l-1-1.73A24.69 24.69 0 0 0 1 12s4.92 8.25 11 8.25a7.38 7.38 0 0 0 2.29-.38l-1.06-1.78a5.19 5.19 0 0 1-1.23.16zM23 12s-4.92-8.25-11-8.25a7.34 7.34 0 0 0-2.46.45L7.61 1 5.89 2l12.5 20.75 1.72-1-2.31-3.84A24.56 24.56 0 0 0 23 12zm-7.55 2a3.93 3.93 0 0 0 .55-2 4 4 0 0 0-4-4h-.16l-1.23-2A5.09 5.09 0 0 1 12 5.75c3.46 0 6.93 3.88 8.61 6.25a21.71 21.71 0 0 1-3.85 4.18z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M0 0h24v24H0z",
        className: "a"
      }), React.createElement("path", {
        d: "M8 12a4 4 0 0 1 .46-1.82l-2.4-4A24.69 24.69 0 0 0 1 12s4.92 8.25 11 8.25a7.38 7.38 0 0 0 2.29-.38L12 16a4 4 0 0 1-4-4zM23 12s-4.92-8.25-11-8.25a7.34 7.34 0 0 0-2.46.45L7.61 1 5.89 2l12.5 20.75 1.72-1-2.31-3.84A24.56 24.56 0 0 0 23 12zM12 8a4 4 0 0 1 4 4 3.93 3.93 0 0 1-.55 2l-3.61-6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.77 20.6A7.89 7.89 0 0 0 16 24a8 8 0 0 0 7.62 8l-1.34-2.23A6 6 0 0 1 18 24a5.5 5.5 0 0 1 .12-1.16z"
      }), React.createElement("path", {
        d: "M24 38.5c-9.21 0-17.31-11-19.62-14.5a50.64 50.64 0 0 1 5.5-6.86A37.62 37.62 0 0 1 13 14.28l-1-1.73A49.24 49.24 0 0 0 2 24s9.85 16.5 22 16.5a14.74 14.74 0 0 0 4.34-.68L27.27 38a12.47 12.47 0 0 1-3.27.5zM46 24S36.15 7.5 24 7.5a16.26 16.26 0 0 0-7.44 2l-4.2-7-1.72 1 25 41.5 1.72-1-4-6.58C40.84 32.62 46 24 46 24zm-18 4.46l-6.07-10.08A5.94 5.94 0 0 1 24 18a6 6 0 0 1 4 10.46zm4.36 7.22L29 30.18a8 8 0 0 0-8.15-13.53l-3.25-5.46A14.21 14.21 0 0 1 24 9.5c9.21 0 17.31 11 19.62 14.5a50.64 50.64 0 0 1-5.5 6.86 32.59 32.59 0 0 1-5.76 4.82z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 24a7.89 7.89 0 0 1 .77-3.4l-4.85-8A49.24 49.24 0 0 0 2 24s9.85 16.5 22 16.5a14.74 14.74 0 0 0 4.34-.68L23.62 32A8 8 0 0 1 16 24zM46 24S36.15 7.5 24 7.5a16.26 16.26 0 0 0-7.44 2l-4.2-7-1.72 1 25 41.5 1.72-1-4-6.58C40.84 32.62 46 24 46 24zm-25.11-7.35A7.87 7.87 0 0 1 24 16a8 8 0 0 1 5 14.18z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M33.53 41.2A16 16 0 0 0 47.25 64l-2.7-4.47A12 12 0 0 1 36 48a11.78 11.78 0 0 1 .23-2.32zM92 48S72.3 15 48 15a32.45 32.45 0 0 0-14.87 3.94L24.71 5l-3.42 2 50 83 3.42-2-7.93-13.2C81.68 65.25 92 48 92 48zm-36 8.91L43.86 36.75A11.83 11.83 0 0 1 48 36a12 12 0 0 1 8 20.91zm8.72 14.48l-6.63-11a16 16 0 0 0-16.33-27.12l-6.57-10.91A28.44 28.44 0 0 1 48 19c18.41 0 34.61 22.07 39.24 29-3.14 4.7-11.63 16.37-22.51 23.39z"
      }), React.createElement("path", {
        d: "M48 77C29.59 77 13.39 54.93 8.76 48a95.2 95.2 0 0 1 17.15-19.46l-2.08-3.44C11.89 34.8 4 48 4 48s19.7 33 44 33a29.34 29.34 0 0 0 8.69-1.37l-2.14-3.54A25 25 0 0 1 48 77z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 48S72.3 15 48 15a32.45 32.45 0 0 0-14.87 3.94L24.71 5l-3.42 2 50 83 3.42-2-7.93-13.2C81.68 65.25 92 48 92 48zM41.76 33.27A16 16 0 0 1 58.1 60.4zM32 48a16 16 0 0 1 1.53-6.8l-9.7-16.1C11.89 34.8 4 48 4 48s19.7 33 44 33a29.34 29.34 0 0 0 8.69-1.37L47.25 64A16 16 0 0 1 32 48z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.46 10.18A4 4 0 0 0 12 16z"
      }), React.createElement("path", {
        d: "M12 18.25c-3.46 0-6.93-3.88-8.61-6.25A21.86 21.86 0 0 1 7.1 7.93l-1-1.73A24.69 24.69 0 0 0 1 12s4.92 8.25 11 8.25a7.38 7.38 0 0 0 2.29-.38l-1.06-1.78a5.19 5.19 0 0 1-1.23.16zM23 12s-4.92-8.25-11-8.25a7.34 7.34 0 0 0-2.46.45L7.61 1 5.89 2l12.5 20.75 1.72-1-2.31-3.84A24.56 24.56 0 0 0 23 12zm-7.55 2a3.93 3.93 0 0 0 .55-2 4 4 0 0 0-4-4h-.16l-1.23-2A5.09 5.09 0 0 1 12 5.75c3.46 0 6.93 3.88 8.61 6.25a21.71 21.71 0 0 1-3.85 4.18z"
      }));

    case 'interaction___eyeView':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 3.75C5.92 3.75 1 12 1 12s4.92 8.25 11 8.25S23 12 23 12s-4.92-8.25-11-8.25zm0 14.5c-3.46 0-6.93-3.88-8.61-6.25C5.07 9.62 8.54 5.75 12 5.75s6.93 3.88 8.61 6.25c-1.68 2.38-5.15 6.25-8.61 6.25z"
      }), React.createElement("path", {
        d: "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 3.75C5.92 3.75 1 12 1 12s4.92 8.25 11 8.25S23 12 23 12s-4.92-8.25-11-8.25zM12 16a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 7.5C11.85 7.5 2 24 2 24s9.85 16.5 22 16.5S46 24 46 24 36.15 7.5 24 7.5zm14.12 23.36C34.75 34.35 29.57 38.5 24 38.5c-9.21 0-17.31-11-19.62-14.5a50.64 50.64 0 0 1 5.5-6.86C13.25 13.65 18.43 9.5 24 9.5c9.21 0 17.31 11 19.62 14.5a50.64 50.64 0 0 1-5.5 6.86z"
      }), React.createElement("path", {
        d: "M24 16a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 1 1 6-6 6 6 0 0 1-6 6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 7.5C11.85 7.5 2 24 2 24s9.85 16.5 22 16.5S46 24 46 24 36.15 7.5 24 7.5zM24 32a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 15C23.7 15 4 48 4 48s19.7 33 44 33 44-33 44-33-19.7-33-44-33zm0 62C29.59 77 13.39 54.93 8.76 48 13.39 41.07 29.59 19 48 19s34.61 22.07 39.24 29C82.61 54.93 66.41 77 48 77z"
      }), React.createElement("path", {
        d: "M48 28a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm0 36a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
      }), React.createElement("path", {
        d: "M48 38a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 5a5 5 0 0 0-5 5h-2a7 7 0 0 1 7-7z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 15C23.7 15 4 48 4 48s19.7 33 44 33 44-33 44-33-19.7-33-44-33zm0 53a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M48 36a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 5a7 7 0 0 0-7 7h-2a9 9 0 0 1 9-9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 3.75C5.92 3.75 1 12 1 12s4.92 8.25 11 8.25S23 12 23 12s-4.92-8.25-11-8.25zm0 14.5c-3.46 0-6.93-3.88-8.61-6.25C5.07 9.62 8.54 5.75 12 5.75s6.93 3.88 8.61 6.25c-1.68 2.38-5.15 6.25-8.61 6.25z"
      }), React.createElement("path", {
        d: "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));

    case 'interaction___filter01':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 3h22v2H1zM5 11h14v2H5zM9 19h6v2H9z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 2h22v4H1zM5 10h14v4H5zM9 18h6v4H9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 7h44v2H2zM10 23h28v2H10zM18 39h12v2H18z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 6h44v4H2zM10 22h28v4H10zM18 38h12v4H18z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 14h88v4H4zM20 46h56v4H20zM36 78h24v4H36z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 12h88v8H4zM20 44h56v8H20zM36 76h24v8H36z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 3h22v2H1zM5 11h14v2H5zM9 19h6v2H9z"
      }));

    case 'interaction___filter02':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.17 4L13 12.17v5l-2 2v-7L2.83 4h18.34m1.21-2H1.62a1 1 0 0 0-.9.55L0 4l9 9v11l6-6v-5l9-9-.72-1.45a1 1 0 0 0-.9-.55z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.38 2H1.62a1 1 0 0 0-.9.55L0 4l10 10v9l4-4v-5L24 4l-.72-1.45a1 1 0 0 0-.9-.55z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42.76 6l.81 1.61L27 24.17v11l-6 6v-17L4.43 7.61 5.24 6h37.52m0-2H5.24a2 2 0 0 0-1.79 1.11L2 8l17 17v21l10-10V25L46 8l-1.45-2.89A2 2 0 0 0 42.76 4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42.76 4H5.24a2 2 0 0 0-1.79 1.11L2 8l18 18v20l8-8V26L46 8l-1.45-2.89A2 2 0 0 0 42.76 4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M89.11 10.21A4 4 0 0 0 85.53 8H10.47a4 4 0 0 0-3.58 2.21L4 16l34 34v42l20-20V50l34-34zM54 48.34v22l-12 12v-34L8.87 15.21l1.6-3.21h75.06l1.6 3.21z"
      }), React.createElement("path", {
        d: "M15 15h66v2H15z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M89.11 10.21A4 4 0 0 0 85.53 8H10.47a4 4 0 0 0-3.58 2.21L4 16l36 36v40l16-16V52l36-36zM81 17H15v-2h66z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.17 4L13 12.17v5l-2 2v-7L2.83 4h18.34m1.21-2H1.62a1 1 0 0 0-.9.55L0 4l9 9v11l6-6v-5l9-9-.72-1.45a1 1 0 0 0-.9-.55z"
      }));

    case 'interaction___fingerprint':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.9 13v-1h-1.8v1a7.57 7.57 0 0 0 7.57 7.57V18.8A5.78 5.78 0 0 1 12.9 13z"
      }), React.createElement("path", {
        d: "M12 1.1A10.91 10.91 0 0 0 1.1 12v1a17 17 0 0 0 1.33 6.61l1.66-.7A15.11 15.11 0 0 1 2.9 13v-1a9.1 9.1 0 0 1 18.2 0v1a2.44 2.44 0 1 1-4.87 0v-1a4.23 4.23 0 0 0-8.46 0v1a10.93 10.93 0 0 0 6.65 10l.7-1.66a9.14 9.14 0 0 1-4.84-4.84 9.18 9.18 0 0 1-.71-3.5v-1a2.43 2.43 0 0 1 4.86 0v1a4.24 4.24 0 1 0 8.47 0v-1A10.91 10.91 0 0 0 12 1.1z"
      }), React.createElement("path", {
        d: "M6.23 12a5.77 5.77 0 0 1 11.54 0v1h1.8v-1a7.57 7.57 0 0 0-15.14 0v1A14.11 14.11 0 0 0 8.6 23.06l1.28-1.27A12.35 12.35 0 0 1 6.23 13z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.9 13v-1h-1.8v1a7.57 7.57 0 0 0 7.57 7.57V18.8A5.78 5.78 0 0 1 12.9 13z"
      }), React.createElement("path", {
        d: "M12 1.1A10.91 10.91 0 0 0 1.1 12v1a17 17 0 0 0 1.33 6.61l1.66-.7A15.11 15.11 0 0 1 2.9 13v-1a9.1 9.1 0 0 1 18.2 0v1a2.44 2.44 0 1 1-4.87 0v-1a4.23 4.23 0 0 0-8.46 0v1a10.93 10.93 0 0 0 6.65 10l.7-1.66a9.14 9.14 0 0 1-4.84-4.84 9.18 9.18 0 0 1-.71-3.5v-1a2.43 2.43 0 0 1 4.86 0v1a4.24 4.24 0 1 0 8.47 0v-1A10.91 10.91 0 0 0 12 1.1z"
      }), React.createElement("path", {
        d: "M6.23 12a5.77 5.77 0 0 1 11.54 0v1h1.8v-1a7.57 7.57 0 0 0-15.14 0v1A14.11 14.11 0 0 0 8.6 23.06l1.28-1.27A12.35 12.35 0 0 1 6.23 13z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 19.5a10 10 0 0 1 10 10h2a12 12 0 0 0-24-.06v.06a22.89 22.89 0 0 0 6.74 16.21l1.41-1.42A20.87 20.87 0 0 1 14 29.47a10 10 0 0 1 10-9.97z"
      }), React.createElement("path", {
        d: "M25 29.5h-2a12 12 0 0 0 12 12v-2a10 10 0 0 1-10-10z"
      }), React.createElement("path", {
        d: "M24 12A17.52 17.52 0 0 0 6.5 29.5a27.39 27.39 0 0 0 2.16 10.7l1.84-.77a25.38 25.38 0 0 1-2-9.93 15.5 15.5 0 0 1 31 0 4.5 4.5 0 0 1-9 0 6.5 6.5 0 0 0-13 0 17.53 17.53 0 0 0 10.69 16.12l.81-1.84a15.5 15.5 0 0 1-9.5-14.28 4.5 4.5 0 0 1 9 0 6.5 6.5 0 0 0 13 0A17.52 17.52 0 0 0 24 12z"
      }), React.createElement("path", {
        d: "M38.85 15.15l1.41-1.41a23 23 0 0 0-32.52 0l1.41 1.41a21 21 0 0 1 29.7 0z"
      }), React.createElement("path", {
        d: "M24 4a25.38 25.38 0 0 1 9.93 2l.77-1.84a27.58 27.58 0 0 0-21.4 0L14.07 6A25.38 25.38 0 0 1 24 4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 20a9.51 9.51 0 0 1 9.5 9.5h3a12.5 12.5 0 0 0-25-.06v.06a23.37 23.37 0 0 0 6.88 16.56l2.12-2.12a20.4 20.4 0 0 1-6-14.47A9.52 9.52 0 0 1 24 20z"
      }), React.createElement("path", {
        d: "M25.5 29.5h-3A12.52 12.52 0 0 0 35 42v-3a9.51 9.51 0 0 1-9.5-9.5z"
      }), React.createElement("path", {
        d: "M24 11.5a18 18 0 0 0-18 18 27.82 27.82 0 0 0 2.2 10.9l2.8-1.17a24.87 24.87 0 0 1-2-9.73 15 15 0 0 1 30 0 4 4 0 0 1-8 0 7 7 0 0 0-14 0 18 18 0 0 0 11 16.58l1.17-2.76A15 15 0 0 1 20 29.5a4 4 0 0 1 8 0 7 7 0 0 0 14 0 18 18 0 0 0-18-18z"
      }), React.createElement("path", {
        d: "M38.5 15.5l2.12-2.12a23.51 23.51 0 0 0-33.24 0L9.5 15.5a20.54 20.54 0 0 1 29 0z"
      }), React.createElement("path", {
        d: "M24 4.5a24.87 24.87 0 0 1 9.73 2l1.17-2.8a28.1 28.1 0 0 0-21.8 0l1.17 2.76A24.87 24.87 0 0 1 24 4.5z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 39a20 20 0 0 1 20 20h4a24 24 0 0 0-48-.11V59a45.68 45.68 0 0 0 13.47 32.41l2.83-2.82A41.77 41.77 0 0 1 28 59a20 20 0 0 1 20-20z"
      }), React.createElement("path", {
        d: "M50 59h-4a24 24 0 0 0 24 24v-4a20 20 0 0 1-20-20z"
      }), React.createElement("path", {
        d: "M48 24a35 35 0 0 0-35 35 54.64 54.64 0 0 0 4.32 21.41L21 78.85A50.66 50.66 0 0 1 17 59a31 31 0 0 1 62 0 9 9 0 0 1-18 0 13 13 0 0 0-26 0 35 35 0 0 0 21.38 32.25l1.55-3.69A31 31 0 0 1 39 59a9 9 0 0 1 18 0 13 13 0 0 0 26 0 35 35 0 0 0-35-35z"
      }), React.createElement("path", {
        d: "M77.7 30.3l2.83-2.83a46.07 46.07 0 0 0-65.06 0l2.83 2.83a42.06 42.06 0 0 1 59.4 0z"
      }), React.createElement("path", {
        d: "M48 8a50.66 50.66 0 0 1 19.85 4l1.56-3.69a55.21 55.21 0 0 0-42.82 0L28.15 12A50.66 50.66 0 0 1 48 8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 40a19 19 0 0 1 19 19h6a25 25 0 0 0-50-.11V59a46.7 46.7 0 0 0 13.77 33.12L41 87.88A40.72 40.72 0 0 1 29 59a19 19 0 0 1 19-19z"
      }), React.createElement("path", {
        d: "M51 59h-6a25 25 0 0 0 25 25v-6a19 19 0 0 1-19-19z"
      }), React.createElement("path", {
        d: "M48 23a36 36 0 0 0-36 36 55.68 55.68 0 0 0 4.4 21.8l5.53-2.34A49.61 49.61 0 0 1 18 59a30 30 0 0 1 60 0 8 8 0 0 1-16 0 14 14 0 0 0-28 0 36 36 0 0 0 22 33.17l2.33-5.53A30 30 0 0 1 40 59a8 8 0 0 1 16 0 14 14 0 0 0 28 0 36 36 0 0 0-36-36z"
      }), React.createElement("path", {
        d: "M77 31l4.24-4.24a47 47 0 0 0-66.46 0L19 31a41 41 0 0 1 58 0z"
      }), React.createElement("path", {
        d: "M48 9a49.61 49.61 0 0 1 19.46 3.93L69.8 7.4a56.2 56.2 0 0 0-43.6 0l2.34 5.53A49.61 49.61 0 0 1 48 9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.9 13v-1h-1.8v1a7.57 7.57 0 0 0 7.57 7.57V18.8A5.78 5.78 0 0 1 12.9 13z"
      }), React.createElement("path", {
        d: "M12 1.1A10.91 10.91 0 0 0 1.1 12v1a17 17 0 0 0 1.33 6.61l1.66-.7A15.11 15.11 0 0 1 2.9 13v-1a9.1 9.1 0 0 1 18.2 0v1a2.44 2.44 0 1 1-4.87 0v-1a4.23 4.23 0 0 0-8.46 0v1a10.93 10.93 0 0 0 6.65 10l.7-1.66a9.14 9.14 0 0 1-4.84-4.84 9.18 9.18 0 0 1-.71-3.5v-1a2.43 2.43 0 0 1 4.86 0v1a4.24 4.24 0 1 0 8.47 0v-1A10.91 10.91 0 0 0 12 1.1z"
      }), React.createElement("path", {
        d: "M6.23 12a5.77 5.77 0 0 1 11.54 0v1h1.8v-1a7.57 7.57 0 0 0-15.14 0v1A14.11 14.11 0 0 0 8.6 23.06l1.28-1.27A12.35 12.35 0 0 1 6.23 13z"
      }));

    case 'interaction___flashOff':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.48 19.4l2-4.12-1.88-3.2-1.87-.68.91-.92-.8-1.32L5 12l5.5 2L6 23h1.17a2 2 0 0 0 1.42-.59l4.52-4.52-.8-1.32zM12.59 13.16v.01-.01zM20.11 21.73L16 15l3-3-5.5-2L18 1h-1.17a2 2 0 0 0-1.42.59l-4.64 4.64L7.61 1 5.89 2l12.5 20.75zM14.52 4.6l-2.15 4.3-.8-1.34zm-.38 7.23l2.13.77-1 1.05z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 23h.67a2 2 0 0 0 1.42-.59l4.83-4.83-2.3-3.82zM8.03 9.47l-2.28 2.28 4.63 1.62-2.35-3.9zM20.11 21.73l-4.27-7.07 2.41-2.41-4.89-1.71-.07-.12L18 1h-.67a2 2 0 0 0-1.42.59L11 6.54 7.61 1 5.89 2l12.5 20.75z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 24l-11-4 9-18h-2.34a4 4 0 0 0-2.83 1.17L19.56 14.44l-7.2-12-1.72 1 25 41.5 1.72-1-7.27-12.03zM32.24 4.59a1.79 1.79 0 0 1 .38-.3l-8.41 16.82 10.16 3.7L29 30.15l-8.4-13.94zM15.76 43.41a1.79 1.79 0 0 1-.38.3l6.94-13.89-2.67-4.44-6-2.19 2.93-2.93-1.08-1.76L10 24l11 4-9 18h2.34a4 4 0 0 0 2.83-1.17L26 36l-1-1.79z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 46h1.34a4 4 0 0 0 2.83-1.17l9.48-9.48-4.55-7.55zM15.88 19.12L11.5 23.5l8.89 3.11-4.51-7.49zM29.71 31.29l6.79-6.79-10-3.5L36 2h-1.34a4 4 0 0 0-2.83 1.17L19.94 15.06 12.36 2.48l-1.72 1 25 41.5 1.72-1z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 48l-22-8L72 4h-4.69a8 8 0 0 0-5.65 2.34L39.12 28.88 24.71 5l-3.42 2 50 83 3.42-2-14.54-24.17zM64.48 9.17a3.88 3.88 0 0 1 .76-.59L48.42 42.23l20.31 7.38L58 60.3 41.25 32.41zM31.52 86.83a3.88 3.88 0 0 1-.76.59l13.89-27.77-5.36-8.89-12-4.37 5.86-5.86L31 37 20 48l22 8-18 36h4.69a8 8 0 0 0 5.65-2.34l17.72-17.72-2.13-3.53z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 92h2.69a8 8 0 0 0 5.65-2.34l19-19-9.14-15.07zM31.75 38.24L23 47l17.78 6.22-9.03-14.98zM59.42 62.58L73 49l-20-7L72 4h-2.69a8 8 0 0 0-5.65 2.34L39.87 30.13 24.71 5l-3.42 2 50 83 3.42-2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.48 19.4l2-4.12-1.88-3.2-1.87-.68.91-.92-.8-1.32L5 12l5.5 2L6 23h1.17a2 2 0 0 0 1.42-.59l4.52-4.52-.8-1.32zM12.59 13.16v.01-.01zM20.11 21.73L16 15l3-3-5.5-2L18 1h-1.17a2 2 0 0 0-1.42.59l-4.64 4.64L7.61 1 5.89 2l12.5 20.75zM14.52 4.6l-2.15 4.3-.8-1.34zm-.38 7.23l2.13.77-1 1.05z"
      }));

    case 'interaction___flashOn':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.52 4.6l-3.11 6.23 4.86 1.77-6.79 6.8 3.11-6.23-4.86-1.77 6.79-6.8M18 1h-1.17a2 2 0 0 0-1.42.59L5 12l5.5 2L6 23h1.17a2 2 0 0 0 1.42-.59L19 12l-5.5-2L18 1z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.25 12.25l-5-1.75L18 1h-.67a2 2 0 0 0-1.42.59L5.75 11.75l5 1.75L6 23h.67a2 2 0 0 0 1.42-.59z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32.62 4.29l-8.41 16.82 10.16 3.7-18.61 18.6a1.79 1.79 0 0 1-.38.3l8.41-16.82-10.16-3.7 18.61-18.6a1.79 1.79 0 0 1 .38-.3M36 2h-2.34a4 4 0 0 0-2.83 1.17L10 24l11 4-9 18h2.34a4 4 0 0 0 2.83-1.17L38 24l-11-4 9-18z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36.5 24.5l-10-3.5L36 2h-1.34a4 4 0 0 0-2.83 1.17L11.5 23.5l10 3.5L12 46h1.34a4 4 0 0 0 2.83-1.17z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M65.24 8.58L48.42 42.23l20.31 7.38-37.21 37.22a3.88 3.88 0 0 1-.76.59l16.82-33.65-20.31-7.38L64.48 9.17a3.88 3.88 0 0 1 .76-.59M72 4h-4.69a8 8 0 0 0-5.65 2.34L20 48l22 8-18 36h4.69a8 8 0 0 0 5.65-2.34L76 48l-22-8L72 4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M73 49l-20-7L72 4h-2.69a8 8 0 0 0-5.65 2.34L23 47l20 7-19 38h2.69a8 8 0 0 0 5.65-2.34z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.52 4.6l-3.11 6.23 4.86 1.77-6.79 6.8 3.11-6.23-4.86-1.77 6.79-6.8M18 1h-1.17a2 2 0 0 0-1.42.59L5 12l5.5 2L6 23h1.17a2 2 0 0 0 1.42-.59L19 12l-5.5-2L18 1z"
      }));

    case 'interaction___logout':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.11 17.55l1.78.9L17.12 12l-3.23-6.45-1.78.9L14.38 11H1v2h13.38l-2.27 4.55z"
      }), React.createElement("path", {
        d: "M21 1H6a2 2 0 0 0-2 2v4h2V3h15v18H6v-4H4v4a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.16 15.83l2.68 1.34 2.84-5.67-2.84-5.67-2.68 1.34L13.57 10H1v3h12.57l-1.41 2.83z"
      }), React.createElement("path", {
        d: "M21 1H6a2 2 0 0 0-2 2v4h3V4h13v16H7v-4H4v5a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25.11 35.55l1.78.9L33.12 24l-6.23-12.45-1.78.9L30.38 23H2v2h28.38l-5.27 10.55z"
      }), React.createElement("path", {
        d: "M42 2H12a4 4 0 0 0-4 4v8h2V6a2 2 0 0 1 2-2h30a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2v-8H8v8a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.21 35.1l3.58 1.8L33.24 24l-6.45-12.89-3.58 1.78L27.76 22H2v4h25.76l-4.55 9.1z"
      }), React.createElement("path", {
        d: "M42 2H12a4 4 0 0 0-4 4v8h4V6h30v36H12v-8H8v8a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M50.21 71.11l3.58 1.78L66.24 48 53.79 23.11l-3.58 1.78L60.76 46H4v4h56.76L50.21 71.11z"
      }), React.createElement("path", {
        d: "M84 4H24a8 8 0 0 0-8 8v16h4V12a4 4 0 0 1 4-4h60a4 4 0 0 1 4 4v72a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4V68h-4v16a8 8 0 0 0 8 8h60a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46.42 70.21l7.16 3.58L66.47 48 53.58 22.21l-7.16 3.58L55.53 44H4v8h51.53l-9.11 18.21z"
      }), React.createElement("path", {
        d: "M84 4H24a8 8 0 0 0-8 8v16h8V12h60v72H24V68h-8v16a8 8 0 0 0 8 8h60a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.11 17.55l1.78.9L17.12 12l-3.23-6.45-1.78.9L14.38 11H1v2h13.38l-2.27 4.55z"
      }), React.createElement("path", {
        d: "M21 1H6a2 2 0 0 0-2 2v4h2V3h15v18H6v-4H4v4a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z"
      }));

    case 'interaction___menu':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 18h20v2H2zM2 11h20v2H2zM2 4h20v2H2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 17h20v4H2zM2 10h20v4H2zM2 3h20v4H2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 38h40v2H4zM4 23h40v2H4zM4 8h40v2H4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 36h40v4H4zM4 22h40v4H4zM4 8h40v4H4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 76h80v4H8zM8 46h80v4H8zM8 16h80v4H8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 72h80v8H8zM8 44h80v8H8zM8 16h80v8H8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 18h20v2H2zM2 11h20v2H2zM2 4h20v2H2z"
      }));

    case 'interaction___more01':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 3a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM15 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM11 17a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 3a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM15 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM11 17a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 6a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM29 21a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM21 36a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 4a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM29 19a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM21 34a5 5 0 1 0 5 5 5 5 0 0 0-5-5z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 12a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-4a10 10 0 1 0 10 10A10 10 0 0 0 42 8zM58 42a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-4a10 10 0 1 0 10 10 10 10 0 0 0-10-10zM42 72a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-4a10 10 0 1 0 10 10 10 10 0 0 0-10-10z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 8a10 10 0 1 0 10 10A10 10 0 0 0 42 8zM58 38a10 10 0 1 0 10 10 10 10 0 0 0-10-10zM42 68a10 10 0 1 0 10 10 10 10 0 0 0-10-10z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 3a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM15 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM11 17a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
      }));

    case 'interaction___more02':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2zM10 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2zM17 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2zM10 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2zM17 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 21a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM24 21a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zM39 21a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 24a5 5 0 1 0 5-5 5 5 0 0 0-5 5zM19 24a5 5 0 1 0 5-5 5 5 0 0 0-5 5zM34 24a5 5 0 1 0 5-5 5 5 0 0 0-5 5z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 42a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-4a10 10 0 1 0 10 10 10 10 0 0 0-10-10zM48 42a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-4a10 10 0 1 0 10 10 10 10 0 0 0-10-10zM78 42a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-4a10 10 0 1 0 10 10 10 10 0 0 0-10-10z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 48a10 10 0 1 0 10-10A10 10 0 0 0 8 48zM38 48a10 10 0 1 0 10-10 10 10 0 0 0-10 10zM68 48a10 10 0 1 0 10-10 10 10 0 0 0-10 10z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2zM10 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2zM17 12a2 2 0 1 0 2-2 2 2 0 0 0-2 2z"
      }));

    case 'interaction___notificationOff':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.32 20v.09a2.55 2.55 0 0 1-4.56 0V20H8l.38.76a4 4 0 0 0 6.84.64l-.84-1.4zM12.57 17H3.24l4.23-8.46-1.22-2.03L1 17l1 2h11.77l-1.2-2zM23 17L16.34 3.68a4.85 4.85 0 0 0-7.83-1.19L7.61 1 5.89 2l12.5 20.75 1.72-1L18.46 19h3.6zm-5.75 0L9.62 4.33a2.82 2.82 0 0 1 4.93.25L20.76 17z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 20l.38.76a4 4 0 0 0 6.84.64l-.84-1.4zM23 17L16.34 3.68a4.85 4.85 0 0 0-7.83-1.19L7.61 1 5.89 2l12.5 20.75 1.72-1L18.46 19h3.6zM6.25 6.51L1 17l1 2h11.77L6.25 6.51z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 44a6.06 6.06 0 0 1-5.45-3.37l-.31-.63H16l.76 1.53A8.07 8.07 0 0 0 30.26 43l-1.11-1.85A6 6 0 0 1 24 44zM46 34L32.68 7.37a9.7 9.7 0 0 0-17.36 0l-3-4.9-1.72 1 25 41.5 1.72-1-3.61-6h10.4zm-3.16 2H32.55l-16-26.59.58-1.15a7.7 7.7 0 0 1 13.78 0L43.78 34zM26.05 36H5.24l-1-2 9.34-18.69-1.22-2.03L2 34l2 4h23.25l-1.2-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 40l.76 1.53A8.07 8.07 0 0 0 30.26 43l-1.81-3zM12.36 13.28L2 34l2 4h23.25L12.36 13.28zM46 34L32.68 7.37a9.7 9.7 0 0 0-17.36 0l-3-4.9-1.72 1 25 41.5 1.72-1-3.61-6h10.4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 88a12.11 12.11 0 0 1-10.89-6.73L36.47 80H32l1.53 3.06a16.17 16.17 0 0 0 27 3l-2.23-3.75A12.09 12.09 0 0 1 48 88zM31.07 37.1l-1.23-2.02-12.73 25.47 1.78.9L31.07 37.1z"
      }), React.createElement("path", {
        d: "M52.09 72H10.47l-2-4 18.69-37.38-2.44-4.06L4 68l4 8h46.5l-2.41-4zM92 68L65.37 14.73a19.42 19.42 0 0 0-34.74 0L24.71 5l-3.42 2 50 83 3.42-2-7.21-12h20.72zm-6.31 4h-20.6l-1.8-3H80v-2H62.08L37 25.31l3.72-7.44A7 7 0 0 1 46.94 14H48v-2h-1.06a9 9 0 0 0-8 5l-3.15 6.31-2.68-4.46 1.15-2.3a15.42 15.42 0 0 1 27.58 0l25.71 51.5z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 80l1.53 3.06a16.17 16.17 0 0 0 27 3l-3.63-6zM30.14 35.56l.11.18-12.36 24.71-1.78-.9 12.91-25.84-4.3-7.15L4 68l4 8h46.5L30.14 35.56zM92 68L65.37 14.73a19.42 19.42 0 0 0-34.74 0L24.71 5l-3.42 2 50 83 3.42-2-7.21-12h20.72zM47 13h-1.06a7 7 0 0 0-6.26 3.87L36.15 24l-1.23-2 3-6a9 9 0 0 1 8-5H47zm33 58H64.49l-1.2-2H80z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.32 20v.09a2.55 2.55 0 0 1-4.56 0V20H8l.38.76a4 4 0 0 0 6.84.64l-.84-1.4zM12.57 17H3.24l4.23-8.46-1.22-2.03L1 17l1 2h11.77l-1.2-2zM23 17L16.34 3.68a4.85 4.85 0 0 0-7.83-1.19L7.61 1 5.89 2l12.5 20.75 1.72-1L18.46 19h3.6zm-5.75 0L9.62 4.33a2.82 2.82 0 0 1 4.93.25L20.76 17z"
      }));

    case 'interaction___notificationOn':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.32 20v.09a2.55 2.55 0 0 1-4.56 0V20H8l.38.76a4 4 0 0 0 7.24 0L16 20zM12 3a2.82 2.82 0 0 1 2.55 1.58L20.76 17H3.24L9.45 4.58A2.82 2.82 0 0 1 12 3m0-2a4.85 4.85 0 0 0-4.34 2.68L1 17l1 2h20.06l.94-2-6.66-13.32A4.85 4.85 0 0 0 12 1z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.38 20.76a4 4 0 0 0 7.24 0L16 20H8zM16.34 3.68a4.85 4.85 0 0 0-8.68 0L1 17l1 2h20.06l.94-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M29.45 40.63a6.09 6.09 0 0 1-10.9 0l-.31-.63H16l.76 1.53a8.1 8.1 0 0 0 14.48 0L32 40h-2.24zM32.68 7.37a9.7 9.7 0 0 0-17.36 0L2 34l2 4h40.11L46 34zM42.84 36H5.24l-1-2L17.11 8.26a7.7 7.7 0 0 1 13.78 0L43.78 34z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.76 41.53a8.1 8.1 0 0 0 14.48 0L32 40H16zM32.68 7.37a9.7 9.7 0 0 0-17.36 0L2 34l2 4h40.11L46 34z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M58.89 81.27a12.18 12.18 0 0 1-21.78 0L36.47 80H32l1.53 3.06a16.18 16.18 0 0 0 28.94 0L64 80h-4.47zM65.37 14.73a19.42 19.42 0 0 0-34.74 0L4 68l4 8h80.22L92 68zM85.69 72H10.47l-2-4 25.74-51.48a15.42 15.42 0 0 1 27.58 0l25.76 51.53z"
      }), React.createElement("path", {
        d: "M48 67h32v2H48zM48 12h-1.06a9 9 0 0 0-8 5L17.11 60.55l1.78.9 21.79-43.58A7 7 0 0 1 46.94 14H48z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M33.53 83.06a16.18 16.18 0 0 0 28.94 0L64 80H32zM65.37 14.73a19.42 19.42 0 0 0-34.74 0L4 68l4 8h80.22L92 68zm-25.69 2.14L17.89 60.45l-1.78-.9L37.89 16a9 9 0 0 1 8-5H47v2h-1.06a7 7 0 0 0-6.26 3.87zM80 71H47v-2h33z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.32 20v.09a2.55 2.55 0 0 1-4.56 0V20H8l.38.76a4 4 0 0 0 7.24 0L16 20zM12 3a2.82 2.82 0 0 1 2.55 1.58L20.76 17H3.24L9.45 4.58A2.82 2.82 0 0 1 12 3m0-2a4.85 4.85 0 0 0-4.34 2.68L1 17l1 2h20.06l.94-2-6.66-13.32A4.85 4.85 0 0 0 12 1z"
      }));

    case 'interaction___playbutton':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 2v20l20-10zm2 3.24L18.53 12 5 18.76z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 2v20l20-10L3 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 7.24L41.53 24 8 40.76V7.24M6 4v40l40-20L6 4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 4v40l40-20L6 4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 8v80l80-40zm4 6.47L83.06 48 16 81.53z"
      }), React.createElement("path", {
        d: "M21.554 25.901l.895-1.788L70.45 48.119l-.894 1.789z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 8v80l80-40zm9.55 17.89l.9-1.78 48 24-.9 1.78z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 2v20l20-10zm2 3.24L18.53 12 5 18.76z"
      }));

    case 'interaction___refresh':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.5 10.5h8v-8h-2v4.25a10 10 0 1 0 .71 9.14l-1.84-.78a8 8 0 1 1-.2-6.61H14.5z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 11h9V2h-3v2.91a10 10 0 1 0 2.18 11l-3.68-1.58A6 6 0 1 1 16.41 8H13z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30 19h13V6h-2v9.53a19 19 0 1 0 .51 15.87l-1.85-.78A17 17 0 1 1 39.49 17H30z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M29 20h15V5h-4v8.84a19 19 0 1 0 1.47 17.56l-3.68-1.56A15 15 0 1 1 36.64 16H29z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M60 38h26V12h-4v19a38 38 0 1 0 1 31.76l-3.68-1.56A34 34 0 1 1 79 34H60z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M58 40h30V10h-8v17.63a38 38 0 1 0 2.94 35.16l-7.36-3.11A30 30 0 1 1 73.28 32H58z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.5 10.5h8v-8h-2v4.25a10 10 0 1 0 .71 9.14l-1.84-.78a8 8 0 1 1-.2-6.61H14.5z"
      }));

    case 'interaction___search':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.41 14h-2.17A8 8 0 1 0 14 15.24v2.17l6 6L23.41 20zM9 15a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm7 1.59V16h.59l4 4-.59.59z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.41 14h-2.17A8 8 0 1 0 14 15.24v2.17l6 6L23.41 20zM9 15a6 6 0 1 1 6-6 6 6 0 0 1-6 6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.44 18h1.12A8.45 8.45 0 0 1 18 9.56V8.44A9.57 9.57 0 0 0 8.44 18z"
      }), React.createElement("path", {
        d: "M35 28h-4.52A16 16 0 1 0 28 30.48V35l12 12 7-7zm-17 4a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm12 2.17V30h4.17l10 10L40 44.17z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 28h-4.52A16 16 0 1 0 28 30.48V35l12 12 7-7zm-17 2a12 12 0 1 1 12-12 12 12 0 0 1-12 12z"
      }), React.createElement("path", {
        d: "M8.44 18h1.12A8.45 8.45 0 0 1 18 9.56V8.44A9.57 9.57 0 0 0 8.44 18z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 14a22 22 0 1 0 22 22 22 22 0 0 0-22-22zm0 42a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M20 36h2a14 14 0 0 1 14-14v-2a16 16 0 0 0-16 16z"
      }), React.createElement("path", {
        d: "M70 56h-9a32 32 0 1 0-5 5v9l24 24 14-14zm-34 8a28 28 0 1 1 28-28 28 28 0 0 1-28 28zm24-4h8.34l16.12 16.12-8.34 8.34L60 68.34zm17.54 25.88l8.34-8.34L88.34 80 80 88.34z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M70 56h-9a32 32 0 1 0-5 5v9l19.29 19.29 14-14zm-34 2a22 22 0 1 1 22-22 22 22 0 0 1-22 22zM76.712 90.71l14.001-14 3.295 3.294-14 14.001z"
      }), React.createElement("path", {
        d: "M20 36h2a14 14 0 0 1 14-14v-2a16 16 0 0 0-16 16z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.41 14h-2.17A8 8 0 1 0 14 15.24v2.17l6 6L23.41 20zM9 15a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm7 1.59V16h.59l4 4-.59.59z"
      }));

    case 'interaction___share':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 19H5V6h6V4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6h-2z"
      }), React.createElement("path", {
        d: "M15 1v2h4.59l-9.3 9.29 1.42 1.42L21 4.41V9h2V1h-8z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 18H6V7h5V4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6h-3z"
      }), React.createElement("path", {
        d: "M14 1v3h3.88l-7.94 7.94 2.12 2.12L20 6.12V10h3V1h-9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 38a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2h12V8H10a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4V26h-2z"
      }), React.createElement("path", {
        d: "M30 3v2h11.59l-20.3 20.29 1.42 1.42L43 6.41V18h2V3H30z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 38H10V12h12V8H10a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4V26h-4z"
      }), React.createElement("path", {
        d: "M28 3v4h10.17L20.59 24.59l2.82 2.82L41 9.83V20h4V3H28z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 76a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4V24a4 4 0 0 1 4-4h24v-4H20a8 8 0 0 0-8 8v52a8 8 0 0 0 8 8h52a8 8 0 0 0 8-8V52h-4z"
      }), React.createElement("path", {
        d: "M60 6v4h23.17L42.59 50.59l2.82 2.82L86 12.83V36h4V6H60z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 76H20V24h24v-8H20a8 8 0 0 0-8 8v52a8 8 0 0 0 8 8h52a8 8 0 0 0 8-8V52h-8z"
      }), React.createElement("path", {
        d: "M56 6v8h20.34L41.17 49.17l5.66 5.66L82 19.66V40h8V6H56z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 19H5V6h6V4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6h-2z"
      }), React.createElement("path", {
        d: "M15 1v2h4.59l-9.3 9.29 1.42 1.42L21 4.41V9h2V1h-8z"
      }));

    case 'interaction___slider':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.36 6a4 4 0 0 0-7.72 0H1v2h3.64a4 4 0 0 0 7.72 0H23V6zM8.5 9a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM15.5 13a4 4 0 0 0-3.86 3H1v2h10.64a4 4 0 0 0 7.72 0H23v-2h-3.64a4 4 0 0 0-3.86-3zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "8.5",
        cy: "7",
        r: "3"
      }), React.createElement("path", {
        d: "M3.5 7a5.47 5.47 0 0 1 .1-1H1v2h2.6a5.47 5.47 0 0 1-.1-1zM13.4 6a5.47 5.47 0 0 1 .1 1 5.47 5.47 0 0 1-.1 1H23V6z"
      }), React.createElement("circle", {
        cx: "15.5",
        cy: "17",
        r: "3"
      }), React.createElement("path", {
        d: "M10.5 17a5.47 5.47 0 0 1 .1-1H1v2h9.6a5.47 5.47 0 0 1-.1-1zM20.4 16a5 5 0 0 1 0 2H23v-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25.91 8a6 6 0 0 0-11.82 0H2v2h12.09a6 6 0 0 0 11.82 0H46V8zM20 13a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM30 18a6 6 0 0 0-5.91 5H2v2h22.09a6 6 0 0 0 11.82 0H46v-2H35.91A6 6 0 0 0 30 18zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM20 33a6 6 0 0 0-5.91 5H2v2h12.09a6 6 0 0 0 11.82 0H46v-2H25.91A6 6 0 0 0 20 33zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 9a6.63 6.63 0 0 1 .08-1H2v2h11.08A6.63 6.63 0 0 1 13 9zM26.92 8a6.29 6.29 0 0 1 0 2H46V8zM23 24a6.63 6.63 0 0 1 .08-1H2v2h21.08a6.63 6.63 0 0 1-.08-1zM36.92 23a6.29 6.29 0 0 1 0 2H46v-2zM26.92 38a6.29 6.29 0 0 1 0 2H46v-2zM13 39a6.63 6.63 0 0 1 .08-1H2v2h11.08a6.63 6.63 0 0 1-.08-1z"
      }), React.createElement("circle", {
        cx: "20",
        cy: "9",
        r: "5"
      }), React.createElement("circle", {
        cx: "30",
        cy: "24",
        r: "5"
      }), React.createElement("circle", {
        cx: "20",
        cy: "39",
        r: "5"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M53.82 16a12 12 0 0 0-23.64 0H4v4h26.18a12 12 0 0 0 23.64 0H92v-4zM42 26a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }), React.createElement("path", {
        d: "M42 22v2a6 6 0 0 0 6-6h-2a4 4 0 0 1-4 4zM60 36a12 12 0 0 0-11.82 10H4v4h44.18a12 12 0 0 0 23.64 0H92v-4H71.82A12 12 0 0 0 60 36zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }), React.createElement("path", {
        d: "M60 52v2a6 6 0 0 0 6-6h-2a4 4 0 0 1-4 4zM42 66a12 12 0 0 0-11.82 10H4v4h26.18a12 12 0 0 0 23.64 0H92v-4H53.82A12 12 0 0 0 42 66zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }), React.createElement("path", {
        d: "M42 82v2a6 6 0 0 0 6-6h-2a4 4 0 0 1-4 4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M28 18a14.71 14.71 0 0 1 .16-2H4v4h24.16a14.71 14.71 0 0 1-.16-2zM55.84 16a14.71 14.71 0 0 1 .16 2 14.71 14.71 0 0 1-.16 2H92v-4zM74 48a14.71 14.71 0 0 1-.16 2H92v-4H73.84a14.71 14.71 0 0 1 .16 2zM46 48a14.71 14.71 0 0 1 .16-2H4v4h42.16a14.71 14.71 0 0 1-.16-2zM56 78a14.71 14.71 0 0 1-.16 2H92v-4H55.84a14.71 14.71 0 0 1 .16 2zM4 76v4h24.16a12.58 12.58 0 0 1 0-4zM42 28a10 10 0 1 0-10-10 10 10 0 0 0 10 10zm0-16v2a4 4 0 0 0-4 4h-2a6 6 0 0 1 6-6zM70 48a10 10 0 1 0-10 10 10 10 0 0 0 10-10zm-14 0h-2a6 6 0 0 1 6-6v2a4 4 0 0 0-4 4zM42 68a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 6a4 4 0 0 0-4 4h-2a6 6 0 0 1 6-6z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.36 6a4 4 0 0 0-7.72 0H1v2h3.64a4 4 0 0 0 7.72 0H23V6zM8.5 9a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM15.5 13a4 4 0 0 0-3.86 3H1v2h10.64a4 4 0 0 0 7.72 0H23v-2h-3.64a4 4 0 0 0-3.86-3zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));

    case 'interaction___trash':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 4h-3l-1.5-3h-7L7 4H4a2 2 0 0 0-2 2h20a2 2 0 0 0-2-2zM9.24 4l.5-1h4.52l.5 1zM18 20.53l-.24.47H6.24L6 20.53V8H4v13l1 2h14l1-2V8h-2v12.53z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 8v13l-1 2H5l-1-2V8h16zM20 4h-3l-1.5-3h-7L7 4H4a2 2 0 0 0-2 2h20a2 2 0 0 0-2-2zM9.24 4l.5-1h4.52l.5 1z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 39.53L34.76 42H13.24L12 39.53V17h-2v23l2 4h24l2-4V17h-2v22.53z"
      }), React.createElement("path", {
        d: "M20 19h8v2h-8zM38 9h-7l-2.38-5h-9.24L17 9h-7a4 4 0 0 0-4 4v2h36v-2a4 4 0 0 0-4-4zM20.62 6h6.76l1.5 3h-9.76zM8 13a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 15v25l2 4h24l2-4V15zm18 6h-8v-2h8zM38 9h-7l-2.38-5h-9.24L17 9h-7a4 4 0 0 0-4 4h36a4 4 0 0 0-4-4zM20.62 6h6.76l1.5 3h-9.76z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 79.06L69.53 84H26.47L24 79.06V34h-4v46l4 8h48l4-8V34h-4v45.06z"
      }), React.createElement("path", {
        d: "M40 38h16v4H40zM76 18H62L57.24 8H38.76L34 18H20a8 8 0 0 0-8 8v4h72v-4a8 8 0 0 0-8-8zm-34.76-6h13.52l3 6H38.24zM16 26a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4zM32.91 48h2.18v32h-2.18zM46.91 48h2.18v32h-2.18zM60.91 48h2.18v32h-2.18z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 18H62L57.24 8H38.76L34 18H20a8 8 0 0 0-8 8h72a8 8 0 0 0-8-8zm-37.76 0l3-6h13.52l3 6zM20 80l4 8h48l4-8V30H20zm29.09 0h-2.18V48h2.18zm11.82-32h2.18v32h-2.18zM40 38h16v4H40zm-7.09 10h2.18v32h-2.18z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 4h-3l-1.5-3h-7L7 4H4a2 2 0 0 0-2 2h20a2 2 0 0 0-2-2zM9.24 4l.5-1h4.52l.5 1zM18 20.53l-.24.47H6.24L6 20.53V8H4v13l1 2h14l1-2V8h-2v12.53z"
      }));

    case 'interaction___upload':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 3.94V17h2V3.94l5.42 3.87 1.16-1.62L12 .77 4.42 6.19l1.16 1.62L11 3.94zM2 21h20v2H2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 5.27V16h4V5.27l4.13 2.95 1.74-2.44L12 .16 4.13 5.78l1.74 2.44L10 5.27zM2 19h20v4H2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 5.94V34h2V5.94l12.42 8.87 1.16-1.62L24 2.77 9.42 13.19l1.16 1.62L23 5.94zM4 42h40v2H4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 7.89V33h4V7.89l10.84 7.74 2.32-3.26L24 1.54 8.84 12.37l2.32 3.26L22 7.89zM4 40h40v4H4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 11.89V68h4V11.89l24.84 17.74 2.32-3.26L48 5.54 18.84 26.37l2.32 3.26L46 11.89zM8 84h80v4H8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 80h80v8H8zM44 15.77V66h8V15.77l21.67 15.48 4.66-6.5L48 3.08 17.68 24.75l4.64 6.5L44 15.77z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 3.94V17h2V3.94l5.42 3.87 1.16-1.62L12 .77 4.42 6.19l1.16 1.62L11 3.94zM2 21h20v2H2z"
      }));

    case 'interaction___volume':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.36 18.36L14 17a7 7 0 0 0 0-9.9l1.41-1.41a9 9 0 0 1 0 12.72z"
      }), React.createElement("path", {
        d: "M18.83 22.08l-1.42-1.42a12.24 12.24 0 0 0 0-17.32l1.42-1.42a14.27 14.27 0 0 1 0 20.16zM10 6.83v10.34L6.83 14H3v-4h3.83L10 6.83m1.75-4.48a.27.27 0 0 0-.18.08L6 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4l5.57 5.57a.27.27 0 0 0 .18.08.25.25 0 0 0 .25-.25V2.6a.25.25 0 0 0-.25-.25z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.36 18.36L14 17a7 7 0 0 0 0-9.9l1.41-1.41a9 9 0 0 1 0 12.72z"
      }), React.createElement("path", {
        d: "M18.83 22.08l-1.42-1.42a12.24 12.24 0 0 0 0-17.32l1.42-1.42a14.27 14.27 0 0 1 0 20.16zM11.75 2.35a.27.27 0 0 0-.18.08L6 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4l5.57 5.57a.27.27 0 0 0 .18.08.25.25 0 0 0 .25-.25V2.6a.25.25 0 0 0-.25-.25z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30.52 36l-1.41-1.41a15 15 0 0 0 0-21.22L30.52 12a17 17 0 0 1 0 24z"
      }), React.createElement("path", {
        d: "M38 43.45L36.53 42a25.53 25.53 0 0 0 0-36L38 4.55a27.55 27.55 0 0 1 0 38.9zM21 8.83v30.34L11.83 30H4V18h7.83L21 8.83m1.5-4.12a.47.47 0 0 0-.35.14L11 16H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7l11.15 11.15a.47.47 0 0 0 .35.14.5.5 0 0 0 .5-.5V5.21a.5.5 0 0 0-.5-.5z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30.52 36l-1.41-1.41a15 15 0 0 0 0-21.22L30.52 12a17 17 0 0 1 0 24z"
      }), React.createElement("path", {
        d: "M38 43.45L36.53 42a25.53 25.53 0 0 0 0-36L38 4.55a27.55 27.55 0 0 1 0 38.9zM22.5 4.71a.47.47 0 0 0-.35.14L11 16H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7l11.15 11.15a.47.47 0 0 0 .35.14.5.5 0 0 0 .5-.5V5.21a.5.5 0 0 0-.5-.5z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M58.21 26.79a30 30 0 0 1 0 42.42L61 72a34 34 0 0 0 0-48z"
      }), React.createElement("path", {
        d: "M75.89 9.11l-2.83 2.83a51 51 0 0 1 0 72.12l2.83 2.83a55 55 0 0 0 0-77.78zM45 9.41a1 1 0 0 0-.7.3L22 32H8a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h14l22.29 22.29a1 1 0 0 0 .7.3 1 1 0 0 0 1-1V10.41a1 1 0 0 0-.99-1zm-3 68.93L23.66 60H8V36h15.66L42 17.66z"
      }), React.createElement("path", {
        d: "M22 39h2v18h-2z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M58.21 26.79a30 30 0 0 1 0 42.42L61 72a34 34 0 0 0 0-48z"
      }), React.createElement("path", {
        d: "M75.89 9.11l-2.83 2.83a51 51 0 0 1 0 72.12l2.83 2.83a55 55 0 0 0 0-77.78zM44.29 9.71L22 32H8a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h14l22.29 22.29a1 1 0 0 0 1.71-.7V10.41a1 1 0 0 0-1.71-.7zM22 59h-2V37h2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15.36 18.36L14 17a7 7 0 0 0 0-9.9l1.41-1.41a9 9 0 0 1 0 12.72z"
      }), React.createElement("path", {
        d: "M18.83 22.08l-1.42-1.42a12.24 12.24 0 0 0 0-17.32l1.42-1.42a14.27 14.27 0 0 1 0 20.16zM10 6.83v10.34L6.83 14H3v-4h3.83L10 6.83m1.75-4.48a.27.27 0 0 0-.18.08L6 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4l5.57 5.57a.27.27 0 0 0 .18.08.25.25 0 0 0 .25-.25V2.6a.25.25 0 0 0-.25-.25z"
      }));

    case 'interaction___wifiOff':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 17a2 2 0 1 0 2 2.32l-1.33-2.21A2.26 2.26 0 0 0 12 17zM9.75 12.32a8.09 8.09 0 0 0-3.41 2l1.42 1.42a5.93 5.93 0 0 1 3.07-1.64zM7.64 8.83a12 12 0 0 0-4.13 2.68l1.42 1.42a9.91 9.91 0 0 1 3.77-2.36zM5.56 5.36A15.76 15.76 0 0 0 .69 8.69L2.1 10.1a14 14 0 0 1 4.49-3zM12 6a13.94 13.94 0 0 1 9.9 4.1l1.41-1.41A15.86 15.86 0 0 0 12 4a16.77 16.77 0 0 0-2.46.19L7.61 1 5.89 2l12.5 20.75 1.72-1-3.7-6.14 1.25-1.25a7.94 7.94 0 0 0-3.17-1.93l-1.41-2.33a9.85 9.85 0 0 1 6 2.85l1.42-1.42A12 12 0 0 0 11.85 8l-1.18-2H12z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 17a2 2 0 1 0 2 2.32l-1.33-2.21A2.26 2.26 0 0 0 12 17zM10.29 13.22a7 7 0 0 0-3.24 1.83l1.41 1.41a5 5 0 0 1 2.94-1.4zM7.64 8.82a12.13 12.13 0 0 0-4.13 2.69l2.13 2.13a8.89 8.89 0 0 1 3.58-2.19zM5 4.5A17.07 17.07 0 0 0 0 8l2.1 2.1a14 14 0 0 1 4.49-3zM12 6a13.94 13.94 0 0 1 9.9 4.1L24 8a16.89 16.89 0 0 0-12-5 16.69 16.69 0 0 0-3 .28L7.61 1 5.89 2l12.5 20.75 1.72-1-3.7-6.14.54-.54a6.86 6.86 0 0 0-1.56-1.14l-1.63-2.72a8.87 8.87 0 0 1 4.6 2.45l2.13-2.13A12 12 0 0 0 12 8h-.16l-1.17-1.93C11.11 6 11.55 6 12 6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 34a4 4 0 1 0 3.86 5l-2.95-4.9A3.91 3.91 0 0 0 24 34zm2 4a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM19.78 25.6a15 15 0 0 0-6.39 3.79l1.42 1.42a12.82 12.82 0 0 1 6-3.41zM15.57 18.61a22.76 22.76 0 0 0-7.83 5.13l1.41 1.41a20.89 20.89 0 0 1 7.47-4.79zM11.4 11.69a30.82 30.82 0 0 0-9.32 6.39l1.41 1.41a29 29 0 0 1 9-6.08zM44.51 19.49l1.41-1.41A31 31 0 0 0 16.8 9.87l-4.44-7.39-1.72 1 25 41.5 1.72-1-10-16.53a13 13 0 0 1 5.79 3.36l1.42-1.42A14.91 14.91 0 0 0 26 25.15l-3.64-6a20.92 20.92 0 0 1 16.48 6l1.41-1.41a22.93 22.93 0 0 0-19-6.55l-3.32-5.52a29 29 0 0 1 26.58 7.82z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.17 34.17a4 4 0 0 0 5.66 5.66 4.12 4.12 0 0 0 .81-1.19L24.25 33a4 4 0 0 0-3.08 1.17zM18.75 23.9a15.83 15.83 0 0 0-6.06 3.79l2.82 2.82a12 12 0 0 1 5.37-3.09zM14.57 17A23.88 23.88 0 0 0 7 22l2.83 2.83a19.84 19.84 0 0 1 6.79-4.45zM43.8 19.2l2.83-2.83a32 32 0 0 0-30.88-8.26l-3.39-5.63-1.72 1 25 41.5 1.72-1-9.93-16.48a12 12 0 0 1 5.06 3l2.82-2.82A15.84 15.84 0 0 0 24.74 23l-2.37-3.9a19.91 19.91 0 0 1 15.77 5.76L41 22a23.93 23.93 0 0 0-20.86-6.67l-2.24-3.64a28 28 0 0 1 25.9 7.51zM10.4 10a32.22 32.22 0 0 0-9 6.34l2.8 2.86a28.08 28.08 0 0 1 8.28-5.72z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 69a8 8 0 1 0 7.88 9.3l-5.35-8.88A7.81 7.81 0 0 0 48 69zm4 8a4 4 0 1 1-4-4 4 4 0 0 1 4 4zM40.09 52.08a29.73 29.73 0 0 0-13.3 7.71l2.83 2.83a25.74 25.74 0 0 1 12.62-7zM31.61 38a45.87 45.87 0 0 0-16.14 10.47l2.83 2.83a41.74 41.74 0 0 1 15.41-9.81zM89 40l2.83-2.83a62 62 0 0 0-57.7-16.56L24.71 5l-3.42 2 50 83 3.42-2-19.18-31.87a25.64 25.64 0 0 1 10.85 6.49l2.83-2.83a29.77 29.77 0 0 0-16.53-8.4l-7.41-12.3C46.18 39 47.08 39 48 39a41.73 41.73 0 0 1 29.7 12.3l2.83-2.83A45.74 45.74 0 0 0 48 35a46.34 46.34 0 0 0-5 .29l-6.68-11.06A58 58 0 0 1 89 40zM23.27 24.16a61.65 61.65 0 0 0-19.11 13L7 40a57.53 57.53 0 0 1 18.35-12.38z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.76 70.76A6 6 0 1 0 54 75.15l-3.31-5.49a6 6 0 0 0-6.93 1.1zM38 48.62a31.85 31.85 0 0 0-12.63 7.75L31 62a23.71 23.71 0 0 1 11.25-6.3zM29.59 34.65a47.88 47.88 0 0 0-15.53 10.41l5.66 5.66a39.7 39.7 0 0 1 14.06-9.12zM21.28 20.85a63.51 63.51 0 0 0-18.53 12.9L8.4 39.4a55.89 55.89 0 0 1 17-11.64zM87.6 39.4l5.65-5.65A64 64 0 0 0 32 17.07L24.71 5l-3.42 2 50 83 3.42-2-19.08-31.71A23.71 23.71 0 0 1 65 62l5.66-5.66a31.94 31.94 0 0 0-20.54-9.28l-4.82-8C46.18 39 47.09 39 48 39a39.71 39.71 0 0 1 28.28 11.72l5.66-5.66a47.76 47.76 0 0 0-41.2-13.49l-4.4-7.3A56 56 0 0 1 87.6 39.4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 17a2 2 0 1 0 2 2.32l-1.33-2.21A2.26 2.26 0 0 0 12 17zM9.75 12.32a8.09 8.09 0 0 0-3.41 2l1.42 1.42a5.93 5.93 0 0 1 3.07-1.64zM7.64 8.83a12 12 0 0 0-4.13 2.68l1.42 1.42a9.91 9.91 0 0 1 3.77-2.36zM5.56 5.36A15.76 15.76 0 0 0 .69 8.69L2.1 10.1a14 14 0 0 1 4.49-3zM12 6a13.94 13.94 0 0 1 9.9 4.1l1.41-1.41A15.86 15.86 0 0 0 12 4a16.77 16.77 0 0 0-2.46.19L7.61 1 5.89 2l12.5 20.75 1.72-1-3.7-6.14 1.25-1.25a7.94 7.94 0 0 0-3.17-1.93l-1.41-2.33a9.85 9.85 0 0 1 6 2.85l1.42-1.42A12 12 0 0 0 11.85 8l-1.18-2H12z"
      }));

    case 'interaction___wifiOn':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "12",
        cy: "19",
        r: "2"
      }), React.createElement("path", {
        d: "M16.24 15.76a6 6 0 0 0-8.48 0l-1.42-1.42a8 8 0 0 1 11.32 0zM21.9 10.1a14 14 0 0 0-19.8 0L.69 8.69a16 16 0 0 1 22.62 0z"
      }), React.createElement("path", {
        d: "M19.07 12.93a10 10 0 0 0-14.14 0l-1.42-1.42a12 12 0 0 1 17 0z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "12",
        cy: "19",
        r: "2"
      }), React.createElement("path", {
        d: "M7.05 15.05l1.41 1.41a5 5 0 0 1 7.08 0L17 15.05a7 7 0 0 0-9.95 0z"
      }), React.createElement("path", {
        d: "M3.51 11.51l2.13 2.13a9 9 0 0 1 12.72 0l2.13-2.13a12 12 0 0 0-17 0z"
      }), React.createElement("path", {
        d: "M12 3A16.89 16.89 0 0 0 0 8l2.1 2.1a14 14 0 0 1 19.8 0L24 8a16.89 16.89 0 0 0-12-5z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 36a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM33.19 30.81a13 13 0 0 0-18.38 0l-1.42-1.42a15 15 0 0 1 21.22 0zM44.51 19.49a29.06 29.06 0 0 0-41 0l-1.43-1.41a31 31 0 0 1 43.84 0z"
      }), React.createElement("path", {
        d: "M38.85 25.15a21 21 0 0 0-29.7 0l-1.41-1.41a23 23 0 0 1 32.52 0z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32.49 30.51a12 12 0 0 0-17 0l-2.82-2.82a16 16 0 0 1 22.62 0z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "37",
        r: "4"
      }), React.createElement("path", {
        d: "M43.8 19.2a28 28 0 0 0-39.6 0l-2.83-2.83a32.05 32.05 0 0 1 45.26 0z"
      }), React.createElement("path", {
        d: "M38.14 24.86a20 20 0 0 0-28.28 0L7 22a24 24 0 0 1 34 0z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 73a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-4a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM66.38 62.62a26 26 0 0 0-36.76 0l-2.83-2.83a30 30 0 0 1 42.42 0zM89 40a58 58 0 0 0-82 0l-2.84-2.84a62.08 62.08 0 0 1 87.68 0z"
      }), React.createElement("path", {
        d: "M77.7 51.3a42 42 0 0 0-59.4 0l-2.83-2.83a46 46 0 0 1 65.06 0z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M65 62a24 24 0 0 0-34 0l-5.66-5.66a32.05 32.05 0 0 1 45.26 0z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "75",
        r: "6"
      }), React.createElement("path", {
        d: "M87.6 39.4a56.08 56.08 0 0 0-79.2 0l-5.65-5.65a64 64 0 0 1 90.5 0z"
      }), React.createElement("path", {
        d: "M76.28 50.72a40 40 0 0 0-56.56 0l-5.66-5.66a48 48 0 0 1 67.88 0z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "12",
        cy: "19",
        r: "2"
      }), React.createElement("path", {
        d: "M16.24 15.76a6 6 0 0 0-8.48 0l-1.42-1.42a8 8 0 0 1 11.32 0zM21.9 10.1a14 14 0 0 0-19.8 0L.69 8.69a16 16 0 0 1 22.62 0z"
      }), React.createElement("path", {
        d: "M19.07 12.93a10 10 0 0 0-14.14 0l-1.42-1.42a12 12 0 0 1 17 0z"
      }));

    case 'location___globe':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm8.05 7h-2.93l-2.27-4.53A9 9 0 0 1 20.05 8zm.95 4a8.76 8.76 0 0 1-.23 2H18v-4h2.77a8.76 8.76 0 0 1 .23 2zM3.23 14a8.81 8.81 0 0 1 0-4H6v4zM8 14v-4h8v4zm4.39-11l2.49 5H9.12l2.49-5H12zm-3.24.45L6.88 8H4a9 9 0 0 1 5.15-4.53zM4 16h2.88l2.27 4.53A9 9 0 0 1 4 16zm7.66 5l-2.54-5h5.76l-2.49 5H12zm3.24-.45L17.12 16h2.93a9 9 0 0 1-5.2 4.53z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 10h6v4H9z"
      }), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm8.77 13a9.17 9.17 0 0 1-.72 2H17l-2.18 4.54a9.24 9.24 0 0 1-2.43.44l2.49-5H9.12l2.49 5a9.24 9.24 0 0 1-2.43-.44L7 16H4a9.17 9.17 0 0 1-.72-2H7v-4H3.23A9.17 9.17 0 0 1 4 8h3l2.18-4.54A9.24 9.24 0 0 1 11.61 3L9.12 8h5.76l-2.49-5a9.24 9.24 0 0 1 2.43.44L17 8h3.05a9.17 9.17 0 0 1 .72 2H17v4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm-6.74 31a25.73 25.73 0 0 1-1.62-8h16.72a25.39 25.39 0 0 1-1.62 8zM4.05 25h9.6a27.52 27.52 0 0 0 1.49 8h-9a19.78 19.78 0 0 1-2.09-8zm26.69-10a25.73 25.73 0 0 1 1.62 8H15.64a25.39 25.39 0 0 1 1.62-8zm-17.09 8h-9.6a19.78 19.78 0 0 1 2.11-8h9a27.5 27.5 0 0 0-1.51 8zm20.7 2H44a19.78 19.78 0 0 1-2.11 8h-9a27.5 27.5 0 0 0 1.46-8zm0-2a27.52 27.52 0 0 0-1.49-8h9A19.78 19.78 0 0 1 44 23zm6.34-10h-8.61c-.06-.15-.12-.3-.19-.45L27.8 4.37A20.08 20.08 0 0 1 40.69 13zM25.42 4.07L29.88 13H18.12l4.46-8.93C23.05 4 23.52 4 24 4s1 0 1.42.07zm-5.22.3l-4.11 8.22c-.06.13-.12.27-.17.41H7.31A20.08 20.08 0 0 1 20.2 4.37zM7.31 35h8.61c.06.15.12.3.19.45l4.09 8.18A20.08 20.08 0 0 1 7.31 35zm15.27 8.93L18.12 35h11.76l-4.46 8.93C25 44 24.48 44 24 44s-.95 0-1.42-.07zm5.22-.3l4.11-8.22c.06-.13.12-.27.17-.41h8.61a20.08 20.08 0 0 1-12.89 8.63z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.26 33h15.48a25.39 25.39 0 0 0 1.62-8H14.64a25.73 25.73 0 0 0 1.62 8zM31.74 15H16.26a25.39 25.39 0 0 0-1.62 8h18.72a25.73 25.73 0 0 0-1.62-8z"
      }), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm20 23h-8.65a27.5 27.5 0 0 1-1.48 8h8a20.74 20.74 0 0 1-1.15 2h-7.64l-4.14 8.36a20.31 20.31 0 0 1-2.47.47L30.88 35H17.12l4.41 8.83a20.31 20.31 0 0 1-2.47-.47L14.92 35H7.31a20.74 20.74 0 0 1-1.15-2h8a27.52 27.52 0 0 1-1.49-8H4v-2h8.65a27.5 27.5 0 0 1 1.48-8h-8a20.74 20.74 0 0 1 1.15-2h7.61l4.14-8.36a20.31 20.31 0 0 1 2.47-.47L17.12 13h13.76l-4.41-8.83a20.31 20.31 0 0 1 2.47.47L33.08 13h7.61a20.74 20.74 0 0 1 1.15 2h-8a27.52 27.52 0 0 1 1.49 8H44z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zM8 49h20.26a54.26 54.26 0 0 0 3.44 18H12.81A39.67 39.67 0 0 1 8 49zm20.23-2H8a39.67 39.67 0 0 1 4.78-18h18.91a54.2 54.2 0 0 0-3.43 18zm5.56-18h28.39a52.09 52.09 0 0 1 3.56 18H30.26a51.82 51.82 0 0 1 3.56-18zm-3.53 20h35.48a51.82 51.82 0 0 1-3.56 18H33.82a52.09 52.09 0 0 1-3.56-18zm37.48 0H88a39.67 39.67 0 0 1-4.78 18H64.31a54.2 54.2 0 0 0 3.43-18zm0-2a54.26 54.26 0 0 0-3.44-18h18.89A39.67 39.67 0 0 1 88 47zM82 27H63.51c-.21-.48-.4-1-.62-1.45l-8.51-17A40.09 40.09 0 0 1 82 27zM52 8.2l9.11 18.21c.09.2.16.4.25.59h-26.7c.08-.18.15-.37.23-.55L44 8.2c1.31-.13 2.64-.2 4-.2s2.67.07 4 .2zm-10.36.31l-8.55 17.08c-.21.46-.4.94-.6 1.41H14A40.09 40.09 0 0 1 41.62 8.51zM14 69h18.49c.21.48.4 1 .62 1.45l8.51 17A40.09 40.09 0 0 1 14 69zm30 18.8l-9.09-18.21c-.09-.2-.16-.4-.25-.59h26.68c-.08.18-.15.37-.23.55L52 87.8c-1.31.13-2.64.2-4 .2s-2.67-.07-4-.2zm10.36-.31l8.53-17.08c.21-.46.4-.94.6-1.41H82a40.09 40.09 0 0 1-27.62 18.49z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M31.82 67h32.36a51.82 51.82 0 0 0 3.56-18H28.26a52.09 52.09 0 0 0 3.56 18zM64.18 29H31.82a51.82 51.82 0 0 0-3.56 18h39.48a52.09 52.09 0 0 0-3.56-18z"
      }), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm40 45H69.74a54.2 54.2 0 0 1-3.43 18h16.88c-.37.68-.76 1.34-1.17 2H65.51l-8.92 18.06c-.82.18-1.64.34-2.47.47L63.34 69H32.66l9.22 18.53c-.83-.13-1.65-.29-2.47-.47L30.49 69H14c-.41-.66-.8-1.32-1.17-2H29.7a54.26 54.26 0 0 1-3.44-18H8v-2h18.26a54.2 54.2 0 0 1 3.43-18H12.81c.37-.68.76-1.34 1.17-2h16.51l8.92-18.06c.82-.18 1.64-.34 2.47-.47L32.66 27h30.68L54.12 8.47c.83.13 1.65.29 2.47.47L65.51 27H82c.41.66.8 1.32 1.17 2H66.3a54.26 54.26 0 0 1 3.44 18H88z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm8.05 7h-2.93l-2.27-4.53A9 9 0 0 1 20.05 8zm.95 4a8.76 8.76 0 0 1-.23 2H18v-4h2.77a8.76 8.76 0 0 1 .23 2zM3.23 14a8.81 8.81 0 0 1 0-4H6v4zM8 14v-4h8v4zm4.39-11l2.49 5H9.12l2.49-5H12zm-3.24.45L6.88 8H4a9 9 0 0 1 5.15-4.53zM4 16h2.88l2.27 4.53A9 9 0 0 1 4 16zm7.66 5l-2.54-5h5.76l-2.49 5H12zm3.24-.45L17.12 16h2.93a9 9 0 0 1-5.2 4.53z"
      }));

    case 'location___house':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.29 13.71L12 3.41 1.71 13.71.29 12.29 12 .59l11.71 11.7-1.42 1.42zM21 23h-8v-7h-2v7H3v-9h2v7h4v-7h6v7h4v-7h2v9z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.29 13.71L12 3.41 1.71 13.71.29 12.29 12 .59l11.71 11.7-1.42 1.42z"
      }), React.createElement("path", {
        d: "M11.99 5.59L3 15v8h7v-8h4v8h7v-8l-9.01-9.41z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.79 26.21L24 6.41 4.21 26.21l-1.42-1.42L24 3.59l21.21 21.2-1.42 1.42z"
      }), React.createElement("path", {
        d: "M41 45H27V30h-6v15H7V26h2v17h10V28h10v15h10V26h2v19z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.79 26.21L24 6.41 4.21 26.21l-1.42-1.42L24 3.59l21.21 21.2-1.42 1.42z"
      }), React.createElement("path", {
        d: "M24 10L7 27v18h13V29h8v16h13V27L24 10z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M87.59 52.41L48 12.83 8.41 52.41l-2.82-2.82L48 7.17l42.41 42.42-2.82 2.82z"
      }), React.createElement("path", {
        d: "M82 90H54V60H42v30H14V52h4v34h20V56h20v30h20V52h4v38zM77 26h-4V16H63v-4h14v14zM76.29 48.71L48 20.41l-28.29 28.3-1.42-1.42L48 17.59l29.71 29.7-1.42 1.42z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M87.59 52.41L48 12.83 8.41 52.41l-2.82-2.82L48 7.17l42.41 42.42-2.82 2.82z"
      }), React.createElement("path", {
        d: "M48 18.17l-34 34V90h26V58h16v32h26V52.17l-34-34zM61 12.08v2.83l16 15.9V12l-16 .08z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.29 13.71L12 3.41 1.71 13.71.29 12.29 12 .59l11.71 11.7-1.42 1.42zM21 23h-8v-7h-2v7H3v-9h2v7h4v-7h6v7h4v-7h2v9z"
      }));

    case 'location___location':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.83 1.51a8.11 8.11 0 0 0-5.66 0 7.41 7.41 0 0 0-3.78 10.27L11 23h2l5.61-11.22a7.41 7.41 0 0 0-3.78-10.27zm2 9.37L12 20.53l-4.82-9.65A5.6 5.6 0 0 1 7 6.31a5 5 0 0 1 2.88-2.93 6.1 6.1 0 0 1 4.24 0A5 5 0 0 1 17 6.31a5.6 5.6 0 0 1-.18 4.57z"
      }), React.createElement("path", {
        d: "M12 6a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12.37 1h-.74a7.47 7.47 0 0 0-6.2 10.84L11 23h2l5.57-11.15A7.47 7.47 0 0 0 12.37 1zm2.57 8.6a3 3 0 0 1-5.88 0 3 3 0 0 1 .18-1.77 3 3 0 0 1 .64-1 2.61 2.61 0 0 1 .44-.37 3 3 0 0 1 3.36 0 2.61 2.61 0 0 1 .44.37 3 3 0 0 1 .64 1 3 3 0 0 1 .18 1.77z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25.91 2.11a16.64 16.64 0 0 0-3.82 0C11.94 3.32 6.26 14.52 10.83 23.67L22 46h4l11.17-22.33c4.57-9.15-1.11-20.35-11.26-21.56zm9.47 20.66L24.76 44h-1.52L12.62 22.77a13.21 13.21 0 0 1 .2-12.14 12.35 12.35 0 0 1 9.51-6.53 14 14 0 0 1 3.34 0 12.35 12.35 0 0 1 9.51 6.53 13.21 13.21 0 0 1 .2 12.14z"
      }), React.createElement("path", {
        d: "M24 12a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24.73 2h-1.46c-10.71.5-17.21 12.12-12.42 21.71L22 46h4l11.15-22.29C41.94 14.12 35.44 2.5 24.73 2zM24 23a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M49.5 4h-3C25.1 5 12.11 28.22 21.69 47.38L44 92h8l22.31-44.62C83.89 28.22 70.9 5 49.5 4zm21.23 41.59L49.53 88h-3.06l-21.2-42.41a26.18 26.18 0 0 1 .87-25A24.81 24.81 0 0 1 46.69 8h2.62a24.81 24.81 0 0 1 20.55 12.55 26.18 26.18 0 0 1 .87 25.04z"
      }), React.createElement("path", {
        d: "M60 36a12 12 0 1 0-12 12 12 12 0 0 0 12-12zm-12 8a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM48 12a22 22 0 0 0-22 22h2a20 20 0 0 1 20-20zM48.103 79.555l14-27.994 1.79.895-14 27.994z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M49.46 4h-2.92C25.12 5 12.12 28.24 21.71 47.41L44 92h8l22.29-44.59C83.88 28.24 70.88 5 49.46 4zM28 34h-2a22 22 0 0 1 22-22v2a20 20 0 0 0-20 20zm8 2a12 12 0 1 1 12 12 12 12 0 0 1-12-12zm13.89 44.45l-1.78-.9 14-28 1.78.9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.83 1.51a8.11 8.11 0 0 0-5.66 0 7.41 7.41 0 0 0-3.78 10.27L11 23h2l5.61-11.22a7.41 7.41 0 0 0-3.78-10.27zm2 9.37L12 20.53l-4.82-9.65A5.6 5.6 0 0 1 7 6.31a5 5 0 0 1 2.88-2.93 6.1 6.1 0 0 1 4.24 0A5 5 0 0 1 17 6.31a5.6 5.6 0 0 1-.18 4.57z"
      }), React.createElement("path", {
        d: "M12 6a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
      }));

    case 'location___office':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 11H8v2H4.5zM4.5 15H8v2H4.5zM21 13v8h-2v-2h-5v2h-2v-8h9m2-2H10v12h6v-2h1v2h6V11z"
      }), React.createElement("path", {
        d: "M8 21H3V8.24l8-4V9h2V1L1 7v16h7v-2zM14 15h2v2h-2zM17 15h2v2h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M10 11v12h5v-3h3v3h5V11zm5 6h-2v-2h2zm5 0h-2v-2h2z",
        className: "a"
      }), React.createElement("path", {
        d: "M8 17H4.5v-2H8v-2H4.5v-2H8V9h5V1L1 7v16h7v-6z",
        className: "a"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 18h14v2H7zM7 24h9v2H7zM7 30h9v2H7zM18 24v22h28V24zm9 20v-4h4v4zm6 0v-4h4v4zm11 0h-5v-6H25v6h-5V26h24z"
      }), React.createElement("path", {
        d: "M4 15.24l20-10V22h2V2L2 14v32h14v-2H4V15.24zM25 29.5h2V35h-2zM31 29.5h2V35h-2zM37 29.5h2V35h-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M27 42h4v4h-4zM33 42h4v4h-4z"
      }), React.createElement("path", {
        d: "M7 32v-2h9v-4H7v-2h9v-2h10V2L2 14v32h14V32zm0-14h14v2H7z",
        className: "a"
      }), React.createElement("path", {
        d: "M18 24v22h7v-6h14v6h7V24zm9 11h-2v-5.5h2zm6 0h-2v-5.5h2zm6 0h-2v-5.5h2z",
        className: "a"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14 35h28v4H14zM14 44h18v4H14zM14 53h18v4H14zM14 62h18v4H14zM36 48v44h56V48zm52 4v31H78v-6H50v6H40V52zM66 81h8v7h-8zm-4 7h-8v-7h8zm-22-3h10v3H40zm38 3v-3h10v3z"
      }), React.createElement("path", {
        d: "M8 30.47l40-20V44h4V4L4 28v64h28v-4H8v-3h24v-2H8V30.47zM50 59h4v11h-4zM62 59h4v11h-4zM74 59h4v11h-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M32 66H14v-4h18v-5H14v-4h18v-5H14v-4h38V4L4 28v57h28zM14 35h28v4H14z",
        className: "a"
      }), React.createElement("path", {
        d: "M4 87h28v5H4zM78 87h14v5H78z"
      }), React.createElement("path", {
        d: "M50 92v-5H36v5h14z",
        className: "a"
      }), React.createElement("path", {
        d: "M54 83h8v9h-8zM66 83h8v9h-8z"
      }), React.createElement("path", {
        d: "M36 48v37h14v-6h28v6h14V48zm18 22h-4V59h4zm12 0h-4V59h4zm12 0h-4V59h4z",
        className: "a"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 11H8v2H4.5zM4.5 15H8v2H4.5zM21 13v8h-2v-2h-5v2h-2v-8h9m2-2H10v12h6v-2h1v2h6V11z"
      }), React.createElement("path", {
        d: "M8 21H3V8.24l8-4V9h2V1L1 7v16h7v-2zM14 15h2v2h-2zM17 15h2v2h-2z"
      }));

    case 'location___target':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 11h-3.07A8 8 0 0 0 13 4.07V1h-2v3.07A8 8 0 0 0 4.07 11H1v2h3.07A8 8 0 0 0 11 19.93V23h2v-3.07A8 8 0 0 0 19.93 13H23zm-10 6.91V16h-2v1.91A6 6 0 0 1 6.09 13H8v-2H6.09A6 6 0 0 1 11 6.09V8h2V6.09A6 6 0 0 1 17.91 11H16v2h1.91A6 6 0 0 1 13 17.91z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 10h-3.26A8 8 0 0 0 14 4.26V1h-4v3.26A8 8 0 0 0 4.26 10H1v4h3.26A8 8 0 0 0 10 19.74V23h4v-3.26A8 8 0 0 0 19.74 14H23zm-11 6a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 23h-6A16 16 0 0 0 25 8.05V2h-2v6.05A16 16 0 0 0 8.05 23H2v2h6.05A16 16 0 0 0 23 40v6h2v-6a16 16 0 0 0 15-15h6zM25 38v-2h-2v2a14 14 0 0 1-12.95-13H12v-2h-1.95A14 14 0 0 1 23 10.05V12h2v-1.95A14 14 0 0 1 38 23h-2v2h2a14 14 0 0 1-13 13z"
      }), React.createElement("path", {
        d: "M24 16a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 1 1 6-6 6 6 0 0 1-6 6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 22h-6.14A16 16 0 0 0 26 8.14V2h-4v6.14A16 16 0 0 0 8.14 22H2v4h6.14A16 16 0 0 0 22 39.86V46h4v-6.14A16 16 0 0 0 39.86 26H46zM26 35.82V33h-4v2.82A12 12 0 0 1 12.18 26H15v-4h-2.82A12 12 0 0 1 22 12.18V15h4v-2.82A12 12 0 0 1 35.82 22H33v4h2.82A12 12 0 0 1 26 35.82z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "6"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 46H79.93A32 32 0 0 0 50 16.07V4h-4v12.07A32 32 0 0 0 16.07 46H4v4h12.07A32 32 0 0 0 46 79.93V92h4V79.93A32 32 0 0 0 79.93 50H92zM50 75.92V72h-4v3.92A28 28 0 0 1 20.08 50H24v-4h-3.92A28 28 0 0 1 46 20.08V24h4v-3.92A28 28 0 0 1 75.92 46H72v4h3.92A28 28 0 0 1 50 75.92z"
      }), React.createElement("path", {
        d: "M48 32a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 44H79.74A32 32 0 0 0 52 16.26V4h-8v12.26A32 32 0 0 0 16.26 44H4v8h12.26A32 32 0 0 0 44 79.74V92h8V79.74A32 32 0 0 0 79.74 52H92zM52 71.66V66h-8v5.66A24.06 24.06 0 0 1 24.34 52H30v-8h-5.66A24.06 24.06 0 0 1 44 24.34V30h8v-5.66A24.06 24.06 0 0 1 71.66 44H66v8h5.66A24.06 24.06 0 0 1 52 71.66z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "48",
        r: "12"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 11h-3.07A8 8 0 0 0 13 4.07V1h-2v3.07A8 8 0 0 0 4.07 11H1v2h3.07A8 8 0 0 0 11 19.93V23h2v-3.07A8 8 0 0 0 19.93 13H23zm-10 6.91V16h-2v1.91A6 6 0 0 1 6.09 13H8v-2H6.09A6 6 0 0 1 11 6.09V8h2V6.09A6 6 0 0 1 17.91 11H16v2h1.91A6 6 0 0 1 13 17.91z"
      }));

    case 'object_devices_camera':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.62 7l-1.45-2.89A2 2 0 0 0 15.38 3H8.62a2 2 0 0 0-1.79 1.11L5.38 7H1v11.24L2.38 21h19.24L23 18.24V7zM21 17.76L20.38 19H3.62L3 17.76V9h3.62l2-4h6.76l2 4H21z"
      }), React.createElement("path", {
        d: "M12 8a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.62 7l-1.45-2.89A2 2 0 0 0 15.38 3H8.62a2 2 0 0 0-1.79 1.11L5.38 7H1v11.24L2.38 21h19.24L23 18.24V7zM12 18a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "13",
        r: "3"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36.62 15l-2.9-5.79A4 4 0 0 0 30.15 7h-12.3a4 4 0 0 0-3.57 2.21L11.38 15H3v21.24L5.38 41h37.24L45 36.24V15zM43 35.76L41.38 39H6.62L5 35.76V17h7.62l3.45-6.89A2 2 0 0 1 17.85 9h12.3a2 2 0 0 1 1.78 1.11L35.38 17H43z"
      }), React.createElement("path", {
        d: "M24 16a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM8 21h4v2H8z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36.62 15l-2.9-5.79A4 4 0 0 0 30.15 7h-12.3a4 4 0 0 0-3.57 2.21L11.38 15H3v21.24L5.38 41h37.24L45 36.24V15zM12 23H8v-2h4zm12 13a10 10 0 1 1 10-10 10 10 0 0 1-10 10z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "26",
        r: "8"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M74.24 28l-5.79-11.58A8 8 0 0 0 61.29 12H34.71a8 8 0 0 0-7.16 4.42L21.76 28H4v44.47L9.76 84h76.48L92 72.47V28zm-62 52l-1.5-3h74.52l-1.5 3zM88 71.53L86.26 75H9.74L8 71.53V32h16.24l6.89-13.79A4 4 0 0 1 34.71 16h26.58a4 4 0 0 1 3.58 2.21L71.76 32H88z"
      }), React.createElement("path", {
        d: "M48 32a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm0 36a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
      }), React.createElement("path", {
        d: "M48 39a13 13 0 1 0 13 13 13 13 0 0 0-13-13zm0 24a11 11 0 1 1 11-11 11 11 0 0 1-11 11zM16 42h8v4h-8zM16 48h8v2h-8zM74 40h2v26h-2zM84 24h-6l-1 2h8l-1-2z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 36a16 16 0 1 0 16 16 15.9 15.9 0 0 0-16-16zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "52",
        r: "11"
      }), React.createElement("path", {
        d: "M9.76 84h76.48l2.5-5H7.26l2.5 5zM74.24 28l-5.79-11.58A8 8 0 0 0 61.29 12H34.71a8 8 0 0 0-7.16 4.42L21.76 28H4v44.47L6.26 77h83.48L92 72.47V28zM24 50h-8v-2h8zm0-4h-8v-4h8zm24 26a19.83 19.83 0 0 1-11.18-3.42c-.53-.36-1-.74-1.54-1.15a19.28 19.28 0 0 1-2.71-2.71 20 20 0 0 1 0-25.44 19.28 19.28 0 0 1 2.71-2.71c.49-.41 1-.79 1.54-1.15A20 20 0 1 1 48 72zm28-6h-2V40h2z"
      }), React.createElement("path", {
        d: "M84 24h-6l-1 2h8l-1-2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.62 7l-1.45-2.89A2 2 0 0 0 15.38 3H8.62a2 2 0 0 0-1.79 1.11L5.38 7H1v11.24L2.38 21h19.24L23 18.24V7zM21 17.76L20.38 19H3.62L3 17.76V9h3.62l2-4h6.76l2 4H21z"
      }), React.createElement("path", {
        d: "M12 8a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
      }));

    case 'object_devices_headset':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 1h-2a9.1 9.1 0 0 0-9 9.17v5.33h1.75L5 18h2v-8H5l-1 2v-1.83A7.09 7.09 0 0 1 11 3h2a6.92 6.92 0 0 1 7 7v2l-1-2h-2v8h2l1-2v5h-5v2h5a2 2 0 0 0 2-2V10a8.9 8.9 0 0 0-9-9z"
      }), React.createElement("path", {
        d: "M13 21h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 1h-2a9.1 9.1 0 0 0-9 9.17v5.33h1.75L5 18h2v-8H5l-1 2v-1.83A7.09 7.09 0 0 1 11 3h2a6.92 6.92 0 0 1 7 7v2l-1-2h-2v8h2l1-2v5h-5v2h5a2 2 0 0 0 2-2V10a8.9 8.9 0 0 0-9-9z"
      }), React.createElement("path", {
        d: "M13 21h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 2h-4A17.19 17.19 0 0 0 5 19.33V30h2l4 8h4V18h-4l-4 8v-6.67A15.19 15.19 0 0 1 22 4h4a14.84 14.84 0 0 1 15 15v7l-4-8h-4v20h4l4-8v11a2 2 0 0 1-2 2H28.72A2 2 0 0 0 27 42h-4a2 2 0 0 0 0 4h4a2 2 0 0 0 1.72-1H39a4 4 0 0 0 4-4V19A16.82 16.82 0 0 0 26 2zM9 26.47L12.24 20H13v16h-.76L9 29.53zm30 3.06L35.76 36H35V20h.76L39 26.47z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 2h-4A17.19 17.19 0 0 0 5 19.33V30h2l4 8h4V18h-4l-4 8v-6.67A15.19 15.19 0 0 1 22 4h4a14.84 14.84 0 0 1 15 15v7l-4-8h-4v20h4l4-8v11a2 2 0 0 1-2 2H28.72A2 2 0 0 0 27 42h-4a2 2 0 0 0 0 4h4a2 2 0 0 0 1.72-1H39a4 4 0 0 0 4-4V19A16.82 16.82 0 0 0 26 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M52 4h-8C25.25 4 10 19.55 10 38.67V60h4l8 16h8V36h-8l-8 16V38.67C14 21.76 27.46 8 44 8h8a29.68 29.68 0 0 1 30 30v14l-8-16h-8v40h8l8-16v22a4 4 0 0 1-4 4H57.45A4 4 0 0 0 54 84h-8a4 4 0 0 0 0 8h8a4 4 0 0 0 3.45-2H78a8 8 0 0 0 8-8V38A33.63 33.63 0 0 0 52 4zM18 52.94L24.47 40H26v32h-1.53L18 59.06zm60 6.12L71.53 72H70V40h1.53L78 52.94z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M52 4h-8C25.25 4 10 19.55 10 38.67V60h4l8 16h8V36h-8l-8 16V38.67C14 21.76 27.46 8 44 8h8a29.68 29.68 0 0 1 30 30v14l-8-16h-8v40h8l8-16v22a4 4 0 0 1-4 4H57.45A4 4 0 0 0 54 84h-8a4 4 0 0 0 0 8h8a4 4 0 0 0 3.45-2H78a8 8 0 0 0 8-8V38A33.63 33.63 0 0 0 52 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 1h-2a9.1 9.1 0 0 0-9 9.17v5.33h1.75L5 18h2v-8H5l-1 2v-1.83A7.09 7.09 0 0 1 11 3h2a6.92 6.92 0 0 1 7 7v2l-1-2h-2v8h2l1-2v5h-5v2h5a2 2 0 0 0 2-2V10a8.9 8.9 0 0 0-9-9z"
      }), React.createElement("path", {
        d: "M13 21h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
      }));

    case 'object_devices_laptop':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 5h16v10h2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10h2zM14 16l-.5 1h-3l-.5-1H0v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4zm8 4H2v-2h6.76l.5 1h5.48l.5-1H22z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 5h16v10h2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10h2zM14.25 17l-.5 1h-3.5l-.5-1H0v2a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 11a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v20h2V11a4 4 0 0 0-4-4H10a4 4 0 0 0-4 4v20h2zM28 33l-1 2h-6l-1-2H2v5a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4v-5zm16 5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3h14.76l1 2h8.48l1-2H44z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M28.5 34l-1 2h-7l-1-2H2v3a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4v-3zM8 11a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v20h2V11a4 4 0 0 0-4-4H10a4 4 0 0 0-4 4v20h2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 22a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v40h4V22a8 8 0 0 0-8-8H20a8 8 0 0 0-8 8v40h4zM56 66l-2 4H42l-2-4H4v10a8 8 0 0 0 8 8h72a8 8 0 0 0 8-8V66zm32 10a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-6h29.53l2 4h16.94l2-4H88z"
      }), React.createElement("path", {
        d: "M20 60h56v2H20zM44 21h8v2h-8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 22a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v40h4V22a8 8 0 0 0-8-8H20a8 8 0 0 0-8 8v40h4z"
      }), React.createElement("path", {
        d: "M44 21h8v2h-8zM57 68l-2 4H41l-2-4H4v6a8 8 0 0 0 8 8h72a8 8 0 0 0 8-8v-6zM20 60h56v2H20z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 5h16v10h2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10h2zM14 16l-.5 1h-3l-.5-1H0v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4zm8 4H2v-2h6.76l.5 1h5.48l.5-1H22z"
      }));

    case 'object_devices_printer':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 7H3a2 2 0 0 0-2 2v7l1 2h3v5h14v-5h3l1-2V9a2 2 0 0 0-2-2zm-4 14H7v-6h10zm4-5.47l-.24.47H19v-3H5v3H3.24L3 15.53V9h18z"
      }), React.createElement("path", {
        d: "M19 12a1 1 0 1 0-.71-.29A1 1 0 0 0 19 12zM7 3h10v3h2V1H5v5h2V3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 7H3a2 2 0 0 0-2 2v7l1 2h3v5h14v-5h3l1-2V9a2 2 0 0 0-2-2zm-4 14H7v-6h10zm2-9a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM7 3h10v3h2V1H5v5h2V3z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 14H6a4 4 0 0 0-4 4v14l2 4h4v10h32V36h4l2-4V18a4 4 0 0 0-4-4zm-4 30H10V28h28zm6-12.47L42.76 34H40v-8H8v8H5.24L4 31.53V18a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2z"
      }), React.createElement("path", {
        d: "M38.4 19a2 2 0 0 0-.8 0 2 2 0 0 0-1.44 1.18 2 2 0 0 0 0 1.56A2 2 0 0 0 37.6 23a2 2 0 0 0 .8 0 2 2 0 0 0 1.44-1.18 2 2 0 0 0 0-1.56A2 2 0 0 0 38.4 19zM14 32h20v2H14zM14 38h10v2H14zM10 4h28v8h2V2H8v10h2V4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42 14H6a4 4 0 0 0-4 4v14l2 4h4v10h32V36h4l2-4V18a4 4 0 0 0-4-4zm-4 30H10V28h28zm0-21a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }), React.createElement("path", {
        d: "M14 32h20v2H14zM14 38h10v2H14zM10 4h28v8h2V2H8v10h2V4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 38a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }), React.createElement("path", {
        d: "M84 28H12a8 8 0 0 0-8 8v28l4 8h8v20h64V72h8l4-8V36a8 8 0 0 0-8-8zM16 68h-5.53L9 65h7zm60 20H20V56h56zm9.53-20H80v-3h7zM88 63h-8V52H16v11H8V36a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4z"
      }), React.createElement("path", {
        d: "M27 63h41v2H27zM27 79h21v2H27zM27 71h41v2H27zM20 8h56v16h4V4H16v20h4V8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M27 63h41v2H27zM27 79h21v2H27zM27 71h41v2H27zM20 8h56v16h4V4H16v20h4V8z"
      }), React.createElement("circle", {
        cx: "76",
        cy: "42",
        r: "2"
      }), React.createElement("path", {
        d: "M84 28H12a8 8 0 0 0-8 8v28l.5 1H16v2H5.5L8 72h8v20h64V72h8l2.5-5H80v-2h11.5l.5-1V36a8 8 0 0 0-8-8zm-8 60H20V56h56zm0-42a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 7H3a2 2 0 0 0-2 2v7l1 2h3v5h14v-5h3l1-2V9a2 2 0 0 0-2-2zm-4 14H7v-6h10zm4-5.47l-.24.47H19v-3H5v3H3.24L3 15.53V9h18z"
      }), React.createElement("path", {
        d: "M19 12a1 1 0 1 0-.71-.29A1 1 0 0 0 19 12zM7 3h10v3h2V1H5v5h2V3z"
      }));

    case 'object_devices_smartphone':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 1H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM7 21v-2h3v2zm10 0h-3v-2h3zm0-4H7V3h10z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 1H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm-3 20h-4v-2h4zm3-4H7V3h10z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M34 2H14a4 4 0 0 0-4 4v36a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zM14 4h20a2 2 0 0 1 2 2v30H12V6a2 2 0 0 1 2-2zm20 40H14a2 2 0 0 1-2-2v-4h24v4a2 2 0 0 1-2 2z"
      }), React.createElement("path", {
        d: "M22 40h4v2h-4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M34 2H14a4 4 0 0 0-4 4v36a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zm-8 40h-4v-2h4zm10-6H12V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M68 4H28a8 8 0 0 0-8 8v72a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8zM28 8h40a4 4 0 0 1 4 4v60H24V12a4 4 0 0 1 4-4zm40 80H28a4 4 0 0 1-4-4v-8h48v8a4 4 0 0 1-4 4z"
      }), React.createElement("path", {
        d: "M44 80h8v4h-8zM44 11h8v2h-8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 11h8v2h-8z"
      }), React.createElement("path", {
        d: "M68 4H28a8 8 0 0 0-8 8v72a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8zM52 84h-8v-4h8zm20-12H24V12a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 1H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM7 21v-2h3v2zm10 0h-3v-2h3zm0-4H7V3h10z"
      }));

    case 'object_devices_tablet':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 1H6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM6 21v-2h4v2zm12 0h-4v-2h4zM6 17V3h12v14z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 1H6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm-4 20h-4v-2h4zm4-4H6V3h12z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 2H12a4 4 0 0 0-4 4v36a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zM12 4h24a2 2 0 0 1 2 2v30H10V6a2 2 0 0 1 2-2zm24 40H12a2 2 0 0 1-2-2v-4h28v4a2 2 0 0 1-2 2z"
      }), React.createElement("path", {
        d: "M22 40h4v2h-4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 2H12a4 4 0 0 0-4 4v36a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zM26 42h-4v-2h4zm12-6H10V6a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 4H24a8 8 0 0 0-8 8v72a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8zM24 8h48a4 4 0 0 1 4 4v60H20V12a4 4 0 0 1 4-4zm48 80H24a4 4 0 0 1-4-4v-8h56v8a4 4 0 0 1-4 4z"
      }), React.createElement("path", {
        d: "M44 80h8v4h-8zM44 11h8v2h-8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 11h8v2h-8z"
      }), React.createElement("path", {
        d: "M72 4H24a8 8 0 0 0-8 8v72a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8zM52 84h-8v-4h8zm24-12H20V12a4 4 0 0 1 4-4h48a4 4 0 0 1 4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 1H6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM6 21v-2h4v2zm12 0h-4v-2h4zM6 17V3h12v14z"
      }));

    case 'object_devices_video':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 5l-4 4V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12l1 2h14l1-2v-3l4 4h2V5zm-6 12.53l-.24.47H3.24L3 17.53V6h12zm6-1.36l-3-3v-2.34l3-3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 20H2l-1-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zM22 5l-3 3v8l3 3h1V5h-1z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M25 14h4v2h-4z"
      }), React.createElement("path", {
        d: "M42 10l-8 8v-6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v24l2 4h28l2-4v-6l8 8h4V10zM32 35.53L30.76 38H5.24L4 35.53V12a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2zM44 36h-1.17L34 27.17v-6.34L42.83 12H44z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30 8H6a4 4 0 0 0-4 4v24l2 4h28l2-4V12a4 4 0 0 0-4-4zm-1 8h-4v-2h4zM44 10l-8 8v12l8 8h2V10h-2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M50 28h8v4h-8zM50 34h8v2h-8z"
      }), React.createElement("path", {
        d: "M84 20L68 36V24a8 8 0 0 0-8-8H12a8 8 0 0 0-8 8v48l4 8h56l4-8V60l16 16h8V20zM10.47 76L9 73h54l-1.5 3zM64 71H8V24a4 4 0 0 1 4-4h48a4 4 0 0 1 4 4zm24 1h-2.34L68 54.34V41.66L85.66 24H88z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 80h56l2.5-5h-61L8 80zM60 16H12a8 8 0 0 0-8 8v48l.5 1h63l.5-1V24a8 8 0 0 0-8-8zm-2 20h-8v-2h8zm0-4h-8v-4h8zM88 20L72 36v24l16 16h4V20h-4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 5l-4 4V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12l1 2h14l1-2v-3l4 4h2V5zm-6 12.53l-.24.47H3.24L3 17.53V6h12zm6-1.36l-3-3v-2.34l3-3z"
      }));

    case 'object_document_checklist':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.71 5.79L8.29 7.21l3.89 3.88 5.41-8.55-1.69-1.07-4.08 6.44-2.11-2.12zM8 13h8v2H8zM8 17h8v2H8z"
      }), React.createElement("path", {
        d: "M18 5.08V21H6V3h7V1H4v22h16V5.08h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 1v22h16V1zm12 18H8v-2h8zm0-4H8v-2h8zm-3.83-3.42L8.79 8.21l1.42-1.42 1.62 1.63 3.83-6 1.68 1.08z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 2v44h32V2zm30 42H10V4h28z"
      }), React.createElement("path", {
        d: "M32.84 9.54l-1.68-1.08-8.33 12.96-4.12-4.13-1.42 1.42 5.88 5.87 9.67-15.04zM16 31h16v2H16zM16 37h16v2H16z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 2v44h32V2zm24 37H16v-2h16zm0-6H16v-2h16zm-8.83-8.42l-5.88-5.87 1.42-1.42 4.12 4.13 8.33-13 1.68 1.08z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 55h32v2H32zM32 75h32v2H32z"
      }), React.createElement("path", {
        d: "M16 4v88h64V4zm60 84H20V8h56z"
      }), React.createElement("path", {
        d: "M65.68 16.08l-3.36-2.16-16.66 25.91-8.25-8.24-2.82 2.82 11.75 11.76 19.34-30.09zM32 65h32v2H32z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 4v88h64V4zm48 73H32v-2h32zm0-10H32v-2h32zm0-10H32v-2h32zM46.34 46.17L34.59 34.41l2.82-2.82 8.25 8.24 16.66-25.91 3.36 2.16z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.71 5.79L8.29 7.21l3.89 3.88 5.41-8.55-1.69-1.07-4.08 6.44-2.11-2.12zM8 13h8v2H8zM8 17h8v2H8z"
      }), React.createElement("path", {
        d: "M18 5.08V21H6V3h7V1H4v22h16V5.08h-2z"
      }));

    case 'object_document_document':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 1H4v22h16V8zm0 2.83L17.17 8H13zM18 21H6V3h5v7h7z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 1H4v22h16V10h-9V1z"
      }), React.createElement("path", {
        d: "M20 8l-7-7v7h7z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 2H8v44h32V16zm-1 2h.17L38 16.83V17H25zm13 40H10V4h13v15h15z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 2H8v44h32V19H23V2z"
      }), React.createElement("path", {
        d: "M26 2h-1v15h15v-1L26 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 52h32v2H32zM32 72h32v2H32zM32 62h32v2H32z"
      }), React.createElement("path", {
        d: "M52 4H16v88h64V32zm-2 4h.34L76 33.66V34H50zm26 80H20V8h26v30h30z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 92h64V38H46V4H16zm16-40h32v2H32zm0 10h32v2H32zm0 10h32v2H32z"
      }), React.createElement("path", {
        d: "M50 4v30h30v-2L52 4h-2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 1H4v22h16V8zm0 2.83L17.17 8H13zM18 21H6V3h5v7h7z"
      }));

    case 'object_transport_airplane':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.53 24l-4.41-4.11-6.42-.59 2.23-4.66 3.47-.77.74-1.49L0 10l2-4.09h10.38L14 2.72A4.9 4.9 0 0 1 18.37 0h.5l.32.4a4.89 4.89 0 0 1 .48 5.17l-1.61 3.2 5.66 8.37-2 4.1-6.89-5.9-.55 1.1 1.59 3zM5.7 17.6l4.3.4 3 2.77.66-1.32-1.58-3 2.13-4.26L21 18.11l.4-.82-5.61-8.37 2.12-4.23a2.94 2.94 0 0 0 0-2.68 2.91 2.91 0 0 0-2.18 1.59L13.6 7.87H3.27l-.42.83L12 11.08l-2.26 4.51-3.45.76z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.65 20l1.25-2.5L17.15 9 19 5.21A4 4 0 0 0 18.67 1 4 4 0 0 0 15 3.21L13.15 7H2.65L1.4 9.5l9.29 2.42L9.17 15l-3.52.78-1.44 3 5.44.5 3.75 3.5 1.5-3-1.61-3L14.65 14z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.3 40l2.5-5-11.49-17 3.78-7.57A8 8 0 0 0 37.33 2h-.06a8 8 0 0 0-7.15 4.42L26.3 14h-21l-2.5 5 18.58 4.85-3.05 6.09-7 1.56-2.88 6 10.88 1 7.5 7 3-6-3.23-6 2.7-5.5zm.19-4.85l-.83 1.66L30.2 26.14 33.27 20zM5.69 17.69L6.54 16h18.77l-3 6zm18.63 15.79l3.23 6.05-1.34 2.68-6.05-5.64-8.69-.8 1.21-2.53 7-1.56 12.2-24.36a6 6 0 0 1 4.38-3.24 6 6 0 0 1 0 5.45z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24.68 15H5.92l-1.67 3.34 16.59 4.33L24.68 15zM34.44 19.97l-3.9 7.78 12.44 10.66 1.66-3.33-10.2-15.11z"
      }), React.createElement("path", {
        d: "M37.19 10a7 7 0 0 0-.4-7A7 7 0 0 0 31 6.87L19 30.81l-7 1.56-2 4.27 9.78.9 6.77 6.32 2.17-4.35-3.22-6z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M69.38 13.19l1.18 3.16 1.88-.7-1.19-3.17a2 2 0 0 0-2.36-1.23l-3.13.75.48 2z"
      }), React.createElement("path", {
        d: "M58 55.44l27.7 23.73 5-9.9-22.78-33.64 7.46-15a15.81 15.81 0 0 0-1.49-16.58L73.82 4h-.11a15.84 15.84 0 0 0-14.16 8.75L52 27.71H10.49L5.54 37.6l36.75 9.59-6 12.06-13.93 3.09-5.69 11.88 17.18 1.58-.85 4.87A2 2 0 0 0 35 83a2 2 0 0 0 1.41-.59l4.08-4.07L53 90.05l6-11.87-6.38-12zm28 14.13l-1.59 3.23-24.55-21 6-12zM11.33 35L13 31.71h37l-5.88 11.82zm11.44 35.76l2.36-4.93 10.79-2.4-1.41 8.41zm31.71 7.48l-2.62 5.24-8.54-8 6.33-6.33zm-5.2-14.35L38 75.22l2.68-15.75 22.49-45a11.76 11.76 0 0 1 8.61-6.38 11.78 11.78 0 0 1 .07 10.72z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23.75 64.08l-4.03 8.41 10.9 1 2.74-11.54-9.61 2.13zM48.82 29.71H11.73l-3.3 6.58 32.81 8.56 7.58-15.14zM50.34 66.24L73.6 19.73A13.75 13.75 0 0 0 72.81 6a13.73 13.73 0 0 0-11.47 7.62L37.74 60.8l-4.69 19.74a2 2 0 0 0 1.07 2.25A2 2 0 0 0 35 83a2 2 0 0 0 1.55-.74l13.81-16zm18.55-55a2 2 0 0 1 2.36 1.23l1.19 3.17-1.88.7-1.18-3.16-3.14.82-.48-2zM68.16 39.56l-7.68 15.35 24.58 21.07 3.27-6.56-20.17-29.86zM44.3 79.46l8.15 7.3 4.28-8.55-4.35-8.17-8.08 9.42z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.53 24l-4.41-4.11-6.42-.59 2.23-4.66 3.47-.77.74-1.49L0 10l2-4.09h10.38L14 2.72A4.9 4.9 0 0 1 18.37 0h.5l.32.4a4.89 4.89 0 0 1 .48 5.17l-1.61 3.2 5.66 8.37-2 4.1-6.89-5.9-.55 1.1 1.59 3zM5.7 17.6l4.3.4 3 2.77.66-1.32-1.58-3 2.13-4.26L21 18.11l.4-.82-5.61-8.37 2.12-4.23a2.94 2.94 0 0 0 0-2.68 2.91 2.91 0 0 0-2.18 1.59L13.6 7.87H3.27l-.42.83L12 11.08l-2.26 4.51-3.45.76z"
      }));

    case 'object_transport_pram':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 18a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9 22.5zM17 18a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zM13 1h-1v9H6.12l-1-2H1v2h2.88l3.5 7h12.24L22 12.24V10a9 9 0 0 0-9-9zm1 2.07A7 7 0 0 1 20 10h-6zM18.38 15H8.62l-1.5-3h12.76z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 18a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9 22.5zM17 18a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zM6.62 11l-1.5-3H1v2h2.88l3.5 7h12.24L22 12.24V11H6.62zM13 1h-1v8h9.94A9 9 0 0 0 13 1z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 34a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM33 34a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM26 2h-1v18H11.12l-1.5-3H2v2h6.38l6.5 13h23.74L43 23.24V19A17 17 0 0 0 26 2zm15 20.76L37.38 30H16.12l-4-8H41zM27 20V4a15 15 0 0 1 14 15v1z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 34a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM33 34a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM11.62 21l-2-4H2v2h6.38l6.5 13h23.74L43 23.24V21H11.62z"
      }), React.createElement("path", {
        d: "M26 2h-1v17h18A17 17 0 0 0 26 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 68a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM66 68a12 12 0 1 0 12 12 12 12 0 0 0-12-12zm0 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM52 4h-2v36H22.24l-3-6H4v4h12.76l13 26h47.48L86 46.47V38A34 34 0 0 0 52 4zm30 41.53L74.76 60H32.24l-8-16H82zM54 40V8.07A30 30 0 0 1 82 38v2z"
      }), React.createElement("path", {
        d: "M31 47h45v2H31z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 72a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-4a12 12 0 1 0 12 12 12 12 0 0 0-12-12zM66 72a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-4a12 12 0 1 0 12 12 12 12 0 0 0-12-12zM86 38A34 34 0 0 0 52 4h-2v34z"
      }), React.createElement("path", {
        d: "M82 42H23.24l-4-8H4v4h12.76l13 26h47.48L86 46.47V42zm-7 7H32v-2h43z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 18a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9 22.5zM17 18a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zM13 1h-1v9H6.12l-1-2H1v2h2.88l3.5 7h12.24L22 12.24V10a9 9 0 0 0-9-9zm1 2.07A7 7 0 0 1 20 10h-6zM18.38 15H8.62l-1.5-3h12.76z"
      }));

    case 'object___alarmclock':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 4a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16a7 7 0 1 1 7-7 7 7 0 0 1-7 7zM6.53 1.27a3.92 3.92 0 0 0-5.27 5.26L2 8l6-6zM22 2a3.91 3.91 0 0 0-4.53-.73L16 2l6 6 .74-1.47A3.94 3.94 0 0 0 22 2z"
      }), React.createElement("path", {
        d: "M10.89 8.55l-1.78.9L11.38 14H16v-2h-3.38l-1.73-3.45z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6.53 1.27a3.92 3.92 0 0 0-5.27 5.26L2 8l6-6zM22 2a3.91 3.91 0 0 0-4.53-.73L16 2l6 6 .74-1.47A3.94 3.94 0 0 0 22 2zM12 4a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm4 10h-4.62L9.11 9.45l1.78-.9L12.62 12H16z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40 25a16 16 0 1 0-26.6 12l-2.79 5.59 1.78.9L15 38.23a16 16 0 0 0 17.62.24l2.49 5 1.78-.9-2.63-5.27A16 16 0 0 0 40 25zM24 39a14 14 0 1 1 14-14 14 14 0 0 1-14 14zM14.14 4.47a7.86 7.86 0 0 0-3.21-.69 7.74 7.74 0 0 0-5.48 2.27A7.76 7.76 0 0 0 4 15l1.5 3 12-12zM6.05 14.62l-.26-.52a5.75 5.75 0 0 1 7.52-7.81l.74.34zM42.55 6.05a7.74 7.74 0 0 0-5.48-2.27 7.86 7.86 0 0 0-3.21.69L30.5 6l12 12 1.5-3a7.76 7.76 0 0 0-1.45-8.95zm-.34 8.05l-.26.52-8-8 .74-.34a5.75 5.75 0 0 1 7.52 7.81z"
      }), React.createElement("path", {
        d: "M24.12 23l-3.23-6.46-1.78.9 3.22 6.45A2 2 0 0 0 22 25a2 2 0 0 0 2 2 2 2 0 0 0 1.72-1H32v-2h-6.28a2 2 0 0 0-1.6-1z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.14 4.47a7.86 7.86 0 0 0-3.21-.69 7.74 7.74 0 0 0-5.48 2.27A7.76 7.76 0 0 0 4 15l1.5 3 12-12zM42.55 6.05a7.74 7.74 0 0 0-5.48-2.27 7.86 7.86 0 0 0-3.21.69L30.5 6l12 12 1.5-3a7.76 7.76 0 0 0-1.45-8.95zM40 25a16 16 0 1 0-26.6 12l-2.79 5.59 1.78.9L15 38.23a16 16 0 0 0 17.62.24l2.49 5 1.78-.9-2.63-5.27A16 16 0 0 0 40 25zm-8 1h-6.28A2 2 0 0 1 24 27a2 2 0 0 1-2-2 2 2 0 0 1 .33-1.1l-3.22-6.45 1.78-.9L24.12 23a2 2 0 0 1 1.6 1H32z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80 50a32 32 0 1 0-53.21 24l-5.58 11.11 3.58 1.78L30 76.46a32 32 0 0 0 35.24.54l5 9.94 3.58-1.78-5.31-10.6A31.93 31.93 0 0 0 80 50zM48 78a28 28 0 1 1 28-28 28 28 0 0 1-28 28z"
      }), React.createElement("path", {
        d: "M48 26a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm0 46a22 22 0 1 1 22-22 22 22 0 0 1-22 22zM28.28 9a15.51 15.51 0 0 0-17.38 3.1A15.5 15.5 0 0 0 8 30l3 6 24-24zM12.1 29.25l-.52-1a11.5 11.5 0 0 1 10.29-16.69 11.36 11.36 0 0 1 4.76 1l1.46.66zM85.1 12.1A15.51 15.51 0 0 0 67.72 9L61 12l24 24 3-6a15.5 15.5 0 0 0-2.9-17.9zm-.68 16.11l-.52 1-16-16 1.46-.66a11.52 11.52 0 0 1 12.9 2.34 11.48 11.48 0 0 1 2.16 13.32z"
      }), React.createElement("path", {
        d: "M51.45 48a4 4 0 0 0-3.2-2l-6.46-12.89-3.58 1.78 6.45 12.91A4 4 0 0 0 48 54a4 4 0 0 0 3.45-2H64v-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80 50a32 32 0 1 0-53.21 24l-5.58 11.11 3.58 1.78L30 76.46a32 32 0 0 0 35.24.54l5 9.94 3.58-1.78-5.31-10.6A31.93 31.93 0 0 0 80 50zM48 78a28 28 0 1 1 28-28 28 28 0 0 1-28 28zM28.28 9a15.51 15.51 0 0 0-17.38 3.1A15.5 15.5 0 0 0 8 30l3 6 24-24zM85.1 12.1A15.51 15.51 0 0 0 67.72 9L61 12l24 24 3-6a15.5 15.5 0 0 0-2.9-17.9z"
      }), React.createElement("path", {
        d: "M48 24a26 26 0 1 0 26 26 26 26 0 0 0-26-26zm16 28H51.45A4 4 0 0 1 44 50a4 4 0 0 1 .66-2.2l-6.45-12.91 3.58-1.78L48.25 46a4 4 0 0 1 3.2 2H64z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 4a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16a7 7 0 1 1 7-7 7 7 0 0 1-7 7zM6.53 1.27a3.92 3.92 0 0 0-5.27 5.26L2 8l6-6zM22 2a3.91 3.91 0 0 0-4.53-.73L16 2l6 6 .74-1.47A3.94 3.94 0 0 0 22 2z"
      }), React.createElement("path", {
        d: "M10.89 8.55l-1.78.9L11.38 14H16v-2h-3.38l-1.73-3.45z"
      }));

    case 'object___calender':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 4V2h-2v2H9V2H7v2H2v17h20V4zm3 15H4V6h3v2h2V6h6v2h2V6h3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 2h2v2H7zM15 2h2v2h-2zM17 4v2h-2V4H9v2H7V4H2v17h20V4zm3 15H4V9h16z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M33 8V4h-2v4H17V4h-2v4H5v34h38V8zm8 32H7V10h8v3h2v-3h14v3h2v-3h8z"
      }), React.createElement("path", {
        d: "M9 18h30v2H9z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15 4h2v4h-2zM31 4h2v4h-2zM33 8v4h-2V8H17v4h-2V8H5v34h38V8zm8 32H7V18h34z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M66 16V8h-4v8H34V8h-4v8H10v68h76V16zm16 64H14V20h16v6h4v-6h28v6h4v-6h16z"
      }), React.createElement("path", {
        d: "M21 34h54v2H21zM21 71h54V45H21zm2-12h11v10H23zm26-2V47h11v10zm11 2v10H49V59zm-13-2H36V47h11zm0 2v10H36V59zm15 10V59h11v10zm11-12H62V47h11zM34 47v10H23V47z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30 8h4v8h-4zM62 8h4v8h-4zM66 16v8h-4v-8H34v8h-4v-8H10v68h76V16zm16 64H14V35.89h68z"
      }), React.createElement("path", {
        d: "M75 45H21v26h54zm-2 12H62V47h11zm-26 2v10H36V59zm-11-2V47h11v10zm13 2h11v10H49zm0-2V47h11v10zM34 47v10H23V47zM23 59h11v10H23zm39 10V59h11v10z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 4V2h-2v2H9V2H7v2H2v17h20V4zm3 15H4V6h3v2h2V6h6v2h2V6h3z"
      }));

    case 'object___clock':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M9.89 5.55l-1.78.9L11.38 13H18v-2h-5.38L9.89 5.55z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm6 12h-6.62L8.11 6.45l1.78-.9L12.62 11H18z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm0 42a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M24.12 22l-5.23-10.45-1.78.9 5.22 10.45A2 2 0 0 0 22 24a2 2 0 0 0 2 2 2 2 0 0 0 1.72-1H36v-2H25.72a2 2 0 0 0-1.6-1z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm12 23H25.72A2 2 0 0 1 24 26a2 2 0 0 1-2-2 2 2 0 0 1 .33-1.1l-5.22-10.45 1.78-.9L24.12 22a2 2 0 0 1 1.6 1H36z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 84a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
      }), React.createElement("path", {
        d: "M48 11a37 37 0 1 0 37 37 37 37 0 0 0-37-37zm1.12 72v-3h-2.24v3A35 35 0 0 1 13 49.12h3v-2.24h-3A35 35 0 0 1 46.88 13v3h2.24v-3A35 35 0 0 1 83 46.88h-3v2.24h3A35 35 0 0 1 49.12 83z"
      }), React.createElement("path", {
        d: "M48.25 44L37.79 23.11l-3.58 1.78L44.66 45.8A4 4 0 0 0 48 52a4 4 0 0 0 3.45-2H72v-4H51.45a4 4 0 0 0-3.2-2z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 83a39 39 0 1 1 39-39 39 39 0 0 1-39 39z"
      }), React.createElement("path", {
        d: "M81 49.12v-2.24h4A37 37 0 0 0 49.12 11v4h-2.24v-4A37 37 0 0 0 11 46.88h4v2.24h-4A37 37 0 0 0 46.88 85v-4h2.24v4A37 37 0 0 0 85 49.12zM72 50H51.45A4 4 0 0 1 44 48a4 4 0 0 1 .66-2.2L34.21 24.89l3.58-1.78L48.25 44a4 4 0 0 1 3.2 2H72z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M9.89 5.55l-1.78.9L11.38 13H18v-2h-5.38L9.89 5.55z"
      }));

    case 'object___coffeemug':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 4.5h-2V3H1v11.58a6.11 6.11 0 0 0 .63 2.69L4 22h10l2.37-4.73a7.28 7.28 0 0 0 .31-.77H19a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4zm-4 10.08a4.09 4.09 0 0 1-.42 1.79L12.76 20H5.24l-1.82-3.63A4.09 4.09 0 0 1 3 14.58V5h12zm6-2.08a2 2 0 0 1-2 2h-2v-8h2a2 2 0 0 1 2 2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 4.5h-2V3H1v11.58a6.11 6.11 0 0 0 .63 2.69L4 22h10l2.37-4.73a7.28 7.28 0 0 0 .31-.77H19a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4zm2 8a2 2 0 0 1-2 2h-2v-8h2a2 2 0 0 1 2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 8h-4V5H2v23.17a11.88 11.88 0 0 0 1.27 5.36L8 43h20l4.73-9.47a12 12 0 0 0 .63-1.53H38a8 8 0 0 0 8-8v-8a8 8 0 0 0-8-8zm-4 6h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4zm-2 14.17a9.93 9.93 0 0 1-1.06 4.47L26.76 41H9.24l-4.18-8.36A9.93 9.93 0 0 1 4 28.17V7h28zM44 24a6 6 0 0 1-6 6h-4.16a11.31 11.31 0 0 0 .16-1.83V28h4a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4h-4v-2h4a6 6 0 0 1 6 6z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 8h-4V5H2v23.17a11.88 11.88 0 0 0 1.27 5.36L8 43h20l4.73-9.47a12 12 0 0 0 .63-1.53H38a8 8 0 0 0 8-8v-8a8 8 0 0 0-8-8zm4 16a4 4 0 0 1-4 4h-4V12h4a4 4 0 0 1 4 4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 16h-8v-6H4v46.33a24.12 24.12 0 0 0 2.53 10.74L16 86h40l9.47-18.93A24.75 24.75 0 0 0 66.73 64H76a16 16 0 0 0 16-16V32a16 16 0 0 0-16-16zM18.47 82L17 79h38l-1.5 3zM64 56.33a20.13 20.13 0 0 1-2.11 9L56 77.06V77H16l-5.89-11.72a20.13 20.13 0 0 1-2.11-9V14h56zM68 26h8a6 6 0 0 1 6 6v16a6 6 0 0 1-6 6h-8zm20 22a12 12 0 0 1-12 12h-8.29a23.59 23.59 0 0 0 .29-3.67V56h8a8 8 0 0 0 8-8V32a8 8 0 0 0-8-8h-8v-4h8a12 12 0 0 1 12 12z"
      }), React.createElement("path", {
        d: "M11 17h2v39h-2z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 16h-8v-6H4v46.33a24.12 24.12 0 0 0 2.53 10.74L12.5 79h47l6-11.93A24.75 24.75 0 0 0 66.73 64H76a16 16 0 0 0 16-16V32a16 16 0 0 0-16-16zM13 56h-2V17h2zm71-8a8 8 0 0 1-8 8h-8V24h8a8 8 0 0 1 8 8zM13.5 81l2.5 5h40l2.5-5h-45z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19 4.5h-2V3H1v11.58a6.11 6.11 0 0 0 .63 2.69L4 22h10l2.37-4.73a7.28 7.28 0 0 0 .31-.77H19a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4zm-4 10.08a4.09 4.09 0 0 1-.42 1.79L12.76 20H5.24l-1.82-3.63A4.09 4.09 0 0 1 3 14.58V5h12zm6-2.08a2 2 0 0 1-2 2h-2v-8h2a2 2 0 0 1 2 2z"
      }));

    case 'object___firstaid':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 18h2v-3h3v-2h-3v-3h-2v3H8v2h3v3zM10.24 3h3.52l1 2H17l-1.45-2.89A2 2 0 0 0 13.76 1h-3.52a2 2 0 0 0-1.79 1.11L7 5h2.24z"
      }), React.createElement("path", {
        d: "M22 6H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 14H3V8h18z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.24 5l1-2h3.52l1 2H17l-1.45-2.89A2 2 0 0 0 13.76 1h-3.52a2 2 0 0 0-1.79 1.11L7 5zM22 6H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-6 9h-3v3h-2v-3H8v-2h3v-3h2v3h3z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 34h2v-5h5v-2h-5v-5h-2v5h-5v2h5v5zM18.68 7.11A2 2 0 0 1 20.47 6h7.06a2 2 0 0 1 1.79 1.11L31.26 11h2.24l-2.39-4.79A4 4 0 0 0 27.53 4h-7.06a4 4 0 0 0-3.58 2.21L14.5 11h2.24z"
      }), React.createElement("path", {
        d: "M44 12H4a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zM8 42H4V14h4zm30 0H10V14h28zm6 0h-4V14h4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.74 11l1.94-3.89A2 2 0 0 1 20.47 6h7.06a2 2 0 0 1 1.79 1.11L31.26 11h2.24l-2.39-4.79A4 4 0 0 0 27.53 4h-7.06a4 4 0 0 0-3.58 2.21L14.5 11zM44 12H4a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zM10 42H8V14h2zm20-13h-5v5h-2v-5h-5v-2h5v-5h2v5h5zm10 13h-2V14h2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 70h8V60h10v-8H52V42h-8v10H34v8h10zm-8-12v-4h10V44h4v10h10v4H50v10h-4V58zM37 12l-5 10h2.24l4-8h19.52l4 8H64l-5-10H37z"
      }), React.createElement("path", {
        d: "M33.37 10.21A4 4 0 0 1 36.94 8h22.12a4 4 0 0 1 3.57 2.21L68.53 22H73L66.21 8.42A8 8 0 0 0 59.06 4H36.94a8 8 0 0 0-7.15 4.42L23 22h4.47zM88 24H8a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h80a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4zM16 84H8V28h8zm62 0H18V28h60zm10 0h-8V28h8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 22l5-10h22l5 10h9L66.21 8.42A8 8 0 0 0 59.06 4H36.94a8 8 0 0 0-7.15 4.42L23 22zM88 24H8a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h80a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4zM18 84h-2V28h2zm44-24H52v10h-8V60H34v-8h10V42h8v10h10zm18 24h-2V28h2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 18h2v-3h3v-2h-3v-3h-2v3H8v2h3v3zM10.24 3h3.52l1 2H17l-1.45-2.89A2 2 0 0 0 13.76 1h-3.52a2 2 0 0 0-1.79 1.11L7 5h2.24z"
      }), React.createElement("path", {
        d: "M22 6H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 14H3V8h18z"
      }));

    case 'object___flag':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 1h2v22H3zM21.77 15H7v-2h11.23l-2.4-4 2.4-4H7V3h14.77l-3.6 6 3.6 6z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 1h2v22H3zM21.77 3H7v12h14.77l-3.6-6 3.6-6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 4h2v40H7zM41.62 30H11v-2h27.38l-5-10 5-10H11V6h30.62l-6 12 6 12z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 4h2v40H7zM41.62 6H11v24h30.62l-6-12 6-12z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 19h48v2H22zM22 51h48v2H22zM14 8h4v80h-4z"
      }), React.createElement("path", {
        d: "M83.24 60H22v-4h54.76l-10-20 10-20H22v-4h61.24l-12 24 12 24z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M83.24 12H22v5h52v2H22v34h52v2H22v5h61.24l-12-24 12-24zM14 8h4v80h-4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 1h2v22H3zM21.77 15H7v-2h11.23l-2.4-4 2.4-4H7V3h14.77l-3.6 6 3.6 6z"
      }));

    case 'object___gauge':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 7.64a5.26 5.26 0 0 1 2.61.7l2.06-1a7.37 7.37 0 0 0-9.88 10.9l1.42-1.42A5.36 5.36 0 0 1 12 7.64z"
      }), React.createElement("path", {
        d: "M18.05 8.86l-5 2.47A2 2 0 0 0 12 11a2 2 0 1 0 2 2.12l5-2.48z"
      }), React.createElement("path", {
        d: "M20.49 4.51a12 12 0 0 0-17 17l1.42-1.42a10 10 0 1 1 14.14 0l1.42 1.42a12 12 0 0 0 .02-17z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.49 4.51a12 12 0 0 0-17 17L4 22h16l.49-.51a12 12 0 0 0 0-16.98zM8.21 16.79l-1.42 1.42a7.36 7.36 0 0 1 9.88-10.9l-2.06 1a5.35 5.35 0 0 0-6.4 8.45zM12 15a2 2 0 0 1 0-4 2 2 0 0 1 1.1.33l5-2.47.9 1.78-5 2.48A2 2 0 0 1 12 15z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.56 10.44A22 22 0 0 0 8.44 41.56l1.42-1.42a20 20 0 1 1 28.28 0l1.42 1.42a22 22 0 0 0 0-31.12z"
      }), React.createElement("path", {
        d: "M33 17l1.42-1.42a14.79 14.79 0 0 0-20.88 20.88L15 35a12.78 12.78 0 0 1 18-18z"
      }), React.createElement("path", {
        d: "M36.55 18.61L25.1 24.33A2 2 0 0 0 24 24a2 2 0 1 0 2 2.12l11.46-5.73z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39.56 10.44A22 22 0 0 0 8.44 41.56L9 42h30l.56-.44a22 22 0 0 0 0-31.12zM15 35l-1.42 1.42a14.79 14.79 0 0 1 20.88-20.88L33 17a12.78 12.78 0 0 0-18 18zm9-7a2 2 0 0 1 0-4 2 2 0 0 1 1.1.33l11.45-5.72.9 1.78L26 26.12A2 2 0 0 1 24 28z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M79.11 20.89a44 44 0 1 0-62.22 62.22l2.83-2.83a40 40 0 0 1 56.56-56.56 40 40 0 0 1 0 56.56l2.83 2.83a44 44 0 0 0 0-62.22z"
      }), React.createElement("path", {
        d: "M48 25.42a26.4 26.4 0 0 1 18.79 7.79l1.42-1.42a28.58 28.58 0 0 0-40.42 40.42l1.42-1.42A26.58 26.58 0 0 1 48 25.42z"
      }), React.createElement("path", {
        d: "M73.11 37.21L50.2 48.66A4 4 0 1 0 48 56a4 4 0 0 0 4-3.75l22.89-11.46z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M79.11 20.89a44 44 0 1 0-62.22 62.22L18 84h60l1.11-.89a44 44 0 0 0 0-62.22zm-49.9 49.9l-1.42 1.42a28.58 28.58 0 0 1 40.42-40.42l-1.42 1.42a26.57 26.57 0 1 0-37.58 37.58zM48 56a4 4 0 1 1 2.2-7.34l22.91-11.45 1.78 3.58L52 52.25A4 4 0 0 1 48 56z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 7.64a5.26 5.26 0 0 1 2.61.7l2.06-1a7.37 7.37 0 0 0-9.88 10.9l1.42-1.42A5.36 5.36 0 0 1 12 7.64z"
      }), React.createElement("path", {
        d: "M18.05 8.86l-5 2.47A2 2 0 0 0 12 11a2 2 0 1 0 2 2.12l5-2.48z"
      }), React.createElement("path", {
        d: "M20.49 4.51a12 12 0 0 0-17 17l1.42-1.42a10 10 0 1 1 14.14 0l1.42 1.42a12 12 0 0 0 .02-17z"
      }));

    case 'object___gear':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.68 3L14 4.79V6l2.2 1.29 1-.59 1.8-.65L20.63 9l-1.39 1.18-1 .58v2.58l1 .58 1.39 1.18L19 18l-1.72-.61-1-.59L14 18v1.17L13.68 21h-3.36L10 19.21V18l-2.2-1.29-1 .59L5 18l-1.67-2.9 1.39-1.18 1-.58v-2.63l-1-.58L3.37 9 5 6.05l1.72.61 1 .59L10 6V4.79L10.32 3h3.36m1.65-2H8.67L8 4.79l-.24.14-3.62-1.32L.81 9.39l2.95 2.47v.28L.81 14.61l3.33 5.78 3.62-1.32.24.14.67 3.79h6.66l.67-3.79.24-.14 3.62 1.32 3.33-5.78-3-2.47v-.28l3-2.47-3.33-5.78-3.62 1.32-.24-.14L15.33 1z"
      }), React.createElement("path", {
        d: "M12 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.25 12a7.69 7.69 0 0 0-.11-1.27l2.64-2.06-2.5-4.34-3.1 1.25A8.36 8.36 0 0 0 15 4.31L14.5 1h-5L9 4.31a8.36 8.36 0 0 0-2.18 1.27l-3.1-1.25-2.5 4.34 2.64 2.06a7.39 7.39 0 0 0 0 2.54l-2.64 2.06 2.5 4.34 3.1-1.25A8.36 8.36 0 0 0 9 19.69L9.5 23h5l.5-3.31a8.36 8.36 0 0 0 2.21-1.27l3.1 1.25 2.5-4.34-2.64-2.06a7.69 7.69 0 0 0 .08-1.27zM12 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M27.27 4L28 8.91l.16 1.15 1.09.43a13.9 13.9 0 0 1 3.87 2.23l.92.73L35.1 13l4.59-1.85L43 16.83l-3.9 3.06-.92.72.18 1.16a13.18 13.18 0 0 1 0 4.46l-.18 1.16.92.72 3.9 3.06-3.26 5.66L35.1 35l-1.1-.45-.92.73a13.9 13.9 0 0 1-3.87 2.23l-1.09.43-.12 1.15-.73 4.91h-6.54L20 39.09l-.16-1.15-1.09-.43a13.9 13.9 0 0 1-3.87-2.23l-.88-.73-1.1.45-4.59 1.83-3.26-5.66L9 28.11l.92-.72-.18-1.16a13.18 13.18 0 0 1 0-4.46l.18-1.16-.92-.72-3.9-3.06 3.26-5.66L12.9 13l1.09.43.92-.73a13.9 13.9 0 0 1 3.87-2.23l1.09-.43.13-1.13.73-4.91h6.54M29 2H19l-.95 6.62a16.61 16.61 0 0 0-4.4 2.54l-6.2-2.49-5 8.66 5.26 4.13A17.76 17.76 0 0 0 7.5 24a17.76 17.76 0 0 0 .21 2.54l-5.26 4.13 5 8.66 6.2-2.49a16.61 16.61 0 0 0 4.4 2.54L19 46h10l1-6.62a16.61 16.61 0 0 0 4.4-2.54l6.2 2.49 5-8.66-5.26-4.13A17.76 17.76 0 0 0 40.5 24a17.76 17.76 0 0 0-.21-2.54l5.26-4.13-5-8.66-6.2 2.49A16.61 16.61 0 0 0 30 8.62L29 2z"
      }), React.createElement("path", {
        d: "M24 18a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40.5 24a17.76 17.76 0 0 0-.21-2.54l5.26-4.13-5-8.66-6.2 2.49A16.61 16.61 0 0 0 30 8.62L29 2H19l-.95 6.62a16.61 16.61 0 0 0-4.4 2.54l-6.2-2.49-5 8.66 5.26 4.13A17.76 17.76 0 0 0 7.5 24a17.76 17.76 0 0 0 .21 2.54l-5.26 4.13 5 8.66 6.2-2.49a16.61 16.61 0 0 0 4.4 2.54L19 46h10l1-6.62a16.61 16.61 0 0 0 4.4-2.54l6.2 2.49 5-8.66-5.26-4.13A17.76 17.76 0 0 0 40.5 24zM24 32a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M54.53 8l1.4 9.78.33 2.32 2.19.85a28.85 28.85 0 0 1 7.75 4.48L68 26.9l2.2-.9 9.18-3.69 6.53 11.32-7.77 6.09-1.85 1.48.36 2.31a29 29 0 0 1 0 9l-.36 2.31 1.85 1.45 7.77 6.09-6.53 11.3L70.2 70l-2.2-.9-1.8 1.47a28.85 28.85 0 0 1-7.75 4.48l-2.19.85-.33 2.32-1.4 9.78H41.47l-1.4-9.78-.33-2.32-2.19-.85a28.85 28.85 0 0 1-7.75-4.48L28 69.1l-2.2.9-9.18 3.69-6.53-11.35 7.77-6.09 1.85-1.45-.36-2.31a29 29 0 0 1 0-9l.36-2.31-1.85-1.45-7.77-6.09 6.53-11.32L25.8 26l2.2.9 1.82-1.47A28.85 28.85 0 0 1 37.55 21l2.19-.85.33-2.32L41.47 8h13.06M58 4H38l-1.89 13.22a33.21 33.21 0 0 0-8.82 5.09l-12.39-5-10 17.35 10.49 8.24a33.54 33.54 0 0 0 0 10.2L4.9 61.34l10 17.32 12.39-5a33.21 33.21 0 0 0 8.82 5.09L38 92h20l1.89-13.22a33.21 33.21 0 0 0 8.82-5.09l12.39 5 10-17.32-10.49-8.27a33.54 33.54 0 0 0 0-10.2l10.49-8.24-10-17.32-12.39 5a33.21 33.21 0 0 0-8.82-5.09L58 4z"
      }), React.createElement("path", {
        d: "M48 36a12 12 0 1 1-12 12 12 12 0 0 1 12-12m0-4a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"
      }), React.createElement("path", {
        d: "M72 48a24 24 0 0 1-24 24M24 48a24 24 0 0 1 24-24",
        className: "a"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M81 48a34.3 34.3 0 0 0-.39-5.1l10.49-8.24-10-17.32-12.39 5a33.21 33.21 0 0 0-8.82-5.09L58 4H38l-1.89 13.22a33.21 33.21 0 0 0-8.82 5.09l-12.39-5-10 17.35 10.49 8.24a33.54 33.54 0 0 0 0 10.2L4.9 61.34l10 17.32 12.39-5a33.21 33.21 0 0 0 8.82 5.09L38 92h20l1.89-13.22a33.21 33.21 0 0 0 8.82-5.09l12.39 5 10-17.32-10.49-8.27A34.3 34.3 0 0 0 81 48zm-58 0h-2a27 27 0 0 1 27-27v2a25 25 0 0 0-25 25zm9 0a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm16 27v-2a25 25 0 0 0 25-25h2a27 27 0 0 1-27 27z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.68 3L14 4.79V6l2.2 1.29 1-.59 1.8-.65L20.63 9l-1.39 1.18-1 .58v2.58l1 .58 1.39 1.18L19 18l-1.72-.61-1-.59L14 18v1.17L13.68 21h-3.36L10 19.21V18l-2.2-1.29-1 .59L5 18l-1.67-2.9 1.39-1.18 1-.58v-2.63l-1-.58L3.37 9 5 6.05l1.72.61 1 .59L10 6V4.79L10.32 3h3.36m1.65-2H8.67L8 4.79l-.24.14-3.62-1.32L.81 9.39l2.95 2.47v.28L.81 14.61l3.33 5.78 3.62-1.32.24.14.67 3.79h6.66l.67-3.79.24-.14 3.62 1.32 3.33-5.78-3-2.47v-.28l3-2.47-3.33-5.78-3.62 1.32-.24-.14L15.33 1z"
      }), React.createElement("path", {
        d: "M12 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"
      }));

    case 'object___lightbulb':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 12h4v2h-4z"
      }), React.createElement("path", {
        d: "M12 1a8 8 0 0 0-8 8 6.88 6.88 0 0 0 1.7 4.6l.85 1C8 16 8 17.53 8 19h8c0-1.47 0-3 1.45-4.44l.85-1A6.88 6.88 0 0 0 20 9a8 8 0 0 0-8-8zm4.81 11.27l-.86 1A6.94 6.94 0 0 0 14.07 17H9.93a6.94 6.94 0 0 0-1.88-3.76l-.86-1A4.89 4.89 0 0 1 6 9a6 6 0 0 1 12 0 4.89 4.89 0 0 1-1.19 3.27zM9 21h6v2H9z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a8 8 0 0 0-8 8 6.88 6.88 0 0 0 1.7 4.6l.85 1C8 16 8 17.53 8 19h8c0-1.47 0-3 1.45-4.44l.85-1A6.88 6.88 0 0 0 20 9a8 8 0 0 0-8-8zm2 13h-4v-2h4zM9 21h6v2H9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2A16 16 0 0 0 8 18a13.79 13.79 0 0 0 3.4 9.2l1.71 1.93C15 31.2 16 34 16 38h16c0-4 1-6.8 2.89-8.87l1.71-1.93A13.79 13.79 0 0 0 40 18 16 16 0 0 0 24 2zm11.11 23.87L33.4 27.8A13.83 13.83 0 0 0 30 36H18a13.83 13.83 0 0 0-3.36-8.2l-1.71-1.93A11.81 11.81 0 0 1 10 18a14 14 0 0 1 28 0 11.81 11.81 0 0 1-2.89 7.87zM17 40h14v2H17zM19 44h10v2H19z"
      }), React.createElement("path", {
        d: "M21.38 25l-2.27 4.55 1.78.9L22.62 27h2.76l1.73 3.45 1.78-.9L26.62 25h-5.24z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 40h14v2H17zM19 44h10v2H19zM24 2A16 16 0 0 0 8 18a13.79 13.79 0 0 0 3.4 9.2l1.71 1.93C15 31.2 16 34 16 38h16c0-4 1-6.8 2.89-8.87l1.71-1.93A13.79 13.79 0 0 0 40 18 16 16 0 0 0 24 2zm3.11 28.45L25.38 27h-2.76l-1.73 3.45-1.78-.9L21.38 25h5.24l2.27 4.55z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 80h26v4H35zM39 88h18v4H39zM48 14a23 23 0 0 0-23 23h2a21 21 0 0 1 21-21zM42.76 50l-4.55 9.1 3.58 1.8 3.45-6.9h5.52l3.45 6.9 3.58-1.8-4.55-9.1H42.76z"
      }), React.createElement("path", {
        d: "M48 4a32 32 0 0 0-32 32 27.58 27.58 0 0 0 6.79 18.4l3.43 3.86C29.89 62.39 32 68 32 76h32c0-8 2.11-13.61 5.78-17.74l3.43-3.86A27.58 27.58 0 0 0 80 36 32 32 0 0 0 48 4zm22.22 47.74l-3.43 3.86A27.81 27.81 0 0 0 60.07 72H35.93a27.81 27.81 0 0 0-6.72-16.4l-3.43-3.86A23.56 23.56 0 0 1 20 36a28 28 0 0 1 56 0 23.56 23.56 0 0 1-5.78 15.74z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 80h26v4H35zM39 88h18v4H39zM48 4a32 32 0 0 0-32 32 27.58 27.58 0 0 0 6.79 18.4l3.43 3.86C29.89 62.39 32 68 32 76h32c0-8 2.11-13.61 5.78-17.74l3.43-3.86A27.58 27.58 0 0 0 80 36 32 32 0 0 0 48 4zM27 37h-2a23 23 0 0 1 23-23v2a21 21 0 0 0-21 21zm27.21 23.89L50.76 54h-5.52l-3.45 6.89-3.58-1.78L42.76 50h10.48l4.55 9.11z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 12h4v2h-4z"
      }), React.createElement("path", {
        d: "M12 1a8 8 0 0 0-8 8 6.88 6.88 0 0 0 1.7 4.6l.85 1C8 16 8 17.53 8 19h8c0-1.47 0-3 1.45-4.44l.85-1A6.88 6.88 0 0 0 20 9a8 8 0 0 0-8-8zm4.81 11.27l-.86 1A6.94 6.94 0 0 0 14.07 17H9.93a6.94 6.94 0 0 0-1.88-3.76l-.86-1A4.89 4.89 0 0 1 6 9a6 6 0 0 1 12 0 4.89 4.89 0 0 1-1.19 3.27zM9 21h6v2H9z"
      }));

    case 'object___lock':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 13a2 2 0 0 0-2 2 2 2 0 0 0 1 1.72V19h2v-2.28A2 2 0 0 0 14 15a2 2 0 0 0-2-2z"
      }), React.createElement("path", {
        d: "M18 9V7A6 6 0 0 0 6 7v2H3v12l1 2h16l1-2V9zM8 7a4 4 0 0 1 8 0v2H8zm11 13.53l-.24.47H5.24L5 20.53V11h14z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 9V7A6 6 0 0 0 6 7v2H3v12l1 2h16l1-2V9zm-5 7.72V19h-2v-2.28A2 2 0 0 1 10 15a2 2 0 0 1 4 0 2 2 0 0 1-1 1.72zM16 9H8V7a4 4 0 0 1 8 0z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M27 30a3 3 0 1 0-4.72 2.45L20 37h8l-2.28-4.55A3 3 0 0 0 27 30z"
      }), React.createElement("path", {
        d: "M38 20v-4a14 14 0 0 0-28 0v4H6v22l2 4h32l2-4V20zm-26-4a12 12 0 0 1 24 0v4h-3v-4a9 9 0 0 0-18 0v4h-3zm19 4H17v-4a7 7 0 0 1 14 0zm9 21.53L38.76 44H9.24L8 41.53V22h32z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 20v-4a14 14 0 0 0-28 0v4H6v22l2 4h32l2-4V20zM20 37l2.28-4.55a3 3 0 1 1 3.44 0L28 37zm13-17H15v-4a9 9 0 0 1 18 0z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M75 40v-9a27 27 0 0 0-54 0v9h-9v44l4 8h64l4-8V40zm-50-9a23 23 0 0 1 46 0v9h-5v-9a18 18 0 0 0-36 0v9h-5zm7 9v-9a16 16 0 0 1 32 0v9zm48 4v39H16V44zM18.47 88L17 85h62l-1.5 3z"
      }), React.createElement("path", {
        d: "M56 72l-4.55-9.1a6 6 0 1 0-6.9 0L40 72z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.5 87l2.5 5h64l2.5-5h-69zM75 40v-9a27 27 0 0 0-54 0v9h-9v44l.5 1h71l.5-1V40zM40 72l4.55-9.1a6 6 0 1 1 6.9 0L56 72zm26-32H30v-9a18 18 0 0 1 36 0z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 13a2 2 0 0 0-2 2 2 2 0 0 0 1 1.72V19h2v-2.28A2 2 0 0 0 14 15a2 2 0 0 0-2-2z"
      }), React.createElement("path", {
        d: "M18 9V7A6 6 0 0 0 6 7v2H3v12l1 2h16l1-2V9zM8 7a4 4 0 0 1 8 0v2H8zm11 13.53l-.24.47H5.24L5 20.53V11h14z"
      }));

    case 'object___paperclip':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 22.47a5.47 5.47 0 0 1-5.18-3.74 5.42 5.42 0 0 1 .3-4.18l5-10a5.47 5.47 0 1 1 9.78 4.9l-3 6a3.24 3.24 0 0 1-4.34 1.44 3.23 3.23 0 0 1-1.44-4.34l3-6 1.78.9-3 6a1.25 1.25 0 0 0 .56 1.66 1.25 1.25 0 0 0 1.66-.56l3-6a3.49 3.49 0 0 0-1.56-4.66 3.48 3.48 0 0 0-4.66 1.56l-5 10a3.49 3.49 0 0 0 1.56 4.66 3.48 3.48 0 0 0 4.66-1.56l1.78.9a5.47 5.47 0 0 1-4.9 3.02z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 23a5.87 5.87 0 0 1-2.66-.63 6 6 0 0 1-2.67-8l5-10a6 6 0 1 1 10.67 5.3l-3 6a3.74 3.74 0 0 1-5 1.67 3.74 3.74 0 0 1-1.67-5l3-6 2.68 1.34-3 6a.74.74 0 1 0 1.32.66l3-6a3 3 0 0 0-5.32-2.66l-5 10a3 3 0 1 0 5.32 2.66l2.68 1.34A6 6 0 0 1 10 23z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.29 45.58a9 9 0 0 1-8.07-12.93L24.1 6.25a6.8 6.8 0 0 1 9-3.16A6.67 6.67 0 0 1 36.61 7a6.72 6.72 0 0 1-.31 5.24L25.43 34.33a4.55 4.55 0 1 1-8.14-4.08L26.61 12l1.78.92-9.32 18.25a2.55 2.55 0 1 0 4.56 2.28l10.87-22.1a4.76 4.76 0 0 0 .22-3.7 4.7 4.7 0 0 0-2.48-2.75 4.82 4.82 0 0 0-6.35 2.23L13 33.53a7 7 0 0 0 12.52 6.18l11.59-23.16 1.78.9-11.58 23.16a9 9 0 0 1-8.02 4.97z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.81 45.82a12.4 12.4 0 0 1-5.14-1.13 12.24 12.24 0 0 1-5.89-16.47L20.2 6.83A9 9 0 0 1 32 2.69a8.9 8.9 0 0 1 4.17 12l-9.35 19.08a5.55 5.55 0 1 1-9.92-5l8.82-17.21 3.56 1.82-8.82 17.24a1.54 1.54 0 0 0-.08 1.21 1.56 1.56 0 0 0 .81.9 1.53 1.53 0 0 0 2-.72l9.43-19.11a4.91 4.91 0 1 0-8.82-4.32L13.38 30a8.23 8.23 0 0 0 14.76 7.28l10.07-20.17 3.58 1.78L31.71 39a12.17 12.17 0 0 1-10.9 6.82z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38.59 91.15a18 18 0 0 1-7.37-1.58 18 18 0 0 1-8.79-24.26l25.76-52.8a13.58 13.58 0 0 1 25 1.46 13.47 13.47 0 0 1-.63 10.49L50.85 68.67a9.05 9.05 0 0 1-12 4.24 9.1 9.1 0 0 1-4.28-12.4l18.65-36.42 3.56 1.82-18.63 36.42a5.1 5.1 0 1 0 9.11 4.57L69 22.69a9.58 9.58 0 0 0-4.51-12.9 9.63 9.63 0 0 0-12.7 4.47L26 67.06a14 14 0 0 0 25 12.36l23.21-46.31 3.58 1.78-23.16 46.32a17.91 17.91 0 0 1-16.04 9.94z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M41.62 91.63a24.52 24.52 0 0 1-10.28-2.26 24.46 24.46 0 0 1-11.77-32.93l20.84-42.77a17.87 17.87 0 0 1 23.67-8.29 17.83 17.83 0 0 1 8.34 24L53.64 67.55a11.09 11.09 0 1 1-19.83-9.95l17.63-34.42 7.12 3.64-17.63 34.42a3.07 3.07 0 0 0-.17 2.43 3.11 3.11 0 0 0 1.63 1.8A3.07 3.07 0 0 0 46.46 64l18.78-38.2a9.82 9.82 0 0 0-4.6-13.2 9.85 9.85 0 0 0-13 4.57L26.76 59.94a16.46 16.46 0 0 0 29.51 14.57l20.15-40.3 7.16 3.58-20.15 40.3a24.35 24.35 0 0 1-21.81 13.54z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 22.47a5.47 5.47 0 0 1-5.18-3.74 5.42 5.42 0 0 1 .3-4.18l5-10a5.47 5.47 0 1 1 9.78 4.9l-3 6a3.24 3.24 0 0 1-4.34 1.44 3.23 3.23 0 0 1-1.44-4.34l3-6 1.78.9-3 6a1.25 1.25 0 0 0 .56 1.66 1.25 1.25 0 0 0 1.66-.56l3-6a3.49 3.49 0 0 0-1.56-4.66 3.48 3.48 0 0 0-4.66 1.56l-5 10a3.49 3.49 0 0 0 1.56 4.66 3.48 3.48 0 0 0 4.66-1.56l1.78.9a5.47 5.47 0 0 1-4.9 3.02z"
      }));

    case 'object___pencil':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.89 3.68l2.43 1.21-5.21 10.43-2.43-1.21 5.21-10.43M14 1L7 15l6 3 7-14-6-3zM7 18v5l4-3-4-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.007 15.01l7-13.998 6.001 3.002-7 13.997zM7 23l4-3-4-2v5z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38.34 7.05l-9.79-4.89-15 30.07-1 12.43a1.1 1.1 0 0 0 .63 1.08 1.12 1.12 0 0 0 .47.11 1.09 1.09 0 0 0 .76-.3l8.94-8.44zm-8.89-2.21L35.66 8 22.55 34.16l-6.21-3.11zm-14.53 35l1.7.85-1.92 1.8zm3.25-.61l-3.08-1.54.38-4.82 6.17 3.08z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38.34 7.05l-9.79-4.89-15 30.07-1 12.43a1.06 1.06 0 0 0 .63 1.08 1.17 1.17 0 0 0 1.23-.19l8.94-8.44zM17.39 40L15 38.75l.47-5.89 6.17 3.08z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76.68 14.11L57.11 4.32 27 64.45l-2 24.87a2.14 2.14 0 0 0 1.24 2.16 2.6 2.6 0 0 0 2.46-.38l17.93-16.89zM31 65.71l12.33 6.17-7.72 7.28-5.47-2.73zm40.32-49.82l-1.66 3.32L57.24 13l1.65-3.32zm-15-1.1L68.76 21 45.11 68.32l-12.43-6.21zm-26.4 63.79l4.09 2-4.6 4.42z"
      }), React.createElement("path", {
        d: "M36.108 61.556L58.11 17.56l1.789.894L37.897 62.45z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M54.265 10.005l2.844-5.688 19.578 9.79-2.844 5.69zM53.37 11.79L27 64.45l-2 24.87a2.14 2.14 0 0 0 1.24 2.16 2.59 2.59 0 0 0 2.46-.38l17.93-16.89 26.31-52.62zm-18.58 68.1L30 77.5l1-11.79 12.33 6.16zm.11-17.44l-1.79-.9 22-44 1.79.9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.89 3.68l2.43 1.21-5.21 10.43-2.43-1.21 5.21-10.43M14 1L7 15l6 3 7-14-6-3zM7 18v5l4-3-4-2z"
      }));

    case 'object___shoppingcart':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 18a2 2 0 0 0-1.72 1H6.72a2.2 2.2 0 0 0-.17-.25L9.32 14h7.5a2 2 0 0 0 1.75-1L23 5H6.06L4.63 2H1v2h2.37l2.91 6.14L7.57 13l-2.91 5A2 2 0 0 0 5 22a2 2 0 0 0 1.72-1h9.56A2 2 0 0 0 18 22a2 2 0 0 0 0-4zM7.08 7H19.6l-2.78 5H9.38L8.1 9.31z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 18a2 2 0 0 0-1.72 1H6.72a2.2 2.2 0 0 0-.17-.25L9.32 14h7.5a2 2 0 0 0 1.75-1L23 5H6.06L4.63 2H1v2h2.37l2.91 6.14L7.57 13l-2.91 5A2 2 0 0 0 5 22a2 2 0 0 0 1.72-1h9.56A2 2 0 0 0 18 22a2 2 0 0 0 0-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 36a4 4 0 0 0-3.86 3H12.86a4 4 0 0 0-1.5-2.21L16.49 28h17.16a4 4 0 0 0 3.49-2.06L46 10H10L7.63 5H2v2h4.37l8.84 19.22-5.73 9.83A3.91 3.91 0 0 0 9 36a4 4 0 1 0 3.86 5h19.28A4 4 0 1 0 36 36zM11.08 12H42.6l-7.2 13a2 2 0 0 1-1.75 1h-16zM9 42a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm27 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 36a4 4 0 0 0-3.86 3H12.86a4 4 0 0 0-1.5-2.21L16.49 28h17.16a4 4 0 0 0 3.49-2.06L46 10H10L7.63 5H2v2h4.37L11 16.78l4.2 9.44-5.72 9.83A3.91 3.91 0 0 0 9 36a4 4 0 1 0 3.86 5h19.28A4 4 0 1 0 36 36zM9 42a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm27 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 72a8 8 0 0 0-7.74 6H24.74a8 8 0 0 0-2.33-3.88L33 56h34.3a8 8 0 0 0 7-4.11L92 20H20.4l-4.62-10H4v4h9.22l17.53 37.89-11.87 20.34A8.27 8.27 0 0 0 17 72a8 8 0 1 0 7.74 10h39.52A8 8 0 1 0 72 72zm13.2-48L70.79 49.94a4 4 0 0 1-3.5 2.06H35.2l-13-28zM17 84a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm55 0a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }), React.createElement("path", {
        d: "M30 28h47v2H30z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M72 72a8 8 0 0 0-7.74 6H24.74a8 8 0 0 0-2.33-3.88L33 56h34.29a8 8 0 0 0 7-4.11L92 20H20.4l-4.62-10H4v4h9.22l17.2 38.45-11.54 19.78A8.27 8.27 0 0 0 17 72a8 8 0 1 0 7.74 10h39.52A8 8 0 1 0 72 72zM30 30v-2h47v2zM17 84a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm55 0a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 18a2 2 0 0 0-1.72 1H6.72a2.2 2.2 0 0 0-.17-.25L9.32 14h7.5a2 2 0 0 0 1.75-1L23 5H6.06L4.63 2H1v2h2.37l2.91 6.14L7.57 13l-2.91 5A2 2 0 0 0 5 22a2 2 0 0 0 1.72-1h9.56A2 2 0 0 0 18 22a2 2 0 0 0 0-4zM7.08 7H19.6l-2.78 5H9.38L8.1 9.31z"
      }));

    case 'object___suitcase':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.24 3h3.52l1 2H17l-1.45-2.89A2 2 0 0 0 13.76 1h-3.52a2 2 0 0 0-1.79 1.11L7 5h2.24zM22 6H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 14H3V8h18z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.24 5l1-2h3.52l1 2H17l-1.45-2.89A2 2 0 0 0 13.76 1h-3.52a2 2 0 0 0-1.79 1.11L7 5zM22 6H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.68 7.11A2 2 0 0 1 20.47 6h7.06a2 2 0 0 1 1.79 1.11L31.26 11h2.24l-2.39-4.79A4 4 0 0 0 27.53 4h-7.06a4 4 0 0 0-3.58 2.21L14.5 11h2.24zM44 12H4a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zM8 42H4V14h4zm30 0H10V14h28zm6 0h-4V14h4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.74 11l1.94-3.89A2 2 0 0 1 20.47 6h7.06a2 2 0 0 1 1.79 1.11L31.26 11h2.24l-2.39-4.79A4 4 0 0 0 27.53 4h-7.06a4 4 0 0 0-3.58 2.21L14.5 11zM44 12H4a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zM10 42H8V14h2zm30 0h-2V14h2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M37 12l-5 10h2.24l4-8h19.52l4 8H64l-5-10H37z"
      }), React.createElement("path", {
        d: "M33.37 10.21A4 4 0 0 1 36.94 8h22.12a4 4 0 0 1 3.57 2.21L68.53 22H73L66.21 8.42A8 8 0 0 0 59.06 4H36.94a8 8 0 0 0-7.15 4.42L23 22h4.47zM88 24H8a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h80a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4zM16 84H8V28h8zm62 0H18V28h60zm10 0h-8V28h8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 22l5-10h22l5 10h9L66.21 8.42A8 8 0 0 0 59.06 4H36.94a8 8 0 0 0-7.15 4.42L23 22zM88 24H8a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h80a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4zM18 84h-2V28h2zm62 0h-2V28h2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.24 3h3.52l1 2H17l-1.45-2.89A2 2 0 0 0 13.76 1h-3.52a2 2 0 0 0-1.79 1.11L7 5h2.24zM22 6H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 14H3V8h18z"
      }));

    case 'object___sun':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 12a5 5 0 1 0-5 5 5 5 0 0 0 5-5zm-5 3a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM0 11h5v2H0zM19 11h5v2h-5zM14.635 18.57l1.732-1 2.5 4.33-1.732 1zM5.138 2.105l1.732-1 2.5 4.33-1.732 1zM14.632 5.432l2.5-4.33 1.731 1-2.499 4.33zM5.14 21.888l2.499-4.33 1.732 1-2.5 4.33z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "5"
      }), React.createElement("path", {
        d: "M0 11h5v2H0zM19 11h5v2h-5zM14.635 18.57l1.732-1 2.5 4.33-1.732 1zM5.138 2.105l1.732-1 2.5 4.33-1.732 1zM14.632 5.432l2.5-4.33 1.731 1-2.499 4.33zM5.14 21.888l2.499-4.33 1.732 1-2.5 4.33z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 16a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 1 1 6-6 6 6 0 0 1-6 6zM2 23h10v2H2zM36 23h10v2H36zM23 7h2v5h-2zM23 36h2v5h-2zM8.777 31.637l4.33-2.5 1 1.732-4.33 2.5zM33.892 17.13l4.33-2.5 1 1.732-4.33 2.5zM33.898 30.86l1-1.733 4.33 2.5-1 1.732zM8.78 16.364l1-1.732 4.331 2.5-1 1.732zM29.13 34.892l1.732-1 5 8.66-1.732 1zM12.137 5.447l1.732-1 5 8.66-1.732 1zM29.137 13.11l4.999-8.66 1.732 1-4.999 8.66zM12.128 42.55l4.999-8.661 1.732 1-4.999 8.66z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "24",
        cy: "24",
        r: "8"
      }), React.createElement("path", {
        d: "M2 23h10v2H2zM36 23h10v2H36zM23 7h2v5h-2zM23 36h2v5h-2zM8.777 31.637l4.33-2.5 1 1.732-4.33 2.5zM33.892 17.13l4.33-2.5 1 1.732-4.33 2.5zM33.898 30.86l1-1.733 4.33 2.5-1 1.732zM8.78 16.364l1-1.732 4.331 2.5-1 1.732zM29.13 34.892l1.732-1 5 8.66-1.732 1zM12.137 5.447l1.732-1 5 8.66-1.732 1zM29.137 13.11l4.999-8.66 1.732 1-4.999 8.66zM12.128 42.55l4.999-8.661 1.732 1-4.999 8.66z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 32a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0 28a12 12 0 1 1 12-12 12 12 0 0 1-12 12zM4 46h20v4H4zM72 46h20v4H72zM47 14h2v10h-2zM47 72h2v10h-2zM18.055 64.13l8.66-5 1 1.733-8.66 5zM68.285 35.13l8.66-5 1 1.733-8.66 5zM68.281 60.87l1-1.731 8.66 5-1 1.732zM18.057 31.863l1-1.732 8.66 5-1 1.732zM58.27 69.775l3.464-2 10 17.32-3.464 2zM24.27 10.895l3.464-2 10 17.32-3.464 2zM58.266 26.206l9.997-17.322 3.464 2-9.997 17.322zM24.266 85.1l9.997-17.322 3.465 2L27.73 87.1z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("circle", {
        cx: "48",
        cy: "48",
        r: "16"
      }), React.createElement("path", {
        d: "M4 46h20v4H4zM72 46h20v4H72zM47 14h2v10h-2zM47 72h2v10h-2zM18.055 64.13l8.66-5 1 1.733-8.66 5zM68.285 35.13l8.66-5 1 1.733-8.66 5zM68.281 60.87l1-1.731 8.66 5-1 1.732zM18.057 31.863l1-1.732 8.66 5-1 1.732zM58.27 69.775l3.464-2 10 17.32-3.464 2zM24.27 10.895l3.464-2 10 17.32-3.464 2zM58.266 26.206l9.997-17.322 3.464 2-9.997 17.322zM24.266 85.1l9.997-17.322 3.465 2L27.73 87.1z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 12a5 5 0 1 0-5 5 5 5 0 0 0 5-5zm-5 3a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM0 11h5v2H0zM19 11h5v2h-5zM14.635 18.57l1.732-1 2.5 4.33-1.732 1zM5.138 2.105l1.732-1 2.5 4.33-1.732 1zM14.632 5.432l2.5-4.33 1.731 1-2.499 4.33zM5.14 21.888l2.499-4.33 1.732 1-2.5 4.33z"
      }));

    case 'object___tag':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.5 1L10 2.75 3.14 16.46A2 2 0 0 0 4 19.14l7 3.47a2 2 0 0 0 .89.21 2 2 0 0 0 1.79-1.11L20.5 8zm-5.64 19.82l-6.93-3.46 6.44-12.88 5-1.15 2 4.61z"
      }), React.createElement("circle", {
        cx: "14",
        cy: "8",
        r: "2"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.5 1L10 2.75 3.14 16.46A2 2 0 0 0 4 19.14l7 3.47a2 2 0 0 0 2.68-.9L20.5 8zM14 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 2L20 5.5 6.29 32.92a4 4 0 0 0 1.79 5.37l13.84 6.92a4 4 0 0 0 5.37-1.79L41 16zm-9.5 40.53a2 2 0 0 1-2.68.89L9 36.5a2 2 0 0 1-.89-2.68L21.37 7.23l12.45-2.9 5 11.61z"
      }), React.createElement("path", {
        d: "M29 10a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M35 2L20 5.5 6.29 32.92a4 4 0 0 0 1.79 5.37l13.84 6.92a4 4 0 0 0 5.37-1.79L41 16zm-6 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M70 4l-30 7-27.42 54.84a8 8 0 0 0 3.58 10.74l27.68 13.84a7.91 7.91 0 0 0 3.58.85 8 8 0 0 0 7.16-4.43L82 32zM51 85.06a4 4 0 0 1-3.58 2.21 3.9 3.9 0 0 1-1.79-.43L17.94 73a4 4 0 0 1-1.78-5.37l26.58-53.16 24.9-5.81 10 23.21z"
      }), React.createElement("path", {
        d: "M59 18a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1-4 4zM20.542 67.885l.92-1.775L48.46 80.109l-.921 1.776z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M70 4l-30 7-27.42 54.84a8 8 0 0 0 3.58 10.74l27.68 13.84a8 8 0 0 0 10.74-3.58L82 32zM47.54 81.89l-27-14 .92-1.78 27 14zM59 32a6 6 0 1 1 6-6 6 6 0 0 1-6 6z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17.5 1L10 2.75 3.14 16.46A2 2 0 0 0 4 19.14l7 3.47a2 2 0 0 0 .89.21 2 2 0 0 0 1.79-1.11L20.5 8zm-5.64 19.82l-6.93-3.46 6.44-12.88 5-1.15 2 4.61z"
      }), React.createElement("circle", {
        cx: "14",
        cy: "8",
        r: "2"
      }));

    case 'object___torch':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 1v4l2 4v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9l2-4V1zm6 20h-2v-7h2zm0-9h-2V9h2zm2-7.47L13.76 7h-3.52L9 4.53V3h6z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M9 21a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9H9zm2-9h2v2h-2zM7 1v4l1 2h8l1-2V1H7z",
        className: "a"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14 2v8l4 8v24a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V18l4-8V2zm14 40a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V18h8zm4-32.47L28.76 16h-9.52L16 9.53V7h16zM32 5H16V4h16z"
      }), React.createElement("path", {
        d: "M22 24h4v4h-4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M18 42a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V18H18zm4-18h4v4h-4zM14 10l3 6h14l3-6V6H14v4z",
        className: "a"
      }), React.createElement("path", {
        d: "M14 2h20v2H14z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M28 4v16l8 16v48a8 8 0 0 0 8 8h8a8 8 0 0 0 8-8V36l8-16V4zm36 4v2H32V8zM52 88h-8a4 4 0 0 1-3.44-2h14.88A4 4 0 0 1 52 88zm4-4H40V36h16zm1.53-52H38.47L32 19.06V12h32v7.06z"
      }), React.createElement("path", {
        d: "M52 48h-8v16h8zm-2 14h-4v-4h4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M46 58h4v4h-4z"
      }), React.createElement("path", {
        d: "M36 84a8.24 8.24 0 0 0 .26 2h23.48a8.24 8.24 0 0 0 .26-2V36H36zm8-28v-8h8v16h-8zM37.08 88A8 8 0 0 0 44 92h8a8 8 0 0 0 6.92-4z",
        className: "a"
      }), React.createElement("path", {
        d: "M28 4h40v4H28z"
      }), React.createElement("path", {
        d: "M28 20l6 12h28l6-12V10H28v10z",
        className: "a"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 1v4l2 4v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9l2-4V1zm6 20h-2v-7h2zm0-9h-2V9h2zm2-7.47L13.76 7h-3.52L9 4.53V3h6z"
      }));

    case 'object___umbrella':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 2.05V0h-2v2.05A11 11 0 0 0 1 13h22A11 11 0 0 0 13 2.05zM3.24 11a9 9 0 0 1 17.53 0H20zM11 21a1 1 0 0 1-2 0H7a3 3 0 0 0 6 0v-6h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 2.05V0h-2v2.05A11 11 0 0 0 1 13h22A11 11 0 0 0 13 2.05zM11 21a1 1 0 0 1-2 0H7a3 3 0 0 0 6 0v-6h-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M45 24.94A21 21 0 0 0 25 4.05V2h-2v2.05A21 21 0 0 0 3 24.9V26a9.9 9.9 0 0 1 14 0 9.9 9.9 0 0 1 14 0 9.9 9.9 0 0 1 14 0zm-7-3.84a11.85 11.85 0 0 0-7 2.27 11.93 11.93 0 0 0-14 0 12 12 0 0 0-11.78-1.28 19 19 0 0 1 37.56 0A11.93 11.93 0 0 0 38 21.1z"
      }), React.createElement("path", {
        d: "M23 41a3 3 0 0 1-6 0h-2a5 5 0 0 0 10 0V25h-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M45 24.94A21 21 0 0 0 25 4.05V2h-2v2.05A21 21 0 0 0 3 24.9V26a9.9 9.9 0 0 1 14 0 9.9 9.9 0 0 1 14 0 9.9 9.9 0 0 1 14 0z"
      }), React.createElement("path", {
        d: "M23 41a3 3 0 0 1-6 0h-2a5 5 0 0 0 10 0V25h-2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M90 49.88A42 42 0 0 0 50 8.05V4h-4v4.05A42 42 0 0 0 6 49.8V52a19.8 19.8 0 0 1 28 0 19.8 19.8 0 0 1 28 0 19.8 19.8 0 0 1 28 0zM76 42.2a23.64 23.64 0 0 0-14 4.55 23.81 23.81 0 0 0-28 0 23.87 23.87 0 0 0-23.56-2.56 38 38 0 0 1 75.12 0A23.86 23.86 0 0 0 76 42.2z"
      }), React.createElement("path", {
        d: "M46 82a6 6 0 0 1-12 0h-4a10 10 0 0 0 20 0V50h-4zM31.34 42.68l2 .24a57.18 57.18 0 0 1 11.47-28.3l-1.58-1.24a59.18 59.18 0 0 0-11.89 29.3zM51.21 14.62a57.18 57.18 0 0 1 11.47 28.3l2-.24a59.18 59.18 0 0 0-11.87-29.3z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 82a6 6 0 0 1-12 0h-4a10 10 0 0 0 20 0V50h-4z"
      }), React.createElement("path", {
        d: "M90 49.88A42 42 0 0 0 50 8.05V4h-4v4.05A42 42 0 0 0 6 49.8V52a19.8 19.8 0 0 1 28 0 19.8 19.8 0 0 1 28 0 19.8 19.8 0 0 1 28 0zm-56.68-7l-2-.24a59.18 59.18 0 0 1 11.87-29.3l1.58 1.24a57.18 57.18 0 0 0-11.45 28.34zm29.36 0a57.18 57.18 0 0 0-11.47-28.3l1.58-1.24a59.18 59.18 0 0 1 11.87 29.3z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13 2.05V0h-2v2.05A11 11 0 0 0 1 13h22A11 11 0 0 0 13 2.05zM3.24 11a9 9 0 0 1 17.53 0H20zM11 21a1 1 0 0 1-2 0H7a3 3 0 0 0 6 0v-6h-2z"
      }));

    case 'object___wrench':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.31 5l-.62-1.31-4.9 5.1-1-.53-.53-1 3.61-3.45 1.42-1.51L19 1.69a6.78 6.78 0 0 0-1.59-.54 7 7 0 0 0-8 9.06L.78 18.8l1.47 2.95 3 1.47 8.59-8.6A7 7 0 0 0 22.31 5zm-2.77 6.55a5 5 0 0 1-5.59 1l-.63-.28-8.52 8.51-1-.53-.58-1.05 8.52-8.53-.28-.62a5 5 0 0 1 5.22-7l-3.9 3.74 1.47 3 3 1.47L21 7.34a5 5 0 0 1-1.46 4.2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.41 5.42L17 10l-2-1-1-2 4.12-3.95.46-.46a6.14 6.14 0 0 0-1.37-.46 6 6 0 0 0-6.67 8.33L2 19l1 2 2 1 8.54-8.54a6 6 0 0 0 7.87-8z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M43.72 10.41L43.1 9.1l-9.31 9.68-3-1.53-1.53-3L37 6.81l1.92-1.92-1.28-.61a12.75 12.75 0 0 0-3-1A13 13 0 0 0 19.89 20.7L2.78 37.8l2.47 5 4.95 2.47 17.1-17.16a13 13 0 0 0 16.42-17.7zm-3.94 13.37A11.05 11.05 0 0 1 27.48 26l-.63-.29L9.8 42.78l-3.05-1.53-1.53-3 17.05-17.1-.27-.63a11.05 11.05 0 0 1 2.24-12.3 10.94 10.94 0 0 1 10-3 11.61 11.61 0 0 1 1.16.3l-8.6 8.25 2.47 5 5 2.47 8.26-8.57a11 11 0 0 1-2.75 11.11z"
      }), React.createElement("circle", {
        cx: "9.5",
        cy: "38.5",
        r: "1.5"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42.82 10.84L34 20l-4-2-2-4 8.24-7.9.92-.92a11.87 11.87 0 0 0-2.73-.92 12 12 0 0 0-13.36 16.67L4 38l2 4 4 2 17.07-17.07a12 12 0 0 0 15.75-16.09zM9.5 40a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9.5 40z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M87.45 20.81L86.2 18.2 67.58 37.55l-6.09-3-3-6.09L73.9 13.62l3.84-3.85-2.55-1.22a26.36 26.36 0 0 0-5.93-2 26 26 0 0 0-29.48 34.84L5.57 75.61l4.94 9.88 9.88 4.94 34.22-34.21a26 26 0 0 0 32.84-35.41zm-7.89 26.75A22.14 22.14 0 0 1 55 52l-1.26-.57L19.6 85.57l-6.11-3.06-3.06-6.12 34.1-34.09L44 41a22 22 0 0 1 24.45-30.52 20.67 20.67 0 0 1 2.31.61L53.55 27.58l5 9.91 9.91 5 16.47-17.2a22 22 0 0 1-5.37 22.27z"
      }), React.createElement("path", {
        d: "M19 73a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2zM47.297 35.706l1.414-1.414L61.708 47.29l-1.415 1.414z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M85.64 21.67L68 40l-8-4-4-8 16.49-15.8 1.84-1.84a24 24 0 0 0-32.19 31.5L8 76l4 8 8 4 34.14-34.14a24 24 0 0 0 31.5-32.19zM19 80a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm41.29-31.29l-13-13 1.42-1.42 13 13z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.31 5l-.62-1.31-4.9 5.1-1-.53-.53-1 3.61-3.45 1.42-1.51L19 1.69a6.78 6.78 0 0 0-1.59-.54 7 7 0 0 0-8 9.06L.78 18.8l1.47 2.95 3 1.47 8.59-8.6A7 7 0 0 0 22.31 5zm-2.77 6.55a5 5 0 0 1-5.59 1l-.63-.28-8.52 8.51-1-.53-.58-1.05 8.52-8.53-.28-.62a5 5 0 0 1 5.22-7l-3.9 3.74 1.47 3 3 1.47L21 7.34a5 5 0 0 1-1.46 4.2z"
      }));

    case 'people___callcenter':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 5h2v5H3zM21.34 17.67L18 16h-3l-1 2h-4l-1-2H6l-3.34 1.67A3 3 0 0 0 1 20.35V24h2v-3.65a1 1 0 0 1 .55-.89L6.47 18h1.29l1 2h6.48l1-2h1.29l2.92 1.46a1 1 0 0 1 .55.89V24h2v-3.65a3 3 0 0 0-1.66-2.68zM9.62 14h.56a2.87 2.87 0 0 1 0-2h-.56L8 8.76V5.5A3.5 3.5 0 0 1 11.5 2h1A3.5 3.5 0 0 1 16 5.5v3.26L15.38 10h2.24l.38-.76V5.5A5.51 5.51 0 0 0 12.5 0h-1A5.51 5.51 0 0 0 6 5.5v3.74l1.83 3.65A2 2 0 0 0 9.62 14z"
      }), React.createElement("path", {
        d: "M13 12a1 1 0 0 0 0 2h5.62L21 9.24V5h-2v3.76L17.38 12z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 5h2v5H4zM10.24 13H11a2 2 0 0 1 2-2h2.76L17 8.53V6a4.85 4.85 0 0 0-5-5 4.85 4.85 0 0 0-5 5v3l1.45 2.89A2 2 0 0 0 10.24 13zM21.34 17.67L18 16h-3l-1 2h-4l-1-2H6l-3.34 1.67A3 3 0 0 0 1 20.35V24h22v-3.65a3 3 0 0 0-1.66-2.68z"
      }), React.createElement("path", {
        d: "M13 12a1 1 0 0 0 0 2h4.62L20 9.24V5h-2v3.76L16.38 12z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M17 22l.89 1.79a4 4 0 0 0 1.66 1.71 4.23 4.23 0 0 1-.05-.5 4 4 0 0 1 .42-1.76 3.07 3.07 0 0 1-.24-.35L18 19.53v-5C18 11 20.19 9 24 9s6 2 6 5.5v5L28.76 22H33a2 2 0 0 1-2 2h-3.78a2 2 0 0 0-1.72-1h-2a2 2 0 0 0 0 4h2a2 2 0 0 0 1.72-1H31a4 4 0 0 0 4-4v-2.59h-.08L36 17.24v-2.48l-1-2A10 10 0 0 0 25 3h-2a10 10 0 0 0-10 9.76l-1 2v2.48L14.38 22zm15.38-2H32v-8h.38L34 15.24v1.52zM23 5h2a8 8 0 0 1 7.41 5h-1.73C29.34 8.12 27 7 24 7s-5.34 1.12-6.68 3h-1.73A8 8 0 0 1 23 5zm-9 10.24L15.62 12H16v8h-.38L14 16.76zM38.68 31.34L32 28h-2l-2 4h-8l-2-4h-2l-6.68 3.34A6 6 0 0 0 6 36.71V44h2v-7.29a4 4 0 0 1 2.21-3.58L16.47 30h.29l2 4h10.48l2-4h.29l6.26 3.13A4 4 0 0 1 40 36.71V44h2v-7.29a6 6 0 0 0-3.32-5.37z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 21V11h-.74A8 8 0 0 1 23 5h2a8 8 0 0 1 7.74 6H32v10h1v1a2 2 0 0 1-2 2h-3.78a2 2 0 0 0-1.72-1h-2a2 2 0 0 0 0 4h2a2 2 0 0 0 1.72-1H31a4 4 0 0 0 4-4v-3l1-2v-2l-1-2A10 10 0 0 0 25 3h-2a10 10 0 0 0-10 10l-1 2v2l2 4zM38.68 31.34L32 28h-2l-2 4h-8l-2-4h-2l-6.68 3.34A6 6 0 0 0 6 36.71V44h36v-7.29a6 6 0 0 0-3.32-5.37z"
      }), React.createElement("path", {
        d: "M25.5 22a3 3 0 0 1 2.22 1h1.66L31 19.76V14.5c0-4-2.68-6.5-7-6.5s-7 2.49-7 6.5v5.26l1.79 3.58a3 3 0 0 0 1.73 1.5 3 3 0 0 1 3-2.84z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M77.37 62.68L64 56h-4l-4 8H40l-4-8h-4l-13.37 6.68A12 12 0 0 0 12 73.42V88h4V73.42a8 8 0 0 1 4.42-7.16L32.94 60h.59l4 8h20.94l4-8h.59l12.52 6.26A8 8 0 0 1 80 73.42V88h4V73.42a12 12 0 0 0-6.63-10.74zM34 44l1.79 3.58A7.92 7.92 0 0 0 39.07 51a7.68 7.68 0 0 1 .75-4.49 4 4 0 0 1-.45-.7L36 39.06V27c0-7 4.37-11 12-11s12 4 12 11v12.06L57.53 44H66a4 4 0 0 1-4 4h-7.55A4 4 0 0 0 51 46h-4a4 4 0 0 0 0 8h4a4 4 0 0 0 3.45-2H62a8 8 0 0 0 8-8v-5.53l2-4v-4.94l-2-4V24A20 20 0 0 0 50 4h-4a20 20 0 0 0-20 20v1.53l-2 4v4.94L28.76 44zm34-10.47L64.76 40H64V24h.76L68 30.47zM46 8h4a16 16 0 0 1 15.46 12h-2.94c-2.36-5-7.42-8-14.52-8s-12.16 3-14.52 8h-2.95A16 16 0 0 1 46 8zM28 30.47L31.24 24H32v16h-.76L28 33.53z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M77.37 62.68L64 56h-4l-4 8H41l-5-8h-4l-13.37 6.68A12 12 0 0 0 12 73.42V88h72V73.42a12 12 0 0 0-6.63-10.74zM32 42V22h-1.86A16 16 0 0 1 46 8h4a16 16 0 0 1 15.86 14H64v20h2v2a4 4 0 0 1-4 4h-7.55A4 4 0 0 0 51 46h-4a4 4 0 0 0 0 8h4a4 4 0 0 0 3.45-2H62a8 8 0 0 0 8-8v-4l3-6v-4l-3-6A20 20 0 0 0 50 4h-4a20 20 0 0 0-20 20l-3 6v4l4 8z"
      }), React.createElement("path", {
        d: "M51 44a6 6 0 0 1 4.46 2h3.3L62 39.53V27c0-8-5.36-13-14-13s-14 5-14 13v12.53l3.58 7.15a5.89 5.89 0 0 0 3.44 3A6 6 0 0 1 47 44z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 5h2v5H3zM21.34 17.67L18 16h-3l-1 2h-4l-1-2H6l-3.34 1.67A3 3 0 0 0 1 20.35V24h2v-3.65a1 1 0 0 1 .55-.89L6.47 18h1.29l1 2h6.48l1-2h1.29l2.92 1.46a1 1 0 0 1 .55.89V24h2v-3.65a3 3 0 0 0-1.66-2.68zM9.62 14h.56a2.87 2.87 0 0 1 0-2h-.56L8 8.76V5.5A3.5 3.5 0 0 1 11.5 2h1A3.5 3.5 0 0 1 16 5.5v3.26L15.38 10h2.24l.38-.76V5.5A5.51 5.51 0 0 0 12.5 0h-1A5.51 5.51 0 0 0 6 5.5v3.74l1.83 3.65A2 2 0 0 0 9.62 14z"
      }), React.createElement("path", {
        d: "M13 12a1 1 0 0 0 0 2h5.62L21 9.24V5h-2v3.76L17.38 12z"
      }));

    case 'people___female':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 9.07a7.24 7.24 0 0 0 .87 3.42 6.51 6.51 0 0 0 3 2.78 2.73 2.73 0 0 0 2.24 0 6.51 6.51 0 0 0 3-2.78A7.24 7.24 0 0 0 17 9.07V6.83a14.12 14.12 0 0 1-5.92-1.3l-2.21-1v2.3H7zm1.5-.74h1.88V6.86a15.82 15.82 0 0 0 5.12 1.39v.82a5.7 5.7 0 0 1-.69 2.7 5.08 5.08 0 0 1-2.32 2.14 1.25 1.25 0 0 1-1 0 5.08 5.08 0 0 1-2.32-2.14 5.7 5.7 0 0 1-.69-2.7zM21.12 17.24A2.23 2.23 0 0 0 19.26 16H14.5L12 21l-2.5-5H4.74a2.23 2.23 0 0 0-1.86 1.24A14.15 14.15 0 0 0 1 24h2a11.71 11.71 0 0 1 1.74-6h3.52l3.21 6h1.06l3.21-6h3.52A11.71 11.71 0 0 1 21 24h2a14.15 14.15 0 0 0-1.88-6.76z"
      }), React.createElement("path", {
        d: "M7 13a7.55 7.55 0 0 1-1-2.76 11.74 11.74 0 0 1 1.23-5.17 5.52 5.52 0 0 1 1.22-1.68 5.24 5.24 0 0 1 7.11 0 5.87 5.87 0 0 1 1.22 1.68A11.87 11.87 0 0 1 18 10.24 7.55 7.55 0 0 1 17 13a3 3 0 0 0 3-2.76 13.81 13.81 0 0 0-1.43-6.06 7.64 7.64 0 0 0-1.67-2.27 7.24 7.24 0 0 0-9.8 0 7.62 7.62 0 0 0-1.66 2.27A13.68 13.68 0 0 0 4 10.24 3 3 0 0 0 7 13z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.12 17.24A2.23 2.23 0 0 0 19.26 16H14.5L12 21l-2.5-5H4.74a2.23 2.23 0 0 0-1.86 1.24A14.15 14.15 0 0 0 1 24h22a14.15 14.15 0 0 0-1.88-6.76zM7.33 13l.43-.76a6.19 6.19 0 0 0 3.12 3 2.73 2.73 0 0 0 2.24 0 6.39 6.39 0 0 0 3.12-3l.43.76c2.2 0 3.33-1.11 3.33-2.76a13.68 13.68 0 0 0-1.44-6.06A7.68 7.68 0 0 0 12 0a7.68 7.68 0 0 0-6.56 4.18A13.68 13.68 0 0 0 4 10.24C4 11.92 5.25 13 7.33 13zM8.5 7.33h1.88V5.86a15.82 15.82 0 0 0 5.12 1.39v1.82a5.7 5.7 0 0 1-.69 2.7 5.08 5.08 0 0 1-2.32 2.14 1.25 1.25 0 0 1-1 0 5.08 5.08 0 0 1-2.32-2.14 5.7 5.7 0 0 1-.69-2.7z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15 22.73h1l-1-2a2 2 0 0 1-2-2 20.69 20.69 0 0 1 2.17-9.1 10.17 10.17 0 0 1 .64-1.12l2.69 1.34V5.72a9.75 9.75 0 0 1 12.1.83 11.08 11.08 0 0 1 2.26 3.1A20.59 20.59 0 0 1 35 18.73a2 2 0 0 1-2 2l-1 2h1a4 4 0 0 0 4-4 22.65 22.65 0 0 0-2.39-10 12.45 12.45 0 0 0-2.69-3.65 11.74 11.74 0 0 0-14.57-1 2 2 0 0 0-.85 1.64v.92a2 2 0 0 0-2.38.79c-.25.39-.53.89-.74 1.31a22.7 22.7 0 0 0-2.38 10 4 4 0 0 0 4 3.99z"
      }), React.createElement("path", {
        d: "M22.21 26.58a4 4 0 0 0 3.58 0 10.81 10.81 0 0 0 4.82-4.82A13.3 13.3 0 0 0 32 15.85V14a21.16 21.16 0 0 1-9.47-2.23L19 10v4h-3v1.88a13.3 13.3 0 0 0 1.39 5.91 10.81 10.81 0 0 0 4.82 4.79zM21 16v-2.79a27.18 27.18 0 0 0 9 2.67 11.34 11.34 0 0 1-1.18 5 8.87 8.87 0 0 1-3.93 3.92 2 2 0 0 1-1.78 0 8.87 8.87 0 0 1-3.93-3.92A11.44 11.44 0 0 1 18 16zM38.64 30.48A4.57 4.57 0 0 0 34.83 28H29l-5 10-5-10h-5.83a4.57 4.57 0 0 0-3.81 2.48A30.14 30.14 0 0 0 6 44h2a27.94 27.94 0 0 1 3.13-12.61 2.66 2.66 0 0 1 2-1.39h4.59L24 42.5 30.24 30h4.59a2.66 2.66 0 0 1 2 1.39A27.94 27.94 0 0 1 40 44h2a30.14 30.14 0 0 0-3.36-13.52z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.21 23.72l3.09 1.55 1.58-2.11a10.85 10.85 0 0 0 4.33 3.95 4 4 0 0 0 3.58 0 10.81 10.81 0 0 0 4.33-4l1.58 2.12 3.09-1.55A4 4 0 0 0 37 20.15V19a22.59 22.59 0 0 0-2.39-10 12.45 12.45 0 0 0-2.69-3.65 11.74 11.74 0 0 0-14.57-1A2 2 0 0 0 16.5 6v.9a2 2 0 0 0-2.38.78c-.25.4-.53.89-.74 1.31A22.75 22.75 0 0 0 11 19v1.15a4 4 0 0 0 2.21 3.57zM18 15.5h3v-2.76a27.18 27.18 0 0 0 9 2.67v1a11.28 11.28 0 0 1-1.18 5 8.89 8.89 0 0 1-3.93 3.93 2 2 0 0 1-1.78 0 8.89 8.89 0 0 1-3.93-3.93 11.28 11.28 0 0 1-1.18-5zM38.64 30.48A4.57 4.57 0 0 0 34.83 28H29l-5 10-5-10h-5.83a4.57 4.57 0 0 0-3.81 2.48A30.14 30.14 0 0 0 6 44h36a30.14 30.14 0 0 0-3.36-13.52z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 60h8v2h-8zM30 46h1.5l-2-4a4 4 0 0 1-3.5-4 41.33 41.33 0 0 1 4.35-18.22 23.38 23.38 0 0 1 1.26-2.24l5.39 2.7V12a19.47 19.47 0 0 1 24.18 1.67 21 21 0 0 1 4.5 6.12A41.42 41.42 0 0 1 70 38a4 4 0 0 1-3.47 4l-2 4H66a8 8 0 0 0 8-8 45.42 45.42 0 0 0-4.78-20 25.21 25.21 0 0 0-5.38-7.3 23.47 23.47 0 0 0-29.14-2A4 4 0 0 0 33 12v1.84a4 4 0 0 0-4.75 1.58A29.34 29.34 0 0 0 26.77 18 45.46 45.46 0 0 0 22 38a8 8 0 0 0 8 8z"
      }), React.createElement("path", {
        d: "M61.21 44.58A26.51 26.51 0 0 0 64 32.76V29a42.34 42.34 0 0 1-18.94-4.47L38 21v8h-6v3.76a26.37 26.37 0 0 0 2.79 11.82 21.47 21.47 0 0 0 9.63 9.63 8 8 0 0 0 7.16 0 21.47 21.47 0 0 0 9.63-9.63zm-11.42 6.05a3.94 3.94 0 0 1-3.58 0 17.59 17.59 0 0 1-7.84-7.84A22.52 22.52 0 0 1 36 33h6v-5.53l1.27.64A46.51 46.51 0 0 0 60 32.82a22.53 22.53 0 0 1-2.37 10 17.59 17.59 0 0 1-7.84 7.81zM77.29 61a9.21 9.21 0 0 0-7.63-5H58L48 76 38 56H26.34a9.21 9.21 0 0 0-7.63 5A60.45 60.45 0 0 0 12 88h4a55.71 55.71 0 0 1 6.27-25.22A5.25 5.25 0 0 1 26.34 60h9.19L48 85l12.47-25h9.19a5.25 5.25 0 0 1 4.07 2.78A55.71 55.71 0 0 1 80 88h4a60.45 60.45 0 0 0-6.71-27z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 60h8v2h-8zM26.42 47.45l6.18 3.09 3.17-4.23a21.54 21.54 0 0 0 8.65 7.9 8 8 0 0 0 7.16 0 21.54 21.54 0 0 0 8.65-7.9l3.17 4.23 6.18-3.09A8 8 0 0 0 74 40.29V38a45.42 45.42 0 0 0-4.78-20 25.21 25.21 0 0 0-5.38-7.3 23.46 23.46 0 0 0-29.13-2A4 4 0 0 0 33 12v1.84a4 4 0 0 0-4.75 1.58A29.34 29.34 0 0 0 26.77 18 45.46 45.46 0 0 0 22 38v2.29a8 8 0 0 0 4.42 7.16zM36 31h6v-5.53a54 54 0 0 0 18 5.35v1.94a22.52 22.52 0 0 1-2.37 10 17.59 17.59 0 0 1-7.84 7.84 3.94 3.94 0 0 1-3.58 0 17.59 17.59 0 0 1-7.84-7.84 22.52 22.52 0 0 1-2.37-10z"
      }), React.createElement("path", {
        d: "M77.29 61a9.21 9.21 0 0 0-7.63-5H58L48 76 38 56H26.34a9.21 9.21 0 0 0-7.63 5A60.45 60.45 0 0 0 12 88h72a60.45 60.45 0 0 0-6.71-27z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 9.07a7.24 7.24 0 0 0 .87 3.42 6.51 6.51 0 0 0 3 2.78 2.73 2.73 0 0 0 2.24 0 6.51 6.51 0 0 0 3-2.78A7.24 7.24 0 0 0 17 9.07V6.83a14.12 14.12 0 0 1-5.92-1.3l-2.21-1v2.3H7zm1.5-.74h1.88V6.86a15.82 15.82 0 0 0 5.12 1.39v.82a5.7 5.7 0 0 1-.69 2.7 5.08 5.08 0 0 1-2.32 2.14 1.25 1.25 0 0 1-1 0 5.08 5.08 0 0 1-2.32-2.14 5.7 5.7 0 0 1-.69-2.7zM21.12 17.24A2.23 2.23 0 0 0 19.26 16H14.5L12 21l-2.5-5H4.74a2.23 2.23 0 0 0-1.86 1.24A14.15 14.15 0 0 0 1 24h2a11.71 11.71 0 0 1 1.74-6h3.52l3.21 6h1.06l3.21-6h3.52A11.71 11.71 0 0 1 21 24h2a14.15 14.15 0 0 0-1.88-6.76z"
      }), React.createElement("path", {
        d: "M7 13a7.55 7.55 0 0 1-1-2.76 11.74 11.74 0 0 1 1.23-5.17 5.52 5.52 0 0 1 1.22-1.68 5.24 5.24 0 0 1 7.11 0 5.87 5.87 0 0 1 1.22 1.68A11.87 11.87 0 0 1 18 10.24 7.55 7.55 0 0 1 17 13a3 3 0 0 0 3-2.76 13.81 13.81 0 0 0-1.43-6.06 7.64 7.64 0 0 0-1.67-2.27 7.24 7.24 0 0 0-9.8 0 7.62 7.62 0 0 0-1.66 2.27A13.68 13.68 0 0 0 4 10.24 3 3 0 0 0 7 13z"
      }));

    case 'people___groupFemale':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6.31 10H4.62L4 8.76V7.5A1.44 1.44 0 0 1 5.5 6a1.46 1.46 0 0 1 .5.09 8.52 8.52 0 0 1 .34-2A3.49 3.49 0 0 0 5.5 4 3.42 3.42 0 0 0 2 7.5v1.26a2 2 0 0 0 .21.9l.62 1.23A2 2 0 0 0 4.62 12h1.76a1.91 1.91 0 0 0 .79-.18zM18.5 4a3.49 3.49 0 0 0-.86.11 8.52 8.52 0 0 1 .34 2A1.46 1.46 0 0 1 18.5 6 1.44 1.44 0 0 1 20 7.5v1.26L19.38 10h-1.69l-.86 1.82a1.91 1.91 0 0 0 .79.18h1.76a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V7.5A3.42 3.42 0 0 0 18.5 4zM12 4c.8 0 2 0 2 2.75v1.51a1.16 1.16 0 0 1-.12.51L13 10.49a1 1 0 0 1-.31.38 1.13 1.13 0 0 1-1.42 0 1 1 0 0 1-.31-.38l-.86-1.72a1.16 1.16 0 0 1-.1-.51V6.75C10 4 11.2 4 12 4m0-2C9.5 2 8 3.5 8 6.75v1.51a3.07 3.07 0 0 0 .33 1.4l.86 1.72a3 3 0 0 0 .85 1 3.13 3.13 0 0 0 3.92 0 3 3 0 0 0 .85-1l.86-1.72a3.07 3.07 0 0 0 .33-1.4V6.75C16 3.5 14.5 2 12 2zM22.34 13.55l-1.1-.55H17v.1a3 3 0 0 1 2 1.56l.13.26V15h1.64l.69.34a1 1 0 0 1 .55.9V18h2v-1.76a3 3 0 0 0-1.67-2.69zM4.88 15a.3.3 0 0 0 0-.08l.13-.26A3 3 0 0 1 7 13.1V13H2.76l-1.1.55A3 3 0 0 0 0 16.24V18h2v-1.76a1 1 0 0 1 .55-.9l.69-.34zM7.74 16h1L12 21.89 15.24 16h1a15.64 15.64 0 0 1 1.52 4c.08.5.22 2 .22 2h2a15.73 15.73 0 0 0-1.88-6.76A2.23 2.23 0 0 0 16.26 14H14l-2 4-2-4H7.74a2.23 2.23 0 0 0-1.86 1.24A15.73 15.73 0 0 0 4 22h2s.14-1.5.22-2a15.64 15.64 0 0 1 1.52-4z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18.12 15.24A2.23 2.23 0 0 0 16.26 14H14l-2 4-2-4H7.74a2.23 2.23 0 0 0-1.86 1.24A15.73 15.73 0 0 0 4 22h16a15.73 15.73 0 0 0-1.88-6.76zM22.34 13.55l-1.1-.55H18.9a3.87 3.87 0 0 1 .94 1.21l.13.27A20.35 20.35 0 0 1 21.38 18H24v-1.76a3 3 0 0 0-1.66-2.69zM4 14.48l.13-.27A3.87 3.87 0 0 1 5.1 13H2.76l-1.1.55A3 3 0 0 0 0 16.24V18h2.62A20.35 20.35 0 0 1 4 14.48zM18.5 4a3.49 3.49 0 0 0-.86.11A9 9 0 0 1 18 6.75v1.51a5.25 5.25 0 0 1-.54 2.3l-.63 1.26a1.91 1.91 0 0 0 .79.18h1.76a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V7.5A3.42 3.42 0 0 0 18.5 4zM6.54 10.56A5.25 5.25 0 0 1 6 8.26V6.75a9 9 0 0 1 .36-2.64A3.49 3.49 0 0 0 5.5 4 3.42 3.42 0 0 0 2 7.5v1.26a2 2 0 0 0 .21.9l.62 1.23A2 2 0 0 0 4.62 12h1.76a1.91 1.91 0 0 0 .79-.18zM12 2C9.5 2 8 3.5 8 6.75v1.51a3.07 3.07 0 0 0 .33 1.4l.86 1.72a3 3 0 0 0 .85 1 3.13 3.13 0 0 0 3.92 0 3 3 0 0 0 .85-1l.86-1.72a3.07 3.07 0 0 0 .33-1.4V6.75C16 3.5 14.5 2 12 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38 12a3.87 3.87 0 0 1 4 4v2.29a2 2 0 0 1-.21.9l-.86 1.7A2 2 0 0 1 39.15 22h-1a6.16 6.16 0 0 1-1.83 2 4 4 0 0 0 .49 0h2.3a4 4 0 0 0 3.57-2.21l.86-1.71a4.09 4.09 0 0 0 .46-1.79V16a5.87 5.87 0 0 0-6-6 5.66 5.66 0 0 0-.72.07c.25.63.48 1.28.68 1.93zM5.28 21.79A4 4 0 0 0 8.85 24h2.3a4 4 0 0 0 .49 0 6.16 6.16 0 0 1-1.83-2h-1a2 2 0 0 1-1.78-1.11l-.86-1.7a2 2 0 0 1-.21-.9V16a3.87 3.87 0 0 1 4-4c.2-.65.43-1.3.68-1.93A5.66 5.66 0 0 0 10 10a5.87 5.87 0 0 0-6 6v2.29a4.09 4.09 0 0 0 .42 1.79zM43.68 26.72L42.24 26h-7a6.16 6.16 0 0 1 4.17 2h2.34l1 .51A4 4 0 0 1 45 32.09V35h2v-2.91a6 6 0 0 0-3.32-5.37zM8.58 28a6.16 6.16 0 0 1 4.17-2h-7l-1.44.72A6 6 0 0 0 1 32.09V35h2v-2.91a4 4 0 0 1 2.21-3.58l1-.51z"
      }), React.createElement("path", {
        d: "M15 22.73h1l-1-2a2 2 0 0 1-2-2 20.69 20.69 0 0 1 2.17-9.1 10.17 10.17 0 0 1 .64-1.12l2.69 1.34V5.72a9.75 9.75 0 0 1 12.1.83 11.08 11.08 0 0 1 2.26 3.1A20.59 20.59 0 0 1 35 18.73a2 2 0 0 1-2 2l-1 2h1a4 4 0 0 0 4-4 22.65 22.65 0 0 0-2.39-10 12.45 12.45 0 0 0-2.69-3.65 11.74 11.74 0 0 0-14.57-1 2 2 0 0 0-.85 1.64v.92a2 2 0 0 0-2.38.79c-.25.39-.53.89-.74 1.31a22.7 22.7 0 0 0-2.38 10 4 4 0 0 0 4 3.99z"
      }), React.createElement("path", {
        d: "M22.21 26.58a4 4 0 0 0 3.58 0 10.81 10.81 0 0 0 4.82-4.82A13.3 13.3 0 0 0 32 15.85V14a21.16 21.16 0 0 1-9.47-2.23L19 10v4h-3v1.88a13.3 13.3 0 0 0 1.39 5.91 10.81 10.81 0 0 0 4.82 4.79zM21 16v-2.79a27.18 27.18 0 0 0 9 2.67 11.34 11.34 0 0 1-1.18 5 8.87 8.87 0 0 1-3.93 3.92 2 2 0 0 1-1.78 0 8.87 8.87 0 0 1-3.93-3.92A11.44 11.44 0 0 1 18 16zM34.83 28H29l-5 10-5-10h-5.83a4.57 4.57 0 0 0-3.81 2.48A30.14 30.14 0 0 0 6 44h2a27.94 27.94 0 0 1 3.13-12.61 2.66 2.66 0 0 1 2-1.39h4.59L24 42.5 30.24 30h4.59a2.66 2.66 0 0 1 2 1.39A27.94 27.94 0 0 1 40 44h2a30.14 30.14 0 0 0-3.36-13.52A4.57 4.57 0 0 0 34.83 28z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39 20.15a6 6 0 0 1-.73 2.85h1.88a3 3 0 0 0 2.68-1.66l.85-1.71a2.94 2.94 0 0 0 .32-1.34V16a4.85 4.85 0 0 0-5-5 5.11 5.11 0 0 0-1.31.18A24.21 24.21 0 0 1 39 19zM5.17 21.34A3 3 0 0 0 7.85 23h1.88A6 6 0 0 1 9 20.15V19a24.21 24.21 0 0 1 1.31-7.82A5.11 5.11 0 0 0 9 11a4.85 4.85 0 0 0-5 5v2.29a2.94 2.94 0 0 0 .32 1.34zM43.68 26.72L42.24 26h-7a6.08 6.08 0 0 1 5.06 3.28l.27.53A30.32 30.32 0 0 1 42.68 35H47v-2.91a6 6 0 0 0-3.32-5.37zM7.69 29.28A6.08 6.08 0 0 1 12.75 26h-7l-1.44.72A6 6 0 0 0 1 32.09V35h4.32a30.32 30.32 0 0 1 2.1-5.19zM13.21 23.46L16.3 25l1.7-2.23a10.72 10.72 0 0 0 4.23 3.81 4 4 0 0 0 3.58 0A10.79 10.79 0 0 0 30 22.77L31.7 25l3.09-1.54A4 4 0 0 0 37 19.88v-1.15a22.65 22.65 0 0 0-2.39-10 12.63 12.63 0 0 0-2.69-3.65 11.74 11.74 0 0 0-14.57-1 2 2 0 0 0-.85 1.64v.92a2 2 0 0 0-2.38.79c-.25.39-.53.89-.74 1.31a22.7 22.7 0 0 0-2.38 10v1.15a4 4 0 0 0 2.21 3.57zM18 15h3v-2.79a27.18 27.18 0 0 0 9 2.67v1a11.33 11.33 0 0 1-1.18 5 8.87 8.87 0 0 1-3.93 3.92 2 2 0 0 1-1.78 0 8.87 8.87 0 0 1-3.93-3.92 11.33 11.33 0 0 1-1.18-5zM34.83 28H29l-5 10-5-10h-5.83a4.57 4.57 0 0 0-3.81 2.48A30.14 30.14 0 0 0 6 44h36a30.14 30.14 0 0 0-3.36-13.52A4.57 4.57 0 0 0 34.83 28z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76.31 20a13 13 0 0 0-1.77.1c.51 1.28 1 2.58 1.38 3.9H76a8.14 8.14 0 0 1 8 8.2v4.38a4 4 0 0 1-.42 1.79l-1.71 3.42A4 4 0 0 1 78.29 44h-1.91a12 12 0 0 1-3.65 3.93 7.93 7.93 0 0 0 1 .07h4.58a8 8 0 0 0 7.16-4.42l1.71-3.42a8 8 0 0 0 .82-3.58v-4.32A12.16 12.16 0 0 0 76.31 20zM19.62 44h-1.91a4 4 0 0 1-3.58-2.21l-1.71-3.42a4 4 0 0 1-.42-1.79V32.2a8.14 8.14 0 0 1 8-8.2h.09c.4-1.32.87-2.62 1.38-3.91a14.77 14.77 0 0 0-1.78-.09A12.16 12.16 0 0 0 8 32.26v4.32a8 8 0 0 0 .84 3.58l1.71 3.42A8 8 0 0 0 17.71 48h4.58a7.93 7.93 0 0 0 1-.07A12 12 0 0 1 19.62 44zM10.42 57l2.05-1H17a11.9 11.9 0 0 1 8.94-4H11.53l-2.9 1.45A11.92 11.92 0 0 0 2 64.18V70h4v-5.82A7.94 7.94 0 0 1 10.42 57zM64 56h6.06H64zM87.37 53.45L84.47 52H70.06A11.9 11.9 0 0 1 79 56h4.53l2 1A7.94 7.94 0 0 1 90 64.18V70h4v-5.82a11.92 11.92 0 0 0-6.63-10.73zM44 60h8v2h-8z"
      }), React.createElement("path", {
        d: "M30 46h1.5l-2-4a4 4 0 0 1-3.5-4 41.33 41.33 0 0 1 4.35-18.22 23.38 23.38 0 0 1 1.26-2.24l5.39 2.7V12a19.47 19.47 0 0 1 24.18 1.67 21 21 0 0 1 4.5 6.12A41.42 41.42 0 0 1 70 38a4 4 0 0 1-3.47 4l-2 4H66a8 8 0 0 0 8-8 45.42 45.42 0 0 0-4.78-20 25.21 25.21 0 0 0-5.38-7.3 23.47 23.47 0 0 0-29.14-2A4 4 0 0 0 33 12v1.84a4 4 0 0 0-4.75 1.58A29.34 29.34 0 0 0 26.77 18 45.46 45.46 0 0 0 22 38a8 8 0 0 0 8 8z"
      }), React.createElement("path", {
        d: "M61.21 44.58A26.51 26.51 0 0 0 64 32.76V29a42.34 42.34 0 0 1-18.94-4.47L38 21v8h-6v3.76a26.37 26.37 0 0 0 2.79 11.82 21.47 21.47 0 0 0 9.63 9.63 8 8 0 0 0 7.16 0 21.47 21.47 0 0 0 9.63-9.63zm-11.42 6.05a3.94 3.94 0 0 1-3.58 0 17.59 17.59 0 0 1-7.84-7.84A22.52 22.52 0 0 1 36 33h6v-5.53l1.27.64A46.51 46.51 0 0 0 60 32.82a22.53 22.53 0 0 1-2.37 10 17.59 17.59 0 0 1-7.84 7.81zM77.29 61a9.21 9.21 0 0 0-7.63-5H58L48 76 38 56H26.34a9.21 9.21 0 0 0-7.63 5A60.45 60.45 0 0 0 12 88h4a55.71 55.71 0 0 1 6.27-25.22A5.25 5.25 0 0 1 26.34 60h9.19L48 85l12.47-25h9.19a5.25 5.25 0 0 1 4.07 2.78A55.71 55.71 0 0 1 80 88h4a60.45 60.45 0 0 0-6.71-27z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 22h-.73A48.59 48.59 0 0 1 78 38v2.29A12 12 0 0 1 76.56 46h1.73a6 6 0 0 0 5.37-3.32l1.71-3.41a6.11 6.11 0 0 0 .63-2.69V32a9.71 9.71 0 0 0-10-10zM18 40.29V38a48.59 48.59 0 0 1 2.73-16H20a9.71 9.71 0 0 0-10 10v4.58a6.11 6.11 0 0 0 .63 2.69l1.71 3.41A6 6 0 0 0 17.71 46h1.73A12 12 0 0 1 18 40.29zM80.05 59.16A69.41 69.41 0 0 1 84.38 70H94v-5.82a11.92 11.92 0 0 0-6.63-10.73L84.47 52H69.06a12.83 12.83 0 0 1 10.99 7.16zM16 59.16A12.83 12.83 0 0 1 27 52H11.53l-2.9 1.45A11.92 11.92 0 0 0 2 64.18V70h9.62A69.41 69.41 0 0 1 16 59.16z"
      }), React.createElement("path", {
        d: "M76.48 61a8.93 8.93 0 0 0-7.42-5H58L48 76 38 56H26.94a8.93 8.93 0 0 0-7.42 5A61.87 61.87 0 0 0 13 88h70a61.87 61.87 0 0 0-6.52-27zM69.31 18.15l-.17-.35a24.35 24.35 0 0 0-5.3-7.13 23.46 23.46 0 0 0-29.13-2A4 4 0 0 0 33 12v1.84a4 4 0 0 0-4.75 1.58c-.5.78-1 1.61-1.4 2.45l-.17.34A44.65 44.65 0 0 0 22 38v2.29a8 8 0 0 0 4.42 7.16l6.18 3.09 3.17-4.23a21.54 21.54 0 0 0 8.65 7.9 8 8 0 0 0 7.16 0 21.54 21.54 0 0 0 8.65-7.9l3.17 4.23 6.18-3.09A8 8 0 0 0 74 40.29V38a44.54 44.54 0 0 0-4.69-19.85zM42 25.47a54 54 0 0 0 18 5.35v1.94a22.52 22.52 0 0 1-2.37 10 17.59 17.59 0 0 1-7.84 7.84 3.94 3.94 0 0 1-3.58 0 17.59 17.59 0 0 1-7.84-7.84 22.52 22.52 0 0 1-2.37-10V31h6z"
      }), React.createElement("path", {
        d: "M44 60h8v2h-8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6.31 10H4.62L4 8.76V7.5A1.44 1.44 0 0 1 5.5 6a1.46 1.46 0 0 1 .5.09 8.52 8.52 0 0 1 .34-2A3.49 3.49 0 0 0 5.5 4 3.42 3.42 0 0 0 2 7.5v1.26a2 2 0 0 0 .21.9l.62 1.23A2 2 0 0 0 4.62 12h1.76a1.91 1.91 0 0 0 .79-.18zM18.5 4a3.49 3.49 0 0 0-.86.11 8.52 8.52 0 0 1 .34 2A1.46 1.46 0 0 1 18.5 6 1.44 1.44 0 0 1 20 7.5v1.26L19.38 10h-1.69l-.86 1.82a1.91 1.91 0 0 0 .79.18h1.76a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V7.5A3.42 3.42 0 0 0 18.5 4zM12 4c.8 0 2 0 2 2.75v1.51a1.16 1.16 0 0 1-.12.51L13 10.49a1 1 0 0 1-.31.38 1.13 1.13 0 0 1-1.42 0 1 1 0 0 1-.31-.38l-.86-1.72a1.16 1.16 0 0 1-.1-.51V6.75C10 4 11.2 4 12 4m0-2C9.5 2 8 3.5 8 6.75v1.51a3.07 3.07 0 0 0 .33 1.4l.86 1.72a3 3 0 0 0 .85 1 3.13 3.13 0 0 0 3.92 0 3 3 0 0 0 .85-1l.86-1.72a3.07 3.07 0 0 0 .33-1.4V6.75C16 3.5 14.5 2 12 2zM22.34 13.55l-1.1-.55H17v.1a3 3 0 0 1 2 1.56l.13.26V15h1.64l.69.34a1 1 0 0 1 .55.9V18h2v-1.76a3 3 0 0 0-1.67-2.69zM4.88 15a.3.3 0 0 0 0-.08l.13-.26A3 3 0 0 1 7 13.1V13H2.76l-1.1.55A3 3 0 0 0 0 16.24V18h2v-1.76a1 1 0 0 1 .55-.9l.69-.34zM7.74 16h1L12 21.89 15.24 16h1a15.64 15.64 0 0 1 1.52 4c.08.5.22 2 .22 2h2a15.73 15.73 0 0 0-1.88-6.76A2.23 2.23 0 0 0 16.26 14H14l-2 4-2-4H7.74a2.23 2.23 0 0 0-1.86 1.24A15.73 15.73 0 0 0 4 22h2s.14-1.5.22-2a15.64 15.64 0 0 1 1.52-4z"
      }));

    case 'people___groupMale':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.83 10.89A2 2 0 0 0 4.62 12h1.76a2.17 2.17 0 0 0 .8-.18l-.74-1.47c0-.1-.07-.22-.11-.32H4.62L4 8.76V7.5A1.44 1.44 0 0 1 5.5 6a1.59 1.59 0 0 1 .5.08v-.33a8.59 8.59 0 0 1 .16-1.69A3.6 3.6 0 0 0 5.5 4 3.42 3.42 0 0 0 2 7.5v1.26a2 2 0 0 0 .21.9zM19.38 12a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V7.5A3.42 3.42 0 0 0 18.5 4a3.6 3.6 0 0 0-.66.06A8.59 8.59 0 0 1 18 5.75v.33a1.59 1.59 0 0 1 .5-.08A1.44 1.44 0 0 1 20 7.5v1.26L19.38 10h-1.69c0 .1-.06.22-.11.32l-.74 1.47a2.17 2.17 0 0 0 .8.18zM9 10.89A2 2 0 0 0 10.74 12h2.52a2 2 0 0 0 1.79-1.11l.74-1.47a2 2 0 0 0 .21-.89V5.75C16 2.5 14.5 2 12 2s-4 .5-4 3.75v2.78a2 2 0 0 0 .21.89zm1-5.14C10 4.07 10.07 4 12 4s2 .07 2 1.75v2.78L13.26 10h-2.52L10 8.53zM22.89 13.83L21.24 13H18.5v1.13l.29.15a4 4 0 0 1 1 .72h1l1.24.62V18h2v-2.38a2 2 0 0 0-1.14-1.79zM5.21 14.28l.29-.15V13H2.76l-1.65.83A2 2 0 0 0 0 15.62V18h2v-2.38L3.24 15h1a4 4 0 0 1 .97-.72zM18.34 15.17L16 14h-2l-1 2h-2l-1-2H8l-2.34 1.17A3 3 0 0 0 4 17.85V22h2v-4.15a1 1 0 0 1 .55-.85l1.92-1h.29l1 2h4.48l1-2h.29l1.92 1a1 1 0 0 1 .55.89V22h2v-4.15a3 3 0 0 0-1.66-2.68z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M22.89 13.83L21.24 13h-2.77l.77.38A5 5 0 0 1 22 17.85V18h2v-2.38a2 2 0 0 0-1.11-1.79zM5.53 13H2.76l-1.65.83A2 2 0 0 0 0 15.62V18h2v-.15a5 5 0 0 1 2.76-4.47zM19.38 12a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V7.5A3.42 3.42 0 0 0 18.5 4a3.6 3.6 0 0 0-.66.06A8.59 8.59 0 0 1 18 5.75v2.78a4.13 4.13 0 0 1-.42 1.79l-.74 1.47a2.17 2.17 0 0 0 .8.18zM9 10.89A2 2 0 0 0 10.74 12h2.52a2 2 0 0 0 1.79-1.11l.74-1.47a2 2 0 0 0 .21-.89V5.75C16 2.5 14.5 2 12 2s-4 .5-4 3.75v2.78a2 2 0 0 0 .21.89zM2.83 10.89A2 2 0 0 0 4.62 12h1.76a2.17 2.17 0 0 0 .8-.18l-.74-1.47A4.13 4.13 0 0 1 6 8.53V5.75a8.59 8.59 0 0 1 .16-1.69A3.6 3.6 0 0 0 5.5 4 3.42 3.42 0 0 0 2 7.5v1.26a2 2 0 0 0 .21.9zM18.34 15.17L16 14h-2l-1 2h-2l-1-2H8l-2.34 1.17A3 3 0 0 0 4 17.85V22h16v-4.15a3 3 0 0 0-1.66-2.68z",
        className: "a"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M33.37 21.74l-.48 1a4 4 0 0 0 3 1.31h2.3a4 4 0 0 0 3.57-2.21l.86-1.71a4.09 4.09 0 0 0 .38-1.84V16a5.87 5.87 0 0 0-6-6 5.94 5.94 0 0 0-1.35.16 18.35 18.35 0 0 1 .28 2A4.13 4.13 0 0 1 37 12a3.87 3.87 0 0 1 4 4v2.29a2 2 0 0 1-.21.9l-.86 1.7A2 2 0 0 1 38.15 22h-2.3a2 2 0 0 1-1.78-1.11l-.23-.45a6.5 6.5 0 0 1-.47 1.3zM6.28 21.79A4 4 0 0 0 9.85 24h2.3a4 4 0 0 0 3-1.31l-.48-1a6.5 6.5 0 0 1-.47-1.3l-.23.45A2 2 0 0 1 12.15 22h-2.3a2 2 0 0 1-1.78-1.11l-.86-1.7a2 2 0 0 1-.21-.9V16a3.87 3.87 0 0 1 4-4 4.13 4.13 0 0 1 1.07.15 18.35 18.35 0 0 1 .28-2A5.94 5.94 0 0 0 11 10a5.87 5.87 0 0 0-6 6v2.29a4.09 4.09 0 0 0 .42 1.79zM16 19.06a3.92 3.92 0 0 0 .42 1.78l1.47 2.95A4 4 0 0 0 21.47 26h5.06a4 4 0 0 0 3.58-2.21l1.47-2.95a3.92 3.92 0 0 0 .42-1.78V18l2-2v-2c0-3.95-1-6.34-2.41-7.79L30 7V5.05a13.3 13.3 0 0 0-6-1c-4.84 0-10 .77-10 10v2l2 2zm14 0a2 2 0 0 1-.21.89l-1.47 2.94A2 2 0 0 1 26.53 24h-5.06a2 2 0 0 1-1.79-1.11L18.21 20a2 2 0 0 1-.21-.89v-4.99l3.55-1.78 1.56 3.11A1 1 0 0 0 24 16a.93.93 0 0 0 .45-.11L30 13.12zM24 6c3.56 0 6.45.38 7.53 4.12l-7.08 3.54-1.56-3.11a1 1 0 0 0-1.34-.44L16 12.86C16.38 6.54 19.71 6 24 6zM45.34 27.55L42.24 26h-9.77l4 2h5.29l2.69 1.34a1 1 0 0 1 .55.9V35h2v-4.76a3 3 0 0 0-1.66-2.69zM15.53 26H5.76l-3.1 1.55A3 3 0 0 0 1 30.24V35h2v-4.76a1 1 0 0 1 .55-.9L6.24 28h5.29zM36.68 30.34L32 28h-3l-2 4h-6l-2-4h-3l-4.68 2.34A6 6 0 0 0 8 35.71V44h2v-8.29a4 4 0 0 1 2.21-3.58L16.47 30h1.29l2 4h8.48l2-4h1.29l4.26 2.13A4 4 0 0 1 38 35.71V44h2v-8.29a6 6 0 0 0-3.32-5.37z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M45.34 27.55L42.24 26h-9.77l.42.21 4.69 2.34A8 8 0 0 1 42 35h5v-4.76a3 3 0 0 0-1.66-2.69zM10.42 28.55l4.69-2.34.42-.21H5.76l-3.1 1.55A3 3 0 0 0 1 30.24V35h5.05a8 8 0 0 1 4.37-6.45z"
      }), React.createElement("path", {
        d: "M36.68 30.34L32 28h-3l-2 4h-6l-2-4h-3l-4.68 2.34A6 6 0 0 0 8 35.71V44h32v-8.29a6 6 0 0 0-3.32-5.37z",
        className: "a"
      }), React.createElement("path", {
        d: "M34 19a6.17 6.17 0 0 1-.62 2.7 3 3 0 0 0 2.47 1.3h2.3a3 3 0 0 0 2.68-1.66l.85-1.71a2.94 2.94 0 0 0 .32-1.34V16a4.85 4.85 0 0 0-5-5 5.33 5.33 0 0 0-1.2.15A20.55 20.55 0 0 1 36 14v3zM14 19l-2-2v-3a20.55 20.55 0 0 1 .2-2.85A5.33 5.33 0 0 0 11 11a4.85 4.85 0 0 0-5 5v2.29a2.94 2.94 0 0 0 .32 1.34l.85 1.71A3 3 0 0 0 9.85 23h2.3a3 3 0 0 0 2.47-1.3A6.17 6.17 0 0 1 14 19zM31.59 6.21L30 7V5.05a13.3 13.3 0 0 0-6-1c-4.84 0-10 .77-10 10v2l2 2v1.06a3.92 3.92 0 0 0 .42 1.78l1.47 2.95A4 4 0 0 0 21.47 26h5.06a4 4 0 0 0 3.58-2.21l1.47-2.95a3.92 3.92 0 0 0 .42-1.78V18l2-2v-2c0-3.95-.95-6.34-2.41-7.79zM29.79 20l-1.47 2.94A2 2 0 0 1 26.53 24h-5.06a2 2 0 0 1-1.79-1.11L18.21 20a2 2 0 0 1-.21-.89v-4.99l3.55-1.78 1.56 3.11A1 1 0 0 0 24 16a.93.93 0 0 0 .45-.11L30 13.12v5.94a2 2 0 0 1-.21.94z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M90.68 55.11L84.47 52H64.94l8 4h10.59l5.36 2.68A2 2 0 0 1 90 60.47V70h4v-9.53a6 6 0 0 0-3.32-5.36zM31.06 52H11.53l-6.21 3.11A6 6 0 0 0 2 60.47V70h4v-9.53a2 2 0 0 1 1.11-1.79L12.47 56h10.59zM73.37 60.68L64 56h-6l-4 8H42l-4-8h-6l-9.37 4.68A12 12 0 0 0 16 71.42V88h4V71.42a8 8 0 0 1 4.42-7.16L32.94 60h2.59l4 8h16.94l4-8h2.59l8.52 4.26A8 8 0 0 1 76 71.42V88h4V71.42a12 12 0 0 0-6.63-10.74zM66.73 43.48l-1 1.9A8 8 0 0 0 71.71 48h4.58a8 8 0 0 0 7.16-4.42l2.13-4.26a4 4 0 0 0 .42-1.79v-5.18A12.23 12.23 0 0 0 73.82 20a12.06 12.06 0 0 0-2.51.29 36.78 36.78 0 0 1 .55 4 8.69 8.69 0 0 1 1.87-.29A8.2 8.2 0 0 1 82 32.29v4.77a2 2 0 0 1-.21.89l-1.92 3.84A4 4 0 0 1 76.29 44h-4.58a4 4 0 0 1-3.58-2.21l-.46-.91a11.56 11.56 0 0 1-.94 2.6zM12.55 43.58A8 8 0 0 0 19.71 48h4.58a8 8 0 0 0 5.93-2.62l-.95-1.9a11.56 11.56 0 0 1-.94-2.6l-.46.91A4 4 0 0 1 24.29 44h-4.58a4 4 0 0 1-3.58-2.21L14.21 38a2 2 0 0 1-.21-.89v-4.82A8.2 8.2 0 0 1 22.27 24a8.69 8.69 0 0 1 1.87.27 36.78 36.78 0 0 1 .55-4 12.06 12.06 0 0 0-2.51-.27A12.23 12.23 0 0 0 10 32.35v5.18a4 4 0 0 0 .42 1.79z"
      }), React.createElement("path", {
        d: "M44 58h8v2h-8zM32 38.11a8.08 8.08 0 0 0 .84 3.58l2.95 5.89A8 8 0 0 0 42.94 52h10.12a8 8 0 0 0 7.15-4.42l2.95-5.89a8.08 8.08 0 0 0 .84-3.58V37l4-4v-5c0-7.89-1.89-12.69-4.81-15.59L60 14v-3.9C56.47 8.29 52.17 8 48 8c-9.68 0-20 1.55-20 20v5l4 4zm28 0a4.09 4.09 0 0 1-.42 1.79l-2.95 5.89A4 4 0 0 1 53.06 48H42.94a4 4 0 0 1-3.57-2.21l-2.95-5.89a4.09 4.09 0 0 1-.42-1.79v-9.87l7.11-3.56 3.1 6.21a2 2 0 0 0 2.68.9L60 26.24zM48 12c7.12 0 12.92.73 15.09 8.22l-14.2 7.1-3.1-6.21a2 2 0 0 0-2.68-.9l-11 5.52C32.76 13.06 39.42 12 48 12z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M90.68 55.11L84.47 52H64.94l10.22 5.11A15.9 15.9 0 0 1 83.93 70H94v-9.53a6 6 0 0 0-3.32-5.36zM20.84 57.11L31.06 52H11.53l-6.21 3.11A6 6 0 0 0 2 60.47V70h10.07a15.9 15.9 0 0 1 8.77-12.89z"
      }), React.createElement("path", {
        d: "M73.37 60.68L64 56h-6l-4 8H42l-4-8h-6l-9.37 4.68A12 12 0 0 0 16 71.42V88h64V71.42a12 12 0 0 0-6.63-10.74z",
        className: "a"
      }), React.createElement("path", {
        d: "M74 22a11.45 11.45 0 0 0-2.36.26A43.93 43.93 0 0 1 72 28v6l-4 4v.11a12.11 12.11 0 0 1-1.23 5.29 6 6 0 0 0 4.94 2.6h4.58a6 6 0 0 0 5.37-3.32l1.92-3.84a3.92 3.92 0 0 0 .42-1.78V32a9.71 9.71 0 0 0-10-10zM28 38.11V38l-4-4v-6a43.93 43.93 0 0 1 .36-5.74A11.45 11.45 0 0 0 22 22a9.71 9.71 0 0 0-10 10v5.06a3.92 3.92 0 0 0 .42 1.78l1.92 3.84A6 6 0 0 0 19.71 46h4.58a6 6 0 0 0 4.94-2.6A12.11 12.11 0 0 1 28 38.11zM44 58h8v2h-8zM63.19 12.41L60 14v-3.9C56.47 8.29 52.17 8 48 8c-9.68 0-20 1.55-20 20v5l4 4v1.11a8.08 8.08 0 0 0 .84 3.58l2.95 5.89A8 8 0 0 0 42.94 52h10.12a8 8 0 0 0 7.15-4.42l2.95-5.89a8.08 8.08 0 0 0 .84-3.58V37l4-4v-5c0-7.89-1.89-12.69-4.81-15.59zM60 38.11a4.09 4.09 0 0 1-.42 1.79l-2.95 5.89A4 4 0 0 1 53.06 48H42.94a4 4 0 0 1-3.57-2.21l-2.95-5.89a4.09 4.09 0 0 1-.42-1.79V26l7.11-3.32 3.1 6.21a2 2 0 0 0 2.68.9L60 24z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.83 10.89A2 2 0 0 0 4.62 12h1.76a2.17 2.17 0 0 0 .8-.18l-.74-1.47c0-.1-.07-.22-.11-.32H4.62L4 8.76V7.5A1.44 1.44 0 0 1 5.5 6a1.59 1.59 0 0 1 .5.08v-.33a8.59 8.59 0 0 1 .16-1.69A3.6 3.6 0 0 0 5.5 4 3.42 3.42 0 0 0 2 7.5v1.26a2 2 0 0 0 .21.9zM19.38 12a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V7.5A3.42 3.42 0 0 0 18.5 4a3.6 3.6 0 0 0-.66.06A8.59 8.59 0 0 1 18 5.75v.33a1.59 1.59 0 0 1 .5-.08A1.44 1.44 0 0 1 20 7.5v1.26L19.38 10h-1.69c0 .1-.06.22-.11.32l-.74 1.47a2.17 2.17 0 0 0 .8.18zM9 10.89A2 2 0 0 0 10.74 12h2.52a2 2 0 0 0 1.79-1.11l.74-1.47a2 2 0 0 0 .21-.89V5.75C16 2.5 14.5 2 12 2s-4 .5-4 3.75v2.78a2 2 0 0 0 .21.89zm1-5.14C10 4.07 10.07 4 12 4s2 .07 2 1.75v2.78L13.26 10h-2.52L10 8.53zM22.89 13.83L21.24 13H18.5v1.13l.29.15a4 4 0 0 1 1 .72h1l1.24.62V18h2v-2.38a2 2 0 0 0-1.14-1.79zM5.21 14.28l.29-.15V13H2.76l-1.65.83A2 2 0 0 0 0 15.62V18h2v-2.38L3.24 15h1a4 4 0 0 1 .97-.72zM18.34 15.17L16 14h-2l-1 2h-2l-1-2H8l-2.34 1.17A3 3 0 0 0 4 17.85V22h2v-4.15a1 1 0 0 1 .55-.85l1.92-1h.29l1 2h4.48l1-2h.29l1.92 1a1 1 0 0 1 .55.89V22h2v-4.15a3 3 0 0 0-1.66-2.68z"
      }));

    case 'people___male':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.83 12.89A2 2 0 0 0 9.62 14h4.76a2 2 0 0 0 1.79-1.11l1.62-3.23a2 2 0 0 0 .21-.9V6a7.85 7.85 0 0 0-.44-2.75C16.68.3 14.57 0 12 0S7.32.3 6.44 3.25A7.85 7.85 0 0 0 6 6v2.76a2 2 0 0 0 .21.9zM12 2c2 0 3.23 0 3.74 2.06a1.33 1.33 0 0 0-.19.05l-3.1 1.55-.56-1.11a1 1 0 0 0-1.34-.44L8.06 5.35C8.35 2 9.67 2 12 2zM8 7.62l2.55-1.28.56 1.11A1 1 0 0 0 12 8a.93.93 0 0 0 .45-.11L16 6.13v2.63L14.38 12H9.62L8 8.76zM21.34 17.67L18 16h-3l-1 2h-4l-1-2H6l-3.34 1.67A3 3 0 0 0 1 20.35V24h2v-3.65a1 1 0 0 1 .55-.89L6.47 18h1.29l1 2h6.48l1-2h1.29l2.92 1.46a1 1 0 0 1 .55.89V24h2v-3.65a3 3 0 0 0-1.66-2.68z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.83 12.89A2 2 0 0 0 9.62 14h4.76a2 2 0 0 0 1.79-1.11l1.62-3.23a2 2 0 0 0 .21-.9V6a7.85 7.85 0 0 0-.44-2.75C16.68.3 14.57 0 12 0S7.32.3 6.44 3.25A7.85 7.85 0 0 0 6 6v2.76a2 2 0 0 0 .21.9zM8 6.62l2.55-1.28.56 1.11A1 1 0 0 0 12 7a.93.93 0 0 0 .45-.11L16 5.13v3.63L14.38 12H9.62L8 8.76zM21.34 17.67L18 16h-3l-1 2h-4l-1-2H6l-3.34 1.67A3 3 0 0 0 1 20.35V24h22v-3.65a3 3 0 0 0-1.66-2.68z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38.68 31.34L32 28h-2l-2 4h-8l-2-4h-2l-6.68 3.34A6 6 0 0 0 6 36.71V44h2v-7.29a4 4 0 0 1 2.21-3.58L16.47 30h.29l2 4h10.48l2-4h.29l6.26 3.13A4 4 0 0 1 40 36.71V44h2v-7.29a6 6 0 0 0-3.32-5.37zM16 19.06a3.92 3.92 0 0 0 .42 1.78l1.47 2.95A4 4 0 0 0 21.47 26h5.06a4 4 0 0 0 3.58-2.21l1.47-2.95a3.92 3.92 0 0 0 .42-1.78v-.65l2-2V14c0-3.95-1-6.34-2.41-7.79L30 7V5.05a13.3 13.3 0 0 0-6-1c-4.84 0-10 .77-10 10v2.41l2 2zm14 0a2 2 0 0 1-.21.89l-1.47 2.94A2 2 0 0 1 26.53 24h-5.06a2 2 0 0 1-1.79-1.11L18.21 20a2 2 0 0 1-.21-.89v-4.87l3.1-1.53 1.52 3.13a1 1 0 0 0 1.38.46l6-3.06zM24 6c3.59 0 6.5.38 7.56 4.22L24 14l-1.52-3.12a1 1 0 0 0-1.35-.46L16 13c.35-6.45 3.69-7 8-7z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M38.68 31.34L32 28h-2l-2 4h-8l-2-4h-2l-6.68 3.34A6 6 0 0 0 6 36.71V44h36v-7.29a6 6 0 0 0-3.32-5.37zM16 19.06a3.92 3.92 0 0 0 .42 1.78l1.47 2.95A4 4 0 0 0 21.47 26h5.06a4 4 0 0 0 3.58-2.21l1.47-2.95a3.92 3.92 0 0 0 .42-1.78v-.65l2-2V14c0-3.95-1-6.34-2.41-7.79L30 7V5.05a13.3 13.3 0 0 0-6-1c-4.84 0-10 .77-10 10v2.41l2 2zm2-5.82l3.1-1.53 1.52 3.13a1 1 0 0 0 1.38.46l6-3.06v6.82a2 2 0 0 1-.21.89l-1.47 2.94A2 2 0 0 1 26.53 24h-5.06a2 2 0 0 1-1.79-1.11L18.21 20a2 2 0 0 1-.21-.89z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 58h8v2h-8z"
      }), React.createElement("path", {
        d: "M77.37 62.68L64 56h-4l-4 8H40l-4-8h-4l-13.37 6.68A12 12 0 0 0 12 73.42V88h4V73.42a8 8 0 0 1 4.42-7.16L32.94 60h.59l4 8h20.94l4-8h.59l12.52 6.26A8 8 0 0 1 80 73.42V88h4V73.42a12 12 0 0 0-6.63-10.74zM32 38.11a8.08 8.08 0 0 0 .84 3.58l2.95 5.89A8 8 0 0 0 42.94 52h10.12a8 8 0 0 0 7.15-4.42l2.95-5.89a8.08 8.08 0 0 0 .84-3.58v-1.28l4-4V28c0-7.89-1.89-12.69-4.81-15.59L60 14v-3.9C56.47 8.29 52.17 8 48 8c-9.68 0-20 1.55-20 20v4.83l4 4zm28 0a4.09 4.09 0 0 1-.42 1.79l-2.95 5.89A4 4 0 0 1 53.06 48H42.94a4 4 0 0 1-3.57-2.21l-2.95-5.89a4.09 4.09 0 0 1-.42-1.79v-9.87l7.11-3.56 3.1 6.21a2 2 0 0 0 2.68.9L60 26.24zM48 12c7.12 0 12.92.73 15.09 8.22l-14.2 7.1-3.1-6.21a2 2 0 0 0-2.68-.9l-11 5.52C32.76 13.06 39.42 12 48 12z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 58h8v2h-8z"
      }), React.createElement("path", {
        d: "M77.37 62.68L64 56h-4l-4 8H40l-4-8h-4l-13.37 6.68A12 12 0 0 0 12 73.42V88h72V73.42a12 12 0 0 0-6.63-10.74zM32 38.11a8.08 8.08 0 0 0 .84 3.58l2.95 5.89A8 8 0 0 0 42.94 52h10.12a8 8 0 0 0 7.15-4.42l2.95-5.89a8.08 8.08 0 0 0 .84-3.58v-1.28l4-4V28c0-7.89-1.89-12.69-4.81-15.59L60 14v-3.9C56.47 8.29 52.17 8 48 8c-9.68 0-20 1.55-20 20v4.83l4 4zm4-11.87l7.11-3.56 3.1 6.21a2 2 0 0 0 2.68.9L60 24.24v13.87a4.09 4.09 0 0 1-.42 1.79l-2.95 5.89A4 4 0 0 1 53.06 48H42.94a4 4 0 0 1-3.57-2.21l-2.95-5.89a4.09 4.09 0 0 1-.42-1.79z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7.83 12.89A2 2 0 0 0 9.62 14h4.76a2 2 0 0 0 1.79-1.11l1.62-3.23a2 2 0 0 0 .21-.9V6a7.85 7.85 0 0 0-.44-2.75C16.68.3 14.57 0 12 0S7.32.3 6.44 3.25A7.85 7.85 0 0 0 6 6v2.76a2 2 0 0 0 .21.9zM12 2c2 0 3.23 0 3.74 2.06a1.33 1.33 0 0 0-.19.05l-3.1 1.55-.56-1.11a1 1 0 0 0-1.34-.44L8.06 5.35C8.35 2 9.67 2 12 2zM8 7.62l2.55-1.28.56 1.11A1 1 0 0 0 12 8a.93.93 0 0 0 .45-.11L16 6.13v2.63L14.38 12H9.62L8 8.76zM21.34 17.67L18 16h-3l-1 2h-4l-1-2H6l-3.34 1.67A3 3 0 0 0 1 20.35V24h2v-3.65a1 1 0 0 1 .55-.89L6.47 18h1.29l1 2h6.48l1-2h1.29l2.92 1.46a1 1 0 0 1 .55.89V24h2v-3.65a3 3 0 0 0-1.66-2.68z"
      }));

    case 'people___photoId':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M0 3v18h24V3zm22 16H2V5h20z"
      }), React.createElement("path", {
        d: "M5 17.62L6.24 17h4.52l1.24.62V18h2v-.38a2 2 0 0 0-1.11-1.79L11.24 15H5.76l-1.65.83A2 2 0 0 0 3 17.62V18h2zM7.62 14h1.76a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V9.5A3.42 3.42 0 0 0 8.5 6 3.42 3.42 0 0 0 5 9.5v1.74l.83 1.65A2 2 0 0 0 7.62 14zM7 9.5A1.44 1.44 0 0 1 8.5 8 1.44 1.44 0 0 1 10 9.5v1.26L9.38 12H7.62L7 10.76zM15 7h5v2h-5zM15 11h5v2h-5z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M0 3v18h24V3zm6 6.5A2.43 2.43 0 0 1 8.5 7 2.43 2.43 0 0 1 11 9.5v1.26a1 1 0 0 1-.11.45l-.61 1.24a1 1 0 0 1-.9.55H7.62a1 1 0 0 1-.9-.55L6 11zm8 8.5H3v-.38a2 2 0 0 1 1.11-1.79L5.76 15h5.48l1.65.83A2 2 0 0 1 14 17.62zm6-5h-5v-2h5zm0-4h-5V7h5z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 8v32h44V8zm42 30H4V10h40z"
      }), React.createElement("path", {
        d: "M14.62 26h4.76a2 2 0 0 0 1.79-1.11L23 21.24V18a5.87 5.87 0 0 0-6-6 5.87 5.87 0 0 0-6 6v3.24l1.83 3.65A2 2 0 0 0 14.62 26zM13 18a3.87 3.87 0 0 1 4-4 3.87 3.87 0 0 1 4 4v2.76L19.38 24h-4.76L13 20.76zM8 31.35a1 1 0 0 1 .55-.89L11 29.24l6 3 6-3 2.45 1.22a1 1 0 0 1 .55.89V35h2v-3.65a3 3 0 0 0-1.66-2.68L23 27l-6 3-6-3-3.34 1.67A3 3 0 0 0 6 31.35V35h2zM28 15h12v2H28zM28 21h12v2H28z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2 8v32h44V8zm10 10a4.85 4.85 0 0 1 5-5 4.85 4.85 0 0 1 5 5v3l-1.45 2.89A2 2 0 0 1 18.76 25h-3.52a2 2 0 0 1-1.79-1.11L12 21zm16 17H6v-3.65a3 3 0 0 1 1.66-2.68L11 27l6 3 6-3 3.34 1.67A3 3 0 0 1 28 31.35zm12-12H28v-2h12zm0-6H28v-2h12z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 16v64h88V16zm84 60H8V20h80z"
      }), React.createElement("path", {
        d: "M29.47 49h5.06a6 6 0 0 0 5.36-3.32L42 41.47v-7c0-5.68-4-9.5-10-9.5s-10 3.82-10 9.5v7l2.11 4.21A6 6 0 0 0 29.47 49zM26 34.5c0-3.5 2.19-5.5 6-5.5s6 2 6 5.5v6l-1.68 3.36A2 2 0 0 1 34.53 45h-5.06a2 2 0 0 1-1.79-1.11L26 40.53zM16 62.71a4 4 0 0 1 2.21-3.58L24 56.24l8 4 8-4 5.79 2.89A4 4 0 0 1 48 62.71V68h4v-5.29a8 8 0 0 0-4.42-7.16L40 51.76l-8 4-8-4-7.58 3.79A8 8 0 0 0 12 62.71V68h4zM58 30h24v4H58zM58 42h24v4H58z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 16v64h88V16zm20 18.5c0-4.5 3-7.5 8-7.5s8 3 8 7.5V41l-1.89 3.79A4 4 0 0 1 34.53 47h-5.06a4 4 0 0 1-3.58-2.21L24 41zM52 68H12v-5.29a8 8 0 0 1 4.42-7.16L24 51.76l8 4 8-4 7.58 3.79A8 8 0 0 1 52 62.71zm30-22H58v-4h24zm0-12H58v-4h24z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M0 3v18h24V3zm22 16H2V5h20z"
      }), React.createElement("path", {
        d: "M5 17.62L6.24 17h4.52l1.24.62V18h2v-.38a2 2 0 0 0-1.11-1.79L11.24 15H5.76l-1.65.83A2 2 0 0 0 3 17.62V18h2zM7.62 14h1.76a2 2 0 0 0 1.79-1.11l.62-1.23a2 2 0 0 0 .21-.9V9.5A3.42 3.42 0 0 0 8.5 6 3.42 3.42 0 0 0 5 9.5v1.74l.83 1.65A2 2 0 0 0 7.62 14zM7 9.5A1.44 1.44 0 0 1 8.5 8 1.44 1.44 0 0 1 10 9.5v1.26L9.38 12H7.62L7 10.76zM15 7h5v2h-5zM15 11h5v2h-5z"
      }));

    case 'people___profileAdd':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.62 14h4.76a2 2 0 0 0 1.79-1.11L17 9.24V6a5.87 5.87 0 0 0-6-6 5.87 5.87 0 0 0-6 6v3.24l1.83 3.65A2 2 0 0 0 8.62 14zM7 6a3.87 3.87 0 0 1 4-4 3.87 3.87 0 0 1 4 4v2.76L13.38 12H8.62L7 8.76zM11 18l-6-3-3.34 1.67A3 3 0 0 0 0 19.35V24h2v-4.65a1 1 0 0 1 .55-.89L5 17.24l6 3 3.16-1.58a6.05 6.05 0 0 1 1.93-3.21zM21 19v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16.09 15.45L11 18l-6-3-3.34 1.67A3 3 0 0 0 0 19.35V24h15.54A5.93 5.93 0 0 1 14 20a6 6 0 0 1 2.09-4.55zM8.62 13h4.76a1 1 0 0 0 .9-.55L16 9V6a4.85 4.85 0 0 0-5-5 4.85 4.85 0 0 0-5 5v3l1.72 3.45a1 1 0 0 0 .9.55zM24 19h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.47 26h5.06a4 4 0 0 0 3.58-2.21L30 20v-6.5C30 9 27 6 22 6s-8 3-8 7.5V20l1.89 3.79A4 4 0 0 0 19.47 26zM16 13.5C16 10 18.19 8 22 8s6 2 6 5.5v6l-1.68 3.36A2 2 0 0 1 24.53 24h-5.06a2 2 0 0 1-1.79-1.11L16 19.53zM31.09 30.78a10.61 10.61 0 0 1 1.77-1.35L30 28l-8 4-8-4-6.68 3.34A6 6 0 0 0 4 36.71V44h2v-7.5a4 4 0 0 1 2.2-3.37l5.8-2.89 8 4 8-4zM46 37h-7v-7h-2v7h-7v2h7v7h2v-7h7v-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M30.81 28.41L30 28l-8 4-8-4-6.68 3.34A6 6 0 0 0 4 36.71V44h23.62a11.95 11.95 0 0 1 3.19-15.59zM19.47 26h5.06a4 4 0 0 0 3.58-2.21L30 20v-6.5C30 9 27 6 22 6s-8 3-8 7.5V20l1.89 3.79A4 4 0 0 0 19.47 26zM46 37h-7v-7h-2v7h-7v2h7v7h2v-7h7v-2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 16c7.63 0 12 4 12 11v12.06l-3.37 6.73A4 4 0 0 1 49.06 48H38.94a4 4 0 0 1-3.57-2.21L32 39.06V27c0-7 4.37-11 12-11m0-4c-10 0-16 6-16 15v13l3.79 7.58A8 8 0 0 0 38.94 52h10.12a8 8 0 0 0 7.15-4.42L60 40V27c0-9-6-15-16-15zM74 60h4v32h-4z"
      }), React.createElement("path", {
        d: "M60 74h32v4H60zM12 84V73a7.94 7.94 0 0 1 4.39-6.74L28 60.47l14.21 7.11 1.79.89 1.79-.89L60 60.47l2.18 1.09a20.78 20.78 0 0 1 3.55-2.7L60 56l-16 8-16-8-13.37 6.68A12 12 0 0 0 8 73.42V88h4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M61.6 56.8L60 56l-16 8-16-8-13.37 6.68A12 12 0 0 0 8 73.42V88h47.22a24 24 0 0 1 6.38-31.2zM38.94 52h10.12a8 8 0 0 0 7.15-4.42L60 40V27c0-9-6-15-16-15s-16 6-16 15v13l3.79 7.58A8 8 0 0 0 38.94 52zM92 74H78V60h-4v14H60v4h14v14h4V78h14v-4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8.62 14h4.76a2 2 0 0 0 1.79-1.11L17 9.24V6a5.87 5.87 0 0 0-6-6 5.87 5.87 0 0 0-6 6v3.24l1.83 3.65A2 2 0 0 0 8.62 14zM7 6a3.87 3.87 0 0 1 4-4 3.87 3.87 0 0 1 4 4v2.76L13.38 12H8.62L7 8.76zM11 18l-6-3-3.34 1.67A3 3 0 0 0 0 19.35V24h2v-4.65a1 1 0 0 1 .55-.89L5 17.24l6 3 3.16-1.58a6.05 6.05 0 0 1 1.93-3.21zM21 19v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
      }));

    case 'people___profile':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.62 14h4.76a2 2 0 0 0 1.79-1.11L18 9.24V6a5.87 5.87 0 0 0-6-6 5.87 5.87 0 0 0-6 6v3.24l1.83 3.65A2 2 0 0 0 9.62 14zM8 6a3.87 3.87 0 0 1 4-4 3.87 3.87 0 0 1 4 4v2.76L14.38 12H9.62L8 8.76zM21.34 16.67L18 15l-6 3-6-3-3.34 1.67A3 3 0 0 0 1 19.35V24h2v-4.65a1 1 0 0 1 .55-.89L6 17.24l6 3 6-3 2.45 1.22a1 1 0 0 1 .55.89V24h2v-4.65a3 3 0 0 0-1.66-2.68z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M10.24 13h3.52a2 2 0 0 0 1.79-1.11L17 9V6a4.85 4.85 0 0 0-5-5 4.85 4.85 0 0 0-5 5v3l1.45 2.89A2 2 0 0 0 10.24 13zM21.34 16.67L18 15l-6 3-6-3-3.34 1.67A3 3 0 0 0 1 19.35V24h22v-4.65a3 3 0 0 0-1.66-2.68z",
        className: "a"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21.47 26h5.06a4 4 0 0 0 3.58-2.21L32 20v-6.5C32 9 29 6 24 6s-8 3-8 7.5V20l1.89 3.79A4 4 0 0 0 21.47 26zM18 13.5C18 10 20.19 8 24 8s6 2 6 5.5v6l-1.68 3.36A2 2 0 0 1 26.53 24h-5.06a2 2 0 0 1-1.79-1.11L18 19.53zM38.68 31.34L32 28l-8 4-8-4-6.68 3.34A6 6 0 0 0 6 36.71V44h2v-7.29a4 4 0 0 1 2.21-3.58L16 30.24l8 4 8-4 5.79 2.89A4 4 0 0 1 40 36.71V44h2v-7.29a6 6 0 0 0-3.32-5.37z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M21.47 26h5.06a4 4 0 0 0 3.58-2.21L32 20v-6.5C32 9 29 6 24 6s-8 3-8 7.5V20l1.89 3.79A4 4 0 0 0 21.47 26zM38.68 31.34L32 28l-8 4-8-4-6.68 3.34A6 6 0 0 0 6 36.71V44h36v-7.29a6 6 0 0 0-3.32-5.37z",
        className: "a"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42.94 52h10.12a8 8 0 0 0 7.15-4.42L64 40V27c0-9-6-15-16-15s-16 6-16 15v13l3.79 7.58A8 8 0 0 0 42.94 52zM36 27c0-7 4.37-11 12-11s12 4 12 11v12.06l-3.37 6.73A4 4 0 0 1 53.06 48H42.94a4 4 0 0 1-3.57-2.21L36 39.06zM77.37 62.68L64 56l-16 8-16-8-13.37 6.68A12 12 0 0 0 12 73.42V88h4V73.42a8 8 0 0 1 4.42-7.16L32 60.47l16 8 16-8 11.58 5.79A8 8 0 0 1 80 73.42V88h4V73.42a12 12 0 0 0-6.63-10.74z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M42.94 52h10.12a8 8 0 0 0 7.15-4.42L64 40V27c0-9-6-15-16-15s-16 6-16 15v13l3.79 7.58A8 8 0 0 0 42.94 52zM77.37 62.68L64 56l-16 8-16-8-13.37 6.68A12 12 0 0 0 12 73.42V88h72V73.42a12 12 0 0 0-6.63-10.74z",
        className: "a"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9.62 14h4.76a2 2 0 0 0 1.79-1.11L18 9.24V6a5.87 5.87 0 0 0-6-6 5.87 5.87 0 0 0-6 6v3.24l1.83 3.65A2 2 0 0 0 9.62 14zM8 6a3.87 3.87 0 0 1 4-4 3.87 3.87 0 0 1 4 4v2.76L14.38 12H9.62L8 8.76zM21.34 16.67L18 15l-6 3-6-3-3.34 1.67A3 3 0 0 0 1 19.35V24h2v-4.65a1 1 0 0 1 .55-.89L6 17.24l6 3 6-3 2.45 1.22a1 1 0 0 1 .55.89V24h2v-4.65a3 3 0 0 0-1.66-2.68z"
      }));

    case 'people___teamFemale':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6.38 13H4.62a2 2 0 0 1-1.79-1.11L2 10.24V8.5C2 5 4.19 5 5.5 5S9 5 9 8.5v1.74l-.83 1.65A2 2 0 0 1 6.38 13zM4 9.76L4.62 11h1.76L7 9.76V8.5C7 7 6.86 7 5.5 7S4 7 4 8.5zM8.3 16.27c.19-.44.39-.89.62-1.35l.13-.26.12-.19-.93-.47H2.76l-1.1.55A3 3 0 0 0 0 17.24V18h2v-.76a1 1 0 0 1 .55-.9l.69-.34h4.52zM13.19 11.38a3 3 0 0 0 .85 1 3.13 3.13 0 0 0 3.92 0 3 3 0 0 0 .85-1l.86-1.72a3.07 3.07 0 0 0 .33-1.4V6.75C20 3.5 18.5 2 16 2s-4 1.5-4 4.75v1.51a3.07 3.07 0 0 0 .33 1.4zM14 6.75C14 4 15.2 4 16 4s2 0 2 2.75v1.51a1.16 1.16 0 0 1-.12.51L17 10.49a1 1 0 0 1-.31.38 1.13 1.13 0 0 1-1.42 0 1 1 0 0 1-.31-.38l-.86-1.72a1.16 1.16 0 0 1-.1-.51zM22.12 15.24A2.23 2.23 0 0 0 20.26 14H18l-2 4-2-4h-2.26a2.23 2.23 0 0 0-1.86 1.24A15.73 15.73 0 0 0 8 22h2s.14-1.5.22-2a15.64 15.64 0 0 1 1.52-4h1L16 21.89 19.24 16h1a15.64 15.64 0 0 1 1.52 4c.08.5.22 2 .22 2h2a15.73 15.73 0 0 0-1.86-6.76z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5.5 6C4.12 6 3 6 3 8.5V10l.72 1.45a1 1 0 0 0 .9.55h1.76a1 1 0 0 0 .9-.55L8 10V8.5C8 6 6.88 6 5.5 6zM22.12 15.24A2.23 2.23 0 0 0 20.26 14H18l-2 4-2-4h-2.26a2.23 2.23 0 0 0-1.86 1.24A15.73 15.73 0 0 0 8 22h16a15.73 15.73 0 0 0-1.88-6.76zM8.28 14H2.76l-1.1.55A3 3 0 0 0 0 17.24V18h6.62a23.31 23.31 0 0 1 1.47-3.66 3.72 3.72 0 0 0 .19-.34zM16 2c-2.5 0-4 1.5-4 4.75v1.51a3.07 3.07 0 0 0 .33 1.4l.86 1.72a3 3 0 0 0 .85 1 3.13 3.13 0 0 0 3.92 0 3 3 0 0 0 .85-1l.86-1.72a3.07 3.07 0 0 0 .33-1.4V6.75C20 3.5 18.5 2 16 2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M14.94 18.89L13.38 22H8.62l-1.41-2.81a2 2 0 0 1-.21-.9V16a3.87 3.87 0 0 1 4-4 4.08 4.08 0 0 1 4 4.12v1a22 22 0 0 1 .87-4.66A6 6 0 0 0 10.6 10 6.07 6.07 0 0 0 5 16.13v2.16a4 4 0 0 0 .42 1.79l1.41 2.81A2 2 0 0 0 8.62 24h4.76a2 2 0 0 0 1.79-1.11l.57-1.12a6.13 6.13 0 0 1-.8-2.88zM14.58 28a6.07 6.07 0 0 1 2.85-1.78L17 26H5l-3.34 1.67A3 3 0 0 0 0 30.35V34h2v-3.65a1 1 0 0 1 .55-.89L5.47 28h9.11zM21 22.73h1l-1-2a2 2 0 0 1-2-2 20.69 20.69 0 0 1 2.17-9.1 10.17 10.17 0 0 1 .64-1.12l2.69 1.34V5.72a9.75 9.75 0 0 1 12.1.83 11.08 11.08 0 0 1 2.26 3.1A20.59 20.59 0 0 1 41 18.73a2 2 0 0 1-2 2l-1 2h1a4 4 0 0 0 4-4 22.65 22.65 0 0 0-2.39-10 12.45 12.45 0 0 0-2.69-3.65 11.74 11.74 0 0 0-14.57-1 2 2 0 0 0-.85 1.64v.92a2 2 0 0 0-2.38.79c-.25.39-.53.89-.74 1.31a22.7 22.7 0 0 0-2.38 10 4 4 0 0 0 4 3.99z"
      }), React.createElement("path", {
        d: "M28.21 26.58a4 4 0 0 0 3.58 0 10.74 10.74 0 0 0 4.81-4.82 13.18 13.18 0 0 0 1.4-5.91V14a21.16 21.16 0 0 1-9.47-2.23L25 10v4h-3v1.88a13.3 13.3 0 0 0 1.39 5.91 10.81 10.81 0 0 0 4.82 4.79zM27 16v-2.79a27.11 27.11 0 0 0 9 2.67 11.34 11.34 0 0 1-1.18 5 8.87 8.87 0 0 1-3.93 3.92 1.94 1.94 0 0 1-.89.2 2 2 0 0 1-.9-.21 8.9 8.9 0 0 1-3.92-3.92A11.44 11.44 0 0 1 24 16zM40.83 28H35l-5 10-5-10h-5.83a4.57 4.57 0 0 0-3.81 2.48A30.14 30.14 0 0 0 12 44h2a27.94 27.94 0 0 1 3.13-12.61 2.66 2.66 0 0 1 2-1.39h4.59L30 42.5 36.24 30h4.59a2.66 2.66 0 0 1 2 1.39A27.94 27.94 0 0 1 46 44h2a30.14 30.14 0 0 0-3.36-13.52A4.57 4.57 0 0 0 40.83 28z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M15 20.15V19a24.65 24.65 0 0 1 .56-5.13A4.85 4.85 0 0 0 11 11a4.85 4.85 0 0 0-5 5v2.06a3.92 3.92 0 0 0 .42 1.78l1 2.05A2 2 0 0 0 9.24 23h3.52a2 2 0 0 0 1.79-1.11l.5-1a6.3 6.3 0 0 1-.05-.74zM13.42 29.81l.27-.53a6.09 6.09 0 0 1 3.74-3.06L17 26H5l-1.68.84A6 6 0 0 0 0 32.21V34h11.65a30.75 30.75 0 0 1 1.77-4.19zM19.21 23.46L22.3 25l1.7-2.23a10.72 10.72 0 0 0 4.23 3.81 4 4 0 0 0 3.58 0A10.79 10.79 0 0 0 36 22.77L37.7 25l3.09-1.54A4 4 0 0 0 43 19.88v-1.15a22.65 22.65 0 0 0-2.39-10 12.63 12.63 0 0 0-2.69-3.65 11.74 11.74 0 0 0-14.57-1 2 2 0 0 0-.85 1.64v.92a2 2 0 0 0-2.38.79c-.25.39-.53.89-.74 1.31a22.7 22.7 0 0 0-2.38 10v1.15a4 4 0 0 0 2.21 3.57zM24 15h3v-2.79a27.18 27.18 0 0 0 9 2.67v1a11.33 11.33 0 0 1-1.18 5 8.87 8.87 0 0 1-3.93 3.92 2 2 0 0 1-1.78 0 8.87 8.87 0 0 1-3.93-3.92 11.33 11.33 0 0 1-1.18-5zM40.83 28H35l-5 10-5-10h-5.83a4.57 4.57 0 0 0-3.81 2.48A30.14 30.14 0 0 0 12 44h36a30.14 30.14 0 0 0-3.36-13.52A4.57 4.57 0 0 0 40.83 28z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M29.72 42.05a4 4 0 0 1-3.43 2h-4.58a4 4 0 0 1-3.58-2.21l-1.71-3.42a4 4 0 0 1-.42-1.84V32a7.74 7.74 0 0 1 7.84-8 8 8 0 0 1 6.41 3.13c.36-1.55.8-3.07 1.31-4.58A12.12 12.12 0 0 0 12 32.32v4.26a8 8 0 0 0 .84 3.58l1.71 3.42A8 8 0 0 0 21.71 48h4.58a8 8 0 0 0 5.55-2.26 12.2 12.2 0 0 1-2.12-3.69zM28 56a11.94 11.94 0 0 1 8.06-4H12l-3.37 1.68A12 12 0 0 0 2 64.42V70h4v-6a7.94 7.94 0 0 1 4.39-6.74L12.94 56H28zM55 60h8v2h-8zM41 46h1.5l-2-4a4 4 0 0 1-3.5-4 41.33 41.33 0 0 1 4.35-18.22 23.38 23.38 0 0 1 1.26-2.24l5.39 2.7V12a19.47 19.47 0 0 1 24.18 1.67 21 21 0 0 1 4.5 6.12A41.42 41.42 0 0 1 81 38a4 4 0 0 1-3.47 4l-2 4H77a8 8 0 0 0 8-8 45.42 45.42 0 0 0-4.78-20 25.21 25.21 0 0 0-5.38-7.3 23.47 23.47 0 0 0-29.14-2A4 4 0 0 0 44 12v1.84a4 4 0 0 0-4.75 1.58A29.34 29.34 0 0 0 37.77 18 45.46 45.46 0 0 0 33 38a8 8 0 0 0 8 8z"
      }), React.createElement("path", {
        d: "M72.21 44.58A26.51 26.51 0 0 0 75 32.76V29a42.34 42.34 0 0 1-18.94-4.47L49 21v8h-6v3.76a26.37 26.37 0 0 0 2.79 11.82 21.47 21.47 0 0 0 9.63 9.63 8 8 0 0 0 7.16 0 21.47 21.47 0 0 0 9.63-9.63zm-11.42 6.05a3.94 3.94 0 0 1-3.58 0 17.59 17.59 0 0 1-7.84-7.84A22.52 22.52 0 0 1 47 33h6v-5.53l1.27.64A46.51 46.51 0 0 0 71 32.82a22.53 22.53 0 0 1-2.37 10 17.59 17.59 0 0 1-7.84 7.81zM88.29 61a9.21 9.21 0 0 0-7.63-5H69L59 76 49 56H37.34a9.21 9.21 0 0 0-7.63 5A60.45 60.45 0 0 0 23 88h4a55.71 55.71 0 0 1 6.27-25.22A5.25 5.25 0 0 1 37.34 60h9.19L59 85l12.47-25h9.19a5.25 5.25 0 0 1 4.07 2.78A55.71 55.71 0 0 1 91 88h4a60.45 60.45 0 0 0-6.71-27z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M29 40.29V38a48.58 48.58 0 0 1 1.91-13.39A10.1 10.1 0 0 0 24 22a9.71 9.71 0 0 0-10 10v4.11a8.08 8.08 0 0 0 .84 3.58l1.5 3A6 6 0 0 0 21.71 46h4.58a6 6 0 0 0 3.59-1.2 12 12 0 0 1-.88-4.51zM26 59.16A12.93 12.93 0 0 1 36.06 52H12l-3.37 1.68A12 12 0 0 0 2 64.42V70h19.62A69.41 69.41 0 0 1 26 59.16zM80.22 18a25.21 25.21 0 0 0-5.38-7.3 23.46 23.46 0 0 0-29.13-2A4 4 0 0 0 44 12v1.84a4 4 0 0 0-4.75 1.58c-.5.78-1.06 1.78-1.48 2.62A45.32 45.32 0 0 0 33 38v2.29a8 8 0 0 0 4.42 7.16l6.18 3.09 3.17-4.23a21.54 21.54 0 0 0 8.65 7.9 8 8 0 0 0 7.16 0 21.54 21.54 0 0 0 8.65-7.9l3.17 4.23 6.18-3.09A8 8 0 0 0 85 40.29V38a45.42 45.42 0 0 0-4.78-20zM53 25.47a54 54 0 0 0 18 5.35v1.94a22.52 22.52 0 0 1-2.37 10 17.59 17.59 0 0 1-7.84 7.84 3.94 3.94 0 0 1-3.58 0 17.59 17.59 0 0 1-7.84-7.84 22.52 22.52 0 0 1-2.37-10V31h6zM55 60h8v2h-8z"
      }), React.createElement("path", {
        d: "M95 88a60.45 60.45 0 0 0-6.71-27 9.21 9.21 0 0 0-7.63-5H69L59 76 49 56H37.34a9.21 9.21 0 0 0-7.63 5A60.45 60.45 0 0 0 23 88z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6.38 13H4.62a2 2 0 0 1-1.79-1.11L2 10.24V8.5C2 5 4.19 5 5.5 5S9 5 9 8.5v1.74l-.83 1.65A2 2 0 0 1 6.38 13zM4 9.76L4.62 11h1.76L7 9.76V8.5C7 7 6.86 7 5.5 7S4 7 4 8.5zM8.3 16.27c.19-.44.39-.89.62-1.35l.13-.26.12-.19-.93-.47H2.76l-1.1.55A3 3 0 0 0 0 17.24V18h2v-.76a1 1 0 0 1 .55-.9l.69-.34h4.52zM13.19 11.38a3 3 0 0 0 .85 1 3.13 3.13 0 0 0 3.92 0 3 3 0 0 0 .85-1l.86-1.72a3.07 3.07 0 0 0 .33-1.4V6.75C20 3.5 18.5 2 16 2s-4 1.5-4 4.75v1.51a3.07 3.07 0 0 0 .33 1.4zM14 6.75C14 4 15.2 4 16 4s2 0 2 2.75v1.51a1.16 1.16 0 0 1-.12.51L17 10.49a1 1 0 0 1-.31.38 1.13 1.13 0 0 1-1.42 0 1 1 0 0 1-.31-.38l-.86-1.72a1.16 1.16 0 0 1-.1-.51zM22.12 15.24A2.23 2.23 0 0 0 20.26 14H18l-2 4-2-4h-2.26a2.23 2.23 0 0 0-1.86 1.24A15.73 15.73 0 0 0 8 22h2s.14-1.5.22-2a15.64 15.64 0 0 1 1.52-4h1L16 21.89 19.24 16h1a15.64 15.64 0 0 1 1.52 4c.08.5.22 2 .22 2h2a15.73 15.73 0 0 0-1.86-6.76z"
      }));

    case 'people___teamMale':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 4c1.93 0 2 .07 2 1.75v2.78L17.26 10h-2.52L14 8.53V5.75C14 4.07 14.07 4 16 4m0-2c-2.5 0-4 .5-4 3.75V9l1 1.89A2 2 0 0 0 14.74 12h2.52a2 2 0 0 0 1.79-1.11L20 9V5.75C20 2.5 18.5 2 16 2zM6.38 13H4.62a2 2 0 0 1-1.79-1.11L2 10.24V8.5C2 5 4.19 5 5.5 5S9 5 9 8.5v1.74l-.83 1.65A2 2 0 0 1 6.38 13zM4 9.76L4.62 11h1.76L7 9.76V8.5C7 7 6.86 7 5.5 7S4 7 4 8.5zM9 14.39L8.24 14H2.76l-1.65.83A2 2 0 0 0 0 16.62V18h2v-1.38L3.24 16h4.22A4 4 0 0 1 9 14.39zM22.34 15.17L20 14h-2l-1 2h-2l-1-2h-2l-2.34 1.17A3 3 0 0 0 8 17.85V22h2v-4.15a1 1 0 0 1 .55-.89l1.92-1h.29l.45.89.55 1.15h4.48l.55-1.11.45-.89h.29l1.92 1a1 1 0 0 1 .55.89V22h2v-4.15a3 3 0 0 0-1.66-2.68z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 2c-2.5 0-4 .5-4 3.75V9l1 1.89A2 2 0 0 0 14.74 12h2.52a2 2 0 0 0 1.79-1.11L20 9V5.75C20 2.5 18.5 2 16 2zM5.5 6C4.12 6 3 6 3 8.5V10l.72 1.45a1 1 0 0 0 .9.55h1.76a1 1 0 0 0 .9-.55L8 10V8.5C8 6 6.88 6 5.5 6zM20 14h-2l-1 2h-2l-1-2h-2l-2.34 1.17A3 3 0 0 0 8 17.85V22h16v-4.15a3 3 0 0 0-1.66-2.68L20 14zM6 17.85A5 5 0 0 1 7.83 14H2.76l-1.65.83A2 2 0 0 0 0 16.62V18h6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M13.38 24H8.62a2 2 0 0 1-1.79-1.11L5 19.24V16a5.87 5.87 0 0 1 6-6 5.87 5.87 0 0 1 6 6v3.24l-1.83 3.65A2 2 0 0 1 13.38 24zM7 18.76L8.62 22h4.76L15 18.76V16a3.87 3.87 0 0 0-4-4 3.87 3.87 0 0 0-4 4zM16.53 28l1.53.77.36-.22 1.84-.92L17 26H5l-3.34 1.67A3 3 0 0 0 0 30.35V34h2v-3.65a1 1 0 0 1 .55-.89L5.47 28h11.06zM24 19.06a3.92 3.92 0 0 0 .42 1.78l1.47 2.95A4 4 0 0 0 29.47 26h5.06a4 4 0 0 0 3.58-2.21l1.47-2.95a3.92 3.92 0 0 0 .42-1.78V18l2-2v-2c0-3.95-1-6.34-2.41-7.79L38 7V5.05a13.3 13.3 0 0 0-6-1c-4.84 0-10 .77-10 10v2l2 2zm14 0a2 2 0 0 1-.21.89l-1.47 2.94A2 2 0 0 1 34.53 24h-5.06a2 2 0 0 1-1.79-1.11L26.21 20a2 2 0 0 1-.21-.89v-4.99l3.55-1.78 1.56 3.11A1 1 0 0 0 32 16a.93.93 0 0 0 .45-.11L38 13.12zM32 6c3.56 0 6.45.38 7.53 4.12l-7.08 3.54-1.56-3.11a1 1 0 0 0-1.34-.44L24 12.86C24.38 6.54 27.71 6 32 6zM44.68 30.34L40 28h-3l-2 4h-6l-2-4h-3l-4.68 2.34A6 6 0 0 0 16 35.71V44h2v-8.29a4 4 0 0 1 2.21-3.58L24.47 30h1.29l2 4h8.48l2-4h1.29l4.26 2.13A4 4 0 0 1 46 35.71V44h2v-8.29a6 6 0 0 0-3.32-5.37z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M11 11a4.85 4.85 0 0 0-5 5v3l1.45 2.89A2 2 0 0 0 9.24 23h3.52a2 2 0 0 0 1.79-1.11L16 19v-3a4.85 4.85 0 0 0-5-5zM18.42 28.55l1.84-.92L17 26H5l-3.34 1.67A3 3 0 0 0 0 30.35V34h14.2a8 8 0 0 1 4.22-5.45z"
      }), React.createElement("path", {
        d: "M44.68 30.34L40 28h-3l-2 4h-6l-2-4h-3l-4.68 2.34A6 6 0 0 0 16 35.71V44h32v-8.29a6 6 0 0 0-3.32-5.37z",
        className: "a"
      }), React.createElement("path", {
        d: "M39.59 6.21L38 7V5.05a13.3 13.3 0 0 0-6-1c-4.84 0-10 .77-10 10v2l2 2v1.06a3.92 3.92 0 0 0 .42 1.78l1.47 2.95A4 4 0 0 0 29.47 26h5.06a4 4 0 0 0 3.58-2.21l1.47-2.95a3.92 3.92 0 0 0 .42-1.78V18l2-2v-2c0-3.95-.95-6.34-2.41-7.79zM37.79 20l-1.47 2.94A2 2 0 0 1 34.53 24h-5.06a2 2 0 0 1-1.79-1.11L26.21 20a2 2 0 0 1-.21-.89v-4.99l3.55-1.78 1.56 3.11A1 1 0 0 0 32 16a.93.93 0 0 0 .45-.11L38 13.12v5.94a2 2 0 0 1-.21.94z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M28.15 48h-8.3a5 5 0 0 1-4.47-2.76L12 38.47V32a11.74 11.74 0 0 1 12-12 11.74 11.74 0 0 1 12 12v6.47l-3.38 6.77A5 5 0 0 1 28.15 48zM16 37.53l3 5.92a1 1 0 0 0 .89.55h8.3a1 1 0 0 0 .89-.55l3-5.92V32a7.73 7.73 0 0 0-8-8 7.73 7.73 0 0 0-8 8zM35.06 56l1 .5 4.47-2.24L36 52H12l-6.68 3.34A6 6 0 0 0 2 60.71V70h4v-9.29a2 2 0 0 1 1.11-1.79L12.94 56zM87.37 60.68L78 56h-6l-4 8H56l-4-8h-6l-9.37 4.68A12 12 0 0 0 30 71.42V88h4V71.42a8 8 0 0 1 4.42-7.16L46.94 60h2.59l4 8h16.94l4-8h2.59l8.52 4.26A8 8 0 0 1 90 71.42V88h4V71.42a12 12 0 0 0-6.63-10.74z"
      }), React.createElement("path", {
        d: "M58 58h8v2h-8zM46 38.11a8.08 8.08 0 0 0 .84 3.58l2.95 5.89A8 8 0 0 0 56.94 52h10.12a8 8 0 0 0 7.15-4.42l3-5.89a8.08 8.08 0 0 0 .79-3.58V37l4-4v-5c0-7.89-1.89-12.69-4.81-15.59L74 14v-3.9C70.47 8.29 66.17 8 62 8c-9.68 0-20 1.55-20 20v5l4 4zm28 0a4.09 4.09 0 0 1-.42 1.79l-3 5.89A4 4 0 0 1 67.06 48H56.94a4 4 0 0 1-3.57-2.21l-2.95-5.89a4.09 4.09 0 0 1-.42-1.79v-9.87l7.11-3.56 3.1 6.21a2 2 0 0 0 2.68.9L74 26.24zM62 12c7.12 0 12.92.73 15.09 8.22l-14.2 7.1-3.1-6.21a2 2 0 0 0-2.68-.9l-11 5.52C46.76 13.06 53.42 12 62 12z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("defs", null), React.createElement("path", {
        d: "M24 22a9.71 9.71 0 0 0-10 10v6l2.89 5.79A4 4 0 0 0 20.47 46h7.06a4 4 0 0 0 3.58-2.21L34 38v-6a9.71 9.71 0 0 0-10-10zM34.84 57.11l5.69-2.85L36 52H12l-6.68 3.34A6 6 0 0 0 2 60.71V70h24.07a15.9 15.9 0 0 1 8.77-12.89z"
      }), React.createElement("path", {
        d: "M87.37 60.68L78 56h-6l-4 8H56l-4-8h-6l-9.37 4.68A12 12 0 0 0 30 71.42V88h64V71.42a12 12 0 0 0-6.63-10.74z",
        className: "a"
      }), React.createElement("path", {
        d: "M58 58h8v2h-8zM77.19 12.41L74 14v-3.9C70.47 8.29 66.17 8 62 8c-9.68 0-20 1.55-20 20v5l4 4v1.11a8.08 8.08 0 0 0 .84 3.58l2.95 5.89A8 8 0 0 0 56.94 52h10.12a8 8 0 0 0 7.15-4.42l3-5.89a8.08 8.08 0 0 0 .79-3.58V37l4-4v-5c0-7.89-1.89-12.69-4.81-15.59zM74 38.11a4.09 4.09 0 0 1-.42 1.79l-3 5.89A4 4 0 0 1 67.06 48H56.94a4 4 0 0 1-3.57-2.21l-2.95-5.89a4.09 4.09 0 0 1-.42-1.79V26l7.11-3.32 3.1 6.21a2 2 0 0 0 2.68.9L74 24z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 4c1.93 0 2 .07 2 1.75v2.78L17.26 10h-2.52L14 8.53V5.75C14 4.07 14.07 4 16 4m0-2c-2.5 0-4 .5-4 3.75V9l1 1.89A2 2 0 0 0 14.74 12h2.52a2 2 0 0 0 1.79-1.11L20 9V5.75C20 2.5 18.5 2 16 2zM6.38 13H4.62a2 2 0 0 1-1.79-1.11L2 10.24V8.5C2 5 4.19 5 5.5 5S9 5 9 8.5v1.74l-.83 1.65A2 2 0 0 1 6.38 13zM4 9.76L4.62 11h1.76L7 9.76V8.5C7 7 6.86 7 5.5 7S4 7 4 8.5zM9 14.39L8.24 14H2.76l-1.65.83A2 2 0 0 0 0 16.62V18h2v-1.38L3.24 16h4.22A4 4 0 0 1 9 14.39zM22.34 15.17L20 14h-2l-1 2h-2l-1-2h-2l-2.34 1.17A3 3 0 0 0 8 17.85V22h2v-4.15a1 1 0 0 1 .55-.89l1.92-1h.29l.45.89.55 1.15h4.48l.55-1.11.45-.89h.29l1.92 1a1 1 0 0 1 .55.89V22h2v-4.15a3 3 0 0 0-1.66-2.68z"
      }));

    case 'people___wheelchair':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.55 19.11l-1.1.55-2.28-4.55A2 2 0 0 0 14.38 14h-2.76l2.72-5.45-4.45-2.22a2 2 0 0 0-1.78 0L4.55 8.11l.9 1.78L9 8.12l2.66 1.33-1.83 3.66A2 2 0 0 0 11.62 16h2.76l3.17 6.34 2.9-1.45zM16 7a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
      }), React.createElement("path", {
        d: "M11.86 18A4 4 0 1 1 8 13v-2a6 6 0 1 0 5.65 8l-.5-1z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.33 18.16l-1.66.84-2.05-4.11a2.5 2.5 0 0 0-2.24-1.38h-2L15 8.33l-4.88-2.45a2.52 2.52 0 0 0-2.24 0L4.33 7.66l1.34 2.68L9 8.68l2 1-1.62 3.2a2.5 2.5 0 0 0 2.24 3.62h2.45l3.26 6.5 4.34-2.17z"
      }), React.createElement("circle", {
        cx: "16",
        cy: "4",
        r: "3"
      }), React.createElement("path", {
        d: "M11.34 18A3.49 3.49 0 1 1 8 13.5v-3a6.5 6.5 0 1 0 6 9.11L13.15 18z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 34.5A10 10 0 1 1 16 24c.33 0 .67 0 1 .05l1-1.88a12.77 12.77 0 0 0-2-.17 12 12 0 1 0 11.54 15.28l-1.39-2.78z"
      }), React.createElement("path", {
        d: "M42.22 40.21A4 4 0 0 0 38.65 38h-1.53l-4.28-8.55a4 4 0 0 0-1.79-1.79l-5.21-2.61 4-8-9-4.74a4 4 0 0 0-3.65 0l-8.88 4.42 4 4 6.18-3.09 3.18 1.77-3.77 7.25a4 4 0 0 0 3.55 5.85h5.94l6.67 13.34 8.79-4.39zM35 43.16L28.62 30.5h-7.18a2 2 0 0 1-1.77-2.92l4.67-9-5.82-3.23-5.82 2.93-1-1 6.38-3.19a2 2 0 0 1 1.83 0l7.27 3.83-4 8 7 3.5a2 2 0 0 1 .89.89L35.88 40h2.77a2 2 0 0 1 1.42.6zM32 15a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10a4 4 0 1 1-4 4 4 4 0 0 1 4-4z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M26 34.5A10 10 0 1 1 16 24c.33 0 .67 0 1 .05l1-1.88a12.77 12.77 0 0 0-2-.17 12 12 0 1 0 11.54 15.28l-1.39-2.78z"
      }), React.createElement("path", {
        d: "M41.78 40.43a3.49 3.49 0 0 0-3.13-1.93h-1.84l-4.42-8.83a3.46 3.46 0 0 0-1.56-1.56l-5.66-2.83 4-8-8.58-4.52a3.52 3.52 0 0 0-3.19 0l-8.24 4.1 3.24 3.25 6.09-3 3.84 2.13-4 7.69A3.49 3.49 0 0 0 21.44 32h6.25l6.59 13.17 7.89-4z"
      }), React.createElement("circle", {
        cx: "32",
        cy: "9",
        r: "5"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 51a17 17 0 0 0-17 17h2a15 15 0 0 1 15-15z"
      }), React.createElement("path", {
        d: "M52 69a20 20 0 1 1-20-21c.67 0 1.33 0 2 .1l2-3.77a24.58 24.58 0 0 0-4-.33 24 24 0 1 0 23.08 30.58L52.29 69z"
      }), React.createElement("path", {
        d: "M49 69h-2a15 15 0 0 1-15 14v2a17 17 0 0 0 17-16z"
      }), React.createElement("path", {
        d: "M84.45 80.42A8 8 0 0 0 77.29 76h-3.05l-8.56-17.11a8.11 8.11 0 0 0-3.57-3.57l-10.43-5.21 8-16-18-9.48a8.05 8.05 0 0 0-7.31-.07l-17.75 8.89 8 8L37 35.26l6.38 3.54-7.59 14.51A8 8 0 0 0 42.88 65h11.88l13.35 26.68 17.57-8.79zm-14.56 5.9L57.24 61H42.88a4 4 0 0 1-3.55-5.85l9.34-17.95-11.62-6.46-11.65 5.83-2-2 12.76-6.38a4 4 0 0 1 3.65 0l14.54 7.66-8 16 14 7a4.08 4.08 0 0 1 1.79 1.79L71.76 80h5.53a4 4 0 0 1 2.85 1.19zM64 30a12 12 0 1 0-12-12 12 12 0 0 0 12 12zm0-20a8 8 0 1 1-8 8 8 8 0 0 1 8-8z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 51a17 17 0 0 0-17 17h2a15 15 0 0 1 15-15z"
      }), React.createElement("path", {
        d: "M52 69a20 20 0 1 1-20-21c.67 0 1.33 0 2 .1l2-3.77a24.58 24.58 0 0 0-4-.33 24 24 0 1 0 23.08 30.58L52.29 69z"
      }), React.createElement("path", {
        d: "M49 69h-2a15 15 0 0 1-15 14v2a17 17 0 0 0 17-16z"
      }), React.createElement("path", {
        d: "M83.55 80.87A7 7 0 0 0 77.29 77h-3.67l-8.83-17.66a7.07 7.07 0 0 0-3.13-3.13l-11.32-5.66 8-16-17.14-9a7 7 0 0 0-6.39-.07l-16.5 8.25 6.49 6.49L37 34.13l7.68 4.27-8 15.37A7 7 0 0 0 42.88 64h12.5l13.17 26.34 15.79-7.89z"
      }), React.createElement("circle", {
        cx: "64",
        cy: "18",
        r: "10"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M19.55 19.11l-1.1.55-2.28-4.55A2 2 0 0 0 14.38 14h-2.76l2.72-5.45-4.45-2.22a2 2 0 0 0-1.78 0L4.55 8.11l.9 1.78L9 8.12l2.66 1.33-1.83 3.66A2 2 0 0 0 11.62 16h2.76l3.17 6.34 2.9-1.45zM16 7a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
      }), React.createElement("path", {
        d: "M11.86 18A4 4 0 1 1 8 13v-2a6 6 0 1 0 5.65 8l-.5-1z"
      }));

    case 'social___cobablog':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm10.8 5a2.49 2.49 0 0 0-.8.1 2.76 2.76 0 0 0-.9.7 4.37 4.37 0 0 1-.7.8.1.1 0 0 0 .1.1c.5.8 1.4 2.4 1.4 2.4s.9 1.6 1.4 2.4a3.92 3.92 0 0 1 .4.9 6.15 6.15 0 0 1 .3 1.1v.1l1.8-3.2zm.5 8.5a9.25 9.25 0 0 0-.3-1H9.2a4.14 4.14 0 0 1-1-.1c-.2 0-1-.2-1.1-.2H7l1.8 3.2h6.4v-.1a1.17 1.17 0 0 0 .2-.7 2.16 2.16 0 0 0-.1-1.1zM12 7.9a6.53 6.53 0 0 1 .7-.8l.1-.1H9.2l-3.1 5.4-.1.1v.1a2.25 2.25 0 0 0 .5.5 1.78 1.78 0 0 0 1 .4 5.76 5.76 0 0 1 1 .2c0-.1.1-.1.1-.2.5-.8 1.4-2.4 1.4-2.4s.9-1.6 1.4-2.4a8 8 0 0 1 .6-.8z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm21.6 10a5 5 0 0 0-1.6.2 5.51 5.51 0 0 0-1.8 1.4 8.74 8.74 0 0 1-1.4 1.6.2.2 0 0 0 .2.2c1 1.6 2.8 4.8 2.8 4.8s1.8 3.2 2.8 4.8a7.84 7.84 0 0 1 .8 1.8A12.3 12.3 0 0 1 32 31v.2l3.6-6.4zm1 17a18.51 18.51 0 0 0-.6-2H18.4a8.28 8.28 0 0 1-2-.2c-.4 0-2-.4-2.2-.4H14l3.6 6.4h12.8v-.2a2.33 2.33 0 0 0 .4-1.4 4.32 4.32 0 0 0-.2-2.2zM24 15.8a13.06 13.06 0 0 1 1.4-1.6l.2-.2h-7.2l-6.2 10.8-.2.2v.2a4.5 4.5 0 0 0 1 1 3.55 3.55 0 0 0 2 .8 11.51 11.51 0 0 1 2 .4c0-.2.2-.2.2-.4 1-1.6 2.8-4.8 2.8-4.8s1.8-3.2 2.8-4.8a16 16 0 0 1 1.2-1.6z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm43.2 20a9.94 9.94 0 0 0-3.2.4 11 11 0 0 0-3.6 2.8c0 .4-2 2.4-2.8 3.2a.39.39 0 0 0 .4.4c2 3.2 5.6 9.6 5.6 9.6s3.6 6.4 5.6 9.6a15.68 15.68 0 0 1 1.6 3.6A24.6 24.6 0 0 1 64 62v.4l7.2-12.8zm2 34a37 37 0 0 0-1.2-4H36.8a16.57 16.57 0 0 1-4-.4c-.8 0-4-.8-4.4-.8H28l7.2 12.8h25.6v-.4a4.66 4.66 0 0 0 .8-2.8c.4-1.2 0-2.8-.4-4.4zM48 31.6a26.12 26.12 0 0 1 2.8-3.2l.4-.4H36.8L24.4 49.6l-.4.4v.4a9 9 0 0 0 2 2 7.11 7.11 0 0 0 4 1.6 23 23 0 0 1 4 .8c0-.4.4-.4.4-.8 2-3.2 5.6-9.6 5.6-9.6s3.6-6.4 5.6-9.6a31.9 31.9 0 0 1 2.4-3.2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'social___facebook':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm10.5 18v-6.4h2.1l.3-2.5h-2.4V9.5c0-.7.2-1.2 1.2-1.2H17V6.1c-.2 0-1-.1-1.8-.1a3 3 0 0 0-3.1 3.3v1.8H10v2.5h2.1V20z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm21 36V27.2h4.2l.6-5H29V19c0-1.4.4-2.4 2.4-2.4H34v-4.4c-.4 0-2-.2-3.6-.2-3.6 0-6.2 2.4-6.2 6.6v3.6H20v5h4.2V40z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm42 72V54.4h8.4l1.2-10H58V38c0-2.8.8-4.8 4.8-4.8H68v-8.8c-.8 0-4-.4-7.2-.4-7.2 0-12.4 4.8-12.4 13.2v7.2H40v10h8.4V80z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'social___instagram':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm13 10a5 5 0 1 0-5 5 5 5 0 0 0 5-5zm-5-3a3 3 0 1 0 3 3 3.08 3.08 0 0 0-3-3zm4-3a1 1 0 0 0 2 0 1 1 0 0 0-2 0z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm26 20a10 10 0 1 0-10 10 9.9 9.9 0 0 0 10-10zm-10-6a6 6 0 1 0 6 6 6.15 6.15 0 0 0-6-6zm8-6a2 2 0 0 0 4 0 2 2 0 0 0-4 0z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm52 40a20 20 0 1 0-20 20 19.81 19.81 0 0 0 20-20zM48 36a12 12 0 1 0 12 12 12.3 12.3 0 0 0-12-12zm16-12a4 4 0 0 0 8 0 4 4 0 0 0-8 0z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'social___linkedin':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm11 7.3a2.38 2.38 0 0 0-2.4 1.3V9.4H9.9V17h2.7v-4.1c0-.2 0-.5.1-.6a1.32 1.32 0 0 1 1.3-.9c.9 0 1.4.7 1.4 1.7V17h2.7v-4.2c-.1-2.4-1.4-3.5-3.1-3.5zM8.5 17V9.4H6.1V17zM7.3 6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 1 0 0-2.4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm22 14.6c-2.8 0-4.4 1.4-4.8 2.6v-2.4h-5.4V34h5.4v-8.2c0-.4 0-1 .2-1.2a2.65 2.65 0 0 1 2.6-1.8c1.8 0 2.8 1.4 2.8 3.4V34h5.4v-8.4c-.2-4.8-2.8-7-6.2-7zM17 34V18.8h-4.8V34zm-2.4-22a2.41 2.41 0 1 0 0 4.8 2.41 2.41 0 1 0 0-4.8z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm44 29.2c-5.6 0-8.8 2.8-9.6 5.2v-4.8H39.6V68h10.8V51.6c0-.8 0-2 .4-2.4a5.3 5.3 0 0 1 5.2-3.6c3.6 0 5.6 2.8 5.6 6.8V68h10.8V51.2c-.4-9.6-5.6-14-12.4-14zM34 68V37.6h-9.6V68zm-4.8-44C26 24 24 26 24 28.8s2 4.8 5.2 4.8 5.2-2 5.2-4.8-2-4.8-5.2-4.8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'social___twitter':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm12.9 5.9A2.2 2.2 0 0 0 15 7a2.69 2.69 0 0 0-2.7 2.7 1.27 1.27 0 0 0 .1.6 7.37 7.37 0 0 1-5.5-2.9 4.19 4.19 0 0 0-.4 1.5 2.94 2.94 0 0 0 1.2 2.3 2.66 2.66 0 0 1-1.2-.3 2.79 2.79 0 0 0 2.1 2.7 1.7 1.7 0 0 1-.7.1h-.5a2.58 2.58 0 0 0 2.5 1.9 5.55 5.55 0 0 1-3.3 1.2H6a7.3 7.3 0 0 0 4.1 1.2 7.68 7.68 0 0 0 7.6-7.8v-.4A5.71 5.71 0 0 0 19 8.4a4.19 4.19 0 0 1-1.5.4 2.55 2.55 0 0 0 1.2-1.5c-.6.2-1.1.4-1.8.6z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm25.8 11.8A4.39 4.39 0 0 0 30 14a5.38 5.38 0 0 0-5.4 5.4 2.54 2.54 0 0 0 .2 1.2 14.73 14.73 0 0 1-11-5.8 8.38 8.38 0 0 0-.8 3 5.87 5.87 0 0 0 2.4 4.6 5.33 5.33 0 0 1-2.4-.6 5.58 5.58 0 0 0 4.2 5.4 3.4 3.4 0 0 1-1.4.2h-1a5.16 5.16 0 0 0 5 3.8 11.09 11.09 0 0 1-6.6 2.4H12a14.6 14.6 0 0 0 8.2 2.4c9.8 0 15.2-8.4 15.2-15.6v-.8a11.41 11.41 0 0 0 2.6-2.8 8.38 8.38 0 0 1-3 .8 5.11 5.11 0 0 0 2.4-3c-1.2.4-2.2.8-3.6 1.2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm51.6 23.6C66 29.2 63.2 28 60 28a10.76 10.76 0 0 0-10.8 10.8 5.07 5.07 0 0 0 .4 2.4 29.47 29.47 0 0 1-22-11.6 16.76 16.76 0 0 0-1.6 6 11.74 11.74 0 0 0 4.8 9.2 10.65 10.65 0 0 1-4.8-1.2 11.16 11.16 0 0 0 8.4 10.8 6.81 6.81 0 0 1-2.8.4h-2a10.32 10.32 0 0 0 10 7.6 22.19 22.19 0 0 1-13.2 4.8H24A29.19 29.19 0 0 0 40.4 72C60 72 70.8 55.2 70.8 40.8v-1.6a22.82 22.82 0 0 0 5.2-5.6 16.76 16.76 0 0 1-6 1.6 10.22 10.22 0 0 0 4.8-6c-2.4.8-4.4 1.6-7.2 2.4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'social___xing':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm5.3 11.9l2-3.3L9.8 8H7.3l1.5 2.6-2 3.2h2.5zm5.2-7.2L11 12.8l2.5 4.4h2.7l-2.5-4.4 3.5-6.1z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm10.6 23.8l4-6.6-3-5.2h-5l3 5.2-4 6.4h5zM29 13.4l-7 12.2 5 8.8h5.4l-5-8.8 7-12.2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm21.2 47.6l8-13.2-6-10.4h-10l6 10.4-8 12.8h10zM58 26.8L44 51.2l10 17.6h10.8l-10-17.6 14-24.4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'social___youtube':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm5 14l8-4-8-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.5 17.31h2v2.34A5.09 5.09 0 0 1 11.1 17c3.25 0 5.15 2.18 5.15 5.38v8.35h-2V22.9c0-2.5-1.35-4.06-3.72-4.06a4 4 0 0 0-4 4.21v7.7h-2zM29.8 10h1.84L19.58 34.08h-1.85zm11.13 15.81v-1.3a14 14 0 0 0-4-.57c-2.52 0-3.92 1.09-3.92 2.78v.05c0 1.69 1.56 2.68 3.38 2.68 2.47 0 4.5-1.51 4.5-3.64m-9.91 1v-.01c0-2.84 2.34-4.35 5.75-4.35a14.2 14.2 0 0 1 4.17.55v-.47c0-2.42-1.48-3.67-4-3.67a9.42 9.42 0 0 0-4.09 1l-.59-1.64a11.14 11.14 0 0 1 4.88-1.12 5.91 5.91 0 0 1 4.35 1.49 5.3 5.3 0 0 1 1.37 3.92v8.22H40.9v-2A5.91 5.91 0 0 1 36 31c-2.5 0-5-1.43-5-4.19"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M8 4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm10 28l16-8-16-8z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M9 34.61h4v4.68A10.19 10.19 0 0 1 22.21 34c6.5 0 10.3 4.37 10.3 10.77V61.5h-4V45.79c0-5-2.7-8.11-7.44-8.11S13 41.06 13 46.11V61.5H9zM59.6 20h3.69L39.16 68.15h-3.69zm22.25 31.62V49A28.06 28.06 0 0 0 74 47.87c-5 0-7.85 2.19-7.85 5.57v.1c0 3.38 3.12 5.36 6.76 5.36 4.94 0 9-3 9-7.28M62 53.7v-.11c0-5.66 4.68-8.68 11.49-8.68a28.78 28.78 0 0 1 8.27 1.14v-.93c0-4.84-3-7.33-8-7.33a18.74 18.74 0 0 0-8.16 2l-1.2-3.27a22.13 22.13 0 0 1 9.78-2.24c3.79 0 6.71 1 8.68 3 1.82 1.82 2.76 4.42 2.76 7.86V61.5H81.8v-4.06a11.76 11.76 0 0 1-9.72 4.63c-5 0-10-2.86-10-8.37"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8h64a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm20 56l32-16-32-16z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M2.5 8.65h1v1.17a2.56 2.56 0 0 1 2.3-1.31 2.46 2.46 0 0 1 2.58 2.69v4.17h-1v-3.92a1.79 1.79 0 0 0-1.86-2 2 2 0 0 0-2 2.11v3.84h-1zM15.15 5h.92L10 17h-.88zm5.56 7.9v-.65a7.07 7.07 0 0 0-2-.28c-1.26 0-2 .54-2 1.39 0 .84.78 1.33 1.69 1.33a2 2 0 0 0 2.25-1.82m-5 .52c0-1.42 1.17-2.17 2.87-2.17a7.14 7.14 0 0 1 2.07.28v-.23c0-1.21-.74-1.83-2-1.83a4.62 4.62 0 0 0-2 .49l-.3-.82a5.52 5.52 0 0 1 2.44-.56A3 3 0 0 1 21 9.3a2.66 2.66 0 0 1 .69 2v4.1h-1v-1a3 3 0 0 1-2.43 1.16 2.27 2.27 0 0 1-2.51-2.1"
      }));

    case 'symbols___asterisk':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 11h-6.27l3.14-5.43-1.74-1L12 10 8.87 4.57l-1.74 1L10.27 11H4v2h6.27l-3.14 5.43 1.74 1L12 14l3.13 5.43 1.74-1L13.73 13H20v-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 10h-4.54l2.27-3.93-3.46-2L12 8 9.73 4.07l-3.46 2L8.54 10H4v4h4.54l-2.27 3.93 3.46 2L12 16l2.27 3.93 3.46-2L15.46 14H20v-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40 23H25.73l7.14-12.36-1.74-1L24 22 16.87 9.64l-1.74 1L22.27 23H8v2h14.27l-7.14 12.36 1.74 1L24 26l7.13 12.36 1.74-1L25.73 25H40v-2z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M40 22H27.46l6.27-10.86-3.46-2L24 20 17.73 9.14l-3.46 2L20.54 22H8v4h12.54l-6.27 10.86 3.46 2L24 28l6.27 10.86 3.46-2L27.46 26H40v-4z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80 46H51.46l14.27-24.71-3.46-2L48 44 33.73 19.29l-3.46 2L44.54 46H16v4h28.54L30.27 74.71l3.46 2L48 52l14.27 24.71 3.46-2L51.46 50H80v-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M80 44H54.93l12.53-21.71-6.92-4L48 40 35.46 18.29l-6.92 4L41.07 44H16v8h25.07L28.54 73.71l6.92 4L48 56l12.54 21.71 6.92-4L54.93 52H80v-8z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20 11h-6.27l3.14-5.43-1.74-1L12 10 8.87 4.57l-1.74 1L10.27 11H4v2h6.27l-3.14 5.43 1.74 1L12 14l3.13 5.43 1.74-1L13.73 13H20v-2z"
      }));

    case 'symbols___error':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 9v4h2V8h-2v1z"
      }), React.createElement("path", {
        d: "M23 18.1l-9.12-16a2.15 2.15 0 0 0-3.74 0L1 18.1A1.94 1.94 0 0 0 2.7 21h18.6a1.94 1.94 0 0 0 1.7-2.9zM2.8 19l9.07-15.92a.15.15 0 0 1 .26 0L21.2 19z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "16.5",
        r: "1.5"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 18.1l-9.12-16a2.15 2.15 0 0 0-3.74 0L1 18.1A1.94 1.94 0 0 0 2.7 21h18.6a1.94 1.94 0 0 0 1.7-2.9zM11 9V8h2v5h-2zm1 9a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 18z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 37.2l-18.23-32a4.31 4.31 0 0 0-7.48 0L2 37.2A3.88 3.88 0 0 0 5.4 43h37.2a3.88 3.88 0 0 0 3.4-5.8zM44.28 40a1.87 1.87 0 0 1-1.68 1H5.4a1.89 1.89 0 0 1-1.64-2.81L22 6.16a2.3 2.3 0 0 1 4 0l18.24 32a1.85 1.85 0 0 1 .04 1.84z"
      }), React.createElement("path", {
        d: "M23 16h2v13h-2z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "35",
        r: "2"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 37.2l-18.23-32a4.31 4.31 0 0 0-7.48 0L2 37.2a3.84 3.84 0 0 0-.1 3.65A3.87 3.87 0 0 0 5.4 43h37.2a3.88 3.88 0 0 0 3.4-5.8zM23 16h2v13h-2zm1 21a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 74.4L55.47 10.34a8.6 8.6 0 0 0-14.94 0L4.05 74.4A7.76 7.76 0 0 0 10.8 86h74.4A7.76 7.76 0 0 0 92 74.4zm-3.38 5.52A3.75 3.75 0 0 1 85.2 82H10.8a3.76 3.76 0 0 1-3.27-5.62L44 12.32a4.61 4.61 0 0 1 8 0l36.47 64.06a3.76 3.76 0 0 1 .1 3.54z"
      }), React.createElement("path", {
        d: "M46 32h4v26h-4z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "70",
        r: "4"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M92 74.4L55.47 10.34a8.6 8.6 0 0 0-14.94 0L4.05 74.4A7.76 7.76 0 0 0 10.8 86h74.4A7.76 7.76 0 0 0 92 74.4zM46 32h4v26h-4zm2 42a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 9v4h2V8h-2v1z"
      }), React.createElement("path", {
        d: "M23 18.1l-9.12-16a2.15 2.15 0 0 0-3.74 0L1 18.1A1.94 1.94 0 0 0 2.7 21h18.6a1.94 1.94 0 0 0 1.7-2.9zM2.8 19l9.07-15.92a.15.15 0 0 1 .26 0L21.2 19z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "16.5",
        r: "1.5"
      }));

    case 'symbols___exclamationmark':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 1h2v16h-2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "21.5",
        r: "1.5"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 1h4v14h-4z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "20.5",
        r: "2.5"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 3h2v33h-2z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "44",
        r: "2"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 3h4v32h-4z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "43",
        r: "3"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 6h4v66h-4z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "88",
        r: "4"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 6h8v66h-8z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "86",
        r: "6"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 1h2v16h-2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "21.5",
        r: "1.5"
      }));

    case 'symbols___heart':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 22.45L1.76 12.24a6 6 0 0 1 0-8.48 6 6 0 0 1 8.48 0L12 5.54l1.72-1.77A6 6 0 0 1 24 8a5.93 5.93 0 0 1-1.76 4.24zM6 4a4 4 0 0 0-2.83 6.83L12 19.62l8.86-8.79a4 4 0 0 0 0-5.66 4.1 4.1 0 0 0-5.66 0L12 8.39 8.83 5.17A4 4 0 0 0 6 4z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 22.45L1.76 12.24a6 6 0 0 1 0-8.48 6 6 0 0 1 8.48 0L12 5.54l1.72-1.77A6 6 0 0 1 24 8a5.93 5.93 0 0 1-1.76 4.24z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42.78 9.22a11 11 0 0 0-15.57 0l-3.15 3.28-3.28-3.28A11 11 0 0 0 5.22 24.78l18.71 18.7 18.85-18.7a11 11 0 0 0 0-15.56zm-1.41 14.14l-17.44 17.3-17.29-17.3a9 9 0 1 1 12.72-12.72l4.72 4.72 4.56-4.72a9 9 0 0 1 12.73 12.72z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M42.78 9.22a11 11 0 0 0-15.57 0l-3.15 3.28-3.28-3.28A11 11 0 0 0 5.22 24.78l18.71 18.7 18.85-18.7a11 11 0 0 0 0-15.56z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M85.56 18.45a22 22 0 0 0-31.14 0L48.12 25l-6.56-6.56a22 22 0 0 0-31.12 31.13L47.85 87l37.7-37.41a22 22 0 0 0 .01-31.14zm-2.83 28.29L47.86 81.33 13.27 46.74a18 18 0 0 1 25.46-25.46l9.44 9.44 9.1-9.44a18 18 0 0 1 25.46 25.46z"
      }), React.createElement("path", {
        d: "M11 34h2a13 13 0 0 1 13-13v-2a15 15 0 0 0-15 15zM50.89 32.9l1.42 1.42 9.5-9.5A12.89 12.89 0 0 1 71 21v-2a14.93 14.93 0 0 0-10.61 4.4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M85.56 18.45a22 22 0 0 0-31.14 0L48.12 25l-6.56-6.56a22 22 0 0 0-31.12 31.13L47.85 87l37.7-37.41a22 22 0 0 0 .01-31.14zM26 21a13 13 0 0 0-13 13h-2a15 15 0 0 1 15-15zm45 0a12.89 12.89 0 0 0-9.19 3.81l-9.5 9.5-1.42-1.41 9.5-9.5A14.93 14.93 0 0 1 71 19z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 22.45L1.76 12.24a6 6 0 0 1 0-8.48 6 6 0 0 1 8.48 0L12 5.54l1.72-1.77A6 6 0 0 1 24 8a5.93 5.93 0 0 1-1.76 4.24zM6 4a4 4 0 0 0-2.83 6.83L12 19.62l8.86-8.79a4 4 0 0 0 0-5.66 4.1 4.1 0 0 0-5.66 0L12 8.39 8.83 5.17A4 4 0 0 0 6 4z"
      }));

    case 'symbols___infoCircle':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M11 11h2v6h-2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "7.5",
        r: "1.5"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm1 16h-2v-6h2zm-1-8a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 12 9z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm0 42a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
      }), React.createElement("path", {
        d: "M23 20h2v16h-2z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "14",
        r: "2"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 2a22 22 0 1 0 22 22A22 22 0 0 0 24 2zm1 34h-2V20h2zm-1-20a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm0 84a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
      }), React.createElement("path", {
        d: "M46 40h4v32h-4z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "28",
        r: "4"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 4a44 44 0 1 0 44 44A44 44 0 0 0 48 4zm2 68h-4V40h4zm-2-40a4 4 0 1 1 4-4 4 4 0 0 1-4 4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
      }), React.createElement("path", {
        d: "M11 11h2v6h-2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "7.5",
        r: "1.5"
      }));

    case 'symbols___info':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 7h2v16h-2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "2.5",
        r: "1.5"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 9h4v14h-4z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "3.5",
        r: "2.5"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M23 13h2v33h-2z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "5",
        r: "2"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22 14h4v32h-4z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "6",
        r: "3"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M46 25h4v66h-4z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "9",
        r: "4"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 25h8v66h-8z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "11",
        r: "6"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11 7h2v16h-2z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "2.5",
        r: "1.5"
      }));

    case 'symbols___legal':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 16.16A3.87 3.87 0 0 0 20 13c0-2.8-3.51-3.91-7.76-5C8.29 7 8 6.23 8 5c0-1.71 1.25-2 5-2 1.83 0 3 .28 3.6.84A1.54 1.54 0 0 1 17 5v1h2V5a3.5 3.5 0 0 0-1-2.57C17 1.45 15.45 1 13 1c-2.95 0-7 0-7 4a3.86 3.86 0 0 0 1 2.84A3.87 3.87 0 0 0 5 11c0 2.8 3.51 3.91 7.76 5 4 1 4.24 1.8 4.24 3 0 1.71-1.25 2-5 2-1.83 0-3-.28-3.6-.84A1.54 1.54 0 0 1 8 19v-1H6v1a3.5 3.5 0 0 0 1 2.57c1 1 2.56 1.43 5 1.43 2.95 0 7 0 7-4a3.86 3.86 0 0 0-1-2.84zM7 11c0-.88 1.24-1.6 2-1.92a19.45 19.45 0 0 0 2.78.89c2.18.55 6.24 1.56 6.24 3 0 .88-1.24 1.6-2 1.92a19.45 19.45 0 0 0-2.78-.89C11.06 13.48 7 12.47 7 11z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M21 13c0-4.08-3.48-4.83-6.56-5.5-.61-.13-1.27-.27-1.95-.44l-1.21-.3A21.89 21.89 0 0 1 9 6.14V6c0-.66.18-1 4-1 2.23 0 2.8.46 2.89.55s.11.11.11.45h4a4.54 4.54 0 0 0-1.28-3.28C17.55 1.55 15.73 1 13 1c-3 0-8 0-8 5a5 5 0 0 0 .26 1.7A5.11 5.11 0 0 0 4 11c0 4.08 3.48 4.83 6.56 5.5.61.13 1.27.27 1.95.44l1.21.3a21.89 21.89 0 0 1 2.28.62V18c0 .66-.18 1-4 1-2.23 0-2.8-.46-2.89-.55S9 18.34 9 18H5a4.54 4.54 0 0 0 1.28 3.28C7.45 22.45 9.27 23 12 23c3 0 8 0 8-5a5 5 0 0 0-.26-1.7A5.11 5.11 0 0 0 21 13zm-6.33.35l-1.18-.29c-.74-.18-1.43-.33-2.09-.47C8.15 11.88 8 11.66 8 11a1.23 1.23 0 0 1 .43-.85c.58.18 1.22.33 1.9.5l1.18.29c.74.18 1.43.33 2.09.47 3.25.71 3.4.93 3.4 1.59a1.23 1.23 0 0 1-.43.85c-.57-.18-1.22-.33-1.9-.5z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32.85 32.3c2-1 5.15-3 5.15-6.3 0-4.88-7-7-14.76-9S14 12.43 14 9c0-4.66 4.16-5 11-5 4 0 6.57.65 7.9 2A4.06 4.06 0 0 1 34 9v1h2V9a6 6 0 0 0-1.69-4.43C32.57 2.82 29.61 2 25 2c-6.09 0-13 0-13 7a8 8 0 0 0 3.15 6.7c-2 1-5.15 3-5.15 6.3 0 4.88 7 7 14.76 9S34 35.57 34 39c0 4.66-4.16 5-11 5-4 0-6.57-.65-7.9-2a4.06 4.06 0 0 1-1.1-3v-1h-2v1a6 6 0 0 0 1.69 4.43C15.43 45.18 18.39 46 23 46c6.09 0 13 0 13-7a8 8 0 0 0-3.15-6.7zM12 22c0-2.61 3.65-4.46 5.2-5a26.35 26.35 0 0 0 5.56 2C30.93 21 36 22.9 36 26c0 2.61-3.65 4.46-5.2 5a25.8 25.8 0 0 0-5.56-2C17.07 27 12 25.1 12 22z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M39 26c0-6.55-5.6-7.76-11.54-9-1.27-.27-2.59-.55-4-.9C15.57 14.08 15 12.45 15 10c0-3.42 2.5-4 10-4 3.66 0 6.07.57 7.19 1.69A3 3 0 0 1 33 10h4a7 7 0 0 0-2-5.14C33.08 2.91 29.89 2 25 2c-5.91 0-14 0-14 8a7.7 7.7 0 0 0 2.08 5.7C11.11 17 9 19 9 22c0 6.55 5.6 7.76 11.54 9 1.27.27 2.59.55 4 .9C32.43 33.92 33 35.55 33 38c0 3.42-2.5 4-10 4-3.66 0-6.07-.57-7.19-1.69A3 3 0 0 1 15 38h-4a7 7 0 0 0 2 5.14c1.94 2 5.13 2.86 10 2.86 5.91 0 14 0 14-8a7.7 7.7 0 0 0-2.08-5.7C36.89 31 39 29 39 26zm-17.62 1.13C15.05 25.76 13 25.06 13 22c0-1.75 2.46-3.18 3.94-3.83a37.9 37.9 0 0 0 5.57 1.77c1.45.36 2.8.65 4.11.93C33 22.24 35 22.94 35 26c0 1.75-2.46 3.18-3.94 3.83a37.9 37.9 0 0 0-5.57-1.77c-1.49-.36-2.8-.65-4.11-.93z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M76 52c0-9.75-14-14-29.51-17.94C31.14 30.22 28 24.87 28 18c0-9.33 8.31-10 22-10 16.13 0 18 5.71 18 10v2h4v-2C72 4 55.44 4 50 4 37.81 4 24 4 24 18c0 5.65 2 10 6.3 13.39C26.35 33.32 20 37.43 20 44c0 9.75 14 14 29.51 17.94C64.86 65.78 68 71.13 68 78c0 9.33-8.31 10-22 10-16.13 0-18-5.71-18-10v-2h-4v2c0 14 16.56 14 22 14 12.19 0 26 0 26-14 0-5.65-2-10-6.3-13.39C69.65 62.68 76 58.57 76 52zM61.6 62a52 52 0 0 0-11.11-4C34.13 54 24 50.19 24 44c0-5.23 7.3-8.92 10.4-10a52 52 0 0 0 11.11 4C61.87 42 72 45.81 72 52c0 5.23-7.3 8.92-10.4 10z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M78 52c0-13.1-11.21-15.52-23.08-18.07-2.54-.55-5.18-1.12-8-1.81C31.14 28.16 30 24.9 30 20c0-6.84 5-8 20-8 9 0 12.77 1.88 14.34 3.45A6.14 6.14 0 0 1 66 20.18h8A14.11 14.11 0 0 0 70 9.8C66.11 5.9 59.57 4 50 4 38.18 4 22 4 22 20c0 4.95 1.43 8.57 4.16 11.4C22.21 33.93 18 38 18 44c0 13.1 11.21 15.52 23.08 18.07 2.54.55 5.18 1.12 8 1.81 15.83 4 17 7.22 17 12.12 0 6.84-5 8-20 8-9 0-12.77-1.88-14.34-3.45A6.14 6.14 0 0 1 30 75.82h-8a14.11 14.11 0 0 0 4 10.38c3.9 3.9 10.44 5.8 20 5.8 11.82 0 28 0 28-16 0-5-1.43-8.57-4.16-11.4C73.79 62.07 78 58 78 52zm-35.24 2.25C27.3 50.92 26 49 26 44c0-3.5 4.91-6.36 7.88-7.66A75.57 75.57 0 0 0 45 39.88c2.9.72 5.6 1.31 8.21 1.87C68.7 45.08 70 47 70 52c0 3.5-4.91 6.36-7.88 7.66A75.57 75.57 0 0 0 51 56.12c-2.93-.72-5.63-1.31-8.24-1.87z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M18 16.16A3.87 3.87 0 0 0 20 13c0-2.8-3.51-3.91-7.76-5C8.29 7 8 6.23 8 5c0-1.71 1.25-2 5-2 1.83 0 3 .28 3.6.84A1.54 1.54 0 0 1 17 5v1h2V5a3.5 3.5 0 0 0-1-2.57C17 1.45 15.45 1 13 1c-2.95 0-7 0-7 4a3.86 3.86 0 0 0 1 2.84A3.87 3.87 0 0 0 5 11c0 2.8 3.51 3.91 7.76 5 4 1 4.24 1.8 4.24 3 0 1.71-1.25 2-5 2-1.83 0-3-.28-3.6-.84A1.54 1.54 0 0 1 8 19v-1H6v1a3.5 3.5 0 0 0 1 2.57c1 1 2.56 1.43 5 1.43 2.95 0 7 0 7-4a3.86 3.86 0 0 0-1-2.84zM7 11c0-.88 1.24-1.6 2-1.92a19.45 19.45 0 0 0 2.78.89c2.18.55 6.24 1.56 6.24 3 0 .88-1.24 1.6-2 1.92a19.45 19.45 0 0 0-2.78-.89C11.06 13.48 7 12.47 7 11z"
      }));

    case 'symbols___music':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 4.22v11.33A4 4 0 1 0 9 19V5.78l10-2.5v9.27A4 4 0 1 0 21 16V.72zM5 21a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm12-3a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 4.22v11.33A4 4 0 1 0 9 19V5.78l10-2.5v9.27A4 4 0 1 0 21 16V.72z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8.72v24A8 8 0 1 0 18 38V18.78l22-5.5v13.44A8 8 0 1 0 42 32V2.22zM10 44a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm24-6a6 6 0 1 1 6-6 6 6 0 0 1-6 6zM18 16.72v-6.44l22-5.5v6.44z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M16 8.72v24A8 8 0 1 0 18 38V18.78l22-5.5v13.44A8 8 0 1 0 42 32V2.22z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 17.44v48A16 16 0 1 0 36 76V36.53l44-11v27.91A16 16 0 1 0 84 64V4.44zM20 88a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm48-12a12 12 0 1 1 12-12 12 12 0 0 1-12 12zM36 34.47V20.56l44-11v13.91z"
      }), React.createElement("path", {
        d: "M11 76h2a7 7 0 0 1 7-7v-2a9 9 0 0 0-9 9zM59 64h2a7 7 0 0 1 7-7v-2a9 9 0 0 0-9 9z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M32 17.44v48A16 16 0 1 0 36 76V36.53l44-11v27.91A16 16 0 1 0 84 64V4.44zM20 69a7 7 0 0 0-7 7h-2a9 9 0 0 1 9-9zm48-12a7 7 0 0 0-7 7h-2a9 9 0 0 1 9-9z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M7 4.22v11.33A4 4 0 1 0 9 19V5.78l10-2.5v9.27A4 4 0 1 0 21 16V.72zM5 21a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm12-3a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
      }));

    case 'symbols___percentage':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5.2 19.4l12-16 1.6 1.2-12 16zM7 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM17 15a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M4.8 19.1l12-16 2.4 1.8-12 16zM7 6a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0-3a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM17 16a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0-3a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M11.2 39.4l24-32 1.6 1.2-24 32zM15 7a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM33 29a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10.4 38.8l24-32 3.2 2.4-24 32zM15 9a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-4a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM33 31a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-4a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M22.4 78.8l48-64 3.2 2.4-48 64zM30 14a12 12 0 1 1-12 12 12 12 0 0 1 12-12m0-4a16 16 0 1 0 16 16 16 16 0 0 0-16-16zM66 58a12 12 0 1 1-12 12 12 12 0 0 1 12-12m0-4a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M20.8 77.6l48-64 6.4 4.8-48 64zM30 18a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-8a16 16 0 1 0 16 16 16 16 0 0 0-16-16zM66 62a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-8a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5.2 19.4l12-16 1.6 1.2-12 16zM7 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM17 15a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"
      }));

    case 'symbols___questionmark':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1C9.05 1 5 1 5 7v.5h2V7c0-4 2-4 5-4 3.88 0 5 .9 5 4 0 2.08-.25 3.9-3.35 5.06l-2.65 1V17h2v-2.56l1.35-.5C19 12.19 19 8.81 19 7c0-5.27-3.36-6-7-6z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "21.5",
        r: "1.5"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1C9.2 1 4 1 4 8h4c0-2.89.76-3 4-3 3.67 0 4 .78 4 3a7.33 7.33 0 0 1 0 .86 8.31 8.31 0 0 1-2.67 1.27L10 11.36V16h4v-1.86l.7-.27c4-1.51 5.3-2.52 5.3-5.87 0-6.2-4.28-7-8-7z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "20.5",
        r: "2.5"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 3c-5.79 0-13 0-13 11v1h2v-1c0-9 4.85-9 11-9 8.33 0 11 2.19 11 9 0 4.38-.56 8.52-7.35 11.06L23 26.81V36h2v-7.81l3.35-1.25C37 23.69 37 17.63 37 14c0-9.13-5.2-11-13-11z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "44",
        r: "2"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M24 3c-5.91 0-14 0-14 12h4c0-8 4-8 10-8 7.76 0 10 1.79 10 8 0 3.38 0 5.61-6.7 8.13l-5.3 2V36h4v-8.11l2.7-1C37.32 23.64 38 19.75 38 15 38 4.45 31.27 3 24 3z"
      }), React.createElement("circle", {
        cx: "24",
        cy: "43",
        r: "3"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 6C36.42 6 22 6 22 28v2h4v-2c0-18 9.71-18 22-18 16.65 0 22 4.37 22 18 0 8.76-1.12 17-14.7 22.13L46 53.61V72h4V56.39l6.7-2.52C74 47.39 74 35.25 74 28 74 9.74 63.61 6 48 6z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "88",
        r: "4"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M48 6C36.18 6 20 6 20 30h8c0-16 8-16 20-16 15.51 0 20 3.59 20 16 0 6.76 0 11.23-13.4 16.25l-10.6 4V72h8V55.77l5.4-2C74.63 47.29 76 39.5 76 30 76 8.91 62.54 6 48 6z"
      }), React.createElement("circle", {
        cx: "48",
        cy: "86",
        r: "6"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 1C9.05 1 5 1 5 7v.5h2V7c0-4 2-4 5-4 3.88 0 5 .9 5 4 0 2.08-.25 3.9-3.35 5.06l-2.65 1V17h2v-2.56l1.35-.5C19 12.19 19 8.81 19 7c0-5.27-3.36-6-7-6z"
      }), React.createElement("circle", {
        cx: "12",
        cy: "21.5",
        r: "1.5"
      }));

    case 'symbols___quotationmark':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 11V9a5 5 0 0 1 4.52-4.95l-.95-1.9A7 7 0 0 0 1 9v10l1 2h7l1-2v-6l-1-2zm5 7.53l-.24.47H3.24L3 18.53V13h4.76l.24.47zM22 11h-6V9a5 5 0 0 1 4.52-4.95l-.95-1.9A7 7 0 0 0 14 9v10l1 2h7l1-2v-6zm-1 7.53l-.24.47h-4.52l-.24-.47V13h4.76l.24.47z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 11V9a5 5 0 0 1 4.52-4.95l-.95-1.9A7 7 0 0 0 1 9v10l1 2h7l1-2v-6l-1-2zM16 11V9a5 5 0 0 1 4.52-4.95l-.95-1.9A7 7 0 0 0 14 9v10l1 2h7l1-2v-6l-1-2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 22H30v-4A12 12 0 0 1 40.08 6.17l-.93-1.88A14 14 0 0 0 28 18v20l2 4h14l2-4V26zm0 15.53L42.76 40H31.24L30 37.53V24h12.76L44 26.47zM4 22v-4A12 12 0 0 1 14.08 6.17l-.93-1.88A14 14 0 0 0 2 18v20l2 4h14l2-4V26l-2-4zm14 15.53L16.76 40H5.24L4 37.53V24h12.76L18 26.47z"
      }));
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M44 22H32v-4a10 10 0 0 1 9-9.95l-1.85-3.76A14 14 0 0 0 28 18v20l2 4h14l2-4V26zM18 22H6v-4a10 10 0 0 1 9-9.95l-1.85-3.76A14 14 0 0 0 2 18v20l2 4h14l2-4V26z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M12 75h20v2H12zM64 75h20v2H64z"
      }), React.createElement("path", {
        d: "M88 44H60v-8a24 24 0 0 1 20.16-23.69l-1.87-3.72A28 28 0 0 0 56 36v40l4 8h28l4-8V52zm0 31.06L85.53 80H62.47L60 75.06V48h25.53L88 52.94zM8 44v-8a24 24 0 0 1 20.16-23.69l-1.87-3.72A28 28 0 0 0 4 36v40l4 8h28l4-8V52l-4-8zm28 31.06L33.53 80H10.47L8 75.06V48h25.53L36 52.94z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M36 44H12v-8a20 20 0 0 1 18.05-19.9l-3.76-7.51A28 28 0 0 0 4 36v40l4 8h28l4-8V52zm-4 35H12v-2h20zM88 44H64v-8a20 20 0 0 1 18-19.9l-3.71-7.51A28 28 0 0 0 56 36v40l4 8h28l4-8V52zm-4 35H64v-2h20z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 11V9a5 5 0 0 1 4.52-4.95l-.95-1.9A7 7 0 0 0 1 9v10l1 2h7l1-2v-6l-1-2zm5 7.53l-.24.47H3.24L3 18.53V13h4.76l.24.47zM22 11h-6V9a5 5 0 0 1 4.52-4.95l-.95-1.9A7 7 0 0 0 14 9v10l1 2h7l1-2v-6zm-1 7.53l-.24.47h-4.52l-.24-.47V13h4.76l.24.47z"
      }));

    case 'symbols___uncategorizedt':
      if (variant === "solid" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 3v42h42V3zm4 40H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2V5h2z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M3 3v42h42V3zm4 40H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5v-2h2zm0-6H5V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-36h-2V5h2zm6 36h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2v-2h2zm0-6h-2V5h2z"
      }));

    case 'symbols___uncategorized':
      if (variant === "outline" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 11h2v2H1zM1 6h2v2H1zM1 16h2v2H1zM1 1h2v2H1zM16 1h2v2h-2zM1 21h2v2H1zM11 1h2v2h-2zM6 1h2v2H6zM11 21h2v2h-2zM21 11h2v2h-2zM21 6h2v2h-2zM6 21h2v2H6zM21 1h2v2h-2zM21 16h2v2h-2zM16 21h2v2h-2zM21 21h2v2h-2z"
      }));
      if (variant === "solid" && size === 24) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M0 0v24h24V0zm3 23H1v-2h2zm0-5H1v-2h2zm0-5H1v-2h2zm0-5H1V6h2zm0-5H1V1h2zm5 20H6v-2h2zM8 3H6V1h2zm5 20h-2v-2h2zm0-20h-2V1h2zm5 20h-2v-2h2zm0-20h-2V1h2zm5 20h-2v-2h2zm0-5h-2v-2h2zm0-5h-2v-2h2zm0-5h-2V6h2zm0-5h-2V1h2z"
      }));
      if (variant === "outline" && size === 48) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M5 17h2v2H5zM5 5h2v2H5zM5 23h2v2H5zM5 29h2v2H5zM5 35h2v2H5zM17 5h2v2h-2zM29 5h2v2h-2zM35 5h2v2h-2zM11 5h2v2h-2zM23 5h2v2h-2zM5 41h2v2H5zM5 11h2v2H5zM41 23h2v2h-2zM41 17h2v2h-2zM41 29h2v2h-2zM41 11h2v2h-2zM11 41h2v2h-2zM41 35h2v2h-2zM41 5h2v2h-2zM23 41h2v2h-2zM41 41h2v2h-2zM17 41h2v2h-2zM29 41h2v2h-2zM35 41h2v2h-2z"
      }));
      if (variant === "outline" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M10 46h4v4h-4zM10 19h4v4h-4zM10 28h4v4h-4zM10 37h4v4h-4zM10 73h4v4h-4zM10 82h4v4h-4zM10 55h4v4h-4zM10 64h4v4h-4zM55 10h4v4h-4zM46 10h4v4h-4zM73 10h4v4h-4zM37 10h4v4h-4zM10 10h4v4h-4zM19 10h4v4h-4zM28 10h4v4h-4zM64 10h4v4h-4zM82 46h4v4h-4zM82 55h4v4h-4zM82 64h4v4h-4zM82 73h4v4h-4zM82 37h4v4h-4zM82 28h4v4h-4zM82 10h4v4h-4zM82 19h4v4h-4zM82 82h4v4h-4zM37 82h4v4h-4zM46 82h4v4h-4zM28 82h4v4h-4zM64 82h4v4h-4zM55 82h4v4h-4zM73 82h4v4h-4zM19 82h4v4h-4z"
      }));
      if (variant === "solid" && size === 96) return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M6 6v84h84V6zm8 80h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-72h-4v-4h4zm9 72h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4zm0-9h-4v-4h4z"
      }));
      return React.createElement("svg", __assign({}, svgAttrs, {
        id: id,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }), title && React.createElement("title", {
        id: idTitle
      }, title), React.createElement("path", {
        d: "M1 11h2v2H1zM1 6h2v2H1zM1 16h2v2H1zM1 1h2v2H1zM16 1h2v2h-2zM1 21h2v2H1zM11 1h2v2h-2zM6 1h2v2H6zM11 21h2v2h-2zM21 11h2v2h-2zM21 6h2v2h-2zM6 21h2v2H6zM21 1h2v2h-2zM21 16h2v2h-2zM16 21h2v2h-2zM21 21h2v2h-2z"
      }));

    default:
      return null;
  }
};

exports.svgIcon = svgIcon;
var iconNames = {
  "banking_card_addCard": "banking_card_addCard",
  "banking_card_blockCard": "banking_card_blockCard",
  "banking_card_multipleCards": "banking_card_multipleCards",
  "banking_card_singleCard": "banking_card_singleCard",
  "banking_cash_banknoteEur": "banking_cash_banknoteEur",
  "banking_cash_banknoteUsd": "banking_cash_banknoteUsd",
  "banking_cash_coinEur": "banking_cash_coinEur",
  "banking_graphs_graph": "banking_graphs_graph",
  "banking_graphs_piechart": "banking_graphs_piechart",
  "banking_transfer_standingOrder": "banking_transfer_standingOrder",
  "banking_transfer_transferRebooking": "banking_transfer_transferRebooking",
  "banking_transfer_transferReceive": "banking_transfer_transferReceive",
  "banking_transfer_transferRecurring": "banking_transfer_transferRecurring",
  "banking_transfer_transferScheduled": "banking_transfer_transferScheduled",
  "banking_transfer_transferStandard": "banking_transfer_transferStandard",
  "banking_transfer_transferslip": "banking_transfer_transferslip",
  "banking___atm": "banking___atm",
  "banking___contactless": "banking___contactless",
  "banking___gem": "banking___gem",
  "banking___handMoney": "banking___handMoney",
  "banking___multibanking": "banking___multibanking",
  "banking___phototan": "banking___phototan",
  "brands_banks_comdirect": "brands_banks_comdirect",
  "brands_banks_commerzbank": "brands_banks_commerzbank",
  "brands_banks_deutschebank": "brands_banks_deutschebank",
  "brands_banks_ing": "brands_banks_ing",
  "brands_banks_n26": "brands_banks_n26",
  "brands_banks_postbank": "brands_banks_postbank",
  "brands_banks_sparkasse": "brands_banks_sparkasse",
  "brands_banks_targo": "brands_banks_targo",
  "brands___apple": "brands___apple",
  "brands___google": "brands___google",
  "brands___visa": "brands___visa",
  "communication_feedback_dislike": "communication_feedback_dislike",
  "communication_feedback_happy": "communication_feedback_happy",
  "communication_feedback_like": "communication_feedback_like",
  "communication_feedback_neutral": "communication_feedback_neutral",
  "communication_feedback_sad": "communication_feedback_sad",
  "communication___call": "communication___call",
  "communication___chat": "communication___chat",
  "communication___envelope": "communication___envelope",
  "communication___inbox": "communication___inbox",
  "communication___news": "communication___news",
  "communication___textchat": "communication___textchat",
  "interaction_arrows_arrowDown": "interaction_arrows_arrowDown",
  "interaction_arrows_arrowLeft": "interaction_arrows_arrowLeft",
  "interaction_arrows_arrowRight": "interaction_arrows_arrowRight",
  "interaction_arrows_arrowUp": "interaction_arrows_arrowUp",
  "interaction_arrows_chevronDown": "interaction_arrows_chevronDown",
  "interaction_arrows_chevronLeft": "interaction_arrows_chevronLeft",
  "interaction_arrows_chevronRight": "interaction_arrows_chevronRight",
  "interaction_arrows_chevronUp": "interaction_arrows_chevronUp",
  "interaction___add": "interaction___add",
  "interaction___checkmark": "interaction___checkmark",
  "interaction___close": "interaction___close",
  "interaction___copy": "interaction___copy",
  "interaction___dashLong": "interaction___dashLong",
  "interaction___dashShort": "interaction___dashShort",
  "interaction___download": "interaction___download",
  "interaction___eyeHide": "interaction___eyeHide",
  "interaction___eyeView": "interaction___eyeView",
  "interaction___filter01": "interaction___filter01",
  "interaction___filter02": "interaction___filter02",
  "interaction___fingerprint": "interaction___fingerprint",
  "interaction___flashOff": "interaction___flashOff",
  "interaction___flashOn": "interaction___flashOn",
  "interaction___logout": "interaction___logout",
  "interaction___menu": "interaction___menu",
  "interaction___more01": "interaction___more01",
  "interaction___more02": "interaction___more02",
  "interaction___notificationOff": "interaction___notificationOff",
  "interaction___notificationOn": "interaction___notificationOn",
  "interaction___playbutton": "interaction___playbutton",
  "interaction___refresh": "interaction___refresh",
  "interaction___search": "interaction___search",
  "interaction___share": "interaction___share",
  "interaction___slider": "interaction___slider",
  "interaction___trash": "interaction___trash",
  "interaction___upload": "interaction___upload",
  "interaction___volume": "interaction___volume",
  "interaction___wifiOff": "interaction___wifiOff",
  "interaction___wifiOn": "interaction___wifiOn",
  "location___globe": "location___globe",
  "location___house": "location___house",
  "location___location": "location___location",
  "location___office": "location___office",
  "location___target": "location___target",
  "object_devices_camera": "object_devices_camera",
  "object_devices_headset": "object_devices_headset",
  "object_devices_laptop": "object_devices_laptop",
  "object_devices_printer": "object_devices_printer",
  "object_devices_smartphone": "object_devices_smartphone",
  "object_devices_tablet": "object_devices_tablet",
  "object_devices_video": "object_devices_video",
  "object_document_checklist": "object_document_checklist",
  "object_document_document": "object_document_document",
  "object_transport_airplane": "object_transport_airplane",
  "object_transport_pram": "object_transport_pram",
  "object___alarmclock": "object___alarmclock",
  "object___calender": "object___calender",
  "object___clock": "object___clock",
  "object___coffeemug": "object___coffeemug",
  "object___firstaid": "object___firstaid",
  "object___flag": "object___flag",
  "object___gauge": "object___gauge",
  "object___gear": "object___gear",
  "object___lightbulb": "object___lightbulb",
  "object___lock": "object___lock",
  "object___paperclip": "object___paperclip",
  "object___pencil": "object___pencil",
  "object___shoppingcart": "object___shoppingcart",
  "object___suitcase": "object___suitcase",
  "object___sun": "object___sun",
  "object___tag": "object___tag",
  "object___torch": "object___torch",
  "object___umbrella": "object___umbrella",
  "object___wrench": "object___wrench",
  "people___callcenter": "people___callcenter",
  "people___female": "people___female",
  "people___groupFemale": "people___groupFemale",
  "people___groupMale": "people___groupMale",
  "people___male": "people___male",
  "people___photoId": "people___photoId",
  "people___profileAdd": "people___profileAdd",
  "people___profile": "people___profile",
  "people___teamFemale": "people___teamFemale",
  "people___teamMale": "people___teamMale",
  "people___wheelchair": "people___wheelchair",
  "social___cobablog": "social___cobablog",
  "social___facebook": "social___facebook",
  "social___instagram": "social___instagram",
  "social___linkedin": "social___linkedin",
  "social___twitter": "social___twitter",
  "social___xing": "social___xing",
  "social___youtube": "social___youtube",
  "symbols___asterisk": "symbols___asterisk",
  "symbols___error": "symbols___error",
  "symbols___exclamationmark": "symbols___exclamationmark",
  "symbols___heart": "symbols___heart",
  "symbols___infoCircle": "symbols___infoCircle",
  "symbols___info": "symbols___info",
  "symbols___legal": "symbols___legal",
  "symbols___music": "symbols___music",
  "symbols___percentage": "symbols___percentage",
  "symbols___questionmark": "symbols___questionmark",
  "symbols___quotationmark": "symbols___quotationmark",
  "symbols___uncategorizedt": "symbols___uncategorizedt",
  "symbols___uncategorized": "symbols___uncategorized"
};
exports.iconNames = iconNames;